import _extends from '@babel/runtime/helpers/extends';
import * as React from 'react';

const SvgAccessibility = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#accessibility_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25A2.625 2.625 0 1 1 12 0a2.625 2.625 0 0 1 0 5.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.25 5.287-.021.006-.02.006a5.458 5.458 0 0 0-.14.042c-.873.256-5.106 1.45-8.09 1.45-2.77 0-6.622-1.032-7.854-1.382a3.46 3.46 0 0 0-.375-.121c-.89-.234-1.5.67-1.5 1.497 0 .819.736 1.209 1.48 1.489v.013l4.463 1.394c.456.175.578.354.637.508.194.497.04 1.48-.016 1.823l-.271 2.109-1.51 8.259a1.519 1.519 0 0 0-.012.069l-.01.06c-.11.756.446 1.49 1.5 1.49.918 0 1.323-.633 1.5-1.496 0 0 1.312-7.386 1.968-7.386.656 0 2.008 7.386 2.008 7.386.176.863.581 1.497 1.5 1.497 1.056 0 1.612-.738 1.5-1.497a2.702 2.702 0 0 0-.036-.19l-1.53-8.191-.27-2.11c-.197-1.228-.039-1.634.014-1.73a.047.047 0 0 0 .004-.006c.05-.094.281-.304.82-.506l4.185-1.463a.784.784 0 0 0 .076-.024c.75-.281 1.5-.67 1.5-1.497 0-.826-.61-1.732-1.5-1.499Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "accessibility_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgAddCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm3.75 10.5h-3v3a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 1 1 0-1.5h3v-3a.75.75 0 1 1 1.5 0v3h3a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAdd = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5a.75.75 0 0 1 .75.75v13.5a.75.75 0 0 1-1.5 0V5.25A.75.75 0 0 1 12 4.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 0 1.5H5.25A.75.75 0 0 1 4.5 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAirplane = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.748 21.75H7.5a.75.75 0 0 1-.683-1.06l3.022-6.667-4.537-.101-1.655 2.005c-.316.396-.567.573-1.21.573h-.84a.828.828 0 0 1-.689-.33c-.111-.151-.22-.406-.114-.77l.93-3.328a.851.851 0 0 1 .024-.074v-.007a.688.688 0 0 1-.025-.075l-.93-3.35c-.1-.356.01-.605.12-.752a.789.789 0 0 1 .638-.314h.887c.479 0 .945.215 1.218.563l1.62 1.97 4.563-.067L6.818 3.31A.75.75 0 0 1 7.5 2.25h1.261a1.172 1.172 0 0 1 .907.46l5.862 7.124 2.708-.07c.198-.012.748-.015.875-.015 2.59.001 4.137.842 4.137 2.251 0 .443-.177 1.266-1.363 1.789-.7.31-1.633.466-2.775.466-.126 0-.674-.004-.875-.015l-2.707-.072-5.877 7.125a1.174 1.174 0 0 1-.905.457Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAlarm = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.2 5.178a1.003 1.003 0 0 0-.052-1.475A2.938 2.938 0 0 0 5.25 3l-.153.004h-.023c-1.586.097-2.824 1.475-2.82 3.137 0 .89.374 1.362.67 1.74a.966.966 0 0 0 .69.365c.012 0 .032.002.093.002a.893.893 0 0 0 .645-.276L7.2 5.178ZM18.928 3.005 18.774 3h-.024a2.938 2.938 0 0 0-1.9.704 1.004 1.004 0 0 0-.052 1.473l2.85 2.796a.893.893 0 0 0 .646.277c.06 0 .08 0 .093-.002a.967.967 0 0 0 .689-.366c.298-.377.67-.847.671-1.74.003-1.663-1.235-3.041-2.82-3.137Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.003 4.5c-4.547 0-8.25 3.7-8.25 8.25a8.214 8.214 0 0 0 1.913 5.276L3.973 19.72a.75.75 0 1 0 1.061 1.06l1.693-1.693a8.232 8.232 0 0 0 10.553 0l1.693 1.693a.752.752 0 0 0 1.288-.528.748.748 0 0 0-.227-.532l-1.694-1.694a8.211 8.211 0 0 0 1.913-5.276c0-4.547-3.7-8.25-8.25-8.25Zm.75 8.25a.75.75 0 0 1-.75.75h-3.75a.75.75 0 1 1 0-1.5h3V7.5a.75.75 0 1 1 1.5 0v5.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAlbums = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 4.5H6.75a.75.75 0 0 1 0-1.5h10.5a.75.75 0 1 1 0 1.5ZM18.75 6.75H5.25a.75.75 0 0 1 0-1.5h13.5a.75.75 0 1 1 0 1.5ZM19.647 21H4.353a2.106 2.106 0 0 1-2.103-2.103V9.603A2.106 2.106 0 0 1 4.353 7.5h15.294a2.106 2.106 0 0 1 2.103 2.103v9.294A2.106 2.106 0 0 1 19.647 21Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAlertCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm0 14.996a.937.937 0 1 1 0-1.875.937.937 0 0 1 0 1.875Zm1.018-9.43-.269 5.72a.75.75 0 0 1-1.5 0L10.98 7.82v-.003a1.02 1.02 0 1 1 2.036 0h.002Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAlert = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 4.537C10.45 3.641 11.233 3 12 3s1.551.641 1.499 1.537l-.374 10.106a1.125 1.125 0 0 1-2.25 0l-.374-10.106Zm1.515-.026Zm-.03 0ZM10.5 19.5a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAmericanFootball = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.721 5.721c-2.08 2.08-3.127 4.716-3.656 6.81l9.403 9.402c2.094-.528 4.73-1.575 6.81-3.657 2.08-2.081 3.127-4.716 3.657-6.81l-9.403-9.399c-2.094.527-4.73 1.575-6.81 3.654Zm8.372 3.138 1.048-1.045a.74.74 0 0 1 1.044 1.045l-1.044 1.048.523.524a.74.74 0 0 1-1.047 1.046l-.523-.523L13.046 12l.523.523a.74.74 0 1 1-1.046 1.046L12 13.046l-1.046 1.047.523.523a.74.74 0 1 1-1.046 1.046l-.524-.522-1.048 1.045a.74.74 0 0 1-1.045-1.044l1.045-1.048-.523-.524a.74.74 0 0 1 1.046-1.046l.524.523L10.954 12l-.523-.523a.74.74 0 0 1 1.046-1.046l.523.523 1.046-1.047-.523-.523a.74.74 0 1 1 1.046-1.046l.524.521ZM22.34 9.358c.342-2.556.187-5.638-.938-6.76-1.125-1.123-4.204-1.28-6.76-.938-.118.016-.242.034-.37.054l8.015 8.016.052-.372ZM1.66 14.642c-.342 2.556-.187 5.638.938 6.76.785.785 2.527 1.098 4.379 1.098a18.141 18.141 0 0 0 2.751-.215L1.713 14.27l-.052.372Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAnalytics = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.375 6a1.875 1.875 0 0 0-1.745 2.56l-3.945 3.945a1.869 1.869 0 0 0-1.37 0l-2.82-2.82a1.876 1.876 0 0 0-3.294-1.742 1.875 1.875 0 0 0-.196 1.741L3.309 14.38a1.875 1.875 0 1 0 1.061 1.06l4.696-4.695c.44.173.929.173 1.368 0l2.82 2.82a1.876 1.876 0 0 0 2.622 2.344 1.876 1.876 0 0 0 .87-2.343L20.69 9.62A1.875 1.875 0 1 0 21.375 6Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAperture = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.744 6.055 8.566 2.877a9.827 9.827 0 0 0-4.52 3.498h7.566a.188.188 0 0 0 .132-.32ZM7.862 7.875H3.17a9.72 9.72 0 0 0-.757 5.902l5.581-5.582a.187.187 0 0 0-.132-.32ZM16.125 7.862V3.167a9.742 9.742 0 0 0-5.901-.754l5.58 5.581a.188.188 0 0 0 .321-.132ZM21.587 10.223l-5.581 5.582a.187.187 0 0 0 .132.32h4.692a9.72 9.72 0 0 0 .757-5.902ZM17.945 11.744l3.18-3.179a9.8 9.8 0 0 0-3.5-4.524v7.57a.188.188 0 0 0 .32.133ZM10.391 16.02c.07.068.163.105.26.105h2.797a.375.375 0 0 0 .267-.112l2.305-2.344a.376.376 0 0 0 .108-.263l-.003-2.85a.376.376 0 0 0-.111-.267L13.67 7.98a.375.375 0 0 0-.264-.108l-2.852.003a.375.375 0 0 0-.267.112L7.98 10.33a.375.375 0 0 0-.108.264l.003 2.85a.375.375 0 0 0 .115.27l2.402 2.306ZM12.256 17.945l3.178 3.178a9.828 9.828 0 0 0 4.52-3.498h-7.566a.188.188 0 0 0-.132.32ZM7.875 16.138v4.695a9.742 9.742 0 0 0 5.901.754l-5.58-5.581a.187.187 0 0 0-.321.132ZM6.055 12.256l-3.18 3.18a9.802 9.802 0 0 0 3.5 4.523v-7.57a.187.187 0 0 0-.32-.133Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgApps = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.875 7.5a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25ZM12 7.5a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25ZM19.125 7.5a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25ZM4.875 14.625a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25ZM12 14.625a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25ZM19.125 14.625a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25ZM4.875 21.75a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25ZM12 21.75a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25ZM19.125 21.75a2.625 2.625 0 1 1 0-5.25 2.625 2.625 0 0 1 0 5.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArchive = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 7.688v11.437a2.625 2.625 0 0 0 2.625 2.625h12.75A2.625 2.625 0 0 0 21 19.125V7.687a.188.188 0 0 0-.188-.187H3.188A.187.187 0 0 0 3 7.688Zm12.516 7.107L12.53 17.78a.75.75 0 0 1-1.06 0l-2.986-2.985a.764.764 0 0 1-.04-1.049.75.75 0 0 1 1.086-.026l1.72 1.72V10.52c0-.404.31-.75.714-.77a.75.75 0 0 1 .786.749v4.94l1.72-1.72a.75.75 0 0 1 1.085.026.764.764 0 0 1-.04 1.05ZM21 2.25H3a1.5 1.5 0 0 0-1.5 1.5v.75A1.5 1.5 0 0 0 3 6h18a1.5 1.5 0 0 0 1.5-1.5v-.75a1.5 1.5 0 0 0-1.5-1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowBackCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12c0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75-5.385 0-9.75 4.365-9.75 9.75Zm9.968-4.282a.751.751 0 0 1 .004 1.06L9.77 11.25h6.261a.75.75 0 1 1 0 1.5H9.77l2.452 2.472a.75.75 0 1 1-1.066 1.056l-3.721-3.75a.75.75 0 0 1 0-1.056l3.721-3.75a.75.75 0 0 1 1.062-.005Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowBack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.233 4.455c.44.439.44 1.151 0 1.59L6.278 12l5.955 5.954a1.125 1.125 0 0 1-1.591 1.591l-6.75-6.75a1.125 1.125 0 0 1 0-1.59l6.75-6.75c.44-.44 1.152-.44 1.591 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12c0-.621.504-1.125 1.125-1.125h13.688a1.125 1.125 0 0 1 0 2.25H5.624A1.125 1.125 0 0 1 4.5 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowDownCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.75c5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75Zm-4.282-9.968a.751.751 0 0 1 1.06-.004l2.472 2.452V7.97a.75.75 0 1 1 1.5 0v6.261l2.472-2.452a.75.75 0 0 1 1.056 1.066l-3.75 3.721a.75.75 0 0 1-1.056 0l-3.75-3.721a.75.75 0 0 1-.005-1.062Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowDown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.455 11.767c.439-.44 1.151-.44 1.59 0L12 17.721l5.954-5.954a1.125 1.125 0 0 1 1.591 1.591l-6.75 6.75c-.439.44-1.151.44-1.59 0l-6.75-6.75a1.125 1.125 0 0 1 0-1.591Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.563c.621 0 1.125.503 1.125 1.124v13.688a1.125 1.125 0 0 1-2.25 0V4.687c0-.62.504-1.125 1.125-1.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowForwardCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 12c0-5.385-4.366-9.75-9.75-9.75-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75Zm-9.968 4.282a.751.751 0 0 1-.004-1.06l2.452-2.472H7.97a.75.75 0 1 1 0-1.5h6.261l-2.452-2.472a.75.75 0 1 1 1.066-1.056l3.721 3.75a.75.75 0 0 1 0 1.056l-3.721 3.75a.75.75 0 0 1-1.062.005Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowForward = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.767 4.455c.44-.44 1.152-.44 1.591 0l6.75 6.75c.44.439.44 1.151 0 1.59l-6.75 6.75a1.125 1.125 0 0 1-1.591-1.59L17.721 12l-5.954-5.955a1.125 1.125 0 0 1 0-1.59Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.563 12c0-.621.503-1.125 1.124-1.125h13.688a1.125 1.125 0 0 1 0 2.25H4.687A1.125 1.125 0 0 1 3.563 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowRedoCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12c0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75-5.385 0-9.75 4.365-9.75 9.75Zm4.5 3.125c.255-2.88 1.6-5.488 5.76-5.488v-1.75a.391.391 0 0 1 .656-.281l3.963 3.738a.385.385 0 0 1 0 .56l-3.957 3.739a.391.391 0 0 1-.656-.282v-1.748c-2.676 0-3.962.632-5.09 1.814-.257.264-.706.061-.676-.302Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowRedo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.756 20.584a.75.75 0 0 1-.506-.71c0-3.426.688-6.166 2.046-8.144C5.936 9.338 8.525 8.052 12 7.891V4.125a.75.75 0 0 1 1.268-.542l8.25 7.875a.75.75 0 0 1 0 1.084l-8.25 7.875A.75.75 0 0 1 12 19.875v-3.74c-2.11.064-3.703.406-4.972 1.062-1.371.709-2.365 1.768-3.437 3.14a.75.75 0 0 1-.835.248Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowUndoCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75Zm4.578 13.177c-1.128-1.182-2.414-1.814-5.09-1.814v1.75a.39.39 0 0 1-.658.281l-3.96-3.738a.384.384 0 0 1 0-.56l3.958-3.739a.39.39 0 0 1 .659.282v1.749c4.159 0 5.504 2.608 5.76 5.489.034.361-.416.564-.669.3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowUndo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 20.625a.75.75 0 0 1-.591-.288c-1.072-1.372-2.066-2.431-3.437-3.14-1.269-.656-2.863-.997-4.972-1.061v3.739a.75.75 0 0 1-1.266.542l-8.25-7.875a.75.75 0 0 1 0-1.084l8.25-7.875A.75.75 0 0 1 12 4.125v3.767c3.475.16 6.065 1.449 7.704 3.838 1.358 1.978 2.046 4.718 2.046 8.145a.75.75 0 0 1-.75.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowUpCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75Zm4.282 9.968a.751.751 0 0 1-1.06.004L12.75 9.77v6.261a.75.75 0 1 1-1.5 0V9.77l-2.472 2.452a.75.75 0 1 1-1.056-1.066l3.75-3.721a.75.75 0 0 1 1.056 0l3.75 3.721a.75.75 0 0 1 .005 1.062Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgArrowUp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.204 3.892c.44-.44 1.152-.44 1.591 0l6.75 6.75a1.125 1.125 0 0 1-1.59 1.591L12 6.278l-5.955 5.955a1.125 1.125 0 0 1-1.59-1.591l6.75-6.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4.5c.621 0 1.125.504 1.125 1.125v13.688a1.125 1.125 0 0 1-2.25 0V5.624c0-.621.504-1.125 1.125-1.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAtCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.975 2.285c-5.383 0-9.75 4.364-9.75 9.75a9.75 9.75 0 0 0 9.75 9.75 9.75 9.75 0 0 0 9.75-9.75c0-5.385-4.367-9.75-9.75-9.75Zm5.85 9.527c-.133 1.53-.786 2.33-1.312 2.731-.525.402-1.156.578-1.7.48a1.948 1.948 0 0 1-1.258-.805 2.909 2.909 0 0 1-2.062.823 2.422 2.422 0 0 1-1.807-.789c-.534-.582-.797-1.423-.718-2.307.14-1.641 1.449-2.69 2.665-2.882 1.276-.201 2.449.306 2.949.912l.18.218-.297 2.362c-.056.672.154 1.1.576 1.177.112.02.38-.007.674-.232.315-.241.71-.75.802-1.803.11-1.244-.204-2.306-.903-3.07-.726-.792-1.832-1.21-3.198-1.21-2.531 0-4.773 2.082-4.996 4.64-.107 1.228.266 2.375 1.05 3.23.767.838 1.842 1.301 3.03 1.301.892 0 1.436-.096 2.32-.412a.657.657 0 0 1 .44 1.237c-1.022.364-1.719.488-2.76.488-1.56 0-2.979-.613-3.998-1.724-1.033-1.13-1.53-2.633-1.39-4.232.137-1.563.865-3.03 2.052-4.131 1.187-1.101 2.699-1.71 4.252-1.71 1.744 0 3.184.566 4.166 1.637.941 1.027 1.383 2.473 1.244 4.072Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.84 10.36c-.696.109-1.48.742-1.564 1.699-.046.518.094.995.379 1.306a1.109 1.109 0 0 0 .84.364c.951 0 1.627-.7 1.722-1.784a.663.663 0 0 1 .016-.097l.15-1.193a2.325 2.325 0 0 0-1.544-.296Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgAttach = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.19 3.236a3.935 3.935 0 0 1 5.452 3.673l-.006 8.84v.006a2.629 2.629 0 0 1-5.257 0V9a.75.75 0 0 1 1.5 0v6.736a1.129 1.129 0 0 0 2.257 0l.006-8.836v-.004a2.435 2.435 0 1 0-4.87 0l.001.004v8.913a3.727 3.727 0 1 0 7.453 0V7.488a.75.75 0 0 1 1.5 0v8.31A5.225 5.225 0 0 1 12 21.093a5.228 5.228 0 0 1-5.227-5.297V6.91a3.935 3.935 0 0 1 2.418-3.673Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBackspace = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.897 4.5H7.353a2.105 2.105 0 0 0-1.578.716.745.745 0 0 0-.09.126L1.5 11.613a.75.75 0 0 0 0 .774l4.179 6.26a.76.76 0 0 0 .094.136 2.104 2.104 0 0 0 1.58.717h11.544A2.106 2.106 0 0 0 21 17.397V6.603A2.106 2.106 0 0 0 18.897 4.5Zm-2.584 10.078a.752.752 0 0 1-.239 1.232.75.75 0 0 1-.822-.172l-2.517-2.513-2.516 2.515a.75.75 0 0 1-1.062-1.062l2.515-2.516-2.517-2.516a.751.751 0 1 1 1.064-1.062l2.517 2.518 2.515-2.518a.75.75 0 1 1 1.062 1.062l-2.518 2.516 2.518 2.516Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBagAdd = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.312 7.94a1.494 1.494 0 0 0-1.062-.44h-3v-.75a5.25 5.25 0 1 0-10.5 0v.75h-3A1.5 1.5 0 0 0 2.25 9v10.125c0 1.828 1.547 3.375 3.375 3.375h12.75c.884 0 1.734-.346 2.366-.963a3.256 3.256 0 0 0 1.009-2.353V9a1.49 1.49 0 0 0-.438-1.06ZM15 15.75h-2.25V18a.75.75 0 1 1-1.5 0v-2.25H9a.75.75 0 1 1 0-1.5h2.25V12a.75.75 0 1 1 1.5 0v2.25H15a.75.75 0 1 1 0 1.5Zm.75-8.25h-7.5v-.75a3.75 3.75 0 0 1 7.5 0v.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBagCheck = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.312 7.94a1.49 1.49 0 0 0-1.062-.44h-3v-.75a5.25 5.25 0 1 0-10.5 0v.75h-3A1.5 1.5 0 0 0 2.25 9v10.125c0 1.828 1.547 3.375 3.375 3.375h12.75c.884 0 1.734-.346 2.366-.963a3.256 3.256 0 0 0 1.009-2.353V9a1.489 1.489 0 0 0-.438-1.06Zm-5.727 4.904-4.2 5.25a.75.75 0 0 1-.573.281H10.8a.75.75 0 0 1-.57-.262l-1.8-2.104a.749.749 0 1 1 1.14-.975l1.211 1.415 3.633-4.543a.75.75 0 0 1 1.172.938ZM15.75 7.5h-7.5v-.75a3.75 3.75 0 0 1 7.5 0v.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBagHandle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.312 7.94a1.49 1.49 0 0 0-1.062-.44h-3v-.75a5.25 5.25 0 1 0-10.5 0v.75h-3A1.5 1.5 0 0 0 2.25 9v10.125c0 1.828 1.547 3.375 3.375 3.375h12.75c.884 0 1.734-.346 2.366-.963a3.256 3.256 0 0 0 1.009-2.353V9a1.489 1.489 0 0 0-.438-1.06ZM8.25 6.75a3.75 3.75 0 0 1 7.5 0v.75h-7.5v-.75Zm9 4.5a5.25 5.25 0 1 1-10.5 0v-.75a.75.75 0 1 1 1.5 0v.75a3.75 3.75 0 0 0 7.5 0v-.75a.75.75 0 1 1 1.5 0v.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBagRemove = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.312 7.94a1.494 1.494 0 0 0-1.062-.44h-3v-.75a5.25 5.25 0 1 0-10.5 0v.75h-3A1.5 1.5 0 0 0 2.25 9v10.125c0 1.828 1.547 3.375 3.375 3.375h12.75c.884 0 1.734-.346 2.366-.963a3.256 3.256 0 0 0 1.009-2.353V9a1.49 1.49 0 0 0-.438-1.06ZM15 15.75H9a.75.75 0 1 1 0-1.5h6a.75.75 0 1 1 0 1.5Zm.75-8.25h-7.5v-.75a3.75 3.75 0 0 1 7.5 0v.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.312 7.94a1.49 1.49 0 0 0-1.062-.44h-3v-.75a5.25 5.25 0 1 0-10.5 0v.75h-3A1.5 1.5 0 0 0 2.25 9v10.125c0 1.828 1.547 3.375 3.375 3.375h12.75c.884 0 1.734-.346 2.366-.963a3.256 3.256 0 0 0 1.009-2.353V9a1.489 1.489 0 0 0-.438-1.06ZM8.25 6.75a3.75 3.75 0 0 1 7.5 0v.75h-7.5v-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBan = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3.75a8.25 8.25 0 1 0 0 16.5 8.25 8.25 0 0 0 0-16.5ZM1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.834 19.425 4.575 6.166l1.591-1.59 13.259 13.258-1.591 1.59Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBandage = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bandage_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.928 7.36a.75.75 0 0 0-1.06 0l-4.376 4.375a.751.751 0 0 0 0 1.06l3.712 3.713a.749.749 0 0 0 1.061 0l4.376-4.375a.751.751 0 0 0 0-1.061l-3.713-3.713Zm-2.648 5.17A.75.75 0 1 1 9.22 11.47a.75.75 0 0 1 1.061 1.061Zm2.25 2.25a.75.75 0 1 1-1.061-1.061.75.75 0 0 1 1.061 1.061Zm0-4.5A.75.75 0 1 1 11.47 9.22a.75.75 0 0 1 1.061 1.061Zm2.25 2.25a.75.75 0 1 1-1.061-1.061.75.75 0 0 1 1.061 1.061ZM21.826 2.174a4.893 4.893 0 0 0-6.903 0l-3.27 3.277a.188.188 0 0 0 .197.308c.175-.07.36-.11.548-.12a2.236 2.236 0 0 1 1.59.66l3.713 3.712a2.237 2.237 0 0 1 .659 1.591 1.672 1.672 0 0 1-.12.548.188.188 0 0 0 .31.197l3.276-3.27a4.893 4.893 0 0 0 0-6.903Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.922 18.133a2.246 2.246 0 0 1-1.59-.657l-3.713-3.714a2.24 2.24 0 0 1-.442-.627c-.215-.454-.065-1.172.116-1.73a.188.188 0 0 0-.31-.187L2.361 14.83a4.88 4.88 0 1 0 6.902 6.903l3.41-3.417a.187.187 0 0 0-.197-.308 1.678 1.678 0 0 1-.555.126Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bandage_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgBarChart = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bar-chart_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 23.25H2.25a1.5 1.5 0 0 1-1.5-1.5V1.5a.75.75 0 0 1 1.5 0v20.25H22.5a.75.75 0 1 1 0 1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.313 20.25H5.438a1.687 1.687 0 0 1-1.688-1.688v-7.125A1.687 1.687 0 0 1 5.438 9.75h1.875A1.687 1.687 0 0 1 9 11.438v7.124a1.687 1.687 0 0 1-1.688 1.688ZM14.063 20.25h-1.876a1.687 1.687 0 0 1-1.687-1.688V9.188A1.687 1.687 0 0 1 12.188 7.5h1.874a1.687 1.687 0 0 1 1.688 1.688v9.374a1.687 1.687 0 0 1-1.688 1.688ZM20.796 20.25H18.92a1.687 1.687 0 0 1-1.688-1.688V6.188A1.687 1.687 0 0 1 18.921 4.5h1.875a1.688 1.688 0 0 1 1.687 1.688v12.375a1.687 1.687 0 0 1-1.688 1.687Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bar-chart_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgBarbell = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.89 8.25a1.403 1.403 0 0 0-1.186.586.094.094 0 0 1-.105.036.093.093 0 0 1-.066-.09V7.066c0-.973-.766-1.792-1.738-1.814a1.781 1.781 0 0 0-1.826 1.78v3.844a.094.094 0 0 1-.094.094h-9.75a.094.094 0 0 1-.094-.094v-3.81c0-.973-.766-1.792-1.738-1.814A1.781 1.781 0 0 0 3.47 7.03v1.752a.094.094 0 0 1-.17.054 1.404 1.404 0 0 0-1.19-.587C1.345 8.274.75 8.92.75 9.685v4.628c0 .764.597 1.411 1.36 1.435a1.404 1.404 0 0 0 1.186-.586.094.094 0 0 1 .173.055v1.719c0 .97.766 1.79 1.738 1.814a1.78 1.78 0 0 0 1.824-1.781v-3.844a.094.094 0 0 1 .094-.094h9.75a.094.094 0 0 1 .094.094v3.81c0 .973.766 1.792 1.738 1.815a1.782 1.782 0 0 0 1.824-1.781v-1.752a.095.095 0 0 1 .066-.09.094.094 0 0 1 .105.036 1.403 1.403 0 0 0 1.189.587c.764-.024 1.359-.67 1.359-1.435V9.686c0-.764-.597-1.411-1.36-1.436Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBarcode = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.647 4.5h-.006l-1.643.015L6 4.5h-.008l-1.722.015c-1.133.003-2.02.926-2.02 2.104v10.794c0 1.179.89 2.102 2.025 2.102h.007l1.72-.015L18 19.515h.008l1.644-.015a2.105 2.105 0 0 0 2.099-2.103V6.603A2.106 2.106 0 0 0 19.647 4.5ZM6.75 15a.75.75 0 1 1-1.5 0V9a.75.75 0 0 1 1.5 0v6Zm3 1.5a.75.75 0 1 1-1.5 0v-9a.75.75 0 0 1 1.5 0v9Zm3-.75a.75.75 0 1 1-1.5 0v-7.5a.75.75 0 1 1 1.5 0v7.5Zm3 .75a.75.75 0 1 1-1.5 0v-9a.75.75 0 1 1 1.5 0v9Zm3-1.5a.75.75 0 1 1-1.5 0V9a.75.75 0 1 1 1.5 0v6Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBaseball = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m20.813 13.86-.022-1.223a9.623 9.623 0 0 1-1.841-.221l-.235.813a.655.655 0 0 1-1.213.141.657.657 0 0 1-.047-.507l.235-.815a9.674 9.674 0 0 1-1.69-.813l-.49.692a.657.657 0 0 1-1.072-.757l.488-.69a9.598 9.598 0 0 1-1.406-1.407l-.69.49a.656.656 0 0 1-.757-1.073l.69-.488a9.625 9.625 0 0 1-.814-1.69l-.812.234a.656.656 0 0 1-.366-1.26l.81-.235a9.648 9.648 0 0 1-.218-1.809l-.854-.015a.656.656 0 0 1-.644-.656 9.75 9.75 0 0 0-7.287 6.917.75.75 0 0 1 .703.734l.02 1.146a9.648 9.648 0 0 1 1.75.217l.235-.811a.656.656 0 1 1 1.26.366l-.234.812a9.615 9.615 0 0 1 1.687.814l.485-.69a.656.656 0 1 1 1.072.757l-.487.69a9.622 9.622 0 0 1 1.408 1.408l.69-.488a.657.657 0 1 1 .758 1.073l-.692.489c.325.535.598 1.1.814 1.689l.815-.237a.656.656 0 0 1 .366 1.26l-.814.235c.13.59.204 1.19.22 1.794l.857.016a.75.75 0 0 1 .733.819 9.75 9.75 0 0 0 7.19-7.08.657.657 0 0 1-.602-.641Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.132 2.634a.656.656 0 0 1-.655.647h-.012l-.788-.014.008.184c.023.415.077.827.161 1.234l.764-.223a.656.656 0 0 1 .366 1.257l-.763.221c.17.45.38.885.625 1.298l.649-.458a.657.657 0 0 1 .757 1.072l-.65.459a8.26 8.26 0 0 0 1.094 1.092l.458-.65a.658.658 0 1 1 1.072.763l-.457.646c.413.246.848.455 1.297.625l.223-.763a.656.656 0 0 1 1.26.366l-.22.762c.477.1.962.157 1.45.171l-.008-.421a.656.656 0 0 1 .645-.668h.012c.04 0 .081.004.121.012a9.75 9.75 0 0 0-7.406-7.665c-.003.02-.002.036-.003.053ZM9.77 21.448a.75.75 0 0 1 .764-.737l.785.014a8.359 8.359 0 0 0-.17-1.404l-.762.221a.659.659 0 0 1-.813-.447.657.657 0 0 1 .447-.814l.76-.22c-.17-.45-.38-.884-.625-1.298l-.647.458a.657.657 0 0 1-.757-1.072l.649-.459a8.204 8.204 0 0 0-1.092-1.093l-.459.65a.656.656 0 1 1-1.072-.758l.459-.648a8.295 8.295 0 0 0-1.298-.625l-.22.763a.657.657 0 1 1-1.261-.367l.221-.763a8.299 8.299 0 0 0-1.233-.161l-.125-.006.007.496a.75.75 0 0 1-.736.763h-.014a.752.752 0 0 1-.185-.023 9.75 9.75 0 0 0 7.39 7.681.737.737 0 0 1-.012-.151Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBasket = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.88 9h-3.005L12.6 3.3a.75.75 0 0 0-1.2 0L7.125 9H4.12a1.527 1.527 0 0 0-1.53 1.52c0 .144.02.286.062.423l2.17 7.647a2.377 2.377 0 0 0 2.289 1.73h9.779a2.4 2.4 0 0 0 2.296-1.728l2.172-7.657a.74.74 0 0 0 .022-.111l.025-.231a.63.63 0 0 0 .004-.073A1.527 1.527 0 0 0 19.88 9ZM12 5l3 4H9l3-4Zm0 11.485a1.766 1.766 0 1 1 1.776-1.768A1.775 1.775 0 0 1 12 16.483v.002Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBasketball = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12 10.94 1.615-1.616a9.707 9.707 0 0 1-2.324-7.043 9.707 9.707 0 0 0-5.635 2.313L12 10.939ZM14.678 8.26l3.666-3.666a9.707 9.707 0 0 0-5.547-2.306 8.215 8.215 0 0 0 1.881 5.973ZM15.74 9.322a8.215 8.215 0 0 0 5.972 1.883 9.706 9.706 0 0 0-2.306-5.549L15.74 9.322ZM8.26 14.678a8.214 8.214 0 0 0-5.973-1.883 9.706 9.706 0 0 0 2.307 5.548l3.667-3.665ZM12 13.06l-1.615 1.616a9.706 9.706 0 0 1 2.324 7.043 9.706 9.706 0 0 0 5.635-2.313L12 13.061ZM21.015 12.735a9.707 9.707 0 0 1-6.34-2.35L13.062 12l6.345 6.344a9.708 9.708 0 0 0 2.315-5.635c-.234.017-.47.026-.706.026ZM10.94 12 4.593 5.656a9.706 9.706 0 0 0-2.315 5.635 9.707 9.707 0 0 1 7.043 2.324L10.939 12ZM5.656 19.406a9.706 9.706 0 0 0 5.547 2.306A8.214 8.214 0 0 0 9.32 15.74l-3.664 3.667Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBatteryCharging = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.108V8.892A1.394 1.394 0 0 1 3.642 7.5h6.443L11.228 6H3.642A2.895 2.895 0 0 0 .75 8.892v6.216A2.895 2.895 0 0 0 3.642 18h4.54c-.015-.114-.01-.23.012-.343l.007-.035.01-.035.305-1.087H3.642a1.394 1.394 0 0 1-1.392-1.392ZM18.108 6h-4.624c.014.112.01.226-.013.338l-.007.034-.01.034-.306 1.094h4.96A1.394 1.394 0 0 1 19.5 8.892v6.216a1.394 1.394 0 0 1-1.392 1.392h-6.53L10.434 18h7.674A2.896 2.896 0 0 0 21 15.108V8.892A2.895 2.895 0 0 0 18.108 6Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.624 13.789a1.143 1.143 0 0 1-1.01-.61 1.172 1.172 0 0 1 .066-1.21l.015-.022.015-.02 2.553-3.349H4.204a.938.938 0 0 0-.937.938v4.968a.938.938 0 0 0 .937.938h4.614l.458-1.634H7.624Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.94 13.167 1.27-1.664a.243.243 0 0 0-.055-.325.2.2 0 0 0-.114-.035h-2.888l.568-2.026.152-.539.29-1.039.024-.086.366-1.301a.171.171 0 0 0 .002-.026v-.008c0-.002 0-.012-.002-.017-.003-.006 0-.005 0-.007a.106.106 0 0 0-.02-.04l-.005-.004a.135.135 0 0 0-.011-.01l-.005-.005a.093.093 0 0 0-.038-.018h-.048a.087.087 0 0 0-.02.008l-.006.003-.014.01-.005.005a.11.11 0 0 0-.017.019l-.844 1.107-.616.808-.462.601-2.986 3.916a.268.268 0 0 0-.037.089.22.22 0 0 0-.004.06.228.228 0 0 0 .094.174.203.203 0 0 0 .114.035h2.888L9.113 17.84v.034a.11.11 0 0 0 .003.018v.006a.102.102 0 0 0 .008.021.162.162 0 0 0 .012.018l.005.005.011.011a.1.1 0 0 0 .042.021h.007a.1.1 0 0 0 .015 0h.006a.115.115 0 0 0 .021-.003.101.101 0 0 0 .02-.007l.006-.003.014-.01.005-.005a.111.111 0 0 0 .017-.019l1.093-1.427.822-1.078 1.72-2.255Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m14.977 12.044-.022.028-2.556 3.35h5.147a.938.938 0 0 0 .937-.938V9.516a.938.938 0 0 0-.937-.938h-4.7l-.457 1.628h1.652a1.142 1.142 0 0 1 1.006.599A1.183 1.183 0 0 1 15 12.014l-.023.03ZM22.5 9.5a.75.75 0 0 0-.75.75v3.5a.75.75 0 1 0 1.5 0v-3.5a.75.75 0 0 0-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBatteryDead = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.595 7.5c-.769 0-1.392.623-1.392 1.392v6.216c0 .769.623 1.392 1.392 1.392h14.466c.769 0 1.392-.623 1.392-1.392V8.892c0-.769-.623-1.392-1.392-1.392H3.595ZM.703 8.892A2.892 2.892 0 0 1 3.595 6h14.466a2.892 2.892 0 0 1 2.892 2.892v6.216A2.892 2.892 0 0 1 18.061 18H3.595a2.892 2.892 0 0 1-2.892-2.892V8.892ZM22.453 9.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 1 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBatteryFull = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.642 7.5c-.769 0-1.392.623-1.392 1.392v6.216c0 .769.623 1.392 1.392 1.392h14.466c.769 0 1.392-.623 1.392-1.392V8.892c0-.769-.623-1.392-1.392-1.392H3.642ZM.75 8.892A2.892 2.892 0 0 1 3.642 6h14.466A2.892 2.892 0 0 1 21 8.892v6.216A2.892 2.892 0 0 1 18.108 18H3.642A2.892 2.892 0 0 1 .75 15.108V8.892Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.546 9.325H4.204a.187.187 0 0 0-.187.187v4.976c0 .103.084.187.187.187h13.342a.188.188 0 0 0 .188-.188V9.513a.188.188 0 0 0-.188-.187Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.767 10.075v3.85h12.217v-3.85H4.767Zm-1.5-.563c0-.518.42-.937.937-.937h13.342c.518 0 .938.42.938.937v4.976c0 .517-.42.937-.938.937H4.204a.938.938 0 0 1-.937-.938V9.513ZM22.5 9.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 1 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBatteryHalf = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.642 7.5c-.769 0-1.392.623-1.392 1.392v6.216c0 .769.623 1.392 1.392 1.392h14.466c.769 0 1.392-.623 1.392-1.392V8.892c0-.769-.623-1.392-1.392-1.392H3.642ZM.75 8.892A2.892 2.892 0 0 1 3.642 6h14.466A2.892 2.892 0 0 1 21 8.892v6.216A2.892 2.892 0 0 1 18.108 18H3.642A2.892 2.892 0 0 1 .75 15.108V8.892Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.063 9.325H4.204a.187.187 0 0 0-.187.187v4.975c0 .104.084.188.187.188h6.859a.188.188 0 0 0 .187-.188V9.512a.187.187 0 0 0-.188-.187Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.767 10.075v3.85H10.5v-3.85H4.767Zm-1.5-.563c0-.518.42-.937.937-.937h6.859c.517 0 .937.42.937.937v4.975c0 .518-.42.938-.938.938H4.205a.937.937 0 0 1-.937-.938V9.512ZM22.5 9.5a.75.75 0 0 1 .75.75v3.5a.75.75 0 1 1-1.5 0v-3.5a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBeaker = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.813 1.5H6c-.908 0-2.152.203-3.005 1.161-.55.616-.745 1.354-.745 1.839a.75.75 0 0 0 .647.743c1.401.194 1.603.278 1.603 1.132V18.75a3.753 3.753 0 0 0 3.75 3.75h9A3.755 3.755 0 0 0 21 18.75V4.5c0-.588.35-1.277.469-1.47l.004-.007c.01-.016.024-.033.037-.051.094-.13.239-.328.239-.607.001-.5-.426-.865-.936-.865ZM3.942 3.894c.245-.415.804-.89 2.076-.89H19.82c-.165.412-.32.946-.32 1.496v3H6V6.375c0-1.75-1-2.257-2.057-2.48Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBed = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 10.814a3.724 3.724 0 0 0-1.5-.314H5.25a3.754 3.754 0 0 0-3.75 3.75v5.25a.75.75 0 1 0 1.5 0v-.375a.38.38 0 0 1 .375-.375h17.25a.38.38 0 0 1 .375.375v.375a.75.75 0 1 0 1.5 0v-5.25a3.754 3.754 0 0 0-2.25-3.436ZM17.625 3.75H6.375A2.625 2.625 0 0 0 3.75 6.375V9.75a.187.187 0 0 0 .24.18c.409-.12.833-.18 1.26-.18h.198a.188.188 0 0 0 .188-.166A1.5 1.5 0 0 1 7.125 8.25H9.75a1.5 1.5 0 0 1 1.49 1.334.188.188 0 0 0 .188.166h1.147a.187.187 0 0 0 .187-.166A1.5 1.5 0 0 1 14.25 8.25h2.625a1.5 1.5 0 0 1 1.49 1.334.188.188 0 0 0 .188.166h.197c.427 0 .851.06 1.26.18a.188.188 0 0 0 .24-.18V6.375a2.625 2.625 0 0 0-2.625-2.625Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBeer = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 9.75H17.25v-.27a2.997 2.997 0 0 0-2.173-4.98 5.204 5.204 0 0 0-2.967-3.355A5.092 5.092 0 0 0 10.125.75c-1.402 0-2.708.575-3.703 1.625A2.625 2.625 0 0 0 3.257 6.01a2.996 2.996 0 0 0 .493 4.836v9.779a2.628 2.628 0 0 0 2.625 2.625h8.25a2.628 2.628 0 0 0 2.625-2.625v-.375h1.125a3.378 3.378 0 0 0 3.375-3.375v-3.75a3.378 3.378 0 0 0-3.375-3.375ZM8.25 19.5a.75.75 0 1 1-1.5 0V12a.75.75 0 0 1 1.5 0v7.5Zm3 0a.75.75 0 1 1-1.5 0V12a.75.75 0 0 1 1.5 0v7.5Zm3 0a.75.75 0 1 1-1.5 0V12a.75.75 0 0 1 1.5 0v7.5ZM15 9c-.39 0-.963-.243-1.251-.53a.75.75 0 0 0-.53-.22h-5.72a.75.75 0 0 0-.702.493C6.477 9.62 5.69 9.75 5.25 9.75a1.5 1.5 0 0 1 0-3c.004 0 .427.016.769.272a.75.75 0 0 0 .9-1.2 2.985 2.985 0 0 0-1.67-.572c-.22 0-.44.025-.655.073a1.125 1.125 0 0 1 1.94-1.112c.084.117.158.24.22.37A.75.75 0 0 0 8.25 4.5c0-.317-.17-.711-.504-1.172-.022-.03-.047-.059-.068-.087.684-.642 1.54-.991 2.447-.991a3.603 3.603 0 0 1 2.589 1.086 3.76 3.76 0 0 1 1.002 3.32.749.749 0 0 0 1.473.28c.057-.3.088-.604.092-.91A1.5 1.5 0 0 1 15 9Zm5.25 7.875a1.875 1.875 0 0 1-1.875 1.875H17.25v-7.5h1.125a1.875 1.875 0 0 1 1.875 1.875v3.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBicycle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.188 21a4.312 4.312 0 1 1 0-8.625 4.312 4.312 0 0 1 0 8.625Zm0-7.125a2.813 2.813 0 1 0 0 5.625 2.813 2.813 0 0 0 0-5.625ZM5.812 21a4.312 4.312 0 1 1 0-8.624 4.312 4.312 0 0 1 0 8.624Zm0-7.125a2.813 2.813 0 1 0 0 5.626 2.813 2.813 0 0 0 0-5.626ZM15 6a1.495 1.495 0 0 0 1.5-1.505A1.478 1.478 0 0 0 15.01 3 1.5 1.5 0 1 0 15 6Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.229 9h-2.051a.188.188 0 0 1-.165-.098l-1.488-2.726a1.453 1.453 0 0 0-2.314-.364l-3.275 3.3c-.275.281-.431.657-.436 1.05 0 .816.59 1.107.867 1.27a149.1 149.1 0 0 1 2.793 1.646.188.188 0 0 1 .09.16v3.24c0 .403.31.75.714.77a.75.75 0 0 0 .786-.748v-4.031a.75.75 0 0 0-.312-.61l-1.735-1.247a.189.189 0 0 1-.068-.213.188.188 0 0 1 .041-.068l1.969-2.1a.188.188 0 0 1 .3.037l1.024 1.846a.75.75 0 0 0 .656.386h2.625a.749.749 0 0 0 .75-.786.765.765 0 0 0-.771-.714Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBluetooth = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.188 7.536a.938.938 0 0 0-.275-.699l-5.25-5.25a.938.938 0 0 0-1.6.663v7.712L7.358 6.788a.938.938 0 0 0-1.218 1.424L10.559 12l-4.418 3.788a.937.937 0 1 0 1.218 1.424l3.704-3.174v7.712a.938.938 0 0 0 1.6.663l5.25-5.25a.938.938 0 0 0-.054-1.375L13.44 12l4.42-3.788a.939.939 0 0 0 .328-.676Zm-2.317 9.017-2.934 2.934v-5.448l2.934 2.514Zm-2.934-6.591V4.513l2.934 2.934-2.934 2.515Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBoat = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22.178a.32.32 0 0 0-.167-.28c-1.27-.683-2.427-1.727-2.936-2.25a.47.47 0 0 0-.596-.072c-2.36 1.52-5.232 1.521-7.591.003a.473.473 0 0 0-.601.073c-.505.529-1.65 1.56-2.927 2.238a.333.333 0 0 0-.182.269.315.315 0 0 0 .371.335c.978-.196 1.922-.641 2.822-1.117a.408.408 0 0 1 .375-.003 8.678 8.678 0 0 0 7.866 0 .414.414 0 0 1 .38.003c.895.469 1.838.918 2.812 1.116a.316.316 0 0 0 .375-.315H19.5ZM22.346 11.574c-.164-.393-.511-.698-.98-.86l-1.116-.445V6.375a3 3 0 0 0-3-3h-1.5V3a1.875 1.875 0 0 0-1.875-1.875h-3.75A1.875 1.875 0 0 0 8.25 3v.375h-1.5a3 3 0 0 0-3 3v3.898l-1.105.44c-.466.155-.827.469-.992.864-.115.276-.246.703-.06 1.24l.004.015 2.187 5.598a1.094 1.094 0 0 0 1.024.695c.024 0 .047 0 .072-.002 1.468-.094 2.625-.81 3.403-1.482 1.112.96 2.419 1.484 3.717 1.484s2.598-.525 3.71-1.486c.777.673 1.936 1.39 3.403 1.484a1.095 1.095 0 0 0 1.096-.691l2.186-5.578c.154-.38.136-.833-.05-1.28Zm-9.737-4.345-.053-.02a1.853 1.853 0 0 0-1.112 0l-.028.01-5.91 2.354a.187.187 0 0 1-.256-.175V6.375a1.5 1.5 0 0 1 1.5-1.5h10.5a1.5 1.5 0 0 1 1.5 1.5v3.02a.187.187 0 0 1-.257.175L12.61 7.229Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBody = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#body_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25A2.625 2.625 0 1 0 12 0a2.625 2.625 0 0 0 0 5.25ZM20.484 6H3.516a1.266 1.266 0 1 0 0 2.531H8.29c.324 0 .703.145.918.703.25.648.128 1.9-.027 2.87L8.98 13.25a.02.02 0 0 1-.006.017l-1.622 9.225a1.286 1.286 0 0 0 1.039 1.488 1.27 1.27 0 0 0 1.472-1.045l1.121-6.412S11.344 15 12 15c.667 0 1.02 1.523 1.02 1.523l1.12 6.418a1.28 1.28 0 0 0 1.485 1.053 1.278 1.278 0 0 0 1.028-1.503l-1.622-9.226a.022.022 0 0 0-.005-.016l-.203-1.146c-.155-.97-.278-2.222-.027-2.87.214-.557.605-.703.904-.703h4.784a1.266 1.266 0 0 0 0-2.532V6Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "body_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgBonfire = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.815 17.267a.862.862 0 0 0-.87-.77.873.873 0 0 0-.853.66l-.853 4.141c-.028.12-.043.245-.044.369 0 .934.782 1.583 1.75 1.583s1.75-.649 1.75-1.583c0-.15-.02-.299-.06-.443l-.82-3.957ZM19.268 19.12a2 2 0 0 0-.279-.205l-3.26-2.275c-.316-.198-.655-.193-.901.047a.633.633 0 0 0-.094.806l2.46 3.235c.057.078.12.151.188.22.427.476 1.373.502 1.893 0 .512-.514.506-1.425-.007-1.828ZM21.717 15.747h-3.3c-.214 0-.417.157-.417.382s.138.367.324.429l3.114.963c.453.104 1.062-.297 1.062-.8 0-.64-.356-.974-.783-.974ZM6.01 16.129c0-.232-.213-.382-.443-.382h-3.3c-.416 0-.767.449-.767.952 0 .503.592.926 1.045.822l3.161-.963c.206-.061.304-.199.304-.43ZM8.276 16.643l-3.26 2.267a1.512 1.512 0 0 0-.282.203 1.234 1.234 0 0 0 0 1.808 1.379 1.379 0 0 0 2.08-.22l2.463-3.216a.614.614 0 0 0-.094-.797.703.703 0 0 0-.907-.045ZM13.756 11.362c.469-.254.912-.494 1.327-.758C17.073 9.343 18 7.84 18 5.87 18 2.84 15.372.976 12.899.76c-.304-.026-.703-.019-.933.183-.23.201-.276.588-.288.895-.065 1.575-1.33 2.765-2.672 4.025-1.313 1.232-2.669 2.507-2.94 4.265-.394 2.563 1.02 4.065 1.897 4.731a1.494 1.494 0 0 0 1.84-.02c.172-.138.312-.312.409-.51.699-1.424 2.145-2.209 3.544-2.967Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.554 7.339c.573-.739 1.266-1.391 1.94-2.023.933-.877 1.772-1.667 2.179-2.524-.574-.346-1.283-.533-2.18-.533-.834 0-.956.243-.956.894 0 .588-.306.962-.672 1.436C6.459 5.114 6 5.708 6 6.602c0 .48.06.88.197 1.236.11-.166.228-.333.357-.499ZM15.485 11.238c-.438.277-.89.523-1.371.783-1.356.735-2.635 1.429-3.23 2.638-.03.062-.058.117-.087.17a.374.374 0 0 0 .182.529c.577.239 1.178.388 1.824.388a5.223 5.223 0 0 0 3.668-1.47A5.037 5.037 0 0 0 18 10.632c0-.235-.021-.47-.062-.703a.375.375 0 0 0-.647-.187c-.477.537-1.075 1.031-1.806 1.495Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBook = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.48 3.469C7.786 2.66 5.42 2.264 2.25 2.25a1.47 1.47 0 0 0-1.325.79 1.5 1.5 0 0 0-.175.705v13.411c0 .907.645 1.59 1.5 1.59 3.331 0 6.673.312 8.675 2.204a.193.193 0 0 0 .325-.14V5.006a.744.744 0 0 0-.256-.562 6.704 6.704 0 0 0-1.514-.976ZM22.59 2.498a1.469 1.469 0 0 0-.84-.248c-3.17.014-5.536.408-7.23 1.219a6.716 6.716 0 0 0-1.514.974.747.747 0 0 0-.256.562v15.803a.185.185 0 0 0 .313.132c1.203-1.196 3.315-2.195 8.689-2.194a1.5 1.5 0 0 0 1.5-1.5v-13.5a1.501 1.501 0 0 0-.662-1.248Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBookmark = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 22.5a.75.75 0 0 1-.498-.188L12 16.755l-6.252 5.558A.75.75 0 0 1 4.5 21.75V4.5a3.003 3.003 0 0 1 3-3h9a3.003 3.003 0 0 1 3 3v17.25a.75.75 0 0 1-.75.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBookmarks = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bookmarks_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 0H8.25a3.005 3.005 0 0 0-2.906 2.25H16.03A3.469 3.469 0 0 1 19.5 5.719V20.01l1.031.825a.75.75 0 0 0 1.219-.605V3a3 3 0 0 0-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 3.75H5.25a3 3 0 0 0-3 3v16.482a.767.767 0 0 0 .31.627.75.75 0 0 0 .923-.033l6.642-5.595 6.642 5.593A.75.75 0 0 0 18 23.23V6.75a3 3 0 0 0-3-3Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bookmarks_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgBriefcase = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 8.25a3.003 3.003 0 0 0-3-3H18V4.5a2.252 2.252 0 0 0-2.25-2.25h-7.5A2.252 2.252 0 0 0 6 4.5v.75H3.75a3.003 3.003 0 0 0-3 3v2.25h22.5V8.25Zm-6.75-3h-9V4.5a.75.75 0 0 1 .75-.75h7.5a.75.75 0 0 1 .75.75v.75ZM15.75 12.375a1.125 1.125 0 0 1-1.125 1.125h-5.25a1.125 1.125 0 0 1-1.125-1.125v-.188A.188.188 0 0 0 8.062 12H.75v6.75a3 3 0 0 0 3 3h16.5a3 3 0 0 0 3-3V12h-7.313a.188.188 0 0 0-.187.188v.187Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBrowsers = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 2.25h-15a3 3 0 0 0-3 3v13.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V5.25a3 3 0 0 0-3-3Zm1.125 4.5H3.375A.375.375 0 0 1 3 6.375V5.25a1.504 1.504 0 0 1 1.5-1.5h15a1.504 1.504 0 0 1 1.5 1.5v1.125a.375.375 0 0 1-.375.375Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBrush = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.929 16.88a.75.75 0 0 1-.742-.645c-.101-.704-.936-1.522-1.717-1.68a.75.75 0 0 1-.407-1.235L17.957 2.3a2.652 2.652 0 0 1 3.773-.03 2.65 2.65 0 0 1 .005 3.74L11.47 16.65a.751.751 0 0 1-.541.23ZM5.62 22.505c-1.507 0-3.068-.792-3.977-2.016a.75.75 0 0 1 .602-1.197c.25 0 .937-.228.937-.964 0-1.831 1.472-3.322 3.282-3.322 1.809 0 3.28 1.49 3.28 3.322 0 2.303-1.85 4.177-4.124 4.177Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBug = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.729 12.756H18.75v-2.26c0-.134-.004-.267-.013-.396 1.387-1.307 1.512-3.03 1.513-4.828a.764.764 0 0 0-.715-.77.75.75 0 0 0-.785.748c0 1.313-.087 2.257-.464 2.992-.9-1.928-3.083-2.995-6.286-2.995-1.866 0-3.478.428-4.66 1.237a4.724 4.724 0 0 0-1.58 1.768c-.416-.722-.51-1.643-.51-2.98 0-.404-.31-.75-.712-.771a.75.75 0 0 0-.788.749c0 1.764.122 3.456 1.52 4.764-.013.158-.02.319-.02.483v2.26H2.271c-.403 0-.75.31-.77.713a.75.75 0 0 0 .75.786h3V15c0 .862.165 1.717.487 2.517-1.203 1.076-1.98 2.264-1.988 4.202 0 .41.31.764.72.78a.748.748 0 0 0 .78-.749c0-1.297.427-2.096 1.227-2.874a6.767 6.767 0 0 0 3.836 2.66.75.75 0 0 0 .937-.727V9.021c0-.404.31-.75.714-.77A.75.75 0 0 1 12.75 9v11.81a.75.75 0 0 0 .938.725 6.768 6.768 0 0 0 3.835-2.66c.797.776 1.223 1.572 1.227 2.858a.762.762 0 0 0 .707.767.75.75 0 0 0 .793-.75c0-1.954-.778-3.151-1.987-4.233A6.72 6.72 0 0 0 18.75 15v-.744h3a.751.751 0 0 0 .75-.786.765.765 0 0 0-.771-.714Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.065 4.875.015.004c.636.178 1.175-.494.853-1.07A4.492 4.492 0 0 0 12.01 1.5h-.02a4.494 4.494 0 0 0-3.946 2.35c-.32.59.24 1.265.883 1.071.924-.28 1.959-.424 3.073-.424 1.13 0 2.16.127 3.065.378Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBuild = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.01 5.65a.75.75 0 0 0-1.198-.188l-2.88 2.882a.756.756 0 0 1-1.06 0l-1.245-1.247a.75.75 0 0 1 0-1.06l2.867-2.869a.75.75 0 0 0-.224-1.215c-2.166-.968-4.87-.463-6.574 1.229-1.449 1.438-1.88 3.685-1.184 6.165a.744.744 0 0 1-.21.75l-7.804 7.128a3.008 3.008 0 1 0 4.247 4.249l7.203-7.822a.745.745 0 0 1 .74-.214 8.41 8.41 0 0 0 2.166.299c1.566 0 2.94-.507 3.93-1.483C22.62 10.446 22.9 7.379 22.01 5.65ZM4.663 20.96a1.5 1.5 0 1 1-.325-2.982 1.5 1.5 0 0 1 .325 2.982Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBulb = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 21.75h-3a.75.75 0 1 0 0 1.5h3a.75.75 0 1 0 0-1.5ZM14.25 19.5h-4.5a.75.75 0 1 0 0 1.5h4.5a.75.75 0 1 0 0-1.5ZM17.317 2.939A7.457 7.457 0 0 0 12 .75a7.482 7.482 0 0 0-7.5 7.5c0 2.185.838 4.23 2.297 5.608L7 14.05C7.845 14.84 9 15.92 9 16.875V18a.75.75 0 0 0 .75.75h1.125a.375.375 0 0 0 .375-.375v-5.493a.375.375 0 0 0-.24-.35 6.127 6.127 0 0 1-1.227-.673.751.751 0 0 1 .3-1.374.75.75 0 0 1 .571.156c.347.245 1.015.609 1.346.609.331 0 .999-.365 1.347-.61a.75.75 0 0 1 .87 1.22c-.382.27-.793.494-1.226.67a.376.376 0 0 0-.241.35v5.495a.375.375 0 0 0 .375.375h1.125A.75.75 0 0 0 15 18v-1.125c0-.932 1.142-2.012 1.976-2.802l.23-.218c1.5-1.433 2.294-3.373 2.294-5.605a7.46 7.46 0 0 0-2.183-5.311Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBus = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 1.5H5.25A2.25 2.25 0 0 0 3 3.75v15a2.246 2.246 0 0 0 .75 1.675v.856A1.219 1.219 0 0 0 4.969 22.5H6.28A1.219 1.219 0 0 0 7.5 21.281V21h9v.281a1.218 1.218 0 0 0 1.219 1.219h1.312a1.218 1.218 0 0 0 1.219-1.219v-.856A2.247 2.247 0 0 0 21 18.75v-15a2.25 2.25 0 0 0-2.25-2.25ZM6.913 18.742a1.5 1.5 0 1 1-.325-2.983 1.5 1.5 0 0 1 .325 2.983Zm4.15-5.242H5.25a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 5.25 6h5.813a.188.188 0 0 1 .187.188v7.125a.188.188 0 0 1-.188.187Zm.937-9H5.272a.765.765 0 0 1-.771-.712A.75.75 0 0 1 5.25 3h13.478c.404 0 .75.31.771.712a.75.75 0 0 1-.749.788H12Zm.938 1.5h5.812a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-5.813a.188.188 0 0 1-.187-.188V6.189A.188.188 0 0 1 12.938 6Zm2.82 11.413a1.5 1.5 0 1 1 2.982-.325 1.5 1.5 0 0 1-2.982.325Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgBusiness = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 8.25H15V3A2.25 2.25 0 0 0 12.75.75h-9A2.25 2.25 0 0 0 1.5 3v19.5a.75.75 0 0 0 .75.75h4.875a.375.375 0 0 0 .375-.375v-3.354c0-.404.31-.75.714-.77A.752.752 0 0 1 9 19.5v3.375a.375.375 0 0 0 .375.375H21.75a.75.75 0 0 0 .75-.75v-12a2.25 2.25 0 0 0-2.25-2.25ZM4.598 20.244a.75.75 0 1 1-.195-1.488.75.75 0 0 1 .195 1.488Zm0-3.75a.75.75 0 1 1-.195-1.488.75.75 0 0 1 .195 1.488Zm0-3.75a.75.75 0 1 1-.195-1.488.75.75 0 0 1 .195 1.488Zm0-3.75a.75.75 0 1 1-.195-1.487.75.75 0 0 1 .195 1.487Zm0-3.75a.75.75 0 1 1-.195-1.487.75.75 0 0 1 .195 1.487Zm3.75 11.25a.75.75 0 1 1-.195-1.488.75.75 0 0 1 .194 1.488Zm0-3.75a.75.75 0 1 1-.195-1.488.75.75 0 0 1 .194 1.488Zm0-3.75a.75.75 0 1 1-.195-1.487.75.75 0 0 1 .194 1.487Zm0-3.75a.75.75 0 1 1-.195-1.487.75.75 0 0 1 .194 1.487Zm3.75 15a.75.75 0 1 1-.195-1.488.75.75 0 0 1 .194 1.488Zm0-3.75a.75.75 0 1 1-.195-1.488.75.75 0 0 1 .194 1.488Zm0-3.75a.75.75 0 1 1-.195-1.488.75.75 0 0 1 .194 1.488Zm0-3.75a.75.75 0 1 1-.195-1.487.75.75 0 0 1 .194 1.487Zm0-3.75a.75.75 0 1 1-.195-1.487.75.75 0 0 1 .194 1.487Zm8.714 16.506H15v-12h5.25a.75.75 0 0 1 .75.75v11.063a.188.188 0 0 1-.188.187Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM18.75 15a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM18.75 11.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM15.75 18.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM15.75 15a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5ZM15.75 11.25a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCafe = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3H4.5a.75.75 0 0 0-.75.75v9a4.505 4.505 0 0 0 4.5 4.5h5.25a4.505 4.505 0 0 0 4.5-4.5V9h.844a2.91 2.91 0 0 0 2.906-2.906V4.5a1.5 1.5 0 0 0-1.5-1.5Zm0 3.094A1.406 1.406 0 0 1 18.844 7.5H18v-3h2.25v1.594ZM18.75 18.75H3a.75.75 0 1 0 0 1.5h15.75a.75.75 0 1 0 0-1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCalculator = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3.75a2.252 2.252 0 0 0-2.25-2.25H6.75A2.252 2.252 0 0 0 4.5 3.75v16.5a2.252 2.252 0 0 0 2.25 2.25h10.5a2.252 2.252 0 0 0 2.25-2.25V3.75ZM7.875 20.25a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Zm0-3.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Zm0-3.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25ZM12 20.25A1.125 1.125 0 1 1 12 18a1.125 1.125 0 0 1 0 2.25Zm0-3.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Zm0-3.75a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Zm5.25 6.375a1.125 1.125 0 1 1-2.25 0v-3.75a1.125 1.125 0 1 1 2.25 0v3.75Zm-1.125-6.375a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Zm.905-4.72a.75.75 0 0 1-.53.22h-9a.75.75 0 0 1-.75-.75v-3a.75.75 0 0 1 .75-.75h9a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-.22.53Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCalendarClear = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6a3 3 0 0 0-3-3h-.75v-.729c0-.404-.31-.75-.714-.77a.75.75 0 0 0-.786.749V3H6.75v-.729c0-.404-.31-.75-.714-.77a.75.75 0 0 0-.786.749V3H4.5a3 3 0 0 0-3 3v.563a.187.187 0 0 0 .188.187h20.625a.188.188 0 0 0 .187-.188V6ZM1.5 19.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.437a.188.188 0 0 0-.188-.187H1.688a.187.187 0 0 0-.187.188V19.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCalendar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 6a3 3 0 0 0-3-3h-.75v-.729c0-.404-.31-.75-.714-.77a.75.75 0 0 0-.786.749V3H6.75v-.729c0-.404-.31-.75-.714-.77a.75.75 0 0 0-.786.749V3H4.5a3 3 0 0 0-3 3v.563a.187.187 0 0 0 .188.187h20.625a.188.188 0 0 0 .187-.188V6ZM1.5 19.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.39a.14.14 0 0 0-.14-.14H1.64a.14.14 0 0 0-.14.14V19.5Zm16.125-9.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm0 3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm-3.75-3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm0 3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm0 3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm-3.75-3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm0 3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm-3.75-3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm0 3.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCall = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.328 22.5c-.915 0-2.2-.33-4.125-1.406-2.34-1.313-4.15-2.524-6.478-4.846-2.245-2.243-3.337-3.695-4.866-6.477-1.726-3.14-1.432-4.787-1.103-5.49.392-.841.97-1.344 1.718-1.844a8.265 8.265 0 0 1 1.342-.712l.13-.057c.232-.104.583-.262 1.029-.093.297.111.562.34.978.75.851.84 2.015 2.71 2.445 3.629.288.62.479 1.028.48 1.486 0 .537-.27.951-.599 1.398-.061.084-.122.164-.181.242-.357.468-.435.604-.383.846.104.486.884 1.933 2.165 3.211 1.28 1.278 2.686 2.009 3.174 2.113.252.054.39-.028.874-.397.07-.053.14-.108.215-.163.5-.372.895-.634 1.419-.634h.003c.456 0 .846.197 1.493.524.844.425 2.77 1.574 3.616 2.427.411.414.64.678.752.975.17.447.01.797-.093 1.031l-.057.13a8.278 8.278 0 0 1-.717 1.339c-.498.745-1.003 1.322-1.846 1.715a3.16 3.16 0 0 1-1.385.303Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCameraReverse = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 6.75h-2.766c-.14 0-.315-.09-.45-.234l-1.216-1.92a.727.727 0 0 0-.065-.086c-.42-.49-.987-.76-1.597-.76H9.844c-.61 0-1.177.27-1.597.76a.729.729 0 0 0-.065.087L6.967 6.518c-.104.114-.25.235-.404.235v-.375a.75.75 0 0 0-.75-.75H4.688a.75.75 0 0 0-.75.75v.375H3.75a2.252 2.252 0 0 0-2.25 2.25V18a2.252 2.252 0 0 0 2.25 2.25h16.5A2.252 2.252 0 0 0 22.5 18V9a2.252 2.252 0 0 0-2.25-2.25Zm-5.398 9.483a4.502 4.502 0 0 1-7.297-2.774.75.75 0 0 1-.773-1.24l.938-.937a.75.75 0 0 1 1.06 0l.938.938a.75.75 0 0 1-.624 1.273 3.003 3.003 0 0 0 4.812 1.577.75.75 0 1 1 .947 1.163h-.001Zm2.366-2.953-.938.937a.75.75 0 0 1-1.06 0l-.938-.937a.75.75 0 0 1 .614-1.275 3 3 0 0 0-4.818-1.569.75.75 0 1 1-.956-1.155 4.5 4.5 0 0 1 7.313 2.766.75.75 0 0 1 .784 1.235l-.001-.002Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCamera = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 15.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 6.75h-2.766c-.14 0-.315-.09-.45-.234l-1.216-1.92a.727.727 0 0 0-.065-.086c-.42-.49-.987-.76-1.597-.76H9.844c-.61 0-1.177.27-1.597.76a.729.729 0 0 0-.065.087L6.967 6.518c-.104.114-.25.235-.404.235v-.375a.75.75 0 0 0-.75-.75H4.688a.75.75 0 0 0-.75.75v.375H3.75a2.252 2.252 0 0 0-2.25 2.25V18a2.252 2.252 0 0 0 2.25 2.25h16.5A2.252 2.252 0 0 0 22.5 18V9a2.252 2.252 0 0 0-2.25-2.25ZM12 17.25a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCarSport = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.168 12.948c-.168-1.894-.446-2.263-.551-2.402-.242-.32-.628-.53-1.037-.75a.169.169 0 0 1-.042-.266.747.747 0 0 0-.036-1.083.763.763 0 0 0-.518-.197h-.732a.798.798 0 0 0-.093.006.401.401 0 0 0-.066-.022c-.434-.915-1.027-2.169-2.256-2.78C16.014 4.546 12.657 4.5 12 4.5c-.656 0-4.014.047-5.835.952-1.23.612-1.822 1.865-2.255 2.78l-.004.008a.305.305 0 0 0-.063.016.798.798 0 0 0-.094-.006h-.733a.763.763 0 0 0-.766.692.747.747 0 0 0 .215.585.169.169 0 0 1-.043.266c-.408.221-.796.43-1.036.75-.105.14-.382.508-.552 2.402-.093 1.066-.107 2.17-.034 2.88.154 1.477.444 2.37.456 2.406a.75.75 0 0 0 .619.51v.009a.75.75 0 0 0 .75.75H5.25a.75.75 0 0 0 .75-.75c.403 0 .684-.072.982-.15.43-.115.869-.192 1.312-.23A42.021 42.021 0 0 1 12 18.188c.836 0 2.321.047 3.754.184.445.037.886.114 1.317.23.285.074.556.142.93.149a.75.75 0 0 0 .75.75h2.625a.75.75 0 0 0 .75-.75v-.006a.75.75 0 0 0 .621-.51c.012-.037.301-.93.456-2.406.073-.71.06-1.812-.035-2.88ZM5.265 8.874c.375-.797.804-1.699 1.568-2.079 1.103-.55 3.39-.797 5.167-.797 1.777 0 4.064.246 5.167.797.764.38 1.19 1.283 1.567 2.079l.047.102a.375.375 0 0 1-.348.535c-1.558-.042-4.84-.177-6.433-.177-1.594 0-4.875.138-6.435.18a.375.375 0 0 1-.349-.535l.05-.105Zm.56 3.733c-.807.097-1.618.145-2.43.143-.497 0-1.01-.14-1.105-.583-.065-.298-.058-.465-.023-.633.03-.143.077-.247.311-.284.61-.094.95.024 1.948.318.661.194 1.138.454 1.41.659.137.101.064.365-.111.38Zm10.377 3.843c-.617.07-1.85.045-4.188.045-2.337 0-3.57.026-4.187-.045-.637-.07-1.448-.672-.894-1.209.369-.353 1.23-.617 2.375-.766 1.146-.149 1.632-.225 2.701-.225 1.07 0 1.506.047 2.701.226 1.196.178 2.099.446 2.376.766.505.574-.248 1.134-.884 1.211v-.003Zm5.508-4.284c-.094.445-.61.583-1.105.583-.827 0-1.654-.047-2.477-.143-.143-.014-.21-.265-.064-.38.267-.21.75-.464 1.41-.659.998-.294 1.573-.411 2.067-.313.12.024.184.153.192.234.033.226.025.456-.023.679Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.985 10.35a.747.747 0 0 0-.047-.145l-1.77-4.133c-.41-.955-1.402-1.572-2.532-1.572H7.364c-1.13 0-2.124.617-2.532 1.572L3.06 10.205A.737.737 0 0 0 3 10.5v8.25a.75.75 0 0 0 .75.75h1.5a.75.75 0 0 0 .75-.75V18h12v.75a.75.75 0 0 0 .75.75h1.5a.75.75 0 0 0 .75-.75V10.5a.756.756 0 0 0-.015-.15ZM6.75 15a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm10.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM4.887 9.75 6.21 6.663C6.38 6.267 6.844 6 7.365 6h9.27c.52 0 .985.267 1.154.663l1.324 3.087H4.887Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCard = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 17.625a2.625 2.625 0 0 0 2.625 2.625h15.75a2.625 2.625 0 0 0 2.625-2.625v-7.219h-21v7.219Zm3.094-3.563A1.406 1.406 0 0 1 6 12.656h2.25a1.406 1.406 0 0 1 1.406 1.406V15a1.406 1.406 0 0 1-1.406 1.406H6A1.406 1.406 0 0 1 4.594 15v-.938ZM19.875 3.75H4.125A2.625 2.625 0 0 0 1.5 6.375v1.219h21V6.375a2.625 2.625 0 0 0-2.625-2.625Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCaretBackCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12c0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75-5.385 0-9.75 4.365-9.75 9.75Zm11.813-3.475v6.95a.75.75 0 0 1-1.23.576l-4.176-3.474a.75.75 0 0 1 0-1.154l4.176-3.474a.75.75 0 0 1 1.23.576Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCaretBack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15.091 4.594-7.646 6.552a1.125 1.125 0 0 0 0 1.708l7.646 6.552c.73.625 1.857.107 1.857-.854V5.446c0-.961-1.127-1.48-1.857-.852Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCaretDownCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 12c0-5.385-4.366-9.75-9.75-9.75-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75Zm-5.699-.833-3.474 4.176a.75.75 0 0 1-1.154 0L7.95 11.167a.75.75 0 0 1 .576-1.23h6.95a.75.75 0 0 1 .576 1.23Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCaretDown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m4.594 8.91 6.552 7.645a1.125 1.125 0 0 0 1.708 0l6.552-7.646c.626-.73.107-1.857-.854-1.857H5.446c-.961 0-1.48 1.127-.852 1.857Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCaretForwardCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 12c0-5.385-4.366-9.75-9.75-9.75-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75ZM9.937 15.475v-6.95a.75.75 0 0 1 1.23-.576l4.176 3.474a.75.75 0 0 1 0 1.154l-4.176 3.474a.75.75 0 0 1-1.23-.576Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCaretForward = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m8.91 19.406 7.645-6.552a1.126 1.126 0 0 0 0-1.708L8.91 4.594c-.73-.626-1.857-.107-1.857.854v13.106c0 .96 1.127 1.48 1.857.852Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCaretUpCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75Zm3.475 11.813h-6.95a.75.75 0 0 1-.576-1.23l3.474-4.176a.75.75 0 0 1 1.154 0l3.474 4.176a.75.75 0 0 1-.576 1.23Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCaretUp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m19.406 15.091-6.552-7.646a1.125 1.125 0 0 0-1.708 0L4.594 15.09c-.626.73-.107 1.857.854 1.857h13.106c.961 0 1.48-1.127.852-1.857Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCart = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.25 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM18.75 21a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM21.413 5.662a1.121 1.121 0 0 0-.87-.412H6.276L5.99 3.62A.75.75 0 0 0 5.25 3h-3a.75.75 0 0 0 0 1.5h2.37l2.141 12.13a.75.75 0 0 0 .739.62h12a.75.75 0 1 0 0-1.5H8.13l-.265-1.5h11.328a1.128 1.128 0 0 0 1.104-.904l1.35-6.75a1.124 1.124 0 0 0-.234-.934Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCash = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 18.75H3a.75.75 0 1 1 0-1.5h18a.75.75 0 1 1 0 1.5ZM19.5 21h-15a.75.75 0 1 1 0-1.5h15a.75.75 0 1 1 0 1.5ZM1.5 12.75H.75V15a1.5 1.5 0 0 0 1.5 1.5H4.5v-.75a3.003 3.003 0 0 0-3-3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 11.25h.75v-3h-.75a4.505 4.505 0 0 1-4.5-4.5V3H6v.75a4.505 4.505 0 0 1-4.5 4.5H.75v3h.75a4.505 4.505 0 0 1 4.5 4.5v.75h12v-.75a4.505 4.505 0 0 1 4.5-4.5Zm-10.5 3a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM19.5 15.75v.75h2.25a1.5 1.5 0 0 0 1.5-1.5v-2.25h-.75a3.004 3.004 0 0 0-3 3ZM22.5 6.75h.75V4.5a1.5 1.5 0 0 0-1.5-1.5H19.5v.75a3.003 3.003 0 0 0 3 3ZM4.5 3.75V3H2.25a1.5 1.5 0 0 0-1.5 1.5v2.25h.75a3.003 3.003 0 0 0 3-3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCellular = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.125 20.25h-2.25a1.125 1.125 0 0 1-1.125-1.125V4.875a1.125 1.125 0 0 1 1.125-1.125h2.25a1.125 1.125 0 0 1 1.125 1.125v14.25a1.125 1.125 0 0 1-1.125 1.125ZM16.125 20.25h-2.25a1.125 1.125 0 0 1-1.125-1.125v-10.5A1.125 1.125 0 0 1 13.875 7.5h2.25a1.125 1.125 0 0 1 1.125 1.125v10.5a1.125 1.125 0 0 1-1.125 1.125ZM10.125 20.25h-2.25a1.125 1.125 0 0 1-1.125-1.125v-7.5A1.125 1.125 0 0 1 7.875 10.5h2.25a1.125 1.125 0 0 1 1.125 1.125v7.5a1.125 1.125 0 0 1-1.125 1.125ZM4.125 20.25h-2.25A1.125 1.125 0 0 1 .75 19.125v-4.5A1.125 1.125 0 0 1 1.875 13.5h2.25a1.125 1.125 0 0 1 1.125 1.125v4.5a1.125 1.125 0 0 1-1.125 1.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChatboxEllipses = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 2.25H4.875A3.379 3.379 0 0 0 1.5 5.625v9A3.379 3.379 0 0 0 4.875 18H6v3a.75.75 0 0 0 1.23.576L11.52 18h7.605a3.379 3.379 0 0 0 3.375-3.375v-9a3.379 3.379 0 0 0-3.375-3.375ZM7.5 11.625a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChatbox = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 21.75A.75.75 0 0 1 6 21v-3H4.875A3.379 3.379 0 0 1 1.5 14.625v-9A3.379 3.379 0 0 1 4.875 2.25h14.25A3.379 3.379 0 0 1 22.5 5.625v9A3.379 3.379 0 0 1 19.125 18h-7.606L7.23 21.576a.752.752 0 0 1-.48.174Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChatbubbleEllipses = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.656 3.836A10.66 10.66 0 0 0 11.992 1.5c-2.856 0-5.523 1.1-7.517 3.098C2.548 6.53 1.49 9.083 1.5 11.783c0 1.98.581 3.915 1.671 5.567l.009.012a2.656 2.656 0 0 0 .074.107l.01.019c.054.093.095.208.058.323l-.863 3.125A1.204 1.204 0 0 0 3.601 22.5a1.38 1.38 0 0 0 .49-.107l3.164-1.142.04-.016a.69.69 0 0 1 .523-.007c.076.03.766.294 1.493.497.605.169 1.863.422 2.849.422 2.796 0 5.407-1.083 7.351-3.05A10.332 10.332 0 0 0 22.5 11.79c0-.71-.075-1.417-.224-2.11-.485-2.279-1.77-4.355-3.62-5.843ZM7.5 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm4.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChatbubble = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.601 22.5a1.205 1.205 0 0 1-1.142-1.564l.863-3.123c.037-.116-.004-.232-.057-.324l-.01-.019-.035-.049-.04-.057-.009-.013A10.109 10.109 0 0 1 1.5 11.783c-.009-2.7 1.048-5.25 2.975-7.185C6.469 2.6 9.135 1.5 11.992 1.5a10.66 10.66 0 0 1 6.664 2.336 10.278 10.278 0 0 1 3.62 5.845c.149.693.224 1.4.224 2.109 0 2.762-1.062 5.357-2.99 7.306-1.944 1.97-4.555 3.05-7.35 3.05-.985 0-2.245-.251-2.85-.422-.727-.203-1.416-.469-1.492-.497a.71.71 0 0 0-.524.007l-.04.016-3.163 1.143a1.38 1.38 0 0 1-.49.107Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChatbubbles = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.833 18.242c0 .004 0 .01-.004.018l.004-.018ZM20.62 19.012a1.255 1.255 0 0 1-.45-.093l-2.66-.944-.02-.008a.482.482 0 0 0-.353-.005c-.065.025-.648.244-1.259.412-.331.09-1.485.387-2.41.387-2.367 0-4.58-.91-6.23-2.56a8.597 8.597 0 0 1-2.536-6.118c0-.593.063-1.183.19-1.762.412-1.904 1.503-3.636 3.073-4.875A9.13 9.13 0 0 1 13.608 1.5c2.447 0 4.728.937 6.422 2.633 1.6 1.607 2.478 3.719 2.471 5.947a8.337 8.337 0 0 1-1.42 4.648l-.009.013-.034.047c-.009.01-.016.021-.024.032l-.007.013a1.03 1.03 0 0 0-.05.098l.737 2.622a1.126 1.126 0 0 1-1.074 1.46Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.056 19.94a.739.739 0 0 0-.482-.38c-.27-.071-.587-.059-.828-.077a9.458 9.458 0 0 1-6.039-2.754 9.338 9.338 0 0 1-2.657-5.284c-.066-.457-.066-.57-.066-.57a.75.75 0 0 0-1.312-.496s-.37.402-.544.806a7.598 7.598 0 0 0 .516 7.034c.122.203.122.297.094.508L2.27 21.16a1.125 1.125 0 0 0 .375 1.074l.021.019c.202.16.452.247.709.247.145 0 .288-.028.422-.084l2.508-.968a.378.378 0 0 1 .268 0 8.665 8.665 0 0 0 2.99.563 8.25 8.25 0 0 0 3.511-.781c.256-.12.657-.25.891-.521a.703.703 0 0 0 .091-.769Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCheckbox = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 2.25H5.25a3.003 3.003 0 0 0-3 3v13.5a3.003 3.003 0 0 0 3 3h13.5a3.004 3.004 0 0 0 3-3V5.25a3.003 3.003 0 0 0-3-3Zm-1.676 6.482-6.3 7.5a.748.748 0 0 1-.562.268h-.013a.75.75 0 0 1-.557-.248l-2.7-3a.751.751 0 0 1 .88-1.186c.09.045.17.107.234.182l2.123 2.36 5.747-6.84a.75.75 0 0 1 1.148.964Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCheckmarkCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm5.074 6.482-6.3 7.5a.748.748 0 0 1-.562.268h-.013a.75.75 0 0 1-.557-.248l-2.7-3a.751.751 0 0 1 .88-1.186c.09.045.17.107.234.182l2.123 2.36 5.747-6.84a.75.75 0 0 1 1.148.964Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCheckmarkDoneCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.136 2.25c-5.483-.074-9.96 4.403-9.886 9.886.073 5.259 4.355 9.541 9.614 9.614 5.485.075 9.96-4.401 9.885-9.885-.072-5.26-4.354-9.542-9.613-9.615Zm-.787 9.022 2.416-2.765a.75.75 0 1 1 1.13.987l-2.416 2.765a.75.75 0 1 1-1.13-.987Zm-1.822 4.259a.75.75 0 0 1-1.06 0L6.22 13.28a.75.75 0 0 1 1.062-1.06l2.25 2.25a.75.75 0 0 1-.004 1.06Zm8.288-6.037-5.245 6a.75.75 0 0 1-.539.256h-.025a.75.75 0 0 1-.53-.22l-2.248-2.25a.75.75 0 0 1 1.061-1.06l1.397 1.398a.374.374 0 0 0 .547-.018l4.454-5.093a.75.75 0 0 1 1.13.987h-.002Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCheckmarkDone = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.244 5.435a.75.75 0 0 1 .07 1.059l-10.5 12a.75.75 0 0 1-1.094.036l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.933 3.933 9.973-11.397a.75.75 0 0 1 1.058-.07ZM1.72 12.97a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.743 5.434a.75.75 0 0 1 .072 1.059l-6.375 7.312a.75.75 0 1 1-1.13-.986l6.375-7.312a.75.75 0 0 1 1.058-.073Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCheckmark = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.994 5.435a.75.75 0 0 1 .07 1.059l-10.5 12a.75.75 0 0 1-1.094.036l-4.5-4.5a.75.75 0 1 1 1.06-1.06l3.933 3.933 9.973-11.397a.75.75 0 0 1 1.058-.07Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChevronBackCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75Zm1.655 13.72a.75.75 0 1 1-1.06 1.06l-4.5-4.5a.75.75 0 0 1 0-1.06l4.5-4.5a.75.75 0 0 1 1.06 1.06L9.685 12l3.97 3.97Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChevronBack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.17 4.455c.44.439.44 1.151 0 1.59L10.216 12l5.955 5.954a1.125 1.125 0 0 1-1.591 1.591l-6.75-6.75a1.125 1.125 0 0 1 0-1.59l6.75-6.75c.439-.44 1.151-.44 1.59 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChevronDownCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 12c0-5.385-4.366-9.75-9.75-9.75-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75Zm-4.72-1.345-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 1.06-1.06l3.97 3.97 3.97-3.97a.75.75 0 0 1 1.06 1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChevronDown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.455 7.83c.439-.44 1.151-.44 1.59 0L12 13.784l5.954-5.955a1.125 1.125 0 0 1 1.591 1.592l-6.75 6.75c-.439.439-1.151.439-1.59 0l-6.75-6.75a1.125 1.125 0 0 1 0-1.591Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChevronForwardCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12c0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75-5.385 0-9.75 4.365-9.75 9.75Zm12.064 0-3.97-3.97a.75.75 0 0 1 1.061-1.06l4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06-1.06l3.97-3.97Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChevronForward = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.83 4.455c.439-.44 1.151-.44 1.59 0l6.75 6.75c.44.439.44 1.151 0 1.59l-6.75 6.75a1.125 1.125 0 0 1-1.59-1.59L13.784 12 7.829 6.045a1.125 1.125 0 0 1 0-1.59Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChevronUpCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75Zm5.03 12.155a.75.75 0 0 1-1.06 0L12 10.435l-3.97 3.97a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1 0 1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgChevronUp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.204 7.83c.44-.44 1.152-.44 1.591 0l6.75 6.75a1.125 1.125 0 0 1-1.59 1.59L12 10.216l-5.955 5.955a1.125 1.125 0 0 1-1.59-1.591l6.75-6.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgClipboard = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 2.25h-.535a.375.375 0 0 1-.349-.238A1.977 1.977 0 0 0 14.526.75H9.474a1.977 1.977 0 0 0-1.841 1.262.375.375 0 0 1-.35.238H6.75a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-15a3 3 0 0 0-3-3Zm-2.256 3H9.006a.75.75 0 0 1 0-1.5h5.988a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCloseCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm3.53 12.22a.75.75 0 1 1-1.06 1.06L12 13.06l-2.47 2.47a.75.75 0 0 1-1.06-1.06L10.94 12 8.47 9.53a.75.75 0 0 1 1.06-1.06L12 10.94l2.47-2.47a.75.75 0 0 1 1.06 1.06L13.06 12l2.47 2.47Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgClose = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m13.591 12 4.453-4.453a1.126 1.126 0 0 0-1.59-1.594L12 10.406 7.547 5.953a1.127 1.127 0 0 0-1.594 1.594L10.406 12l-4.453 4.453a1.127 1.127 0 1 0 1.594 1.594L12 13.594l4.453 4.453a1.127 1.127 0 0 0 1.594-1.594L13.591 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCloudCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75Zm3.281 13.125H9.05c-1.478 0-2.698-1.2-2.672-2.677.025-1.488 1.11-2.341 2.407-2.545a.372.372 0 0 0 .29-.235C9.471 8.87 10.482 7.875 12 7.875c1.555 0 2.9 1.054 3.288 2.822a.832.832 0 0 0 .618.63c.865.207 1.719.823 1.719 1.986 0 1.419-1.055 2.062-2.344 2.062Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCloudDone = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.896 10.652a.75.75 0 0 1-.569-.58c-.36-1.72-1.146-3.195-2.305-4.313A7.199 7.199 0 0 0 12 3.749c-1.664 0-3.199.549-4.438 1.585A7.324 7.324 0 0 0 5.593 7.96a.75.75 0 0 1-.533.43c-1.265.263-2.394.812-3.243 1.587C.627 11.056 0 12.536 0 14.25c0 1.687.674 3.229 1.898 4.34 1.179 1.07 2.769 1.66 4.477 1.66h12.188c1.517 0 2.823-.402 3.777-1.161 1.086-.865 1.66-2.149 1.66-3.714 0-2.699-1.969-4.246-4.104-4.723Zm-4.463-.419-5.053 6a.749.749 0 0 1-.563.267h-.012a.75.75 0 0 1-.557-.248l-2.152-2.384a.764.764 0 0 1 .014-1.05.75.75 0 0 1 1.086.03l1.59 1.76 4.5-5.343a.749.749 0 1 1 1.147.967v.001Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCloudDownload = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.158 8.883c-.622-.395-1.399-.683-2.254-.84a.75.75 0 0 1-.591-.577c-.369-1.617-1.154-3.006-2.304-4.058C15.663 2.178 13.885 1.5 12 1.5c-1.657 0-3.188.52-4.424 1.5A7.037 7.037 0 0 0 5.61 5.476a.752.752 0 0 1-.548.42c-1.271.23-2.368.689-3.206 1.346C.642 8.195 0 9.542 0 11.137c0 3.16 2.622 5.363 6.375 5.363h4.875v-5.979c0-.404.31-.75.714-.77a.75.75 0 0 1 .786.749v6h5.813c3.405 0 5.437-1.605 5.437-4.294 0-1.408-.637-2.558-1.842-3.323ZM11.25 19.942l-1.72-1.718a.75.75 0 0 0-1.06 1.062l3 2.995a.75.75 0 0 0 1.06 0l3-2.995a.75.75 0 0 0-1.06-1.062l-1.72 1.718V16.5h-1.5v3.442Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCloudOffline = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 21.75a.746.746 0 0 1-.53-.22l-18-18a.75.75 0 0 1 1.06-1.06l18 18a.75.75 0 0 1-.53 1.28ZM1.815 9.224C.628 10.307 0 11.785 0 13.5c0 1.687.674 3.229 1.898 4.34 1.179 1.07 2.769 1.66 4.477 1.66h9.037a.375.375 0 0 0 .266-.64L4.728 7.91a.375.375 0 0 0-.374-.093c-.979.3-1.85.779-2.539 1.407ZM22.34 18.339c1.086-.865 1.66-2.149 1.66-3.714 0-2.699-1.969-4.246-4.104-4.723a.75.75 0 0 1-.569-.58c-.36-1.72-1.146-3.195-2.305-4.313A7.199 7.199 0 0 0 12 2.999c-1.459 0-2.818.423-3.967 1.224a.375.375 0 0 0-.053.575l13.661 13.661a.375.375 0 0 0 .478.044 3.98 3.98 0 0 0 .221-.164Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCloudUpload = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.203 9.844a6.22 6.22 0 0 0-2.314-1.037.755.755 0 0 1-.571-.573c-.366-1.628-1.153-3.025-2.31-4.084C15.663 2.918 13.885 2.24 12 2.24c-1.657 0-3.188.52-4.424 1.502a7.035 7.035 0 0 0-1.971 2.485.75.75 0 0 1-.53.416c-1.254.253-2.386.79-3.25 1.552C.63 9.25 0 10.652 0 12.253c0 1.618.68 3.093 1.912 4.16C3.09 17.43 4.675 17.99 6.375 17.99h4.875V10.8l-1.72 1.72a.75.75 0 0 1-1.085-.025.764.764 0 0 1 .04-1.05L11.47 8.46a.75.75 0 0 1 1.06 0l2.986 2.984c.294.295.31.778.018 1.074a.751.751 0 0 1-1.063.003L12.75 10.8v7.19h5.813c1.469 0 2.808-.413 3.77-1.162 1.09-.848 1.667-2.063 1.667-3.508 0-1.403-.622-2.606-1.797-3.477ZM11.25 21.01a.75.75 0 1 0 1.5 0v-3.02h-1.5v3.02Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCloud = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.563 20.25H6.374c-1.708 0-3.298-.59-4.477-1.66C.674 17.48 0 15.938 0 14.25c0-1.715.628-3.193 1.815-4.276.849-.775 1.98-1.324 3.243-1.588a.75.75 0 0 0 .533-.428 7.324 7.324 0 0 1 1.97-2.625C8.802 4.298 10.337 3.75 12 3.75a7.199 7.199 0 0 1 5.022 2.01c1.16 1.117 1.946 2.592 2.306 4.313a.75.75 0 0 0 .568.581C22.03 11.13 24 12.676 24 15.375c0 1.565-.574 2.85-1.66 3.714-.954.76-2.26 1.161-3.777 1.161Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCloudyNight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.938 22.5H4.967c-1.382 0-2.574-.367-3.446-1.061C.526 20.646 0 19.469 0 18.038c0-1.38.567-2.543 1.64-3.363.568-.434 1.276-.758 2.032-.94a.75.75 0 0 0 .553-.572c.335-1.526 1.043-2.836 2.078-3.832a6.554 6.554 0 0 1 4.572-1.83c1.515 0 2.913.498 4.043 1.442a6.666 6.666 0 0 1 1.764 2.323.754.754 0 0 0 .522.421c1.125.245 2.129.74 2.888 1.433 1.085.99 1.658 2.34 1.658 3.905 0 1.54-.616 2.947-1.734 3.962-1.073.976-2.522 1.513-4.078 1.513ZM23.931 9.834a.766.766 0 0 0-.063-.74.75.75 0 0 0-.918-.262c-.501.218-1.147.336-1.87.34-2.593.02-4.753-2.109-4.753-4.701 0-.738.116-1.399.337-1.91a.764.764 0 0 0-.087-.766.75.75 0 0 0-.896-.235c-1.81.789-3.102 2.415-3.528 4.338a.186.186 0 0 0 .08.197.187.187 0 0 0 .07.028A7.619 7.619 0 0 1 15.88 7.79a8.09 8.09 0 0 1 1.858 2.242.767.767 0 0 0 .447.359c1.12.336 2.114.886 2.918 1.619.139.127.271.258.398.394a.187.187 0 0 0 .241.027 6.053 6.053 0 0 0 2.19-2.598Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCloudy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.625 20.25H5.437c-1.517 0-2.823-.402-3.777-1.161C.574 18.224 0 16.94 0 15.375c0-2.699 1.969-4.246 4.104-4.723a.75.75 0 0 0 .569-.58c.36-1.72 1.146-3.195 2.305-4.313A7.199 7.199 0 0 1 12 3.749c1.664 0 3.199.549 4.438 1.585A7.323 7.323 0 0 1 18.41 7.96a.75.75 0 0 0 .533.43c1.266.263 2.394.812 3.243 1.586C23.372 11.057 24 12.535 24 14.25c0 1.687-.674 3.229-1.898 4.34-1.179 1.07-2.769 1.66-4.477 1.66Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCodeDownload = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24 6.102a.984.984 0 0 1-.092 1.389l-5.153 4.51 5.153 4.508a.984.984 0 1 1-1.296 1.482l-6-5.25a.984.984 0 0 1 0-1.482l6-5.25a.984.984 0 0 1 1.389.093ZM15.76 6.102a.984.984 0 0 1 1.388-.093l6 5.25a.984.984 0 0 1 0 1.482l-6 5.25a.984.984 0 1 1-1.296-1.482L21.005 12l-5.153-4.509a.984.984 0 0 1-.093-1.389Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.303 12.81a.984.984 0 0 1 1.393-.002l2.304 2.3 2.305-2.3a.984.984 0 0 1 1.39 1.393l-3 2.995a.984.984 0 0 1-1.39 0l-3-2.995a.984.984 0 0 1-.002-1.392Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 6.516c.544 0 .984.44.984.984v8.251a.984.984 0 1 1-1.968 0V7.5c0-.544.44-.984.984-.984Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCodeSlash = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.234a.98.98 0 0 1-.648-.243l-6-5.25a.985.985 0 0 1 0-1.482l6-5.25A.984.984 0 0 1 8.15 7.491L2.995 12l5.153 4.509a.984.984 0 0 1-.648 1.725ZM16.5 18.234a.984.984 0 0 1-.649-1.725l5.154-4.51-5.153-4.508a.984.984 0 1 1 1.296-1.482l6 5.25a.985.985 0 0 1 0 1.482l-6 5.25a.979.979 0 0 1-.648.243ZM9.75 20.485a.984.984 0 0 1-.943-1.266l4.5-15a.984.984 0 1 1 1.886.562l-4.5 15a.984.984 0 0 1-.943.704Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCodeWorking = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.219a1.219 1.219 0 1 0 0-2.438 1.219 1.219 0 0 0 0 2.438Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 11.016a.984.984 0 1 0 0 1.968.984.984 0 0 0 0-1.968ZM10.547 12a1.453 1.453 0 1 1 2.906 0 1.453 1.453 0 0 1-2.906 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.219 13.219a1.219 1.219 0 1 0 0-2.438 1.219 1.219 0 0 0 0 2.438Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.219 11.016a.984.984 0 1 0 0 1.968.984.984 0 0 0 0-1.968ZM14.766 12a1.453 1.453 0 1 1 2.906 0 1.453 1.453 0 0 1-2.906 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.781 13.219a1.219 1.219 0 1 0 0-2.438 1.219 1.219 0 0 0 0 2.438Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.781 11.016a.984.984 0 1 0 0 1.968.984.984 0 0 0 0-1.968ZM6.328 12a1.453 1.453 0 1 1 2.906 0 1.453 1.453 0 0 1-2.906 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.24 6.102a.984.984 0 0 1-.092 1.389l-5.153 4.51 5.153 4.508a.984.984 0 1 1-1.296 1.482l-6-5.25a.984.984 0 0 1 0-1.482l6-5.25a.984.984 0 0 1 1.389.093ZM15.76 6.102a.984.984 0 0 1 1.388-.093l6 5.25a.984.984 0 0 1 0 1.482l-6 5.25a.984.984 0 0 1-1.296-1.482L21.005 12l-5.153-4.509a.984.984 0 0 1-.093-1.389Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCode = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 18.234a.98.98 0 0 1-.648-.243l-6-5.25a.985.985 0 0 1 0-1.482l6-5.25A.984.984 0 0 1 8.15 7.491L2.995 12l5.153 4.509a.984.984 0 0 1-.648 1.725ZM16.5 18.234a.984.984 0 0 1-.649-1.725l5.154-4.51-5.153-4.508a.984.984 0 1 1 1.296-1.482l6 5.25a.985.985 0 0 1 0 1.482l-6 5.25a.979.979 0 0 1-.648.243Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCog = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 11.716a.496.496 0 0 0-.439-.466l-1.202-.195a.254.254 0 0 1-.21-.219 6.815 6.815 0 0 0-.08-.446.259.259 0 0 1 .123-.274l1.068-.593a.485.485 0 0 0 .234-.602l-.185-.51a.484.484 0 0 0-.569-.306l-1.197.235a.258.258 0 0 1-.273-.132 8.512 8.512 0 0 0-.225-.395.262.262 0 0 1 .02-.304l.798-.921a.489.489 0 0 0 .018-.645l-.348-.418a.48.48 0 0 0-.637-.093l-1.048.63a.253.253 0 0 1-.3-.03c-.115-.102-.234-.2-.345-.29a.255.255 0 0 1-.08-.292l.433-1.143a.485.485 0 0 0-.202-.613l-.473-.276a.483.483 0 0 0-.63.132l-.767.963a.215.215 0 0 1-.262.08 8.682 8.682 0 0 0-.458-.173.254.254 0 0 1-.176-.245l.019-1.222a.492.492 0 0 0-.402-.51l-.537-.093a.49.49 0 0 0-.55.336l-.4 1.163a.256.256 0 0 1-.25.17h-.457a.258.258 0 0 1-.249-.171l-.396-1.157a.49.49 0 0 0-.552-.34l-.538.094a.49.49 0 0 0-.401.506l.019 1.226a.255.255 0 0 1-.181.246c-.108.042-.34.131-.447.17-.093.034-.195-.003-.278-.098l-.762-.938a.483.483 0 0 0-.631-.135l-.472.273a.486.486 0 0 0-.202.618l.433 1.14a.26.26 0 0 1-.08.293c-.113.093-.23.187-.346.291a.252.252 0 0 1-.298.03l-1.036-.642a.487.487 0 0 0-.638.094l-.347.417a.483.483 0 0 0 .018.644l.8.92a.254.254 0 0 1 .022.303c-.08.127-.157.261-.226.395a.26.26 0 0 1-.275.132L3.502 8.1a.485.485 0 0 0-.569.304l-.187.51a.487.487 0 0 0 .234.603l1.068.593a.253.253 0 0 1 .124.277l-.011.06c-.025.13-.047.254-.069.386a.257.257 0 0 1-.209.217l-1.204.195a.489.489 0 0 0-.429.481v.543a.481.481 0 0 0 .43.481l1.203.194a.253.253 0 0 1 .211.22c.023.147.047.3.08.445a.259.259 0 0 1-.123.275l-1.068.593a.485.485 0 0 0-.234.602l.187.51a.484.484 0 0 0 .569.306l1.198-.232a.257.257 0 0 1 .272.132c.07.13.146.264.225.394a.261.261 0 0 1-.02.305l-.797.92a.488.488 0 0 0-.024.646l.348.417a.48.48 0 0 0 .636.094l1.049-.63a.252.252 0 0 1 .3.03c.116.102.234.2.345.29a.257.257 0 0 1 .081.291l-.434 1.144a.485.485 0 0 0 .202.613l.473.273a.483.483 0 0 0 .63-.132l.777-.954c.065-.08.168-.117.245-.086.163.068.272.106.466.17a.255.255 0 0 1 .176.246l-.02 1.22a.492.492 0 0 0 .403.51l.536.094a.489.489 0 0 0 .551-.336l.399-1.16a.256.256 0 0 1 .25-.172h.458a.257.257 0 0 1 .248.172l.397 1.157a.492.492 0 0 0 .552.34l.538-.094a.49.49 0 0 0 .401-.506l-.018-1.226a.254.254 0 0 1 .175-.244c.18-.06.307-.11.418-.153l.028-.01c.145-.05.216.01.257.061l.785.967a.483.483 0 0 0 .63.132l.472-.273a.485.485 0 0 0 .202-.614l-.433-1.141a.259.259 0 0 1 .079-.292c.114-.094.23-.188.347-.292a.253.253 0 0 1 .299-.029l1.05.628a.487.487 0 0 0 .637-.093l.347-.418a.483.483 0 0 0-.017-.644l-.8-.922a.255.255 0 0 1-.021-.302c.08-.127.157-.261.226-.396a.26.26 0 0 1 .275-.132l1.194.233a.485.485 0 0 0 .57-.305l.184-.51a.486.486 0 0 0-.234-.602l-1.069-.594a.252.252 0 0 1-.122-.276l.011-.06c.024-.13.047-.254.069-.386a.257.257 0 0 1 .209-.217l1.204-.195a.489.489 0 0 0 .43-.482v-.548ZM8.51 16.122a.741.741 0 0 1-1.194.125 6.331 6.331 0 0 1 .02-8.515.741.741 0 0 1 1.195.13l2.14 3.766a.743.743 0 0 1 0 .738l-2.16 3.756ZM12 18.333c-.446 0-.89-.047-1.327-.14a.742.742 0 0 1-.48-1.095l2.157-3.75a.739.739 0 0 1 .642-.372h4.319a.74.74 0 0 1 .708.962c-.82 2.547-3.206 4.395-6.019 4.395Zm.352-7.682L10.22 6.894a.74.74 0 0 1 .483-1.092c.427-.09.862-.135 1.298-.135 2.813 0 5.199 1.849 6.017 4.396a.741.741 0 0 1-.707.963h-4.313a.739.739 0 0 1-.645-.375Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgColorFill = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 22.5c-1.654 0-3-1.364-3-3.041 0-1.56 1.344-3.066 2.066-3.874.088-.098.164-.183.22-.249a.935.935 0 0 1 1.432 0c.053.062.123.14.204.231.727.811 2.078 2.321 2.078 3.893 0 1.676-1.346 3.04-3 3.04ZM18.667 12.968 7.823 2.214a2.442 2.442 0 0 0-3.45 0l-.211.211a2.494 2.494 0 0 0-.745 1.75 2.422 2.422 0 0 0 .715 1.732l1.945 1.945-3.968 3.961a2.087 2.087 0 0 0-.609 1.5 2.007 2.007 0 0 0 .633 1.446l6.152 5.906a2.063 2.063 0 0 0 2.863-.009l5.817-5.638a.731.731 0 0 1 .386-.2c.185-.03.372-.044.56-.041h.014a1.057 1.057 0 0 0 .742-1.809ZM7.14 6.79 5.192 4.844a.937.937 0 0 1 0-1.328l.242-.242a.94.94 0 0 1 1.33 0l1.955 1.94-1.58 1.576Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgColorFilter = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.893 9.494a.188.188 0 0 0 .214 0 7.12 7.12 0 0 1 6.02-.957.187.187 0 0 0 .242-.188A6.383 6.383 0 0 0 12 2.25a6.383 6.383 0 0 0-6.369 6.1.188.188 0 0 0 .242.188 7.12 7.12 0 0 1 6.02.957v-.001ZM18.999 9.964a7.149 7.149 0 0 1-3.894 5.073.187.187 0 0 0-.107.173l.002.165a7.104 7.104 0 0 1-2.21 5.154.188.188 0 0 0 .03.295c.995.607 2.14.927 3.305.926 3.378 0 6.286-2.825 6.375-6.203a6.378 6.378 0 0 0-3.223-5.713.188.188 0 0 0-.278.13Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.308 9.547a.187.187 0 0 0-.126-.207 6.367 6.367 0 0 0-5.363.586.188.188 0 0 0-.03.295 7.12 7.12 0 0 1 2.085 3.815.188.188 0 0 0 .278.128 6.388 6.388 0 0 0 3.156-4.617ZM9 15.375c0-.055 0-.11.002-.165a.188.188 0 0 0-.107-.173 7.15 7.15 0 0 1-3.894-5.073.187.187 0 0 0-.276-.13 6.379 6.379 0 0 0-3.223 5.713c.092 3.378 2.998 6.203 6.375 6.203a6.34 6.34 0 0 0 3.303-.925.188.188 0 0 0 .03-.296A7.105 7.105 0 0 1 9 15.375Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.875 9c-.7 0-1.395.114-2.057.34a.187.187 0 0 0-.126.207 6.388 6.388 0 0 0 3.156 4.617.188.188 0 0 0 .278-.127 7.121 7.121 0 0 1 2.085-3.816.187.187 0 0 0-.03-.295A6.337 6.337 0 0 0 7.875 9ZM12 15.75a7.095 7.095 0 0 1-2.002-.287.189.189 0 0 0-.225.1.188.188 0 0 0-.017.088 6.36 6.36 0 0 0 2.118 4.472.187.187 0 0 0 .252 0 6.36 6.36 0 0 0 2.118-4.472.19.19 0 0 0-.072-.156.188.188 0 0 0-.17-.032c-.65.191-1.324.288-2.002.287ZM14.183 14.453a6.372 6.372 0 0 0-2.056-3.824.19.19 0 0 0-.254 0 6.372 6.372 0 0 0-2.056 3.824.187.187 0 0 0 .126.207 6.377 6.377 0 0 0 4.114 0 .187.187 0 0 0 .126-.207Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgColorPalette = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m20.672 15.76-.003-.003c-.465-.43-1.068-.531-1.507-.606l-.033-.005c-.424-.07-.491-.117-.683-.29-.115-.101-.251-.264-.251-.465s.136-.365.25-.466l1.42-1.26c1.215-1.074 1.884-2.515 1.884-4.059 0-1.543-.668-2.985-1.884-4.06-1.683-1.48-3.985-2.296-6.486-2.296-2.892 0-5.785 1.095-7.941 3.005C3.38 7.072 2.25 9.507 2.25 12.11c0 2.603 1.132 5.038 3.188 6.855a10.791 10.791 0 0 0 3.586 2.082c1.31.459 2.685.697 4.072.703h.085c2.86 0 5.583-.964 7.472-2.644.454-.401.71-.976.719-1.62.01-.664-.252-1.31-.7-1.727ZM5.25 9.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm1.875 6.328a1.5 1.5 0 1 1 0-2.999 1.5 1.5 0 0 1 0 3ZM9 6.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Zm3 12.703a2.25 2.25 0 1 1 0-4.499 2.25 2.25 0 0 1 0 4.5ZM15.375 8.25a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgColorWand = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 9.75H2.25A.752.752 0 0 1 1.5 9c0-.412.337-.75.75-.75H4.5c.412 0 .75.338.75.75s-.338.75-.75.75ZM5.817 6.567a.753.753 0 0 1-.53-.22l-1.589-1.59a.753.753 0 0 1 0-1.059.753.753 0 0 1 1.06 0l1.589 1.59a.744.744 0 0 1 0 1.059.745.745 0 0 1-.53.22ZM9 5.25a.752.752 0 0 1-.75-.75V2.25c0-.413.338-.75.75-.75s.75.337.75.75V4.5c0 .412-.338.75-.75.75ZM12.183 6.567a.752.752 0 0 1-.75-.75c0-.197.08-.389.22-.53l1.59-1.589a.753.753 0 0 1 1.059 0c.29.291.29.77 0 1.06l-1.59 1.589a.753.753 0 0 1-.53.22ZM4.228 14.522a.752.752 0 0 1-.75-.75c0-.197.08-.39.22-.53l1.59-1.589a.752.752 0 0 1 1.059 0c.29.29.29.769 0 1.06L4.757 14.3a.753.753 0 0 1-.529.22ZM10.978 7.828a2.232 2.232 0 0 0-3.15-.033 2.232 2.232 0 0 0-.033 3.15l.033.033L9.68 12.83a.376.376 0 0 0 .53 0l2.62-2.62a.376.376 0 0 0 0-.53l-1.852-1.852ZM21.422 18.272l-7.003-7.003a.376.376 0 0 0-.53 0l-2.62 2.62a.376.376 0 0 0 0 .53l7.003 7.003c.862.876 2.273.89 3.15.032.877-.862.89-2.273.033-3.15-.01-.009-.019-.023-.033-.032Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCompass = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.125a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm4.925 5.312-2.197 5.494a3.002 3.002 0 0 1-1.672 1.672l-5.494 2.197a.376.376 0 0 1-.487-.487l2.197-5.494a3 3 0 0 1 1.672-1.672l5.494-2.197a.375.375 0 0 1 .487.487Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgConstruct = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.605 5.916a.79.79 0 0 0-1.269-.213L19.94 8.1a.523.523 0 0 1-.734 0L18.15 7.047a.524.524 0 0 1 0-.735l2.385-2.385a.789.789 0 0 0-.247-1.285c-1.862-.797-4.176-.349-5.625 1.092-1.257 1.247-1.633 3.187-1.031 5.33a.515.515 0 0 1-.148.52l-8.105 7.53a2.66 2.66 0 1 0 3.756 3.759l7.598-8.119a.516.516 0 0 1 .511-.149c2.11.563 4.031.188 5.27-1.03.713-.704 1.21-1.696 1.401-2.8.18-1.04.067-2.083-.31-2.859Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 17.738c-.654-.544-2.05-1.8-3.472-3.104l-3.097 3.31c1.324 1.406 2.522 2.711 3.047 3.322l.003.004a1.406 1.406 0 0 0 1.006.48h.051c.369-.002.722-.146.985-.404l.003-.004 1.567-1.564a1.38 1.38 0 0 0-.094-2.04ZM5.557 10.057a.96.96 0 0 0-.141-.504.13.13 0 0 1 .123-.198h.003c.039.004.25.034.548.216.222.134.855.566 1.956 1.666-.012.374.108.741.339 1.037l3.104-2.885a1.58 1.58 0 0 0-1.012-.432.126.126 0 0 1-.01-.012l-.03-.032-1.151-1.586a1.334 1.334 0 0 1-.187-1.224c.105-.304.297-.57.552-.767.266-.207.868-.455 1.38-.498a2.48 2.48 0 0 1 .712.044c.112.028.222.06.33.1a.75.75 0 0 0 .869-1.145c-.012-.016-.062-.084-.135-.175a4.308 4.308 0 0 0-.45-.485c-.382-.345-1.372-.927-2.672-.927-.744 0-1.48.143-2.17.422-1.799.724-2.976 1.715-3.516 2.24l-.005.004c-.364.36-.7.745-1.008 1.154a1.266 1.266 0 0 0-.22.552.344.344 0 0 1-.362.29h-.05a.968.968 0 0 0-.685.276L.29 8.534l-.015.015a.98.98 0 0 0-.011 1.346c.008.01.017.018.026.027l2.227 2.172a.984.984 0 0 0 1.37.004l1.381-1.35a.962.962 0 0 0 .29-.691Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgContract = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 14.25a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 0 1.5H15v4.5a.75.75 0 0 1-1.5 0v-5.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.198 14.2a.75.75 0 0 1 1.06 0l5.522 5.52a.75.75 0 1 1-1.06 1.06l-5.522-5.52a.75.75 0 0 1 0-1.06ZM9.75 3.75a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-.75.75H4.5a.75.75 0 0 1 0-1.5H9V4.5a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22 3.22a.75.75 0 0 1 1.06 0l5.522 5.52a.75.75 0 0 1-1.06 1.06L3.22 4.28a.75.75 0 0 1 0-1.06ZM14.25 3.75a.75.75 0 0 1 .75.75V9h4.5a.75.75 0 0 1 0 1.5h-5.25a.75.75 0 0 1-.75-.75V4.5a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.78 3.22a.75.75 0 0 1 0 1.06l-5.52 5.522a.75.75 0 0 1-1.06-1.06l5.52-5.522a.75.75 0 0 1 1.06 0ZM3.75 14.25a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0V15H4.5a.75.75 0 0 1-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 14.198a.75.75 0 0 1 0 1.06L4.28 20.78a.75.75 0 0 1-1.06-1.06l5.52-5.522a.75.75 0 0 1 1.06 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgContrast = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5a10.5 10.5 0 0 0-7.424 17.925 10.499 10.499 0 1 0 14.849-14.85A10.431 10.431 0 0 0 12 1.5ZM3 12c0-4.963 4.037-9 9-9v18c-4.963 0-9-4.037-9-9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCopy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 22.5h-10.5a3.375 3.375 0 0 1-3.375-3.375v-10.5A3.375 3.375 0 0 1 8.625 5.25h10.5A3.375 3.375 0 0 1 22.5 8.625v10.5a3.375 3.375 0 0 1-3.375 3.375Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.75h11.057a3.381 3.381 0 0 0-3.182-2.25h-10.5A3.375 3.375 0 0 0 1.5 4.875v10.5a3.38 3.38 0 0 0 2.25 3.182V7.5A3.75 3.75 0 0 1 7.5 3.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCreate = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.56 2.496a.753.753 0 0 0-1.089-.026l-.58.577a.375.375 0 0 0 0 .53l.532.53a.374.374 0 0 0 .531 0l.566-.562a.762.762 0 0 0 .04-1.05ZM18.72 4.219l-8.463 8.447a.422.422 0 0 0-.108.184l-.391 1.165a.183.183 0 0 0 .227.228l1.165-.391a.423.423 0 0 0 .184-.108l8.447-8.463a.422.422 0 0 0 0-.594l-.466-.468a.422.422 0 0 0-.596 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.11 9.078-5.714 5.725c-.22.221-.492.385-.79.478l-1.215.407a1.684 1.684 0 0 1-2.078-2.078l.407-1.214c.092-.299.256-.57.477-.791l5.725-5.715a.375.375 0 0 0-.265-.64H4.875A2.625 2.625 0 0 0 2.25 7.875v11.25a2.625 2.625 0 0 0 2.625 2.625h11.25a2.625 2.625 0 0 0 2.625-2.625V9.343a.375.375 0 0 0-.64-.265Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCrop = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.469 16.219H9A1.22 1.22 0 0 1 7.781 15V2.531a1.031 1.031 0 1 0-2.062 0V5.72H2.53a1.031 1.031 0 1 0 0 2.062H5.72V15A3.285 3.285 0 0 0 9 18.281h7.219v3.188a1.031 1.031 0 1 0 2.062 0V18.28h3.188a1.031 1.031 0 1 0 0-2.062Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.031 7.781H15A1.219 1.219 0 0 1 16.219 9v4.969a1.031 1.031 0 1 0 2.062 0V9A3.285 3.285 0 0 0 15 5.719h-4.969a1.031 1.031 0 0 0 0 2.062Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCube = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.667 6.389a.187.187 0 0 0 0-.324l-7.16-4.16a3.006 3.006 0 0 0-3.015 0l-7.158 4.16a.187.187 0 0 0 0 .324l8.572 5.043a.188.188 0 0 0 .19 0l8.571-5.043ZM2.531 7.665a.187.187 0 0 0-.281.164v8.15a2.25 2.25 0 0 0 1.118 1.94l7.6 4.558a.188.188 0 0 0 .282-.162v-9.457a.187.187 0 0 0-.094-.162L2.531 7.665ZM12.75 12.891v9.422a.187.187 0 0 0 .281.162l7.601-4.558a2.25 2.25 0 0 0 1.118-1.937V7.828a.187.187 0 0 0-.281-.161l-8.625 5.062a.186.186 0 0 0-.094.162Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgCut = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.85 10.5c.763 0 1.503-.258 2.099-.734l1.945.792.32-.592c.057-.106.125-.206.202-.299l.667-.676-1.93-1.169A3.375 3.375 0 1 0 4.851 10.5Zm0-5.25a1.875 1.875 0 1 1 0 3.75 1.875 1.875 0 0 1 0-3.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.5 7.922-.259-.59c-.21-.488-.69-.75-1.536-.837-.475-.047-1.264-.058-2.33.179-.937.209-5.725 1.322-7.732 2.748-.949.674-1.127 1.578-1.268 2.304-.13.663-.234 1.186-.844 1.64-.703.523-1.278.769-1.574.873a3.363 3.363 0 1 0 1.162 1.78L22.5 7.923ZM11.976 12a.75.75 0 1 1 0-1.5.75.75 0 0 1 0 1.5ZM4.85 18.75a1.875 1.875 0 1 1 0-3.75 1.875 1.875 0 0 1 0 3.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.115 12.181 12.19 14.44l1.295.613.17.081c.876.425 3.208 1.553 5.589 1.694.182.01.35.016.505.016.97-.002 1.485-.25 1.802-.438l.949-.656-6.385-3.569Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgDesktop = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M.75 16.5A2.252 2.252 0 0 0 3 18.75h6.276l-.188 1.5H6.75a.75.75 0 1 0 0 1.5h10.5a.75.75 0 1 0 0-1.5h-2.338l-.188-1.5H21a2.252 2.252 0 0 0 2.25-2.25v-2.25H.75v2.25ZM12 15.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5ZM23.25 4.5A2.252 2.252 0 0 0 21 2.25H3A2.252 2.252 0 0 0 .75 4.5v9h22.5v-9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgDice = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m20.666 6.064-7.159-4.16a3.007 3.007 0 0 0-3.015 0l-7.158 4.16a.188.188 0 0 0 0 .324l8.572 5.043a.187.187 0 0 0 .19 0l8.571-5.043a.188.188 0 0 0 0-.324ZM12 7.125c-.621 0-1.125-.335-1.125-.75 0-.414.504-.75 1.125-.75s1.125.336 1.125.75c0 .415-.504.75-1.125.75ZM11.156 12.694 2.531 7.663a.188.188 0 0 0-.281.162v8.153a2.25 2.25 0 0 0 1.118 1.94l7.6 4.557a.187.187 0 0 0 .257-.068.187.187 0 0 0 .025-.094v-9.457a.187.187 0 0 0-.094-.162ZM4.5 17.25c-.414 0-.75-.504-.75-1.125S4.086 15 4.5 15s.75.504.75 1.125c0 .62-.336 1.125-.75 1.125Zm4.5-1.5c-.414 0-.75-.504-.75-1.125S8.586 13.5 9 13.5s.75.504.75 1.125c0 .62-.336 1.125-.75 1.125ZM21.469 7.665l-8.625 5.065a.187.187 0 0 0-.094.162v9.42a.187.187 0 0 0 .281.163l7.601-4.558a2.25 2.25 0 0 0 1.118-1.939v-8.15a.187.187 0 0 0-.281-.163ZM15 19.875c-.414 0-.75-.503-.75-1.125 0-.62.336-1.125.75-1.125s.75.504.75 1.125c0 .622-.336 1.125-.75 1.125Zm0-4.125c-.414 0-.75-.504-.75-1.125 0-.62.336-1.125.75-1.125s.75.504.75 1.125-.336 1.125-.75 1.125Zm4.5 1.5c-.414 0-.75-.503-.75-1.125 0-.62.336-1.125.75-1.125s.75.504.75 1.125c0 .622-.336 1.125-.75 1.125Zm0-4.125c-.414 0-.75-.504-.75-1.125 0-.62.336-1.125.75-1.125s.75.504.75 1.125-.336 1.125-.75 1.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgDisc = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25a3.75 3.75 0 1 0 0 7.5 3.75 3.75 0 0 0 0-7.5Zm0 5.25a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.424 4.575a10.5 10.5 0 1 0-14.849 14.85 10.5 10.5 0 1 0 14.85-14.85ZM12 17.25a5.25 5.25 0 1 1 0-10.5 5.25 5.25 0 0 1 0 10.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgDocumentAttach = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.563 11.25H15A2.25 2.25 0 0 1 12.75 9V2.437a.188.188 0 0 0-.188-.187h-2.496a3.066 3.066 0 0 0-.304-.46C9.222 1.12 8.418.75 7.5.75c-1.766 0-3 1.388-3 3.375v6.75c0 1.172.953 1.875 1.875 1.875a1.856 1.856 0 0 0 1.875-1.875V3.75a.75.75 0 0 0-1.5 0v7.125a.363.363 0 0 1-.375.375c-.105 0-.375-.068-.375-.375v-6.75c0-.907.394-1.875 1.5-1.875C8.892 2.25 9 3.663 9 4.096V10.6c0 .818-.256 1.558-.722 2.084-.473.535-1.131.816-1.903.816s-1.43-.281-1.903-.816c-.466-.526-.722-1.266-.722-2.084V6.75a.75.75 0 0 0-1.5 0v3.85c0 2.414 1.556 4.201 3.75 4.384v5.266a3 3 0 0 0 3 3h9.75a3 3 0 0 0 3-3v-8.813a.188.188 0 0 0-.188-.187Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 9.75h6.085a.094.094 0 0 0 .066-.16L14.41 2.85a.093.093 0 0 0-.16.065V9a.75.75 0 0 0 .75.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgDocumentLock = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9h6.085a.094.094 0 0 0 .066-.16L12.91 2.1a.093.093 0 0 0-.16.065V8.25a.75.75 0 0 0 .75.75ZM12 12.75c-.413 0-.75.294-.75.656v.844h1.5v-.844c0-.362-.337-.656-.75-.656Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.063 10.5H13.5a2.25 2.25 0 0 1-2.25-2.25V1.687a.188.188 0 0 0-.188-.187H6.75a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-8.813a.188.188 0 0 0-.188-.187ZM15.75 18a1.5 1.5 0 0 1-1.5 1.5h-4.5a1.5 1.5 0 0 1-1.5-1.5v-2.25a1.5 1.5 0 0 1 1.5-1.5v-.844c0-1.189 1.01-2.156 2.25-2.156s2.25.967 2.25 2.156v.844a1.5 1.5 0 0 1 1.5 1.5V18Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgDocumentText = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.063 10.5H13.5a2.25 2.25 0 0 1-2.25-2.25V1.687a.188.188 0 0 0-.188-.187H6.75a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-8.813a.188.188 0 0 0-.188-.187ZM15.75 18h-7.5a.75.75 0 1 1 0-1.5h7.5a.75.75 0 1 1 0 1.5Zm0-3.75h-7.5a.75.75 0 1 1 0-1.5h7.5a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.65 8.84 12.91 2.1a.093.093 0 0 0-.16.065V8.25a.75.75 0 0 0 .75.75h6.085a.094.094 0 0 0 .066-.16Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgDocument = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.063 10.5H13.5a2.25 2.25 0 0 1-2.25-2.25V1.687a.188.188 0 0 0-.188-.187H6.75a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h10.5a3 3 0 0 0 3-3v-8.813a.188.188 0 0 0-.188-.187Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.65 8.84 12.91 2.1a.093.093 0 0 0-.16.065V8.25a.75.75 0 0 0 .75.75h6.085a.094.094 0 0 0 .066-.16Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgDocuments = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.987 11.625a.188.188 0 0 0 .134-.32L10.446 7.57a.187.187 0 0 0-.321.132v3.361a.562.562 0 0 0 .563.563h3.299Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.234 12.516a2.046 2.046 0 0 1-.609-1.454V6.75H5.25a3.009 3.009 0 0 0-3 3v10.5a3 3 0 0 0 3 3H12a3 3 0 0 0 3-3v-7.125h-4.313a2.044 2.044 0 0 1-1.453-.61ZM17.438 5.625h3.299a.188.188 0 0 0 .134-.32L17.196 1.57a.187.187 0 0 0-.321.132v3.361a.562.562 0 0 0 .563.563Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.438 7.125a2.079 2.079 0 0 1-2.063-2.063V.75h-5.063A2.816 2.816 0 0 0 7.5 3.563V5.25h1.974a1.913 1.913 0 0 1 1.354.57l5.117 5.202c.357.362.556.851.555 1.36v6.368h2.486c1.524 0 2.764-1.262 2.764-2.813V7.126h-4.313Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgDownload = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.625 7.5H12.75v7.19l2.47-2.47a.75.75 0 0 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 1.06-1.06l2.47 2.47V7.5H6.375a2.628 2.628 0 0 0-2.625 2.625v9.75A2.628 2.628 0 0 0 6.375 22.5h11.25a2.627 2.627 0 0 0 2.625-2.625v-9.75A2.627 2.627 0 0 0 17.625 7.5ZM12.75 2.25a.75.75 0 1 0-1.5 0V7.5h1.5V2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgDuplicate = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 5.25h-10.5A3.375 3.375 0 0 0 5.25 8.625v10.5A3.375 3.375 0 0 0 8.625 22.5h10.5a3.375 3.375 0 0 0 3.375-3.375v-10.5a3.375 3.375 0 0 0-3.375-3.375Zm-1.521 9.375h-2.979v2.979c0 .404-.31.75-.714.77a.752.752 0 0 1-.786-.749v-3h-2.979a.765.765 0 0 1-.77-.714.75.75 0 0 1 .749-.786h3v-2.979c0-.404.31-.75.714-.77a.75.75 0 0 1 .786.749v3h3a.75.75 0 0 1 .75.786.765.765 0 0 1-.771.714Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.557 3.75a3.381 3.381 0 0 0-3.182-2.25h-10.5A3.375 3.375 0 0 0 1.5 4.875v10.5a3.38 3.38 0 0 0 2.25 3.182V7.5A3.75 3.75 0 0 1 7.5 3.75h11.057Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 .75C7.453.75 3.75 4.453 3.75 9v9.683c0 1.2.47 2.354 1.313 3.21A4.43 4.43 0 0 0 8.25 23.25c1.728 0 3.15-.732 4.224-2.176.21-.281.448-.69.723-1.165.718-1.236 1.701-2.928 2.961-3.784 1.208-.821 2.214-1.854 2.906-2.987A7.798 7.798 0 0 0 20.25 9c0-4.547-3.7-8.25-8.25-8.25Zm4.5 8.625a.75.75 0 0 1-.75-.75c0-1.86-1.682-3.375-3.75-3.375S8.25 6.764 8.25 8.625v1.426c1.275-.368 2.738-.315 3.013-.301a2.25 2.25 0 0 1 1.81 3.558.872.872 0 0 1-.045.056c-.776.89-1.688 2.132-1.803 2.578a.75.75 0 0 1-1.45-.381c.258-.982 1.73-2.729 2.093-3.148a.75.75 0 0 0-.626-1.163H11.2c-.778-.042-2.15.037-2.95.39v2.61a.75.75 0 1 1-1.5 0V8.625C6.75 5.937 9.105 3.75 12 3.75s5.25 2.187 5.25 4.875a.75.75 0 0 1-.75.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEarth = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.424 4.581a10.5 10.5 0 1 0-14.849 14.85 10.499 10.499 0 1 0 14.85-14.85ZM3 12.006c0-.797.105-1.59.314-2.358.344.74.844 1.38 1.184 2.14.439.977 1.618.706 2.139 1.562.462.76-.031 1.72.314 2.516.252.577.844.703 1.253 1.125.418.425.409 1.008.472 1.563a14.314 14.314 0 0 0 .353 1.95C5.522 19.27 3 15.927 3 12.005Zm9 9a9.04 9.04 0 0 1-1.5-.126c.005-.127.007-.245.02-.328.114-.745.487-1.474.99-2.032.498-.55 1.18-.922 1.6-1.547.411-.61.534-1.43.365-2.141-.25-1.052-1.68-1.404-2.45-1.974-.443-.328-.837-.835-1.419-.877-.268-.018-.493.04-.758-.03-.244-.062-.435-.194-.695-.16-.485.064-.791.583-1.313.512-.494-.066-1.004-.645-1.116-1.116-.145-.605.335-.802.848-.855.214-.023.454-.047.66.031.271.1.4.366.642.5.457.25.549-.15.479-.554-.104-.607-.226-.854.315-1.272.375-.288.695-.496.635-1.013-.035-.303-.202-.44-.047-.743.118-.23.441-.438.651-.575.544-.355 2.328-.328 1.599-1.32-.214-.291-.61-.812-.985-.883-.468-.089-.676.435-1.003.665-.338.239-.995.51-1.333.14-.454-.496.302-.658.469-1.005.077-.162 0-.386-.13-.598.169-.071.34-.137.515-.198.11.08.24.13.375.14.314.021.61-.148.883.065.304.235.523.53.926.604.39.07.803-.157.9-.556.058-.243 0-.5-.056-.75a8.945 8.945 0 0 1 4.921 1.51c-.093-.036-.205-.031-.344.033-.284.132-.687.468-.72.802-.039.379.52.432.785.432.399 0 .803-.178.674-.638-.056-.2-.132-.407-.254-.533.294.204.576.425.844.663l-.013.012c-.27.282-.584.504-.768.847-.13.24-.277.355-.541.417-.145.034-.311.047-.433.145-.34.267-.146.909.175 1.102.406.243 1.01.129 1.316-.219.24-.272.38-.744.811-.743.19 0 .372.074.507.206.179.185.143.358.181.588.067.41.429.188.649-.019.16.285.305.579.433.88-.242.348-.434.728-1.016.322-.348-.243-.563-.596-1-.706-.382-.094-.773.004-1.15.069-.43.074-.938.107-1.263.432-.315.313-.481.732-.816 1.047-.647.61-.92 1.274-.502 2.136.404.828 1.247 1.278 2.157 1.219.893-.06 1.822-.578 1.796.72-.009.46.087.779.228 1.206.13.394.122.775.152 1.182.028.475.103.947.222 1.409A8.988 8.988 0 0 1 12 21.006Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEasel = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.688 5.25H4.313a.563.563 0 0 0-.563.563v8.625c0 .31.252.562.563.562h15.375c.31 0 .562-.252.562-.563V5.813a.562.562 0 0 0-.563-.563Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.25 3h-7.5v-.75a.75.75 0 1 0-1.5 0V3h-7.5A2.252 2.252 0 0 0 1.5 5.25V15a2.252 2.252 0 0 0 2.25 2.25h2.006l-1.227 4.294a.75.75 0 1 0 1.442.412l1.345-4.706h3.934v2.25a.75.75 0 1 0 1.5 0v-2.25h3.934l1.345 4.706a.75.75 0 1 0 1.442-.412l-1.227-4.294h2.006A2.252 2.252 0 0 0 22.5 15V5.25A2.252 2.252 0 0 0 20.25 3ZM21 15a.75.75 0 0 1-.75.75H3.75A.75.75 0 0 1 3 15V5.25a.75.75 0 0 1 .75-.75h16.5a.75.75 0 0 1 .75.75V15Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEgg = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 22.5c-2.464 0-4.534-.822-5.986-2.378-1.481-1.588-2.264-3.9-2.264-6.69 0-2.627 1.007-5.557 2.762-8.041C8.234 2.953 10.285 1.5 12 1.5c1.715 0 3.766 1.453 5.488 3.89 1.755 2.485 2.762 5.415 2.762 8.042 0 2.79-.783 5.102-2.264 6.69C16.534 21.678 14.464 22.5 12 22.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEllipse = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.75c-5.376 0-9.75-4.374-9.75-9.75S6.624 2.25 12 2.25s9.75 4.374 9.75 9.75-4.374 9.75-9.75 9.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEllipsisHorizontalCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.219a1.219 1.219 0 1 0 0-2.438 1.219 1.219 0 0 0 0 2.438ZM16.219 13.219a1.219 1.219 0 1 0 0-2.438 1.219 1.219 0 0 0 0 2.438ZM7.781 13.219a1.219 1.219 0 1 0 0-2.438 1.219 1.219 0 0 0 0 2.438Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12c0-5.383 4.367-9.75 9.75-9.75s9.75 4.367 9.75 9.75-4.367 9.75-9.75 9.75S2.25 17.383 2.25 12ZM12 3.75A8.252 8.252 0 0 0 3.75 12 8.252 8.252 0 0 0 12 20.25 8.252 8.252 0 0 0 20.25 12 8.252 8.252 0 0 0 12 3.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEllipsisHorizontal = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM19.5 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM4.5 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEllipsisVerticalCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.219a1.219 1.219 0 1 0 0-2.438 1.219 1.219 0 0 0 0 2.438ZM12 17.438A1.219 1.219 0 1 0 12 15a1.219 1.219 0 0 0 0 2.438ZM12 9a1.219 1.219 0 1 0 0-2.438A1.219 1.219 0 0 0 12 9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12c0-5.383 4.367-9.75 9.75-9.75s9.75 4.367 9.75 9.75-4.367 9.75-9.75 9.75S2.25 17.383 2.25 12ZM12 3.75A8.252 8.252 0 0 0 3.75 12 8.252 8.252 0 0 0 12 20.25 8.252 8.252 0 0 0 20.25 12 8.252 8.252 0 0 0 12 3.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEllipsisVertical = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM12 21.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5ZM12 6.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEnter = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.375v4.875h7.19l-2.47-2.47a.75.75 0 0 1 1.06-1.06l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 0 1-1.06-1.06l2.47-2.47H7.5v4.875a2.628 2.628 0 0 0 2.625 2.625h9.75a2.627 2.627 0 0 0 2.625-2.625V6.375a2.627 2.627 0 0 0-2.625-2.625h-9.75A2.628 2.628 0 0 0 7.5 6.375ZM2.25 11.25a.75.75 0 1 0 0 1.5H7.5v-1.5H2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgExit = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 17.625V12.75H8.953a.75.75 0 1 1 0-1.5h6.797V6.375a2.627 2.627 0 0 0-2.625-2.625h-9A2.628 2.628 0 0 0 1.5 6.375v11.25a2.628 2.628 0 0 0 2.625 2.625h9a2.627 2.627 0 0 0 2.625-2.625ZM19.94 12.75l-2.47 2.47a.75.75 0 0 0 1.06 1.06l3.75-3.75a.75.75 0 0 0 0-1.06l-3.75-3.75a.75.75 0 0 0-1.06 1.06l2.47 2.47h-4.19v1.5h4.19Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgExpand = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.25 14.25A.75.75 0 0 1 21 15v5.25a.75.75 0 0 1-.75.75H15a.75.75 0 0 1 0-1.5h4.5V15a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.72 13.72a.75.75 0 0 1 1.06 0l5.522 5.52a.75.75 0 1 1-1.06 1.06l-5.522-5.52a.75.75 0 0 1 0-1.06ZM3 3.75A.75.75 0 0 1 3.75 3H9a.75.75 0 0 1 0 1.5H4.5V9A.75.75 0 0 1 3 9V3.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.698 3.699a.75.75 0 0 1 1.06 0l5.522 5.52a.75.75 0 1 1-1.06 1.06L3.698 4.76a.75.75 0 0 1 0-1.06ZM14.25 3.75A.75.75 0 0 1 15 3h5.25a.75.75 0 0 1 .75.75V9a.75.75 0 0 1-1.5 0V4.5H15a.75.75 0 0 1-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.3 3.698a.75.75 0 0 1 0 1.06l-5.52 5.522a.75.75 0 1 1-1.06-1.06l5.52-5.522a.75.75 0 0 1 1.06 0ZM3.75 14.25a.75.75 0 0 1 .75.75v4.5H9A.75.75 0 0 1 9 21H3.75a.75.75 0 0 1-.75-.75V15a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.28 13.72a.75.75 0 0 1 0 1.06l-5.52 5.522a.75.75 0 1 1-1.06-1.06l5.52-5.522a.75.75 0 0 1 1.06 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgExtensionPuzzle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.178 22.5h-3.334a.844.844 0 0 1-.844-.844v-1.299a1.468 1.468 0 0 0-.455-1.067c-.365-.356-.895-.553-1.448-.54-1.001.024-1.847.905-1.847 1.925v.98a.844.844 0 0 1-.844.845H4.107A2.608 2.608 0 0 1 1.5 19.892v-3.299a.844.844 0 0 1 .844-.843h1.299c.429 0 .847-.184 1.176-.516a1.973 1.973 0 0 0 .572-1.402C5.377 12.838 4.559 12 3.605 12H2.344a.844.844 0 0 1-.844-.844v-3.3A2.607 2.607 0 0 1 4.107 5.25h2.59a.375.375 0 0 0 .375-.375V4.57A3.072 3.072 0 0 1 10.197 1.5c1.664.029 3.017 1.424 3.017 3.109v.266a.375.375 0 0 0 .375.375h2.59A2.572 2.572 0 0 1 18.75 7.82v2.59a.375.375 0 0 0 .375.375h.265c1.715 0 3.11 1.359 3.11 3.03 0 1.716-1.378 3.112-3.071 3.112h-.304a.375.375 0 0 0-.375.375v2.625a2.572 2.572 0 0 1-2.572 2.572Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEyeOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21a.744.744 0 0 1-.53-.22L3.22 4.28a.75.75 0 0 1 1.06-1.06l16.5 16.5a.75.75 0 0 1-.53 1.28ZM11.625 14.805l-2.428-2.428a.094.094 0 0 0-.159.08 3.005 3.005 0 0 0 2.508 2.507.093.093 0 0 0 .096-.051.093.093 0 0 0-.017-.108ZM12.375 9.195l2.431 2.43a.093.093 0 0 0 .15-.022.094.094 0 0 0 .01-.057 3.007 3.007 0 0 0-2.51-2.51.094.094 0 0 0-.081.159Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.016 12.814a1.51 1.51 0 0 0-.005-1.63c-1.24-1.918-2.85-3.547-4.653-4.712-1.999-1.29-4.202-1.972-6.373-1.972a10.619 10.619 0 0 0-3.367.553.187.187 0 0 0-.073.31l2.215 2.215a.188.188 0 0 0 .179.049 4.5 4.5 0 0 1 5.437 5.438.187.187 0 0 0 .05.178l3.185 3.188a.188.188 0 0 0 .253.01 16.115 16.115 0 0 0 3.152-3.627ZM12 16.5a4.5 4.5 0 0 1-4.373-5.56.188.188 0 0 0-.05-.18L4.444 7.627a.188.188 0 0 0-.253-.01c-1.144.975-2.203 2.162-3.172 3.549a1.496 1.496 0 0 0-.03 1.666c1.238 1.937 2.83 3.569 4.607 4.718 2 1.295 4.15 1.951 6.39 1.951a11.169 11.169 0 0 0 3.404-.541.187.187 0 0 0 .075-.311l-2.225-2.225a.19.19 0 0 0-.178-.05A4.5 4.5 0 0 1 12 16.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEye = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.008 11.184c-1.24-1.918-2.85-3.547-4.653-4.712-1.995-1.29-4.199-1.972-6.37-1.972-1.994 0-3.954.57-5.826 1.693-1.91 1.145-3.639 2.818-5.141 4.972a1.496 1.496 0 0 0-.03 1.666c1.238 1.937 2.831 3.569 4.607 4.718 1.999 1.295 4.15 1.951 6.39 1.951 2.189 0 4.396-.676 6.384-1.956 1.802-1.16 3.408-2.796 4.644-4.73a1.51 1.51 0 0 0-.005-1.63ZM12 16.5a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgEyedrop = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.612 2.39a3.047 3.047 0 0 0-2.143-.89h-.036a2.897 2.897 0 0 0-2.079.902.603.603 0 0 0-.05.059l-2.531 3.27c-.264.333-.598.407-.787.217l-.089-.089a2.251 2.251 0 0 0-3.184 3.184l.465.465a.092.092 0 0 1 .027.066.094.094 0 0 1-.027.066L2.75 18.065c-.22.219-.553.678-.93 2.138-.19.736-.305 1.39-.31 1.418a.75.75 0 0 0 .863.869c.027-.005.677-.114 1.412-.302 1.456-.372 1.924-.715 2.15-.938l8.426-8.427a.093.093 0 0 1 .132 0l.465.465a2.252 2.252 0 0 0 3.184-3.185l-.075-.072c-.234-.234-.118-.567.203-.803l3.27-2.529a.835.835 0 0 0 .068-.061 2.962 2.962 0 0 0 .89-2.11 2.994 2.994 0 0 0-.887-2.137Zm-9.857 10.918c-.137.137-.758.371-1.096.033-.338-.338-.105-.957.032-1.094l1.547-1.547a.095.095 0 0 1 .066-.028.094.094 0 0 1 .067.028l.93.93a.096.096 0 0 1 .027.065.093.093 0 0 1-.027.067l-1.546 1.546Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFastFood = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fast-food_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.479 4.5H18.21l.418-1.672 1.796-.612a.766.766 0 0 0 .5-.924.75.75 0 0 0-.964-.503l-2.203.75a.75.75 0 0 0-.485.529L16.665 4.5H10.52c-.404 0-.75.31-.77.714A.75.75 0 0 0 10.5 6h.129l.047.406a.389.389 0 0 0 .386.344c1.829 0 3.453.51 4.694 1.477a5.714 5.714 0 0 1 2.109 3.378c.02.093.075.175.154.229a3.374 3.374 0 0 1 1.237 4.051.371.371 0 0 0-.007.26 4.5 4.5 0 0 1 .251 1.48 4.347 4.347 0 0 1-1.003 2.81 3.756 3.756 0 0 1-1.35 1.016.375.375 0 0 0-.196.204c-.195.508-.47.98-.815 1.4a.118.118 0 0 0 .027.174c.018.012.04.019.062.019h2.307a2.26 2.26 0 0 0 2.243-2.07L22.378 6h.122a.75.75 0 0 0 .75-.786.765.765 0 0 0-.771-.714Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.095 15a1.117 1.117 0 0 1 .797.328l.727.727a.189.189 0 0 0 .204.04.189.189 0 0 0 .061-.04l.726-.727A1.12 1.12 0 0 1 8.407 15h9.214a.374.374 0 0 0 .379-.371v-.004a1.878 1.878 0 0 0-1.5-1.838c-.038-1.391-.61-2.556-1.665-3.375-.976-.76-2.28-1.162-3.773-1.162H7.688c-3.198 0-5.364 1.817-5.438 4.537a1.878 1.878 0 0 0-1.5 1.838.375.375 0 0 0 .375.375h3.97ZM8.716 16.5a.376.376 0 0 0-.265.11l-1.038 1.038a.938.938 0 0 1-1.326 0L5.05 16.61a.375.375 0 0 0-.265-.11H1.531a.747.747 0 0 0-.739.617 3.056 3.056 0 0 0-.042.508c0 1.434.99 2.602 2.215 2.625.114.709.39 1.349.805 1.85.613.741 1.505 1.15 2.511 1.15h6.188c1.006 0 1.898-.409 2.511-1.151.415-.501.69-1.141.805-1.85 1.224-.022 2.215-1.19 2.215-2.625 0-.17-.014-.34-.042-.508a.747.747 0 0 0-.739-.616H8.716Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fast-food_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgFemale = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.156 8.906C20.156 4.41 16.497.75 12 .75c-4.497 0-8.156 3.66-8.156 8.156 0 4.148 3.112 7.583 7.125 8.091v1.472H9.28a1.031 1.031 0 1 0 0 2.062h1.688v1.688a1.031 1.031 0 1 0 2.062 0V20.53h1.688a1.031 1.031 0 1 0 0-2.062H13.03v-1.472c4.013-.508 7.125-3.943 7.125-8.09Zm-14.25 0A6.1 6.1 0 0 1 12 2.812a6.1 6.1 0 0 1 6.094 6.094A6.1 6.1 0 0 1 12 15a6.1 6.1 0 0 1-6.094-6.094Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFileTrayFull = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m22.484 12.595-1.5-7.116C20.694 3.927 19.58 3 18 3H6c-.787 0-1.453.22-1.973.653-.52.434-.862 1.046-1.012 1.823l-1.5 7.12a.78.78 0 0 0-.015.154V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-5.25a.78.78 0 0 0-.016-.155Zm-18-6.815v-.013C4.65 4.903 5.131 4.5 5.998 4.5H18c.872 0 1.353.4 1.513 1.261l.003.019 1.262 5.994a.188.188 0 0 1-.183.226H15a.746.746 0 0 0-.75.742 2.25 2.25 0 1 1-4.5 0A.746.746 0 0 0 9 12H3.405a.189.189 0 0 1-.182-.143.187.187 0 0 1-.001-.083L4.484 5.78Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 7.5H6.75a.75.75 0 0 1 0-1.5h10.5a.75.75 0 1 1 0 1.5ZM18 10.5H6A.75.75 0 1 1 6 9h12a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFileTrayStacked = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 16.5H15a.75.75 0 0 0-.75.75 2.25 2.25 0 0 1-4.5 0A.75.75 0 0 0 9 16.5H2.25a.75.75 0 0 0-.75.75v3a3.003 3.003 0 0 0 3 3h15a3.004 3.004 0 0 0 3-3v-3a.75.75 0 0 0-.75-.75ZM22.475 8.807l-1.493-5.598C20.685 1.669 19.572.75 18 .75H6c-.787 0-1.453.22-1.973.653-.52.434-.855 1.034-1.008 1.803l-1.494 5.6A.745.745 0 0 0 1.5 9v2.25c0 1.654 1.346 3.75 3 3.75h15c1.654 0 3-2.096 3-3.75V9a.75.75 0 0 0-.025-.193Zm-1.823-.557H15a.746.746 0 0 0-.75.742 2.25 2.25 0 0 1-4.5 0A.746.746 0 0 0 9 8.25H3.348a.094.094 0 0 1-.09-.118l1.228-4.616C4.653 2.653 5.134 2.25 6 2.25h12c.871 0 1.352.4 1.512 1.259l1.23 4.623a.094.094 0 0 1-.09.118Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFileTray = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m22.484 12.595-1.5-7.116C20.694 3.927 19.58 3 18 3H6c-.787 0-1.453.22-1.973.653-.52.434-.862 1.046-1.012 1.823l-1.5 7.12a.78.78 0 0 0-.015.154V18a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3v-5.25a.78.78 0 0 0-.016-.155Zm-18-6.815v-.013C4.65 4.903 5.131 4.5 5.998 4.5H18c.872 0 1.353.4 1.513 1.261l.003.019 1.262 5.994a.188.188 0 0 1-.183.226H15a.746.746 0 0 0-.75.742 2.25 2.25 0 1 1-4.5 0A.747.747 0 0 0 9 12H3.405a.189.189 0 0 1-.182-.143.187.187 0 0 1-.001-.083L4.484 5.78Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFilm = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.438 3.75H3.563A2.065 2.065 0 0 0 1.5 5.813v12.375a2.065 2.065 0 0 0 2.063 2.062h16.875a2.064 2.064 0 0 0 2.062-2.063V5.813a2.065 2.065 0 0 0-2.063-2.062ZM5.25 18.188a.562.562 0 0 1-.563.562H3.563A.563.563 0 0 1 3 18.187v-1.125a.562.562 0 0 1 .563-.562h1.124a.563.563 0 0 1 .563.563v1.125Zm0-3.75a.562.562 0 0 1-.563.562H3.563A.563.563 0 0 1 3 14.437v-1.124a.562.562 0 0 1 .563-.563h1.124a.563.563 0 0 1 .563.563v1.124Zm0-3.75a.562.562 0 0 1-.563.562H3.563A.563.563 0 0 1 3 10.687V9.563A.563.563 0 0 1 3.563 9h1.124a.563.563 0 0 1 .563.563v1.124Zm0-3.75a.563.563 0 0 1-.563.562H3.563A.563.563 0 0 1 3 6.937V5.813a.563.563 0 0 1 .563-.562h1.124a.563.563 0 0 1 .563.563v1.125Zm11.329 5.812H7.42a.75.75 0 1 1 0-1.5h9.158a.75.75 0 1 1 0 1.5ZM21 18.188a.562.562 0 0 1-.563.562h-1.125a.562.562 0 0 1-.562-.563v-1.125a.562.562 0 0 1 .563-.562h1.125a.562.562 0 0 1 .562.563v1.125Zm0-3.75a.562.562 0 0 1-.563.562h-1.125a.562.562 0 0 1-.562-.563v-1.124a.562.562 0 0 1 .563-.563h1.125a.562.562 0 0 1 .562.563v1.124Zm0-3.75a.562.562 0 0 1-.563.562h-1.125a.562.562 0 0 1-.562-.563V9.563A.563.563 0 0 1 19.313 9h1.125a.562.562 0 0 1 .562.563v1.124Zm0-3.75a.563.563 0 0 1-.563.562h-1.125a.562.562 0 0 1-.562-.563V5.813a.563.563 0 0 1 .563-.562h1.125a.562.562 0 0 1 .562.563v1.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFilterCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm1.5 14.25h-3a.75.75 0 1 1 0-1.5h3a.75.75 0 1 1 0 1.5Zm2.25-3h-7.5a.75.75 0 1 1 0-1.5h7.5a.75.75 0 1 1 0 1.5Zm1.5-3H6.75a.75.75 0 1 1 0-1.5h10.5a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFilter = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.125 7.875H1.875a1.125 1.125 0 0 1 0-2.25h20.25a1.125 1.125 0 0 1 0 2.25ZM18.375 13.125H5.625a1.125 1.125 0 1 1 0-2.25h12.75a1.125 1.125 0 1 1 0 2.25ZM13.875 18.375h-3.75a1.125 1.125 0 1 1 0-2.25h3.75a1.125 1.125 0 1 1 0 2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFingerPrint = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.966 9.469a.717.717 0 0 1-.569-.273.696.696 0 0 1-.05-.78C3.25 6.907 6 3.386 12 3.386c2.6 0 4.88.684 6.775 2.03 1.559 1.105 2.433 2.355 2.849 2.958a.692.692 0 0 1-.188.974.727.727 0 0 1-.995-.187C19.688 8.078 17.39 4.78 12 4.78c-5.262 0-7.64 3.034-8.415 4.334a.703.703 0 0 1-.619.354Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.023 23.25a.718.718 0 0 1-.178-.02c-4.352-1.079-5.977-5.43-6.043-5.61l-.01-.04c-.036-.126-.91-3.11.431-4.857.615-.797 1.55-1.206 2.784-1.206 1.147 0 1.975.357 2.544 1.095.469.603.656 1.347.838 2.063.38 1.491.656 2.275 2.24 2.355.695.035 1.152-.371 1.412-.718.7-.944.822-2.484.294-3.844-.679-1.754-3.088-5.062-7.335-5.062-1.813 0-3.48.583-4.815 1.678-1.106.907-1.982 2.187-2.404 3.504-.782 2.45.244 6.302.254 6.337a.696.696 0 0 1-.51.856.722.722 0 0 1-.878-.497c-.047-.176-1.143-4.284-.24-7.116.985-3.07 4.023-6.163 8.594-6.163 2.113 0 4.109.718 5.775 2.074 1.29 1.055 2.344 2.471 2.895 3.887.7 1.808.513 3.838-.478 5.163-.66.884-1.6 1.346-2.64 1.296-2.713-.136-3.2-2.029-3.556-3.41-.365-1.416-.6-2.1-1.996-2.1-.766 0-1.305.212-1.64.648-.457.598-.493 1.532-.442 2.21.033.472.113.94.239 1.396.111.282 1.564 3.844 5.043 4.706a.698.698 0 0 1 .516.85.72.72 0 0 1-.694.525Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.436 22.928a.725.725 0 0 1-.523-.22c-1.742-1.828-2.727-3.873-3.098-6.429v-.013c-.208-1.693.097-4.088 1.59-5.736C8.507 9.315 10.056 8.697 12 8.697c2.301 0 4.109 1.07 5.236 3.089.818 1.466.98 2.928.985 2.988a.709.709 0 0 1-.64.769.715.715 0 0 1-.787-.623 7.22 7.22 0 0 0-.837-2.498c-.874-1.542-2.204-2.326-3.962-2.326-1.519 0-2.707.457-3.524 1.36-1.179 1.3-1.407 3.304-1.245 4.63.325 2.26 1.194 4.059 2.727 5.665a.69.69 0 0 1-.035.99.724.724 0 0 1-.483.187Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.461 20.915c-1.523 0-2.819-.422-3.855-1.26-2.082-1.678-2.316-4.41-2.326-4.526a.716.716 0 0 1 1.427-.11c.005.04.214 2.275 1.819 3.562.95.759 2.219 1.06 3.783.884a.713.713 0 0 1 .793.618.7.7 0 0 1-.63.773c-.336.04-.673.059-1.011.06ZM18.665 2.287C18.07 1.9 15.963.75 12 .75c-4.16 0-6.272 1.27-6.74 1.594a.544.544 0 0 0-.086.065.017.017 0 0 1-.01.005.697.697 0 0 0-.239.523.706.706 0 0 0 .718.696.73.73 0 0 0 .416-.131c.02-.015 1.838-1.35 5.942-1.35s5.932 1.33 5.952 1.34a.715.715 0 0 0 .432.14.706.706 0 0 0 .716-.697.698.698 0 0 0-.436-.648Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFish = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fish_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12c0-.776-.669-2.192-2.138-3.469a9.706 9.706 0 0 0-2.825-1.693.148.148 0 0 0-.185.073.801.801 0 0 1-.022.04l-.45.746a8.59 8.59 0 0 0 .004 8.614l.01.019.41.75a.188.188 0 0 0 .232.085C22.483 15.816 24 13.195 24 12Zm-4.402-.007a.75.75 0 1 1-.195-1.488.75.75 0 0 1 .195 1.488Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.724 12c0-1.778.47-3.525 1.363-5.062l.006-.01.216-.36a.188.188 0 0 0-.12-.28 13.328 13.328 0 0 0-1.841-.253.372.372 0 0 1-.201-.075c-.904-.688-2.696-1.89-4.522-2.198a.75.75 0 0 0-.844.945l.498 1.743a.188.188 0 0 1-.113.227c-1.728.641-3.215 1.816-4.3 2.711a.375.375 0 0 1-.472.003 14.547 14.547 0 0 0-.454-.346C3.082 7.688.899 7.509.807 7.503a.75.75 0 0 0-.79.909c.02.09.432 1.907 1.487 3.357a.38.38 0 0 1 0 .447C.449 13.666.037 15.483.018 15.573a.75.75 0 0 0 .789.91c.093-.007 2.275-.188 4.13-1.542.152-.111.3-.224.444-.338a.375.375 0 0 1 .472.003c1.09.9 2.58 2.076 4.312 2.719a.188.188 0 0 1 .114.226l-.5 1.743a.75.75 0 0 0 .844.946c.804-.136 2.432-.603 4.502-2.195a.382.382 0 0 1 .204-.078c.618-.04 1.233-.123 1.839-.248a.189.189 0 0 0 .149-.19.187.187 0 0 0-.023-.083l-.211-.389A10.07 10.07 0 0 1 15.724 12Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "fish_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgFitness = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.08 7.164a.75.75 0 0 1 1.389.12l1.706 5.69 1.406-2.81a.75.75 0 0 1 1.342 0l1.29 2.586h4.536a9.987 9.987 0 0 0 1.001-4.47C21.72 5.37 19.385 3 16.543 3 14.29 3 12.793 4.385 12 5.39 11.209 4.384 9.711 3 7.457 3 4.615 3 2.28 5.37 2.25 8.28a9.897 9.897 0 0 0 .419 2.97h4.367L9.08 7.164Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m15.08 13.835-.83-1.658-1.58 3.158a.75.75 0 0 1-1.145.247.75.75 0 0 1-.246-.367L9.573 9.527l-1.407 2.808a.75.75 0 0 1-.666.415H3.25a13.37 13.37 0 0 0 1.748 2.703c.88 1.072 2.475 2.787 6.159 5.288a1.492 1.492 0 0 0 1.687 0c3.684-2.501 5.28-4.216 6.159-5.288.317-.386.614-.787.89-1.203H15.75a.75.75 0 0 1-.67-.415ZM21.75 12.75h-1c-.25.52-.536 1.02-.856 1.5h1.856a.75.75 0 1 0 0-1.5ZM2.25 11.25a.75.75 0 1 0 0 1.5h1a10.559 10.559 0 0 1-.581-1.5H2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFlag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 22.5a.75.75 0 0 1-.75-.75V3.194a1.125 1.125 0 0 1 .558-.972c.567-.33 1.71-.722 3.942-.722 1.744 0 3.695.69 5.416 1.297 1.386.49 2.696.953 3.584.953a8.617 8.617 0 0 0 3.328-.68.844.844 0 0 1 1.172.778V14.13a.937.937 0 0 1-.563.858c-.408.179-1.898.762-3.937.762-1.132 0-2.55-.335-4.05-.69-1.686-.398-3.43-.81-4.95-.81-1.728 0-2.613.262-3 .427v7.073a.75.75 0 0 1-.75.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFlame = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.48 9.26a14.082 14.082 0 0 0-2.502-4.218C14.118 2.89 11.674 1.5 9.75 1.5a.75.75 0 0 0-.726.938c.65 2.484-.697 4.55-2.124 6.736C5.72 10.986 4.5 12.856 4.5 15c0 4.135 3.365 7.5 7.5 7.5s7.5-3.365 7.5-7.5c0-2.03-.343-3.96-1.02-5.74Zm-4.965 10.366c-.484.516-1.09.624-1.515.624-.424 0-1.031-.108-1.515-.624-.485-.516-.735-1.334-.735-2.376 0-1.178.413-2.076.813-2.943.232-.503.469-1.016.61-1.564a.375.375 0 0 1 .585-.211c.428.331.81.72 1.133 1.155.851 1.126 1.359 2.458 1.359 3.563 0 1.043-.254 1.864-.735 2.376Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFlashOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21a.746.746 0 0 1-.53-.22L3.22 4.28a.75.75 0 0 1 1.06-1.06l16.5 16.5a.75.75 0 0 1-.53 1.28ZM20.227 9.562A.75.75 0 0 0 19.5 9h-5.1l1.322-7.236a.865.865 0 0 0-1.531-.686L9.85 6.443a.188.188 0 0 0 .013.25l7.078 7.08a.186.186 0 0 0 .218.034.186.186 0 0 0 .06-.05l2.85-3.523a.767.767 0 0 0 .157-.672ZM14.136 17.306l-7.078-7.078a.188.188 0 0 0-.278.014l-2.852 3.523a.767.767 0 0 0-.155.673A.75.75 0 0 0 4.5 15h5.101l-1.316 7.236v.005a.861.861 0 0 0 1.523.681l4.341-5.365a.188.188 0 0 0-.013-.251Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFlash = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.132 23.25a.86.86 0 0 1-.848-1.01v-.005L9.6 15H4.5a.75.75 0 0 1-.583-1.222l10.273-12.7a.865.865 0 0 1 1.538.642c0 .014-.004.028-.006.042L14.4 9h5.1a.75.75 0 0 1 .583 1.221l-10.275 12.7a.866.866 0 0 1-.676.329Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFlashlight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.656 10.125c.439-.439.71-.895.806-1.357.127-.607-.06-1.198-.526-1.664l-5.04-5.04c-.664-.662-1.802-.936-3.021.28l-.094.093a.376.376 0 0 0 0 .53l7.249 7.251a.374.374 0 0 0 .532 0l.094-.093ZM11.725 7.176l-.007.11c-.025.336-.323.897-.65 1.225l-8.852 8.85a2.353 2.353 0 0 0-.706 1.907c.06.634.373 1.263.88 1.771l.571.57c.591.591 1.302.891 1.992.891a2.362 2.362 0 0 0 1.687-.714l8.852-8.85c.332-.332.883-.624 1.227-.65.82-.062 2.042-.154 3.178-.734a.188.188 0 0 0 .047-.299l-7.208-7.207a.188.188 0 0 0-.3.047c-.568 1.077-.648 2.199-.71 3.083Zm-.466 6.882a.938.938 0 1 1-1.455-1.184.938.938 0 0 1 1.455 1.184Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFlask = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m21.203 17.11-5.856-9.276A2.254 2.254 0 0 1 15 6.632V3h.73c.403 0 .75-.31.77-.714a.751.751 0 0 0-.75-.786H8.271c-.403 0-.75.31-.77.714A.75.75 0 0 0 8.25 3H9v3.632c0 .425-.12.842-.347 1.201L2.798 17.11a3.469 3.469 0 0 0-.118 3.555C3.302 21.806 4.517 22.5 5.82 22.5H18.18c1.302 0 2.517-.694 3.139-1.838a3.468 3.468 0 0 0-.117-3.553ZM9.921 8.633c.378-.599.579-1.293.578-2.002V3.188A.188.188 0 0 1 10.688 3h2.624a.187.187 0 0 1 .188.188v3.444c0 .709.2 1.403.579 2.002l2.71 4.29a.375.375 0 0 1-.319.576H7.53a.375.375 0 0 1-.318-.575l2.71-4.29Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFlower = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#flower_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.31 14.246a3.164 3.164 0 0 0-2.08-5.415.243.243 0 0 1-.167-.41 3.18 3.18 0 0 0-2.344-5.311h-.012c-.788 0-1.547.295-2.128.828a.244.244 0 0 1-.41-.168 3.172 3.172 0 0 0-6.339 0 .244.244 0 0 1-.409.168 3.146 3.146 0 0 0-2.13-.83h-.01a3.183 3.183 0 0 0-2.343 5.313.244.244 0 0 1-.168.41 3.174 3.174 0 0 0 0 6.338.246.246 0 0 1 .229.288.245.245 0 0 1-.061.122 3.166 3.166 0 0 0 2.347 5.297h.012a3.159 3.159 0 0 0 2.124-.813.244.244 0 0 1 .409.168 3.174 3.174 0 0 0 6.339 0 .246.246 0 0 1 .15-.215.244.244 0 0 1 .259.047 3.158 3.158 0 0 0 2.123.816h.012a3.163 3.163 0 0 0 2.347-5.296.245.245 0 0 1 .168-.41 3.155 3.155 0 0 0 2.081-.927ZM12 15.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "flower_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgFolderOpen = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 4.5h-7.307a1.12 1.12 0 0 1-.624-.188L9.89 3.441A2.614 2.614 0 0 0 8.432 3H4.875A2.628 2.628 0 0 0 2.25 5.625V6.75h19.5c0-1.448-1.177-2.25-2.625-2.25ZM19.863 21H4.137a2.625 2.625 0 0 1-2.622-2.585L.76 10.693v-.013A2.25 2.25 0 0 1 3 8.25h18.005a2.25 2.25 0 0 1 2.24 2.43v.013l-.76 7.722A2.625 2.625 0 0 1 19.863 21Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFolder = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 7.125A2.625 2.625 0 0 0 20.625 4.5H10.318a1.12 1.12 0 0 1-.624-.188L8.39 3.441A2.614 2.614 0 0 0 6.932 3H3.375A2.625 2.625 0 0 0 .75 5.625v2.25a.375.375 0 0 0 .375.375h21.75a.375.375 0 0 0 .375-.375v-.75ZM.75 18.375A2.625 2.625 0 0 0 3.375 21h17.25a2.625 2.625 0 0 0 2.625-2.625v-8.25a.375.375 0 0 0-.375-.375H1.125a.375.375 0 0 0-.375.375v8.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFootball = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm6.703 14.25h-2.12a.374.374 0 0 1-.323-.188l-.757-1.297a.375.375 0 0 1-.04-.281l.696-2.809a.375.375 0 0 1 .218-.256l1.317-.557a.375.375 0 0 1 .391.06l1.952 1.68a.376.376 0 0 1 .126.34 8.192 8.192 0 0 1-1.138 3.126.376.376 0 0 1-.322.182ZM6.306 11.116l1.317.557a.374.374 0 0 1 .218.256l.696 2.809a.375.375 0 0 1-.04.28l-.757 1.294a.375.375 0 0 1-.323.188h-2.12a.376.376 0 0 1-.32-.179 8.192 8.192 0 0 1-1.138-3.125.375.375 0 0 1 .126-.34l1.952-1.68a.375.375 0 0 1 .389-.06Zm12.044-4.09-.847 2.409a.377.377 0 0 1-.206.221l-1.387.588a.376.376 0 0 1-.387-.059l-2.637-2.212a.376.376 0 0 1-.136-.285V6.112a.375.375 0 0 1 .167-.311l2.008-1.338a.375.375 0 0 1 .359-.032 8.292 8.292 0 0 1 2.997 2.224.375.375 0 0 1 .069.37ZM9.075 4.464l2.008 1.338a.375.375 0 0 1 .167.311v1.574a.374.374 0 0 1-.134.288l-2.637 2.212a.375.375 0 0 1-.387.058l-1.389-.589a.375.375 0 0 1-.208-.221l-.847-2.408a.375.375 0 0 1 .07-.37 8.293 8.293 0 0 1 3-2.226.375.375 0 0 1 .357.033Zm.811 15.35-.924-2.33a.375.375 0 0 1 .024-.328l.711-1.218a.375.375 0 0 1 .324-.188h3.958a.374.374 0 0 1 .324.188l.711 1.218a.376.376 0 0 1 .025.328l-.918 2.329a.375.375 0 0 1-.267.228 8.277 8.277 0 0 1-3.703 0 .374.374 0 0 1-.265-.227Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgFunnel = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.875 21.75c-.12 0-.24-.02-.354-.058l-3.757-1.25A1.121 1.121 0 0 1 9 19.374v-5.588a.02.02 0 0 0-.004-.006L1.09 4.572A1.406 1.406 0 0 1 2.16 2.25h19.685a1.406 1.406 0 0 1 1.068 2.322l-7.908 9.21a.036.036 0 0 0-.004.005v6.838a1.122 1.122 0 0 1-1.125 1.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGameController = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.647 11.502c-.994-4.495-2.49-6.894-4.71-7.55A5.022 5.022 0 0 0 16.5 3.75c-.643 0-1.202.156-1.794.322-.714.2-1.524.428-2.706.428s-1.993-.227-2.708-.427C8.7 3.906 8.141 3.75 7.5 3.75a5.426 5.426 0 0 0-1.487.202C3.805 4.605 2.31 7.002 1.3 11.5.216 16.338.75 19.392 2.798 20.101c.28.1.576.15.874.151 1.403 0 2.528-1.168 3.296-2.125.869-1.083 1.886-1.632 5.032-1.632 2.81 0 3.973.38 4.978 1.632.631.786 1.228 1.337 1.823 1.683.792.46 1.583.563 2.351.299 1.21-.413 1.904-1.505 2.063-3.246.12-1.335-.065-3.088-.568-5.361ZM9.75 11.25h-1.5v1.5a.75.75 0 1 1-1.5 0v-1.5h-1.5a.75.75 0 1 1 0-1.5h1.5v-1.5a.75.75 0 0 1 1.5 0v1.5h1.5a.75.75 0 1 1 0 1.5Zm3.938.187a.938.938 0 1 1 0-1.876.938.938 0 0 1 0 1.876ZM15.75 13.5a.937.937 0 1 1 0-1.874.937.937 0 0 1 0 1.874Zm0-4.125a.938.938 0 1 1 0-1.876.938.938 0 0 1 0 1.876Zm2.063 2.062a.938.938 0 1 1 0-1.876.938.938 0 0 1 0 1.876Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGift = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.75 19.5a3 3 0 0 0 3 3h4.313a.188.188 0 0 0 .187-.188v-8.625a.188.188 0 0 0-.188-.187H4.125a.375.375 0 0 0-.375.375V19.5ZM11.25 11.812V6.75h1.5v5.062a.188.188 0 0 0 .188.188H19.5a2.247 2.247 0 0 0 1.836-.952c.269-.38.413-.833.414-1.298V9a2.25 2.25 0 0 0-2.25-2.25h-1.9a.094.094 0 0 1-.093-.094c0-.017.005-.033.013-.047A3.375 3.375 0 0 0 12 2.757a3.375 3.375 0 0 0-5.52 3.852.094.094 0 0 1-.08.14H4.5A2.25 2.25 0 0 0 2.25 9v.75A2.254 2.254 0 0 0 4.5 12h6.563a.187.187 0 0 0 .187-.187Zm1.5-6.937a1.875 1.875 0 1 1 1.875 1.875H12.75V4.875Zm-3.51-1.87a1.875 1.875 0 0 1 2.01 1.87V6.75H9.375a1.875 1.875 0 0 1-.134-3.745ZM12.938 22.5h4.312a3 3 0 0 0 3-3v-5.625a.375.375 0 0 0-.375-.375h-6.938a.188.188 0 0 0-.187.188v8.624a.188.188 0 0 0 .188.188Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGitBranch = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 7.5a2.999 2.999 0 1 0-4.513 2.589c-.107 1.363-.94 1.734-3.515 2.27-.833.172-1.684.349-2.471.653V7.096a3 3 0 1 0-3 0v9.807a3 3 0 1 0 3.02.011c.112-.843.75-1.14 3.059-1.618 1.286-.265 2.614-.54 3.74-1.263 1.359-.871 2.087-2.193 2.172-3.932A3 3 0 0 0 19.5 7.5ZM7.5 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm9-12a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGitCommit = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 10.5h-3.188a6 6 0 0 0-11.62 0H3a1.5 1.5 0 0 0 0 3h3.19a6 6 0 0 0 11.622 0H21a1.5 1.5 0 1 0 0-3ZM12 15a3 3 0 1 1 0-5.999 3 3 0 0 1 0 6Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGitCompare = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.233 15.97a.75.75 0 0 0-1.28.53V18h-.937a1.313 1.313 0 0 1-1.313-1.313V7.125a3 3 0 1 0-3-.055v9.617A4.317 4.317 0 0 0 8.016 21h.937v1.5a.75.75 0 0 0 1.28.53l3-3a.75.75 0 0 0 0-1.06l-3-3ZM5.25 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM20.25 16.903v-9.59A4.317 4.317 0 0 0 15.937 3H15V1.5a.75.75 0 0 0-1.28-.53l-3 3a.75.75 0 0 0 0 1.06l3 3A.75.75 0 0 0 15 7.5V6h.938a1.313 1.313 0 0 1 1.312 1.312v9.591a3 3 0 1 0 3 0ZM18.75 21a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGitMerge = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.047 10.5a3 3 0 0 0-2.594 1.494c-1.98-.056-3.993-.596-5.447-1.468-1.51-.906-2.33-2.063-2.445-3.438a3 3 0 1 0-3.014.008v9.807a3 3 0 1 0 3 0v-4.428c2.098 1.594 5.029 2.456 7.901 2.52a3 3 0 1 0 2.599-4.495Zm-12-7.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm12-6a1.5 1.5 0 1 1 0-3.001 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGitNetwork = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 4.5a3 3 0 1 0-4.515 2.588c-.083.978-.537 1.786-1.353 2.404C14.3 10.125 13.13 10.5 12 10.5c-1.13 0-2.3-.375-3.132-1.008-.816-.618-1.27-1.426-1.353-2.404a3 3 0 1 0-3.006.014c.098 1.915.993 3.603 2.546 4.78.975.74 2.18 1.252 3.445 1.482v3.54a3 3 0 1 0 3 0v-3.54c1.266-.23 2.47-.742 3.445-1.481 1.553-1.178 2.448-2.866 2.546-4.781A3 3 0 0 0 21 4.5ZM6 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm6 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm6-15a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGitPullRequest = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9 4.5a3 3 0 1 0-4.5 2.596v9.807a3 3 0 1 0 3 0V7.096A3 3 0 0 0 9 4.5ZM6 3a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0 18a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM19.5 16.903v-9.59A4.317 4.317 0 0 0 15.188 3h-.938V1.5a.75.75 0 0 0-1.28-.53l-3 3a.75.75 0 0 0 0 1.06l3 3a.75.75 0 0 0 1.28-.53V6h.938A1.312 1.312 0 0 1 16.5 7.312v9.591a3 3 0 1 0 3 0ZM18 21a1.5 1.5 0 1 1 0-3.001 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGlasses = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 8.625h-.51a3.692 3.692 0 0 0-.75-.337c-.826-.272-1.915-.413-3.24-.413-1.325 0-2.414.14-3.237.413-.66.22-.95.463-1.043.557a2.247 2.247 0 0 0-1.939 0c-.094-.094-.384-.337-1.043-.557-.824-.272-1.913-.413-3.238-.413s-2.414.14-3.237.413a3.69 3.69 0 0 0-.75.337H2.25a.75.75 0 0 0 0 1.5h.008c.047 2.13.302 3.412.849 4.323a3.13 3.13 0 0 0 1.496 1.313c.573.245 1.276.365 2.147.365 1.132 0 2.741-.174 3.643-1.677.454-.756.707-1.767.807-3.305a.748.748 0 0 0 .05-.269.75.75 0 1 1 1.5 0c0 .091.017.182.05.268.1 1.539.353 2.549.807 3.305a3.13 3.13 0 0 0 1.496 1.313c.573.245 1.276.365 2.147.365 1.132 0 2.741-.174 3.643-1.677.547-.912.803-2.192.849-4.323h.008a.75.75 0 1 0 0-1.5v-.001Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGlobe = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.973 16.148c.277-.97.46-2.098.53-3.18a.205.205 0 0 0-.127-.202.205.205 0 0 0-.082-.016h-3.331a.207.207 0 0 0-.21.205v2.593a.208.208 0 0 0 .194.205c.939.076 1.867.255 2.766.534a.209.209 0 0 0 .26-.14ZM15.168 17.687a12.181 12.181 0 0 0-2.184-.426.209.209 0 0 0-.211.118.207.207 0 0 0-.02.083v3.058a.21.21 0 0 0 .317.173c.745-.434 1.36-1.164 1.915-2.13.09-.157.229-.428.312-.594a.2.2 0 0 0-.13-.282ZM11.03 17.269c-.74.07-1.47.208-2.183.413-.124.036-.176.207-.12.319.084.166.188.38.276.539.61 1.078 1.258 1.758 1.933 2.153a.21.21 0 0 0 .317-.173v-3.06a.195.195 0 0 0-.224-.191ZM11.044 12.75H7.713a.205.205 0 0 0-.197.134.207.207 0 0 0-.012.083c.07 1.081.251 2.21.528 3.18a.21.21 0 0 0 .262.14 12.76 12.76 0 0 1 2.765-.532.208.208 0 0 0 .195-.205v-2.594a.21.21 0 0 0-.13-.191.206.206 0 0 0-.08-.015ZM12.984 6.74c.74-.07 1.47-.213 2.18-.429a.202.202 0 0 0 .13-.281c-.084-.167-.2-.407-.29-.567-.576-1.03-1.225-1.75-1.933-2.156a.21.21 0 0 0-.317.174v3.057a.206.206 0 0 0 .146.193.207.207 0 0 0 .084.009ZM12.963 11.25h3.33a.205.205 0 0 0 .21-.214c-.07-1.068-.247-2.24-.523-3.198a.21.21 0 0 0-.181-.147.209.209 0 0 0-.081.009c-.891.269-1.819.489-2.77.562a.206.206 0 0 0-.195.203v2.583a.206.206 0 0 0 .21.202ZM10.936 3.308c-.722.401-1.367 1.145-1.943 2.173-.09.16-.197.38-.282.547a.202.202 0 0 0 .13.282c.71.22 1.44.363 2.181.43a.208.208 0 0 0 .23-.202V3.481a.21.21 0 0 0-.316-.173ZM11.059 8.262c-.952-.073-1.88-.293-2.77-.563a.21.21 0 0 0-.262.139c-.276.957-.454 2.13-.523 3.198a.206.206 0 0 0 .209.214h3.33a.207.207 0 0 0 .21-.203V8.464a.206.206 0 0 0-.194-.202Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.424 4.575a10.5 10.5 0 1 0-14.849 14.85 10.5 10.5 0 1 0 14.85-14.85ZM8.278 20.195a10.275 10.275 0 0 1-.585-.92 18.95 18.95 0 0 1-.315-.616.342.342 0 0 0-.484-.148c-.201.113-.468.268-.662.395a6.905 6.905 0 0 1-1.105-1.052c.454-.32.93-.608 1.426-.86.087-.047.13-.1.102-.196a17.568 17.568 0 0 1-.66-3.852.204.204 0 0 0-.202-.195h-2.66a.094.094 0 0 1-.094-.08A4.606 4.606 0 0 1 3 12c-.002-.224.011-.448.041-.67a.094.094 0 0 1 .094-.08h2.66c.107 0 .195-.062.2-.17a17.47 17.47 0 0 1 .657-3.836.204.204 0 0 0-.103-.24 12.217 12.217 0 0 1-1.398-.838 7.96 7.96 0 0 1 1.084-1.07c.192.126.44.268.64.381a.37.37 0 0 0 .516-.16 11.7 11.7 0 0 1 .284-.557c.18-.321.376-.633.588-.933A8.672 8.672 0 0 1 12 3c1.357 0 2.62.328 3.775.865.204.286.391.583.562.89.122.219.25.487.36.719a.201.201 0 0 0 .277.09c.252-.136.525-.293.766-.45.396.323.76.684 1.087 1.077-.435.302-.89.573-1.362.812a.204.204 0 0 0-.102.24c.367 1.241.585 2.522.65 3.815a.203.203 0 0 0 .2.194l2.655-.004a.094.094 0 0 1 .094.08c.054.445.054.896 0 1.341a.094.094 0 0 1-.094.081H18.21a.204.204 0 0 0-.201.196 17.22 17.22 0 0 1-.65 3.81.208.208 0 0 0 .102.244c.235.121.496.257.72.395.226.137.448.285.663.437a8.098 8.098 0 0 1-1.078 1.075 10.93 10.93 0 0 0-.367-.231l-.312-.177c-.18-.1-.37-.025-.46.16a9.961 9.961 0 0 1-.9 1.537c-1.154.54-2.371.804-3.728.804-1.357 0-2.567-.264-3.722-.804Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGolf = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 15.022v-5.54l7.81-3.549a.75.75 0 0 0 0-1.366L12.31.817a.75.75 0 0 0-1.06.683v13.522a13.606 13.606 0 0 1 1.5 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.719 21.445c-.402-2.008-1.646-3.69-3.6-4.865-1.523-.917-3.406-1.467-5.369-1.58v3.738a.75.75 0 1 1-1.5 0V15c-1.963.113-3.846.663-5.37 1.58-1.953 1.174-3.197 2.857-3.599 4.865a1.523 1.523 0 0 0 .302 1.27c.282.348.698.535 1.167.535h16.5c.469 0 .885-.19 1.167-.535a1.525 1.525 0 0 0 .302-1.27Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgGrid = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.563 11.25H3.186A1.687 1.687 0 0 1 1.5 9.562V3.189A1.687 1.687 0 0 1 3.188 1.5h6.374a1.687 1.687 0 0 1 1.688 1.688v6.374a1.687 1.687 0 0 1-1.688 1.688ZM20.813 11.25h-6.375a1.687 1.687 0 0 1-1.688-1.688V3.189A1.687 1.687 0 0 1 14.438 1.5h6.374A1.687 1.687 0 0 1 22.5 3.188v6.374a1.687 1.687 0 0 1-1.688 1.688ZM9.563 22.5H3.186A1.687 1.687 0 0 1 1.5 20.812v-6.375a1.687 1.687 0 0 1 1.688-1.687h6.374a1.687 1.687 0 0 1 1.688 1.688v6.374A1.687 1.687 0 0 1 9.562 22.5ZM20.813 22.5h-6.375a1.687 1.687 0 0 1-1.688-1.688v-6.375a1.687 1.687 0 0 1 1.688-1.687h6.374a1.687 1.687 0 0 1 1.688 1.688v6.374a1.687 1.687 0 0 1-1.688 1.688Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHammer = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m13.133 11.38-1.224-1.224a1.5 1.5 0 0 0-2.116-.006l-8.51 7.853c-.31.292-.513.665-.532 1.081a1.505 1.505 0 0 0 .432 1.122l1.828 1.849a1.514 1.514 0 0 0 1.067.445h.055c.417-.016.79-.211 1.087-.524l7.907-8.47a1.5 1.5 0 0 0 .005-2.126ZM22.969 8.906l-.015-.014-1.606-1.59a1.006 1.006 0 0 0-.716-.294c-.216 0-.425.068-.6.194 0-.02.003-.04.004-.057.021-.305.054-.765-.243-1.182a12.1 12.1 0 0 0-1.167-1.351c-.624-.615-1.983-1.773-4.065-2.622a6.541 6.541 0 0 0-2.488-.49c-1.48 0-2.604.667-3.035 1.063a5.621 5.621 0 0 0-.665.76.75.75 0 0 0 .875 1.141c.131-.049.265-.09.402-.123.284-.06.575-.078.865-.054.618.051 1.35.358 1.673.614.548.44.812 1.035.855 1.926.009.179-.361.85-.937 1.616a.75.75 0 0 0 .068.984l1.613 1.613a.75.75 0 0 0 1.031.03c.456-.408 1.151-1.022 1.394-1.172.36-.222.618-.265.689-.272a.9.9 0 0 1 .53.111.058.058 0 0 1-.015.045l-.086.08-.014.014a1.01 1.01 0 0 0 .003 1.432l1.605 1.59a1.005 1.005 0 0 0 .717.292c.266 0 .523-.104.713-.29l2.602-2.57a1.025 1.025 0 0 0 .013-1.424Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHandLeft = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.288 9.911c-.728-.413-1.637-.107-2.03.642l-1.94 3.956a.329.329 0 0 1-.626-.145V3.375c0-.652-.602-1.125-1.255-1.125-.652 0-1.218.473-1.218 1.125v7.342a.527.527 0 0 1-.506.533.516.516 0 0 1-.525-.516V1.125C12.188.473 11.675 0 11.021 0c-.652 0-1.178.473-1.178 1.125v9.592a.527.527 0 0 1-.506.533.516.516 0 0 1-.525-.516V2.625c0-.652-.567-1.125-1.22-1.125-.652 0-1.218.52-1.218 1.172v8.795a.527.527 0 0 1-.506.533.516.516 0 0 1-.525-.516V5.625c0-.652-.52-1.125-1.172-1.125-.653 0-1.178.48-1.172 1.125V15.75C3 21.254 6.375 24 10.5 24h.75c4.125 0 5.424-1.856 6.375-4.125l3.22-7.922c.311-.844.17-1.629-.557-2.042Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHandRight = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.712 9.911c.728-.413 1.637-.107 2.03.642l1.94 3.956a.328.328 0 0 0 .626-.145V3.375c0-.652.602-1.125 1.255-1.125.652 0 1.218.473 1.218 1.125v7.342a.526.526 0 0 0 .506.533.516.516 0 0 0 .525-.516V1.125c0-.652.513-1.125 1.166-1.125.652 0 1.178.473 1.178 1.125v9.592a.526.526 0 0 0 .506.533.516.516 0 0 0 .525-.516V2.625c0-.652.567-1.125 1.22-1.125.652 0 1.218.52 1.218 1.172v8.795a.527.527 0 0 0 .506.533.516.516 0 0 0 .525-.516V5.625c0-.652.52-1.125 1.172-1.125.653 0 1.178.48 1.172 1.125V15.75c0 5.504-3.375 8.25-7.5 8.25h-.75c-4.125 0-5.424-1.856-6.375-4.125l-3.219-7.922c-.312-.844-.17-1.629.556-2.042Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHappy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.425 4.575a10.499 10.499 0 1 0-14.85 14.85 10.5 10.5 0 1 0 14.85-14.85ZM8.625 9.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm7.86 4.976C15.922 16.616 14.132 18 12.003 18c-2.13 0-3.92-1.385-4.487-3.274a.375.375 0 0 1 .367-.476h8.235a.375.375 0 0 1 .367.476ZM15.375 12a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHardwareChip = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.125 7.5h-8.25a.375.375 0 0 0-.375.375v8.25c0 .207.168.375.375.375h8.25a.375.375 0 0 0 .375-.375v-8.25a.375.375 0 0 0-.375-.375Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 9a.75.75 0 1 0 0-1.5H21V6a3.003 3.003 0 0 0-3-3h-1.5v-.75a.75.75 0 1 0-1.5 0V3h-2.25v-.75a.75.75 0 1 0-1.5 0V3H9v-.75a.75.75 0 0 0-1.5 0V3H6a3.003 3.003 0 0 0-3 3v1.5h-.75a.75.75 0 0 0 0 1.5H3v2.25h-.75a.75.75 0 1 0 0 1.5H3V15h-.75a.75.75 0 1 0 0 1.5H3V18a3.003 3.003 0 0 0 3 3h1.5v.75a.75.75 0 1 0 1.5 0V21h2.25v.75a.75.75 0 1 0 1.5 0V21H15v.75a.75.75 0 1 0 1.5 0V21H18a3.004 3.004 0 0 0 3-3v-1.5h.75a.75.75 0 1 0 0-1.5H21v-2.25h.75a.75.75 0 1 0 0-1.5H21V9h.75ZM18 16.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-9A1.5 1.5 0 0 1 7.5 6h9A1.5 1.5 0 0 1 18 7.5v9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHeadset = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.273 4.568C17.27 2.618 14.62 1.5 12 1.5c-2.62 0-5.27 1.118-7.273 3.068C2.647 6.594 1.5 9.234 1.5 12c0 1.25.41 2.864 1.541 5.885 1.131 3.022 3.38 4.287 4.331 4.494.272.06.592.121.878.121.494 0 .978-.129 1.406-.375l.656-.375c.707-.413.913-1.319.507-2.032l-4.075-7.152a1.488 1.488 0 0 0-2.042-.551l-.642.375a2.65 2.65 0 0 0-.656.543.187.187 0 0 1-.328-.094A5.375 5.375 0 0 1 3 12c0-2.358.984-4.616 2.773-6.357C7.5 3.963 9.768 3 12 3s4.5.963 6.227 2.643C20.016 7.383 21 9.642 21 12a5.37 5.37 0 0 1-.079.84.187.187 0 0 1-.328.093 2.65 2.65 0 0 0-.656-.543l-.642-.375a1.487 1.487 0 0 0-2.042.551l-4.072 7.152c-.406.713-.2 1.619.507 2.032l.656.375c.428.246.913.375 1.406.375.286 0 .606-.062.878-.121.95-.207 3.2-1.473 4.33-4.494C22.09 14.865 22.5 13.25 22.5 12c0-2.766-1.146-5.406-3.227-7.432Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHeartCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm3.501 11.85c-.44.537-1.237 1.395-3.08 2.645a.747.747 0 0 1-.843 0c-1.843-1.25-2.64-2.11-3.08-2.644-.938-1.142-1.387-2.316-1.373-3.586.014-1.456 1.182-2.64 2.602-2.64.957 0 1.641.498 2.068.956a.282.282 0 0 0 .408 0c.428-.458 1.111-.956 2.068-.956 1.42 0 2.588 1.184 2.603 2.64.014 1.27-.436 2.444-1.373 3.586Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHeartDislikeCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm1.092 14.024c-.207.15-.43.308-.67.47a.746.746 0 0 1-.844 0c-1.843-1.251-2.64-2.11-3.08-2.645-.938-1.142-1.387-2.316-1.373-3.586v-.03a.188.188 0 0 1 .32-.127l5.669 5.634a.189.189 0 0 1 .031.224.188.188 0 0 1-.053.06Zm3.188.756a.75.75 0 0 1-1.06 0L6.97 8.78a.75.75 0 0 1 1.06-1.06l8.25 8.25a.75.75 0 0 1 0 1.06Zm-.661-3.076a.184.184 0 0 1-.281.018L9.524 8.196a.187.187 0 0 1 .131-.321h.073c.956 0 1.64.499 2.068.957a.278.278 0 0 0 .407 0c.427-.458 1.112-.957 2.068-.957 1.42 0 2.588 1.185 2.603 2.64.012 1.216-.4 2.343-1.256 3.44Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHeartDislike = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.586 21a.75.75 0 0 1-.532-.221L1.905 3.529A.75.75 0 0 1 2.97 2.47l17.148 17.25A.75.75 0 0 1 19.586 21ZM17.106 3.75c-2.067 0-3.498 1.163-4.331 2.133a.281.281 0 0 1-.425 0c-.833-.97-2.264-2.133-4.33-2.133a5.05 5.05 0 0 0-1.454.213l12.616 12.689c.14-.161.267-.311.381-.45 1.875-2.285 2.773-4.63 2.748-7.172-.028-2.911-2.364-5.28-5.205-5.28ZM3.234 6.991a5.393 5.393 0 0 0-.421 2.039c-.026 2.54.873 4.886 2.747 7.171.88 1.072 2.475 2.787 6.159 5.288a1.494 1.494 0 0 0 1.687 0 45.901 45.901 0 0 0 2.465-1.787L3.234 6.991Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHeartHalf = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.543 3C14.29 3 12.793 4.385 12 5.39 11.209 4.384 9.711 3 7.457 3 4.615 3 2.28 5.37 2.25 8.28c-.025 2.542.873 4.888 2.747 7.172.88 1.073 2.475 2.787 6.16 5.288a1.492 1.492 0 0 0 1.687 0c3.684-2.5 5.279-4.215 6.159-5.288 1.875-2.284 2.772-4.63 2.747-7.172C21.72 5.37 19.385 3 16.543 3ZM12 19.5V9.73c0-.92.245-1.817.666-2.635a5.766 5.766 0 0 1 1.024-1.344c.85-.83 1.81-1.251 2.853-1.251 2.023 0 3.686 1.702 3.707 3.797C20.297 13.2 16.108 16.71 12 19.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHeart = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 21a1.5 1.5 0 0 1-.844-.261c-3.684-2.5-5.279-4.216-6.159-5.288-1.875-2.285-2.772-4.63-2.747-7.171C2.28 5.368 4.615 3 7.457 3c2.066 0 3.497 1.164 4.33 2.133a.281.281 0 0 0 .425 0C13.046 4.163 14.477 3 16.543 3c2.842 0 5.178 2.368 5.207 5.28.025 2.541-.873 4.887-2.747 7.172-.88 1.072-2.475 2.787-6.16 5.287A1.5 1.5 0 0 1 12 21Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHelpBuoy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.424 4.575a10.499 10.499 0 1 0-14.849 14.85 10.5 10.5 0 1 0 14.85-14.85Zm-10.418 7.62a3 3 0 1 1 5.987-.39 3 3 0 0 1-5.987.39Zm11.25-3.123-4.517.274a.19.19 0 0 1-.162-.075 4.5 4.5 0 0 0-.847-.847.19.19 0 0 1-.074-.161l.274-4.518a.186.186 0 0 1 .085-.146.188.188 0 0 1 .169-.018 9.048 9.048 0 0 1 5.235 5.237.186.186 0 0 1-.081.229.188.188 0 0 1-.084.025h.002ZM9.072 3.745l.274 4.518a.19.19 0 0 1-.075.161 4.5 4.5 0 0 0-.847.847.19.19 0 0 1-.16.075l-4.518-.274a.188.188 0 0 1-.165-.254A9.047 9.047 0 0 1 8.818 3.58a.187.187 0 0 1 .254.164ZM3.746 14.927l4.517-.273a.19.19 0 0 1 .161.074 4.5 4.5 0 0 0 .847.847.19.19 0 0 1 .075.162l-.274 4.517a.187.187 0 0 1-.254.164 9.048 9.048 0 0 1-5.237-5.236.188.188 0 0 1 .165-.255Zm11.182 5.327-.274-4.518a.192.192 0 0 1 .075-.16 4.5 4.5 0 0 0 .847-.848.19.19 0 0 1 .16-.074l4.518.273a.188.188 0 0 1 .176.168c.003.03 0 .059-.011.086a9.046 9.046 0 0 1-5.237 5.237.188.188 0 0 1-.254-.164Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHelpCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-4.969 0-9 4.031-9 9s4.031 9 9 9 9-4.031 9-9-4.031-9-9-9Zm-.281 14.25a.938.938 0 1 1 0-1.875.938.938 0 0 1 0 1.875Zm1.567-4.781c-.76.51-.864.977-.864 1.406a.656.656 0 0 1-1.313 0c0-1.027.473-1.844 1.445-2.497.904-.606 1.415-.99 1.415-1.836 0-.574-.328-1.01-1.008-1.334-.16-.076-.515-.15-.953-.145-.55.007-.976.139-1.305.403-.62.499-.672 1.042-.672 1.05a.656.656 0 1 1-1.312-.064c.005-.114.084-1.14 1.16-2.006.56-.449 1.27-.682 2.11-.693.595-.007 1.155.094 1.534.273 1.135.537 1.758 1.432 1.758 2.516 0 1.586-1.06 2.298-1.995 2.927Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHelp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.72 5.146c-.29-.14-.913-.28-1.708-.271-.843.012-1.676.198-2.344.749m4.052-.478c.75.368 1.842 1.09 1.842 2.542 0 1.596-.924 2.312-2.516 3.407-.864.594-1.47 1.227-1.854 1.939-.386.718-.505 1.443-.505 2.154a.938.938 0 0 0 1.875 0c0-.492.08-.892.282-1.266.204-.38.573-.806 1.264-1.282l.037-.024c1.51-1.039 3.292-2.264 3.292-4.928 0-2.617-2.039-3.807-2.893-4.226h-.001c-.649-.317-1.595-.474-2.555-.462-1.08.015-2.394.255-3.512 1.177a5.378 5.378 0 0 0-1.631 2.25c-.126.332-.195.62-.233.832a3.624 3.624 0 0 0-.048.38v.006c0 .001 0 .002.936.043l-.937-.041a.937.937 0 1 0 1.875.071 2.904 2.904 0 0 1 .16-.628 3.504 3.504 0 0 1 1.07-1.466",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.625 20.25a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHome = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.26 4.748a.375.375 0 0 0-.518 0l-8.63 8.244a.375.375 0 0 0-.115.271L2.995 21a1.5 1.5 0 0 0 1.5 1.5H9a.75.75 0 0 0 .75-.75v-6.375a.375.375 0 0 1 .375-.375h3.75a.375.375 0 0 1 .375.375v6.375a.75.75 0 0 0 .75.75h4.503a1.5 1.5 0 0 0 1.5-1.5v-7.737a.375.375 0 0 0-.116-.271l-8.626-8.244Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.012 11.444 19.505 8.09V3a.75.75 0 0 0-.75-.75h-2.25a.75.75 0 0 0-.75.75v1.5L13.04 1.904c-.254-.257-.632-.404-1.04-.404-.407 0-.784.147-1.038.405l-9.97 9.539a.765.765 0 0 0-.063 1.048.749.749 0 0 0 1.087.05l9.726-9.294a.375.375 0 0 1 .519 0l9.727 9.294a.75.75 0 0 0 1.06-.02c.287-.299.263-.791-.036-1.078Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgHourglass = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.486 20.021c-.41-3.604-2.055-5.098-3.256-6.187C15.4 13.078 15 12.684 15 12c0-.676.398-1.062 1.226-1.802 1.216-1.086 2.88-2.574 3.26-6.227a2.204 2.204 0 0 0-.562-1.7 2.358 2.358 0 0 0-1.75-.771H6.825a2.36 2.36 0 0 0-1.752.771 2.205 2.205 0 0 0-.56 1.7c.38 3.641 2.038 5.118 3.248 6.196C8.598 10.912 9 11.301 9 12c0 .708-.403 1.104-1.242 1.863-1.196 1.083-2.836 2.566-3.244 6.159a2.184 2.184 0 0 0 .548 1.696 2.365 2.365 0 0 0 1.763.782h10.35a2.365 2.365 0 0 0 1.762-.782 2.184 2.184 0 0 0 .549-1.697Zm-3.394.229H7.928c-.731 0-.938-.844-.425-1.367 1.241-1.258 3.747-2.16 3.747-3.602V10.5c0-.93-1.781-1.64-2.883-3.15-.182-.25-.164-.6.298-.6h6.69c.395 0 .48.348.3.597C14.57 8.86 12.75 9.565 12.75 10.5v4.781c0 1.431 2.611 2.203 3.769 3.603.466.565.303 1.366-.427 1.366Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgIceCream = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.578 16.5c-1.024-.024-1.828-.886-1.828-1.91v-1.597a.375.375 0 0 0-.281-.363C4.887 12.216 3.75 10.77 3.75 9a3.757 3.757 0 0 1 3.106-3.695.375.375 0 0 0 .31-.32 4.875 4.875 0 0 1 9.667 0 .374.374 0 0 0 .31.32 3.75 3.75 0 0 1-.643 7.445 3.484 3.484 0 0 1-2.224-.816.372.372 0 0 0-.465-.007 2.949 2.949 0 0 1-1.811.636 3.772 3.772 0 0 1-1.022-.15.374.374 0 0 0-.478.36v1.852A1.874 1.874 0 0 1 8.578 16.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.347 14.049a.375.375 0 0 0-.347.37v.206a3.38 3.38 0 0 1-2.376 3.224.375.375 0 0 0-.23.505l1.918 4.444a.75.75 0 0 0 1.377-.002l3.458-8.07a.374.374 0 0 0-.29-.519 4.984 4.984 0 0 1-1.683-.543.373.373 0 0 0-.335-.01c-.47.218-.976.351-1.492.395Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgIconFacebook = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.6 12a9.6 9.6 0 1 0-11.1 9.483v-6.708H8.063V12H10.5V9.885c0-2.406 1.434-3.735 3.626-3.735 1.05 0 2.15.188 2.15.188V8.7h-1.211c-1.193 0-1.565.74-1.565 1.5V12h2.663l-.426 2.775H13.5v6.708c4.59-.72 8.1-4.691 8.1-9.483Z",
    fill: "#1877F2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.737 14.775 16.163 12H13.5v-1.8c0-.76.372-1.5 1.565-1.5h1.21V6.338s-1.099-.188-2.149-.188c-2.193 0-3.626 1.329-3.626 3.735V12H8.062v2.775H10.5v6.708a9.659 9.659 0 0 0 3 0v-6.708h2.237Z",
    fill: "#fff"
  }));
};

const SvgIconGoogle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.805 10.041H21V10h-9v4h5.651A5.998 5.998 0 0 1 6 12a6 6 0 0 1 6-6c1.53 0 2.921.577 3.98 1.52L18.81 4.69A9.954 9.954 0 0 0 12 2C6.478 2 2 6.478 2 12c0 5.523 4.478 10 10 10 5.523 0 10-4.477 10-10 0-.67-.069-1.325-.195-1.959Z",
    fill: "#FFC107"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.153 7.346 6.44 9.755A5.997 5.997 0 0 1 12 6c1.53 0 2.921.577 3.98 1.52l2.83-2.829A9.954 9.954 0 0 0 12 2a9.994 9.994 0 0 0-8.847 5.346Z",
    fill: "#FF3D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 22c2.583 0 4.93-.988 6.705-2.596l-3.095-2.619A5.955 5.955 0 0 1 12 18a5.997 5.997 0 0 1-5.641-3.973L3.098 16.54C4.753 19.777 8.114 22 12 22Z",
    fill: "#4CAF50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.805 10.041H21V10h-9v4h5.651a6.02 6.02 0 0 1-2.043 2.785h.002l3.095 2.619C18.485 19.602 22 17 22 12c0-.67-.069-1.325-.195-1.959Z",
    fill: "#1976D2"
  }));
};

const SvgIconMicrosoft = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.525 11.525H2.4V2.4h9.125v9.125Z",
    fill: "#F1511B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 11.525h-9.124V2.4H21.6v9.125Z",
    fill: "#80CC28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.525 21.6H2.4v-9.125h9.125V21.6Z",
    fill: "#00ADEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6 21.6h-9.124v-9.125H21.6V21.6Z",
    fill: "#FBBC09"
  }));
};

const SvgImage = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-15a3.003 3.003 0 0 0-3 3v12a3.003 3.003 0 0 0 3 3h15a3.004 3.004 0 0 0 3-3V6a3.003 3.003 0 0 0-3-3Zm-3.75 3a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5ZM4.5 19.5A1.5 1.5 0 0 1 3 18v-3.17l4.446-3.952a2.253 2.253 0 0 1 3.084.09l3.045 3.037L8.08 19.5H4.5ZM21 18a1.5 1.5 0 0 1-1.5 1.5h-9.299l5.692-5.692a2.237 2.237 0 0 1 2.89-.007L21 15.649V18Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgImages = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#images_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.107 5.25H6.657c-1.595 0-2.907 1.29-2.907 2.875v11.5c0 1.585 1.313 2.875 2.906 2.875h14.438c1.593 0 2.906-1.227 2.906-2.813V8.126a2.887 2.887 0 0 0-2.893-2.875Zm-3.616 2.875a2.156 2.156 0 1 1-2.17 2.157 2.165 2.165 0 0 1 2.17-2.157ZM6.637 21.063c-.797 0-1.4-.645-1.4-1.437v-3.04l4.24-3.786a2.18 2.18 0 0 1 2.974.085l2.937 2.912-5.297 5.265H6.637ZM22.5 19.625a1.44 1.44 0 0 1-1.44 1.437h-8.92l5.489-5.453a2.168 2.168 0 0 1 2.786-.007l2.085 1.77v2.253Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 1.5H3a3 3 0 0 0-3 3v12a3.005 3.005 0 0 0 2.25 2.906V7.125A3.375 3.375 0 0 1 5.625 3.75h15.281A3.005 3.005 0 0 0 18 1.5Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "images_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgInfinite = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.375 12c0-3.127 2.582-5.625 5.719-5.625 2.303 0 4.06 1.409 5.158 2.62a12.709 12.709 0 0 1 1.717 2.43c.01.02.02.036.025.048l.008.015.002.005.002.003L12 12l1.006-.503a1.125 1.125 0 0 1-2.011 1.008l-.002-.004-.014-.027a9.423 9.423 0 0 0-.337-.574 10.463 10.463 0 0 0-1.058-1.394c-.941-1.04-2.137-1.881-3.49-1.881-1.938 0-3.469 1.534-3.469 3.375s1.531 3.375 3.469 3.375c1.06 0 2.047-.464 2.916-1.222a1.125 1.125 0 0 1 1.48 1.694c-1.152 1.006-2.644 1.778-4.396 1.778C2.957 17.625.375 15.127.375 12Zm10.62.504Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.519 8.145c1.13-.967 2.66-1.77 4.387-1.77 3.137 0 5.719 2.498 5.719 5.625s-2.582 5.625-5.719 5.625c-2.303 0-4.06-1.409-5.158-2.62a12.712 12.712 0 0 1-1.717-2.43c-.01-.02-.02-.036-.025-.048l-.008-.015-.002-.005-.002-.003L12 12l-1.006.503a1.125 1.125 0 0 1 2.011-1.008l.002.004.014.027.065.12a10.458 10.458 0 0 0 1.33 1.85c.941 1.038 2.137 1.879 3.49 1.879 1.938 0 3.469-1.534 3.469-3.375s-1.531-3.375-3.469-3.375c-1.025 0-2.055.486-2.925 1.23a1.125 1.125 0 0 1-1.462-1.71Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgInformationCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.625c-5.17 0-9.375 4.206-9.375 9.375 0 5.17 4.206 9.375 9.375 9.375 5.17 0 9.375-4.206 9.375-9.375 0-5.17-4.206-9.375-9.375-9.375Zm0 3.844a1.219 1.219 0 1 1 0 2.437 1.219 1.219 0 0 1 0-2.437Zm2.25 10.593h-4.125a.75.75 0 1 1 0-1.5h1.313v-4.124h-.75a.75.75 0 1 1 0-1.5h1.5a.75.75 0 0 1 .75.75v4.874h1.312a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgInformation = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 10.313c0-.518.42-.938.938-.938h3c.517 0 .937.42.937.938v8.062a.937.937 0 1 1-1.875 0V11.25H9.187a.937.937 0 0 1-.937-.938Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.828 18.563c0-.518.42-.938.938-.938h6.468a.938.938 0 0 1 0 1.875H8.766a.937.937 0 0 1-.938-.938Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 7.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgInvertMode = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18ZM1.5 12C1.5 6.201 6.201 1.5 12 1.5S22.5 6.201 22.5 12 17.799 22.5 12 22.5 1.5 17.799 1.5 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 8.25v7.5a3.75 3.75 0 0 0 0-7.5ZM12 2.25v6a3.75 3.75 0 1 0 0 7.5v6A9.75 9.75 0 0 1 2.25 12 9.75 9.75 0 0 1 12 2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgJournal = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.594 1.5H6.75a3.003 3.003 0 0 0-3 3v15a3.003 3.003 0 0 0 3 3h6.844v-21ZM17.25 1.5h-.844v21h.844a3.004 3.004 0 0 0 3-3v-15a3.003 3.003 0 0 0-3-3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgKey = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.223 7.836c0 .61 0 1.2.193 1.753-2.02 2.372-7.355 8.64-7.852 9.117a.946.946 0 0 0-.314.704c0 .398.244.782.45.998.31.323 1.631 1.547 1.875 1.313.722-.704.867-.891 1.162-1.182.446-.436-.046-1.326.108-1.687.155-.361.32-.431.586-.488.267-.056.74.136 1.111.14.39.005.6-.159.89-.43.235-.216.404-.418.409-.732.009-.421-.6-.98-.146-1.425.455-.445 1.111.291 1.594.235.483-.056 1.069-.727 1.13-1.013.06-.286-.549-1.022-.455-1.439.033-.14.319-.469.534-.515.216-.047 1.172.323 1.388.276.262-.056.567-.333.816-.487.726.314 1.387.44 2.236.44 3.21 0 5.812-2.503 5.812-5.587 0-3.085-2.602-5.577-5.813-5.577-3.21 0-5.714 2.502-5.714 5.586ZM18.75 6.75a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgKeypad = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 18.75a2.25 2.25 0 1 0 0 4.501 2.25 2.25 0 0 0 0-4.501ZM12 12.75a2.25 2.25 0 1 0 0 4.501 2.25 2.25 0 0 0 0-4.501ZM12 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM12 .75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM18 12.75a2.25 2.25 0 1 0 0 4.501 2.25 2.25 0 0 0 0-4.501ZM18 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM18 .75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM6 12.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM6 6.75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5ZM6 .75a2.25 2.25 0 1 0 0 4.5 2.25 2.25 0 0 0 0-4.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLanguage = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m22.422 20.325-4.219-10.22a1.031 1.031 0 0 0-1.906 0l-4.22 10.22a1.034 1.034 0 0 0 .559 1.351 1.03 1.03 0 0 0 1.348-.564l.86-2.081h4.812l.86 2.08a1.032 1.032 0 1 0 1.905-.786Zm-6.727-3.357 1.555-3.766 1.555 3.766h-3.11ZM12.555 16.074a1.031 1.031 0 0 0-.23-1.439c-.009-.007-.702-.521-1.71-1.628 1.859-2.516 2.912-5.379 3.341-6.726h1.513a1.031 1.031 0 0 0 0-2.062H10.03V3.28a1.031 1.031 0 1 0-2.062 0v.938H2.53a1.031 1.031 0 1 0 0 2.062h9.246c-.446 1.264-1.268 3.258-2.521 5.08-1.472-1.954-2.02-3.218-2.024-3.229a1.031 1.031 0 0 0-1.902.797c.027.065.682 1.605 2.478 3.934l.128.165c-1.839 2.079-3.644 3.368-4.399 3.785a1.03 1.03 0 1 0 .988 1.81c.101-.055 2.278-1.26 4.764-4.012 1.055 1.13 1.781 1.662 1.825 1.693a1.031 1.031 0 0 0 1.441-.23Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLaptop = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#laptop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 18.75h-1.328c.372-.413.578-.95.578-1.507V6.007a2.259 2.259 0 0 0-2.257-2.257H3.757A2.26 2.26 0 0 0 1.5 6.007v11.236c0 .557.206 1.094.578 1.507H.75a.75.75 0 1 0 0 1.5h22.5a.75.75 0 1 0 0-1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "laptop_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgLayers = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 12c-.631 0-1.263-.112-1.755-.336L3.308 8.5C2.99 8.356 2.25 7.934 2.25 7.136c0-.797.74-1.218 1.058-1.365l6.998-3.19c.964-.441 2.42-.441 3.384 0l7.002 3.19c.318.145 1.058.567 1.058 1.365s-.74 1.219-1.058 1.365l-6.938 3.163c-.491.224-1.123.336-1.754.336Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.689 10.632-.708-.32-1.817.832-4.406 2.016c-.492.225-1.125.337-1.755.337-.63 0-1.262-.112-1.754-.337l-4.41-2.016-1.818-.832-.713.321c-.318.145-1.058.57-1.058 1.367s.74 1.223 1.058 1.367l6.937 3.17c.49.226 1.122.338 1.755.338.633 0 1.263-.113 1.755-.337l6.931-3.17c.32-.144 1.064-.567 1.064-1.368 0-.801-.74-1.222-1.061-1.368Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m20.689 15.506-.708-.319-1.817.832-4.406 2.013c-.492.224-1.125.336-1.755.336-.63 0-1.262-.112-1.754-.336l-4.41-2.016-1.818-.828-.713.32c-.318.145-1.058.57-1.058 1.367s.74 1.222 1.058 1.366l6.937 3.169c.49.224 1.124.34 1.755.34.63 0 1.26-.116 1.752-.34l6.934-3.168c.32-.145 1.064-.567 1.064-1.367s-.74-1.222-1.061-1.369Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLeaf = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.563 11.344a.75.75 0 0 1 1.06-.032c3.452 3.252 6.915 5.23 10.99 6.238.55-1.5.599-3.151.124-4.762-.63-2.137-2.097-3.999-4.241-5.384-1.915-1.236-3.828-1.558-5.68-1.87-2.335-.392-4.54-.764-6.646-2.993-.234-.246-.553-.345-.859-.265-.348.094-.582.37-.694.825-.263 1.067-.094 4.055.644 7.21 1.186 5.07 3.078 7.635 4.456 8.894 1.781 1.626 4.107 2.527 6.419 2.527.436 0 .87-.032 1.302-.096 1.955-.296 3.582-1.278 4.5-2.707-4.195-1.091-7.779-3.166-11.344-6.523a.75.75 0 0 1-.03-1.062ZM21.91 18.009a25.988 25.988 0 0 1-2.296-.458 7.385 7.385 0 0 1-.676 1.378 27.38 27.38 0 0 0 2.745.562.75.75 0 1 0 .228-1.482Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLibrary = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 22.5h-.75A1.5 1.5 0 0 1 .75 21V5.25a1.5 1.5 0 0 1 1.5-1.5H3a1.5 1.5 0 0 1 1.5 1.5V21A1.5 1.5 0 0 1 3 22.5ZM11.25 8.25a1.5 1.5 0 0 0-1.5-1.5h-3a1.5 1.5 0 0 0-1.5 1.5v1.313a.187.187 0 0 0 .188.187h5.625a.188.188 0 0 0 .187-.188V8.25ZM5.25 21a1.5 1.5 0 0 0 1.5 1.5h3a1.5 1.5 0 0 0 1.5-1.5v-1.406a.094.094 0 0 0-.094-.094H5.344a.094.094 0 0 0-.094.094V21ZM11.156 11.25H5.344a.094.094 0 0 0-.094.094v6.562c0 .052.042.094.094.094h5.812a.094.094 0 0 0 .094-.094v-6.562a.094.094 0 0 0-.094-.094ZM15 22.5h-1.5A1.5 1.5 0 0 1 12 21V3a1.5 1.5 0 0 1 1.5-1.5H15A1.5 1.5 0 0 1 16.5 3v18a1.5 1.5 0 0 1-1.5 1.5ZM23.245 20.88l-1.51-15.937c-.07-.734-.795-1.266-1.62-1.187l-1.492.14c-.825.08-1.437.737-1.368 1.47l1.511 15.938c.07.734.794 1.266 1.619 1.187l1.492-.14c.825-.08 1.437-.737 1.368-1.47Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLink = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 8.625a3.375 3.375 0 0 0 0 6.75h2.656a1.125 1.125 0 1 1 0 2.25H6.75a5.625 5.625 0 1 1 0-11.25h2.597a1.125 1.125 0 0 1 0 2.25H6.75ZM13.528 7.5c0-.621.503-1.125 1.125-1.125h2.597a5.625 5.625 0 1 1 0 11.25h-2.656a1.125 1.125 0 0 1 0-2.25h2.656a3.375 3.375 0 0 0 0-6.75h-2.597A1.125 1.125 0 0 1 13.528 7.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8 12c0-.621.504-1.125 1.125-1.125h8.244a1.125 1.125 0 1 1 0 2.25H7.925A1.125 1.125 0 0 1 6.8 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgListCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25ZM7.875 16.406a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Zm0-3.328a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Zm0-3.422a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Zm8.625 6.328h-6a.75.75 0 1 1 0-1.5h6a.75.75 0 1 1 0 1.5Zm0-3.328h-6a.75.75 0 1 1 0-1.5h6a.75.75 0 0 1 0 1.5Zm0-3.375h-6a.75.75 0 1 1 0-1.5h6a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgList = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.375 6.75c0-.621.504-1.125 1.125-1.125H21a1.125 1.125 0 0 1 0 2.25H7.5A1.125 1.125 0 0 1 6.375 6.75ZM6.375 12c0-.621.504-1.125 1.125-1.125H21a1.125 1.125 0 0 1 0 2.25H7.5A1.125 1.125 0 0 1 6.375 12ZM6.375 17.25c0-.621.504-1.125 1.125-1.125H21a1.125 1.125 0 0 1 0 2.25H7.5a1.125 1.125 0 0 1-1.125-1.125ZM2.25 6.75a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM2.25 12a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0ZM2.25 17.25a1.5 1.5 0 1 1 3 0 1.5 1.5 0 0 1-3 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLocate = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5c.621 0 1.125.504 1.125 1.125V4.5a1.125 1.125 0 0 1-2.25 0V2.625c0-.621.504-1.125 1.125-1.125ZM12 18.375c.621 0 1.125.504 1.125 1.125v1.875a1.125 1.125 0 0 1-2.25 0V19.5c0-.621.504-1.125 1.125-1.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.625 5.452a7.875 7.875 0 1 1 8.75 13.096 7.875 7.875 0 0 1-8.75-13.096ZM12 6.375a5.625 5.625 0 1 0 0 11.25 5.625 5.625 0 0 0 0-11.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.375 12c0-.621.504-1.125 1.125-1.125h1.875a1.125 1.125 0 0 1 0 2.25H19.5A1.125 1.125 0 0 1 18.375 12ZM1.5 12c0-.621.504-1.125 1.125-1.125H4.5a1.125 1.125 0 0 1 0 2.25H2.625A1.125 1.125 0 0 1 1.5 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLocation = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 10.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5c-4.135 0-7.5 3.218-7.5 7.172 0 1.883.858 4.387 2.55 7.443 1.36 2.453 2.933 4.672 3.75 5.776a1.49 1.49 0 0 0 2.402 0c.816-1.104 2.39-3.323 3.75-5.776 1.69-3.055 2.548-5.56 2.548-7.443C19.5 4.718 16.135 1.5 12 1.5ZM12 12a3 3 0 1 1 0-5.999A3 3 0 0 1 12 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLockClosed = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9h-.75V5.25a4.5 4.5 0 1 0-9 0V9h-.75a3.003 3.003 0 0 0-3 3v8.25a3.003 3.003 0 0 0 3 3h10.5a3.004 3.004 0 0 0 3-3V12a3.004 3.004 0 0 0-3-3ZM15 9H9V5.25a3 3 0 1 1 6 0V9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLockOpen = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 9H9V5.25a3 3 0 1 1 6 0 .75.75 0 1 0 1.5 0 4.5 4.5 0 1 0-9 0V9h-.75a3.003 3.003 0 0 0-3 3v8.25a3.003 3.003 0 0 0 3 3h10.5a3.004 3.004 0 0 0 3-3V12a3.004 3.004 0 0 0-3-3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogIn = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 3.75h-7.5A2.628 2.628 0 0 0 8.25 6.375v4.875h7.19l-2.47-2.47a.75.75 0 0 1 1.06-1.06l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 0 1-1.06-1.06l2.47-2.47H8.25v4.875c0 1.502 1.584 2.625 3 2.625h7.125A2.627 2.627 0 0 0 21 17.625V6.375a2.627 2.627 0 0 0-2.625-2.625ZM3.75 11.25a.75.75 0 1 0 0 1.5h4.5v-1.5h-4.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogOut = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 12a.75.75 0 0 1 .75-.75H15V6.375c0-1.5-1.584-2.625-3-2.625H4.875A2.628 2.628 0 0 0 2.25 6.375v11.25a2.628 2.628 0 0 0 2.625 2.625h7.5A2.627 2.627 0 0 0 15 17.625V12.75H8.25A.75.75 0 0 1 7.5 12ZM21.53 11.47l-3.75-3.75a.75.75 0 0 0-1.06 1.06l2.47 2.47H15v1.5h4.19l-2.47 2.47a.75.75 0 1 0 1.06 1.06l3.75-3.75a.75.75 0 0 0 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoAlipay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.8 1.5c-1.876 0-3.3 1.506-3.3 3.365v14.27c0 1.858 1.518 3.365 3.394 3.365h14.213c1.875 0 3.393-1.507 3.393-3.364v-.146c-.063-.026-5.413-2.277-8.18-3.595-1.866 2.276-4.274 3.656-6.773 3.656-4.227 0-5.663-3.667-3.661-6.08.436-.527 1.179-1.03 2.331-1.313 1.802-.439 4.67.274 7.36 1.153.5-.917.9-1.887 1.193-2.89H6.485v-.827h4.271V7.602H5.582V6.77h5.174V4.64s0-.358.367-.358h2.088v2.484h5.117v.832h-5.117v1.496h4.176a16.85 16.85 0 0 1-1.768 4.426c1.265.454 2.311.885 3.159 1.167 2.827.937 3.62 1.052 3.722 1.064V4.865c0-1.86-1.519-3.365-3.393-3.365H4.8Zm2.325 11.378a6.297 6.297 0 0 0-.547.03c-.53.053-1.523.284-2.067.76-1.628 1.407-.653 3.981 2.643 3.981 1.915 0 3.83-1.214 5.334-3.158-1.94-.937-3.61-1.633-5.363-1.613Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoAmazon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.273 17.753a14.087 14.087 0 0 0 7.166 4.497c2.513.515 5.123.232 7.467-.81a10.57 10.57 0 0 0 3.131-2.202.299.299 0 0 0-.093-.4.55.55 0 0 0-.375-.002 18.84 18.84 0 0 1-5.464 1.844c-1.997.22-4.018.08-5.967-.414a20.94 20.94 0 0 1-5.582-2.836.234.234 0 0 0-.284.324Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.148 18.209a7.878 7.878 0 0 1 2.294-.105l.031.006a.469.469 0 0 1 .346.565 9.594 9.594 0 0 1-.71 2.16.12.12 0 0 0 .132.153.117.117 0 0 0 .05-.021 3.904 3.904 0 0 0 1.459-3.02.582.582 0 0 0-.479-.62 4.488 4.488 0 0 0-3.228.673.12.12 0 0 0-.027.167.118.118 0 0 0 .132.041ZM14.261 15.231a7.691 7.691 0 0 1-1.355 1.186 6.337 6.337 0 0 1-3.126.88 4.664 4.664 0 0 1-2.695-.93 4.558 4.558 0 0 1-1.283-4.7 5.267 5.267 0 0 1 3.061-3.238 17.235 17.235 0 0 1 4.908-.729V5.954a1.773 1.773 0 0 0-1.537-1.514c-.495-.067-1-.001-1.46.192a2.291 2.291 0 0 0-1.272 1.625.562.562 0 0 1-.59.315L6.526 6.36a.533.533 0 0 1-.393-.476A4.859 4.859 0 0 1 7.85 2.91a6.743 6.743 0 0 1 4.238-1.41c1.419.013 2.8.467 3.95 1.297a4.07 4.07 0 0 1 1.439 3.292v6.043c.03.508.157 1.006.375 1.466l.744 1.089a.61.61 0 0 1 0 .526l-2.203 1.862a.585.585 0 0 1-.594-.021 11.475 11.475 0 0 1-1.537-1.823Zm-.497-5.476a12.08 12.08 0 0 0-2.062.135 2.953 2.953 0 0 0-1.952 1.48 2.953 2.953 0 0 0 .144 2.53 1.903 1.903 0 0 0 2.208.572 3.684 3.684 0 0 0 1.662-2.605V9.755Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoAmplify = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m5.265 12.563 1.891-3.22 1.625 2.765-3.166 5.39h6.328l1.618 2.752H.75l4.515-7.688ZM8.01 7.886 9.57 5.23l8.826 15.02H15.27L8.01 7.886Zm2.428-4.136h3.121l9.691 16.5h-3.126l-9.686-16.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoAndroid = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m17.855 9.328 1.99-3.449a.404.404 0 0 0-.45-.593.4.4 0 0 0-.244.188l-2.016 3.493a12.297 12.297 0 0 0-5.134-1.094c-1.862 0-3.594.392-5.133 1.094L4.852 5.474a.403.403 0 1 0-.697.405L6.14 9.328C2.709 11.186.384 14.66 0 18.728h24c-.384-4.067-2.71-7.542-6.145-9.4ZM6.49 15.358a1.006 1.006 0 1 1 0-2.01 1.006 1.006 0 0 1 0 2.01Zm11.016 0a1.007 1.007 0 1 1 .001 0h-.002Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoAngular = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.011 12h3.977L12 7.812 10.011 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5 1.5 5.25 3.662 18 12 22.5l8.332-4.5L22.5 5.25 12 1.5Zm4.125 15-1.246-2.625H9.12L7.875 16.5H6l6-13.125L18 16.5h-1.875Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoAppleAppstore = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.2 1.5 1.5 6.2 1.5 12S6.2 22.5 12 22.5 22.5 17.8 22.5 12 17.8 1.5 12 1.5ZM8.016 16.589a.725.725 0 0 1-.631.358.698.698 0 0 1-.369-.101.725.725 0 0 1-.262-.994l.716-1.192a.41.41 0 0 1 .354-.201h.106c.52 0 .883.312.99.615l-.904 1.515Zm6.068-2.344-4.694.005H6.27a.725.725 0 0 1-.727-.757c.015-.394.359-.692.75-.692h2.262l2.68-4.563-.868-1.48c-.195-.336-.108-.78.227-.992a.73.73 0 0 1 1.025.242l.464.793h.005l.465-.793a.73.73 0 0 1 1.022-.242c.333.212.42.656.222.994l-.868 1.48-.844 1.438-1.832 3.124v.006h2.7c.339 0 .763.181.935.474l.015.03c.151.258.237.435.237.692a.647.647 0 0 1-.055.242l-.001-.001Zm3.644.005h-1.27v.005l.928 1.58a.74.74 0 0 1-.242 1.01.727.727 0 0 1-.741.01.737.737 0 0 1-.269-.261l-1.373-2.337-.853-1.454-1.1-1.881a1.798 1.798 0 0 1-.03-1.781c.217-.384.383-.485.383-.485l2.448 4.14h2.106c.393 0 .731.304.75.692a.733.733 0 0 1-.735.762h-.002Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoApple = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.365 6.415c-1.89 0-2.688.902-4.005.902-1.35 0-2.379-.895-4.016-.895-1.603 0-3.313.978-4.399 2.646-1.524 2.35-1.265 6.78 1.204 10.552.883 1.35 2.062 2.865 3.609 2.881h.028c1.345 0 1.744-.88 3.594-.89h.028c1.823 0 2.188.885 3.527.885h.028c1.547-.016 2.79-1.695 3.673-3.04.636-.967.872-1.453 1.36-2.548-3.572-1.355-4.146-6.418-.614-8.36-1.078-1.35-2.593-2.131-4.021-2.131l.004-.002Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.95 1.5c-1.126.076-2.438.793-3.207 1.728-.698.847-1.271 2.104-1.046 3.324h.09c1.198 0 2.424-.722 3.14-1.646.69-.88 1.213-2.127 1.022-3.406Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoBehance = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.13 10.95c-1.355 0-1.542 1.35-1.542 1.35h2.878s.018-1.35-1.336-1.35ZM9.6 12.3H7.05v2.344h2.423c.366-.01 1.05-.112 1.05-1.139 0-1.219-.923-1.205-.923-1.205Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.202 1.5 1.5 6.202 1.5 12S6.202 22.5 12 22.5 22.5 17.798 22.5 12 17.798 1.5 12 1.5Zm2.213 6.45h3.614v1.078h-3.615V7.95Zm-1.829 5.663c0 2.671-2.784 2.587-2.784 2.587H5.044V7.434H9.6c1.388 0 2.48.764 2.48 2.335 0 1.57-1.336 1.668-1.336 1.668 1.762 0 1.64 2.176 1.64 2.176Zm6.76-.146h-4.542c0 1.627 1.542 1.524 1.542 1.524 1.458 0 1.406-.943 1.406-.943h1.542c0 2.504-3 2.33-3 2.33-3.595 0-3.365-3.351-3.365-3.351s-.005-3.366 3.365-3.366c3.549.005 3.052 3.806 3.052 3.806Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.219 9.904c0-.91-.619-.91-.619-.91H7.05v1.956h2.39c.413 0 .779-.136.779-1.046Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoBitbucket = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.647 1.511a.92.92 0 0 0-.12-.01H1.482c-.403-.006-.725.322-.731.738a.536.536 0 0 0 .01.131l3.062 19.277c.038.234.154.448.328.607a.937.937 0 0 0 .631.246h14.68a.724.724 0 0 0 .72-.629l1.822-11.62h-6.76l-.865 5.25H9.619L8.413 8.563h13.855l.974-6.187c.06-.41-.206-.8-.595-.865Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoBitcoin = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.24 13.088c-.234-.54-.595-1.013-1.316-1.411a4.599 4.599 0 0 0-1.191-.47c.28-.13.538-.304.764-.515.332-.296.583-.672.731-1.092.136-.427.192-.875.164-1.322-.051-.787-.206-1.551-.618-2.1-.413-.548-.994-.97-1.763-1.266-.59-.224-1.195-.365-2.133-.417V1.5h-1.875v3h-1.5v-3H8.581v3H4.5v2.25h1.306c.408 0 .685.037.825.108a.62.62 0 0 1 .305.281c.061.117.09.394.09.82v8.12c0 .421-.029.693-.09.815-.06.122-.094.23-.239.295-.145.066-.15.061-.553.061H4.906L4.5 19.5h4.078v3H10.5v-3H12v3h1.875v-3.019c1.219-.06 2.086-.22 2.784-.483.905-.337 1.599-.83 2.096-1.476.497-.647.656-1.636.7-2.4.03-.68-.002-1.556-.214-2.034ZM10.5 7.03H12V10.5h-1.5V7.031Zm0 9.938V12.75H12v4.219h-1.5Zm3.375-9.755c.281.117.464.352.647.595.201.268.305.624.305 1.003 0 .366-.136.68-.352.961-.178.23-.319.39-.6.52V7.215Zm1.35 8.752c-.366.323-.577.473-1.036.647a2.637 2.637 0 0 1-.314.089V12.82c.183.027.362.081.53.16.365.154.712.323.928.618.239.34.37.743.375 1.158-.002.511-.133.9-.484 1.21h.001Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoBuffer = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m1.872 6.996 9.253 4.468c.24.115.562.175.88.175.319 0 .64-.06.88-.175l9.254-4.468c.487-.234.487-.618 0-.853l-9.253-4.468a2.122 2.122 0 0 0-.88-.175c-.318 0-.64.06-.881.175L1.872 6.143c-.487.235-.487.618 0 .853Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.139 11.574s-1.69-.815-1.914-.925c-.224-.11-.284-.103-.52.006-.235.11-6.825 3.292-6.825 3.292-.278.12-.578.18-.88.175-.317 0-.64-.06-.88-.175 0 0-6.415-3.094-6.716-3.243-.326-.157-.42-.157-.716-.016l-1.828.88c-.487.234-.487.618 0 .853l9.254 4.468c.24.115.563.175.88.175.318 0 .64-.06.881-.175l9.253-4.467c.498-.23.498-.613.011-.848Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.14 17.004s-1.69-.815-1.915-.926c-.224-.11-.284-.103-.52.006-.235.109-6.82 3.299-6.82 3.299-.277.12-.577.18-.88.175-.317 0-.64-.06-.88-.175 0 0-6.415-3.094-6.715-3.243-.329-.159-.422-.159-.717-.016l-1.828.88c-.487.234-.487.618 0 .853l9.253 4.468c.24.12.562.175.88.175.318 0 .64-.06.88-.175l9.255-4.466c.493-.237.493-.62.006-.855Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoCapacitor = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m22.5 4.739-5.045 5.045 5.009 5.018-3.248 3.249L5.94 4.774l3.248-3.249 5.018 5.01L19.25 1.5l3.25 3.239ZM1.526 9.187l3.248-3.249L18.05 19.215l-3.248 3.248-5.016-5.009L4.738 22.5 1.5 19.25l5.035-5.044-5.01-5.019Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoChrome = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.85 11.997A3.15 3.15 0 1 0 12 8.847a3.158 3.158 0 0 0-3.15 3.15Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.348 10.209v.002a9.687 9.687 0 0 0-.328-1.352h-7.29c.893.797 1.47 1.883 1.47 3.143a4.058 4.058 0 0 1-.577 2.097l-4.795 8.328a.09.09 0 0 1 0 .013v.013-.012a10.473 10.473 0 0 0 2.124.012c.47-.042.936-.117 1.396-.222 4.668-1.066 8.152-5.244 8.152-10.234 0-.6-.05-1.197-.152-1.788Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.196c-1.575 0-2.887-.84-3.623-2.1L3.563 5.768l-.007-.01a10.5 10.5 0 0 0 6.166 16.487v-.002l3.642-6.31a3.941 3.941 0 0 1-1.364.263Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m4.28 4.901 3.625 6.246A4.18 4.18 0 0 1 12 7.781h9.617a11.553 11.553 0 0 0-1.208-2.06l.006.004c.47.642.874 1.33 1.202 2.056h.008a11.532 11.532 0 0 0-1.203-2.063.121.121 0 0 1-.016-.012A10.497 10.497 0 0 0 4.272 4.89l.007.012Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoClosedCaptioning = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M0 3.75v16.5h24V3.75H0Zm21.75 8.24c0 1.206-.075 2.124-.177 3.62-.101 1.495-.9 2.547-2.77 2.712-1.87.165-4.489.18-6.803.175-2.297.005-4.928-.005-6.803-.175-1.875-.17-2.663-1.22-2.77-2.713-.108-1.493-.177-2.413-.177-3.62 0-1.206.005-1.99.177-3.619.171-1.63 1.078-2.537 2.77-2.702 1.691-.165 4.606-.165 6.803-.165s5.11 0 6.803.165c1.694.165 2.599 1.078 2.77 2.702.172 1.624.177 2.418.177 3.62Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.23 13.258v.037c0 .84-.52 1.335-1.217 1.335-.695 0-1.164-.557-1.231-1.335 0 0-.061-.408-.061-1.233-.004-.448.02-.896.071-1.34.124-.877.552-1.336 1.247-1.336.695 0 1.242.598 1.242 1.506v.026h2.324c0-1.13-.284-2.145-.855-2.785-.572-.64-1.418-.96-2.54-.96a5.066 5.066 0 0 0-1.548.22 2.757 2.757 0 0 0-1.215.78c-.34.373-.603.868-.79 1.492-.188.624-.282 1.406-.282 2.356 0 .928.077 1.701.227 2.325.15.624.375 1.12.675 1.49.29.365.681.634 1.125.774.453.144.984.217 1.594.217 1.287 0 2.215-.329 2.771-.965.557-.636.827-1.562.827-2.779h-2.375c.01 0 .01.13.01.175ZM9.249 13.258v.037c0 .84-.52 1.335-1.216 1.335s-1.165-.557-1.232-1.335c0 0-.061-.408-.061-1.233-.004-.448.02-.896.071-1.34.124-.877.552-1.336 1.247-1.336.696 0 1.242.599 1.242 1.506v.026h2.325c0-1.13-.281-2.145-.855-2.785-.575-.64-1.418-.96-2.541-.96a5.065 5.065 0 0 0-1.547.22 2.757 2.757 0 0 0-1.216.78c-.34.37-.603.866-.794 1.49-.19.624-.281 1.406-.281 2.356 0 .928.077 1.702.227 2.326.15.623.375 1.118.675 1.49.29.364.681.633 1.125.773.453.145.984.217 1.593.217 1.289 0 2.216-.328 2.773-.964.556-.637.834-1.563.834-2.78h-2.38c.01.002.01.131.01.178Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoCodepen = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.308 14.247c-.718-.486-1.44-.964-2.159-1.45-.094-.065-.16-.07-.258 0L7.07 14.021c1.462.974 4.369 2.916 4.369 2.916v-2.522c0-.057-.073-.13-.13-.168ZM9.145 11.282c.725-.476 1.445-.959 2.161-1.447a.354.354 0 0 0 .132-.25V7.162S8.53 9.089 7.066 10.065c.642.43 1.25.84 1.865 1.24.047.03.159.013.214-.023ZM12.649 9.813c.74.502 1.485 1 2.232 1.491a.201.201 0 0 0 .18 0l1.864-1.24-4.363-2.917v2.5a.224.224 0 0 0 .087.166ZM12.099 10.798a.246.246 0 0 0-.222.008c-.226.14-.444.29-.665.438l-1.188.797 1.82 1.213a.29.29 0 0 0 .294.005l1.828-1.22L12.1 10.8ZM6.61 11.115v1.857l1.388-.93-1.389-.927Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5Zm6.516 12.422c0 .27-.125.462-.352.614a2229.974 2229.974 0 0 0-5.78 3.852c-.274.184-.523.176-.796-.006a1162.413 1162.413 0 0 0-5.749-3.829c-.24-.159-.356-.354-.356-.643v-3.738c0-.288.119-.485.358-.643C7.758 8.257 9.68 6.98 11.594 5.7c.272-.182.52-.188.794-.004 1.923 1.288 3.849 2.572 5.778 3.852.219.146.349.326.349.594v3.78Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.824 12.808c-.706.48-1.415.954-2.127 1.422-.113.074-.136.155-.135.29v2.407l4.36-2.906-1.806-1.213c-.108-.076-.183-.074-.292 0ZM17.344 12.97v-1.857l-1.387.931 1.387.926Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoCss3 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m3 1.5 1.64 18.9 7.35 2.1 7.37-2.102L21 1.5H3Zm13.626 15.698-4.623 1.318-4.615-1.324-.316-3.645h2.262l.16 1.854 2.513.71.006.014 2.506-.696.264-3.007H9.516l-.188-2.344h5.656l.204-2.39H6.562L6.375 5.39h11.277l-1.026 11.807Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoDesignernews = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.843 5.756 10.447 3l3.406 5.749-.01-2.993Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.91 3v9.169h-1.95l-3.385-5.547.09 5.547H8.519V6.15L6.52 4.5c.053.067.107.135.155.208.536.782.803 1.716.803 2.84 0 2.766-1.64 4.619-4.119 4.619H0v.022L10.693 21H24V9.643L15.91 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.245 7.618c0-1.631-.761-2.537-2.127-2.537H2.089v5.006h1.018c1.393 0 2.138-.866 2.138-2.47Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoDeviantart = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 4.841V.75h-4.186l-.418.412-1.975 3.678-.621.41h-7.05v5.618h3.876l.345.408-4.221 7.883v4.091h4.186l.418-.412 1.975-3.679.621-.409h7.05v-5.619h-3.876l-.345-.41 4.221-7.88Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoDiscord = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 3.118A2.344 2.344 0 0 0 19.412.797L4.577.75A2.327 2.327 0 0 0 2.25 3.071v15.304c0 1.28 1.044 2.25 2.327 2.25H17.25l-.61-2.063 5.11 4.688V3.118ZM15.218 15.46s-.409-.487-.75-.906c1.488-.419 2.055-1.335 2.055-1.335a6.517 6.517 0 0 1-1.305.668c-.53.22-1.082.383-1.646.487a7.973 7.973 0 0 1-2.94-.011 8.65 8.65 0 0 1-1.668-.488 6.647 6.647 0 0 1-.829-.385c-.034-.022-.068-.034-.102-.057-.023-.01-.034-.022-.047-.022-.204-.114-.318-.193-.318-.193s.545.895 1.987 1.325c-.34.43-.76.929-.76.929-2.51-.08-3.463-1.71-3.463-1.71 0-3.612 1.635-6.545 1.635-6.545C8.7 6.006 10.245 6.04 10.245 6.04l.113.136c-2.043.577-2.973 1.472-2.973 1.472s.25-.136.67-.318c1.214-.532 2.179-.668 2.577-.713.064-.013.128-.02.193-.023a9.64 9.64 0 0 1 2.293-.022 9.451 9.451 0 0 1 3.417 1.076s-.897-.851-2.827-1.428l.159-.18s1.555-.035 3.179 1.179c0 0 1.634 2.932 1.634 6.544 0-.013-.954 1.618-3.462 1.697Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.94 10.219c-.647 0-1.158.555-1.158 1.245 0 .69.522 1.246 1.158 1.246.647 0 1.158-.555 1.158-1.246.011-.692-.511-1.245-1.158-1.245ZM14.083 10.219c-.647 0-1.158.555-1.158 1.245 0 .69.522 1.246 1.158 1.246.647 0 1.158-.555 1.158-1.246 0-.69-.522-1.245-1.158-1.245Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoDocker = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-docker_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.766 9.898c-.067-.056-.668-.513-1.96-.513-.339.002-.678.032-1.012.09-.245-1.707-1.659-2.532-1.715-2.579l-.345-.2-.222.323c-.28.44-.488.921-.612 1.428-.235.97-.09 1.884.4 2.664-.59.335-1.546.413-1.747.422H.747a.746.746 0 0 0-.747.752 11.308 11.308 0 0 0 .691 4.07c.546 1.427 1.358 2.489 2.403 3.133 1.182.725 3.108 1.137 5.278 1.137.982 0 1.962-.09 2.927-.267a12.067 12.067 0 0 0 3.83-1.394 10.478 10.478 0 0 0 2.604-2.14c1.258-1.417 2.004-3 2.55-4.407h.222c1.37 0 2.215-.547 2.683-1.015.31-.294.553-.651.712-1.048l.1-.29-.234-.166Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.217 11.08H4.33a.188.188 0 0 0 .188-.187V8.995a.188.188 0 0 0-.188-.187H2.217a.187.187 0 0 0-.188.187v1.896a.195.195 0 0 0 .188.187M5.133 11.08h2.115a.188.188 0 0 0 .187-.187V8.995a.187.187 0 0 0-.187-.187H5.133a.187.187 0 0 0-.188.187v1.896a.195.195 0 0 0 .188.187M8.105 11.08h2.114a.187.187 0 0 0 .187-.187V8.995a.187.187 0 0 0-.187-.187H8.105a.187.187 0 0 0-.188.187v1.896a.182.182 0 0 0 .188.187M11.033 11.08h2.115a.188.188 0 0 0 .187-.187V8.995a.187.187 0 0 0-.188-.187h-2.114a.188.188 0 0 0-.188.187v1.896a.188.188 0 0 0 .188.187M5.133 8.37h2.115a.195.195 0 0 0 .187-.187V6.286a.187.187 0 0 0-.187-.188H5.133a.188.188 0 0 0-.188.188V8.18a.203.203 0 0 0 .188.188M8.105 8.37h2.114a.195.195 0 0 0 .187-.187V6.286a.187.187 0 0 0-.187-.188H8.105a.188.188 0 0 0-.188.188V8.18a.188.188 0 0 0 .188.188M11.033 8.37h2.115a.195.195 0 0 0 .187-.187V6.286a.195.195 0 0 0-.188-.188h-2.114a.188.188 0 0 0-.188.188V8.18a.195.195 0 0 0 .188.188M11.033 5.65h2.115a.187.187 0 0 0 .187-.188v-1.9a.195.195 0 0 0-.188-.187h-2.114a.188.188 0 0 0-.188.188v1.895a.196.196 0 0 0 .188.188M13.982 11.08h2.115a.188.188 0 0 0 .187-.187V8.995a.187.187 0 0 0-.187-.187h-2.115a.187.187 0 0 0-.188.187v1.896a.195.195 0 0 0 .188.187"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-docker_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgLogoDribbble = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.203 1.5 1.5 6.203 1.5 12S6.203 22.5 12 22.5 22.5 17.802 22.5 12 17.797 1.5 12 1.5Zm6.667 4.84a8.736 8.736 0 0 1 2.062 5.08c-1.892-.098-4.156-.098-5.972.071-.23-.58-.465-1.148-.722-1.695 2.094-.908 3.707-2.1 4.632-3.456ZM12 3.25a8.71 8.71 0 0 1 5.584 2.013c-.952 1.202-2.445 2.25-4.304 3.04-1.018-1.881-2.188-3.5-3.436-4.774A8.79 8.79 0 0 1 12 3.249Zm-3.96.957c1.264 1.258 2.45 2.86 3.49 4.734-1.975.604-4.239.95-6.655.95a21.6 21.6 0 0 1-1.35-.044 8.755 8.755 0 0 1 4.515-5.64Zm-4.774 7.377c.498.022 1.001.033 1.51.028 2.756-.033 5.32-.465 7.525-1.172.208.432.405.875.59 1.329a5.41 5.41 0 0 0-.782.234c-3.013 1.266-5.386 3.305-6.671 5.772A8.719 8.719 0 0 1 3.25 12c0-.14.005-.279.016-.416ZM12 20.75a8.699 8.699 0 0 1-5.365-1.843c1.165-2.308 3.243-4.219 5.863-5.403.246-.115.574-.208.951-.29.313.864.592 1.76.837 2.69a31.79 31.79 0 0 1 .808 4.272A8.678 8.678 0 0 1 12 20.75Zm4.73-1.394a30.34 30.34 0 0 0-1.444-6.388c1.718-.14 3.774-.12 5.41 0a8.741 8.741 0 0 1-3.965 6.388Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoDropbox = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.015 5.918 6.382 9.585l5.633 3.668-5.633 3.669-5.632-3.7 5.633-3.667L.75 5.918 6.383 2.25l5.632 3.668ZM6.352 18.082l5.633-3.668 5.633 3.668-5.633 3.667-5.632-3.668Zm5.663-4.86 5.633-3.668-5.633-3.637 5.602-3.668 5.633 3.668-5.633 3.667 5.633 3.668-5.633 3.669-5.602-3.7Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoEdge = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-edge_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.977.703C5.789.703.727 5.766.727 11.953c0 6.188 5.062 11.25 11.25 11.25 4.003 0 7.537-2.119 9.53-5.292a.321.321 0 0 0-.222-.49.322.322 0 0 0-.205.035 5.093 5.093 0 0 1-.863.403c-1.725.591-2.676.614-3.848.563-1.308-.056-2.902-.506-4.022-1.172-1.12-.666-2.04-1.622-2.536-2.452-.497-.83-.797-1.87-.661-3.201.136-1.36 1.378-2.466 2.831-2.466 1.57 0 2.85 1.247 2.85 2.817 0 .797-.38 1.486-.867 2.04-.108.098-.356.454.272.937.745.572 2.419.844 3.745.778 1.327-.066 2.77-.59 3.76-1.631.787-.83 1.49-2.161 1.49-3.628C23.227 4.58 17.79.704 11.977.704Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-edge_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgLogoElectron = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.067 11.953a.464.464 0 0 0 .445-.34.46.46 0 0 0-.046-.35c-.771-1.339-.835-2.443-.349-3.281.668-1.152 2.513-1.578 4.935-1.139a.462.462 0 0 0 .462-.715.461.461 0 0 0-.297-.191c-1.369-.248-2.625-.243-3.628.014-1.045.267-1.828.81-2.271 1.57-.656 1.133-.595 2.564.348 4.2a.461.461 0 0 0 .4.232ZM16.95 6.738c1.512.02 2.467.436 2.944 1.259.666 1.147.118 2.944-1.466 4.806a.46.46 0 0 0 .546.715.462.462 0 0 0 .159-.12c.896-1.053 1.516-2.134 1.793-3.126.287-1.032.207-1.979-.235-2.737-.647-1.115-1.881-1.694-3.73-1.719h-.007a.461.461 0 0 0-.006.922h.003ZM15.303 19.448a.463.463 0 0 0-.633.157c-.769 1.272-1.714 1.973-2.66 1.973-1.336 0-2.626-1.374-3.457-3.676a.463.463 0 0 0-.871.312c.469 1.302 1.1 2.38 1.828 3.116.755.766 1.62 1.172 2.5 1.172 1.283 0 2.509-.86 3.452-2.42a.46.46 0 0 0-.159-.632v-.002ZM20.236 15.87a1.506 1.506 0 0 0-1.402 2.077c-1.959.914-5.615.225-8.993-1.716-1.543-.886-2.914-1.963-3.966-3.112a.464.464 0 0 0-.803.289.46.46 0 0 0 .12.332c1.116 1.219 2.564 2.357 4.188 3.29 1.888 1.084 3.856 1.81 5.692 2.1.542.088 1.09.134 1.64.136 1.084 0 2.016-.201 2.743-.6a1.51 1.51 0 1 0 .783-2.797h-.002Zm0 2.093a.59.59 0 0 1-.367-.128.47.47 0 0 0-.103-.103.592.592 0 1 1 .47.23Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.848 15.872c.027-.997.582-2.204 1.579-3.43 1.087-1.333 2.657-2.625 4.422-3.64 1.559-.895 3.056-1.495 4.597-1.824a.46.46 0 1 0-.193-.9c-1.634.348-3.224.984-4.865 1.926-3.946 2.266-6.58 5.584-6.46 8.117a1.515 1.515 0 1 0 .92-.25Zm-.084 2.09a.586.586 0 1 1 .008-1.17.586.586 0 0 1-.008 1.17Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.01 4.515a1.511 1.511 0 0 0 1.243-.647c.839.548 1.594 1.64 2.147 3.1.61 1.611.93 3.533.93 5.556 0 1.743-.243 3.391-.703 4.856a.456.456 0 0 0 .303.578.464.464 0 0 0 .578-.302c.489-1.553.747-3.297.747-5.132 0-2.211-.364-4.302-1.053-6.047-.676-1.71-1.6-2.925-2.679-3.523a1.514 1.514 0 1 0-1.514 1.561Zm0-2.093A.586.586 0 1 1 12 3.593a.586.586 0 0 1 .008-1.171ZM11.766 11.407a1.142 1.142 0 1 0 .483 2.232 1.143 1.143 0 1 0-.483-2.232Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoEuro = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.866 12.75V10.5h6.759L18 8.25h-7.134v-.381c0-1.814.772-2.933 4.086-2.933 1.354 0 2.88.127 4.805.442l.493-3.281a23.837 23.837 0 0 0-5.463-.597c-5.915 0-8.459 2.08-8.459 5.927v.823H3.75v2.25h2.578v2.25H3.75V15h2.578v1.572c0 3.846 2.542 5.928 8.458 5.928 1.836.011 3.668-.19 5.458-.6l-.496-3.28c-1.924.315-3.444.44-4.798.44-3.314 0-4.084-.945-4.084-3.184V15h6.022l.369-2.25h-6.391Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoFacebook = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5 12.064c0-5.799-4.702-10.5-10.5-10.5S1.5 6.265 1.5 12.064c0 5.24 3.84 9.584 8.86 10.373V15.1H7.692v-3.036h2.666V9.75c0-2.63 1.568-4.085 3.966-4.085 1.15 0 2.351.205 2.351.205v2.584h-1.324c-1.304 0-1.712.81-1.712 1.64v1.97h2.912l-.465 3.036h-2.446v7.338c5.02-.788 8.859-5.132 8.859-10.374Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoFigma = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.25a3.75 3.75 0 0 0 0-7.5h-7.5a3.75 3.75 0 0 0 0 7.5 3.75 3.75 0 0 0 0 7.5A3.75 3.75 0 1 0 12 19.5V8.25h3.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoFirebase = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.368 15.44 6.592 1.186c.077-.486.73-.6.96-.166l2.39 4.474-5.574 9.946Zm15.882 3.31L18.06 5.775a.516.516 0 0 0-.87-.281L3.75 18.75l7.47 4.308a1.556 1.556 0 0 0 1.496 0l7.534-4.308Zm-6.077-11.3L12.46 4.19a.509.509 0 0 0-.907 0l-7.53 13.423L14.173 7.45Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoFirefox = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.1 9.123v-.004l-.032-.107a10.092 10.092 0 0 0-.07-.228l-.003-.01a10.474 10.474 0 0 0-1.074-2.313 10.554 10.554 0 0 0-3.503-3.457 10.448 10.448 0 0 0-6.394-1.457c-1.13.119-3.037.525-4.583 1.883 5.63-2.874 13.15.587 12.51 7.023-.228 2.297-2.178 3.875-3.993 4.141-.323.05-.651.053-.975.01-4.434-.616-4.163-4.25-2.816-5.804-1.78-.012-3.162 2.193-2.49 4.359-1.545-2.868.015-7.36 3.324-8.719-3.888-.562-7.533 1.322-8.705 4.597.14-1.197.42-2.374.832-3.506 0 0-2.12 1.675-2.552 5.198a9.23 9.23 0 0 0-.024.22c-.017.165-.03.33-.037.496v.038c-.004.07-.007.14-.008.21v.058c0 .082-.004.165-.004.248 0 5.799 4.701 10.5 10.5 10.5 5.8 0 10.497-4.7 10.497-10.5a10.5 10.5 0 0 0-.4-2.876Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoFlickr = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.225 1.5 1.5 6.225 1.5 12S6.225 22.5 12 22.5 22.5 17.775 22.5 12 17.775 1.5 12 1.5ZM8.149 14.625a2.625 2.625 0 1 1-.17-5.247 2.625 2.625 0 0 1 .17 5.247Zm7.875 0a2.625 2.625 0 1 1-.17-5.246 2.625 2.625 0 0 1 .17 5.246Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoFoursquare = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.66 1.5H6.495C4.954 1.5 4.5 2.663 4.5 3.394V21.19c0 .824.442 1.13.69 1.231.248.101.933.188 1.344-.289 0 0 5.272-6.135 5.362-6.226.137-.138.137-.138.274-.138h3.411c1.434 0 1.664-1.025 1.814-1.629.124-.505 1.522-7.687 1.99-9.963C19.74 2.437 19.3 1.5 17.66 1.5Zm-.265 12.64c.124-.506 1.522-7.688 1.99-9.964l-1.99 9.963ZM17 4.53l-.469 2.425c-.055.265-.388.544-.696.544h-4.497c-.489 0-.839.288-.839.778v.63c0 .491.352.84.844.84h3.837c.345 0 .684.38.609.75-.076.369-.426 2.182-.469 2.385-.043.202-.274.549-.685.549h-3.011c-.548 0-.714.072-1.081.53-.367.457-3.669 4.434-3.669 4.434-.033.038-.066.027-.066-.015V4.495c0-.313.272-.68.679-.68h8.96A.582.582 0 0 1 17 4.53Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoGithub = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 1.5C6.202 1.5 1.5 6.323 1.5 12.267c0 4.758 3.01 8.79 7.181 10.214a.82.82 0 0 0 .178.019c.39 0 .54-.286.54-.534 0-.258-.01-.933-.015-1.833a4.802 4.802 0 0 1-1.059.126c-2.02 0-2.48-1.57-2.48-1.57-.478-1.242-1.167-1.575-1.167-1.575-.914-.642-.005-.66.066-.66h.004c1.055.093 1.608 1.115 1.608 1.115.525.919 1.228 1.176 1.857 1.176a2.953 2.953 0 0 0 1.2-.28c.093-.695.365-1.168.665-1.44-2.33-.272-4.781-1.195-4.781-5.32 0-1.177.408-2.138 1.078-2.888-.108-.272-.469-1.369.103-2.85a.874.874 0 0 1 .235-.023c.38 0 1.237.145 2.653 1.13a9.76 9.76 0 0 1 5.259 0c1.416-.985 2.273-1.13 2.653-1.13a.874.874 0 0 1 .235.023c.571 1.481.21 2.578.103 2.85.67.755 1.078 1.716 1.078 2.888 0 4.134-2.456 5.043-4.796 5.31.375.333.713.99.713 1.993 0 1.439-.014 2.601-.014 2.953 0 .253.145.539.534.539a.9.9 0 0 0 .188-.019c4.176-1.425 7.181-5.46 7.181-10.214C22.5 6.323 17.798 1.5 12 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoGitlab = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m23.16 13.2-1.18-3.66a.512.512 0 0 0-.03-.099l-2.366-7.356a.942.942 0 0 0-1.451-.468.926.926 0 0 0-.336.473L15.54 9.1H8.415L6.157 2.09a.926.926 0 0 0-.884-.654h-.006a.945.945 0 0 0-.896.657l-2.37 7.363c0 .006-.005.012-.007.018L.793 13.2a1.366 1.366 0 0 0 .489 1.522l10.38 7.613a.528.528 0 0 0 .627-.004l10.382-7.61a1.366 1.366 0 0 0 .489-1.521ZM7.644 10.176l2.893 8.989-6.945-8.99h4.052Zm5.775 8.99 2.774-8.617.12-.375h4.056l-6.284 8.128-.666.864ZM18.694 2.78l2.033 6.32h-4.07l2.037-6.32Zm-3.499 7.392-2.016 6.261-1.202 3.73-3.214-9.992h6.432ZM5.263 2.78 7.3 9.1H3.234l2.029-6.32ZM1.907 13.855a.29.29 0 0 1-.104-.324l.89-2.765 6.545 8.465-7.331-5.376Zm20.14 0-7.332 5.374.024-.033 6.519-8.432.89 2.766a.291.291 0 0 1-.102.324",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoGooglePlaystore = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.788V21.21a.203.203 0 0 0 .345.144L12.187 12 2.595 2.644a.203.203 0 0 0-.345.144ZM16.21 8.156 4.181 1.53l-.007-.004c-.208-.113-.404.168-.235.33l9.428 9.016 2.841-2.716ZM3.941 22.143c-.17.164.026.444.235.331l.007-.004 12.026-6.626-2.84-2.716-9.428 9.015ZM21.065 10.828l-3.359-1.85L14.548 12l3.158 3.02 3.359-1.848c.913-.505.913-1.84 0-2.344Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoGoogle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m22.18 10.382-.107-.45h-9.77v4.136h5.838c-.606 2.878-3.419 4.393-5.716 4.393-1.672 0-3.434-.703-4.6-1.833a6.566 6.566 0 0 1-1.96-4.636c0-1.741.783-3.484 1.922-4.63 1.14-1.146 2.86-1.787 4.57-1.787 1.96 0 3.363 1.04 3.888 1.514l2.939-2.923c-.862-.757-3.23-2.666-6.922-2.666-2.847 0-5.578 1.09-7.574 3.08C2.718 6.54 1.7 9.372 1.7 12s.965 5.32 2.874 7.294C6.613 21.399 9.5 22.5 12.475 22.5c2.706 0 5.27-1.06 7.1-2.984 1.796-1.894 2.726-4.514 2.726-7.261 0-1.156-.116-1.843-.122-1.873Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoHackernews = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5v21h21v-21h-21Zm11.703 11.758v3.937h-2.187v-3.937l-3.61-6.563h2.578l2.172 4.572 2.078-4.572h2.471l-3.502 6.563Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoHtml5 = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m3 1.5 1.638 18.9 7.351 2.1 7.37-2.102L21 1.5H3Zm14.438 6.188H8.813L9 10.078h8.25l-.633 7.096L12 18.491 7.374 17.18l-.317-3.632h2.262l.16 1.842L12 16.08l2.504-.699.262-3.007H6.937l-.59-7.012h11.287l-.197 2.324Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoInstagram = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.375 3.25a4.388 4.388 0 0 1 4.375 4.375v8.75a4.388 4.388 0 0 1-4.375 4.375h-8.75a4.389 4.389 0 0 1-4.375-4.375v-8.75A4.388 4.388 0 0 1 7.625 3.25h8.75Zm0-1.75h-8.75C4.256 1.5 1.5 4.256 1.5 7.625v8.75c0 3.369 2.756 6.125 6.125 6.125h8.75c3.369 0 6.125-2.756 6.125-6.125v-8.75c0-3.369-2.756-6.125-6.125-6.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.687 7.625a1.312 1.312 0 1 1 0-2.625 1.312 1.312 0 0 1 0 2.625ZM12 8.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7Zm0-1.75a5.25 5.25 0 1 0 0 10.5 5.25 5.25 0 0 0 0-10.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoIonic = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 7.214a4.786 4.786 0 1 0 0 9.571 4.786 4.786 0 0 0 0-9.571ZM18.871 7.64a2.18 2.18 0 1 0 0-4.362 2.18 2.18 0 0 0 0 4.361Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m21.556 7.65-.091-.201-.146.165a3.281 3.281 0 0 1-1.316.906l-.14.051.057.137A8.505 8.505 0 0 1 20.578 12c0 4.73-3.848 8.578-8.578 8.578-4.73 0-8.578-3.848-8.578-8.578C3.422 7.269 7.269 3.42 12 3.42a8.481 8.481 0 0 1 3.676.83l.135.061.059-.137a3.29 3.29 0 0 1 .968-1.27l.172-.137-.196-.097A10.388 10.388 0 0 0 12 1.5C6.21 1.5 1.5 6.21 1.5 12S6.21 22.5 12 22.5 22.5 17.79 22.5 12a10.415 10.415 0 0 0-.944-4.35Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoIonitron = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.957 12.619c-.124-1.566-.552-2.72-1.474-2.69a.047.047 0 0 0-.043.064c.24.59.454 1.73.43 2.722a.047.047 0 0 1-.013.033.047.047 0 0 1-.066.003.047.047 0 0 1-.015-.033c-.103-.994-.333-1.93-.76-2.785A8.75 8.75 0 0 0 3.66 11.854a.188.188 0 0 1-.156.146l-.405.057c-.806.113-1.261 1.636-1.017 3.399.243 1.762 1.101 3.103 1.908 2.99l.62-.086a.188.188 0 0 1 .184.086 8.752 8.752 0 0 0 15.891-2.628.187.187 0 0 1 .173-.145l.206-.01c.71-.12 1.02-1.465.893-3.044Zm-17.527.057a.047.047 0 0 1 .044-.07c.012.001.022.006.03.014.452.47.95 1.296 1.093 2.338.152 1.08-.105 2.118-.428 2.712a.047.047 0 0 1-.058.02.046.046 0 0 1-.028-.054c.19-.677.242-1.586.107-2.566-.132-.952-.409-1.794-.76-2.394Zm8.38 5.147a.728.728 0 0 1-.64-1.071.726.726 0 1 1 .64 1.07Zm3.836-.222a.72.72 0 1 1-.07-1.44.72.72 0 0 1 .07 1.44Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.758 3.281a.015.015 0 0 1 .005.01c.005.009.01.014.014.023v.005a.27.27 0 0 0 .108.126c.094.07.234.113.403.14a2.986 2.986 0 0 0 .694.015c-.019-.019-.038-.042-.057-.06h-.06a2.437 2.437 0 0 1-.544-.043.924.924 0 0 1-.394-.16.433.433 0 0 1-.066-.065.21.21 0 0 1 0-.108c.024-.108.113-.225.258-.347.158-.128.329-.238.511-.328.042-.019.08-.042.122-.06.005-.006.014-.006.023-.01-.038.161-.041.33-.009.492.108.558.544.951 1.088.966l.187 1.139.595-.141-.187-1.092c.506-.216.764-.755.656-1.313-.03-.159-.093-.31-.183-.445-.248-.037-.73-.037-1.368.098.051-.014.098-.032.15-.046a6.34 6.34 0 0 1 1.007-.197c.028-.005.057-.005.085-.01l.164-.014h.028c.169-.01.338-.005.506.014.098.012.194.034.286.066a.286.286 0 0 0 .16.422 1.196 1.196 0 0 1-.235.262c-.051.042-.108.085-.164.127l-.305.178-.014.07a.016.016 0 0 0 .01-.004l.394-.22c.056-.038.112-.076.159-.113a1.356 1.356 0 0 0 .262-.263l.014-.028a.288.288 0 0 0 .254-.281.285.285 0 0 0-.286-.286.32.32 0 0 0-.132.033 1.153 1.153 0 0 0-.384-.127 2.976 2.976 0 0 0-.825-.018.637.637 0 0 1-.094.009 1.179 1.179 0 0 0-.876-.174 1.212 1.212 0 0 0-.835.61c-.06.023-.122.051-.178.08-.033.014-.06.028-.094.042a2.848 2.848 0 0 0-.651.426c-.145.136-.23.267-.249.39a.288.288 0 0 0 .047.21Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoJavascript = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 1.5v21h21v-21h-21Zm11.25 16.313c0 2.044-1.207 3.04-2.955 3.04-1.58 0-2.496-.817-2.96-1.804l1.606-.973c.31.55.545 1.015 1.222 1.015.562 0 1.024-.253 1.024-1.24V11.25h2.063v6.563Zm4.657 2.993c-1.832 0-3.016-.826-3.594-1.968l1.609-.932c.422.691.973 1.152 1.945 1.152.818 0 1.293-.362 1.293-.926 0-.677-.49-.916-1.392-1.313l-.493-.212c-1.424-.605-2.368-1.366-2.368-2.974 0-1.48 1.127-2.56 2.89-2.56 1.254 0 2.156.39 2.805 1.531l-1.54.99c-.338-.606-.703-.844-1.268-.844-.578 0-.945.367-.945.844 0 .592.367.831 1.213 1.198l.493.211c1.678.72 2.622 1.453 2.622 3.102 0 1.776-1.395 2.701-3.27 2.701Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoLaravel = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-laravel_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.699 10.998c-.154-.166-1.258-1.514-1.852-2.24-.317-.387-.567-.692-.672-.818l-.008-.01-.01-.01c-.244-.274-.592-.587-1.114-.587-.085.001-.17.008-.254.02l-.054.008c-.114.012-.471.07-1.319.21-.656.107-1.646.27-1.796.284l-.033.003-.032.006c-.469.084-.78.292-.917.619-.073.172-.15.522.138.93.072.104.32.449.747 1.04l.879 1.218-5.22 1.22-5.12-8.389-.01-.016-.01-.015-.02-.03c-.21-.308-.47-.691-1.224-.691-.053 0-.108 0-.17.005-.215.012-1.004.074-1.916.146-1.008.08-2.386.187-2.565.192h-.035l-.037.004c-.428.042-.739.215-.923.515-.307.502-.067 1.064.012 1.249.158.373 1.597 3.406 2.866 6.083a616.758 616.758 0 0 1 1.786 3.78 1.634 1.634 0 0 0 1.544 1.013c.155-.001.31-.018.462-.052h.01l.009-.002c.65-.159 2.71-.682 4.181-1.06l.281.49c1.028 1.805 1.777 3.11 2.024 3.444.126.177.501.693 1.207.693.256 0 .49-.066.738-.136l.072-.02h.005c.494-.14 7.064-2.445 7.4-2.594l.01-.005c.256-.113.641-.283.76-.722.077-.287.008-.578-.206-.865l-.003-.004-.004-.005a634.538 634.538 0 0 0-2.114-2.786 90.187 90.187 0 0 0 2.033-.541c.538-.16.7-.501.75-.69.037-.148.085-.526-.276-.884Zm-15 2.728c-.835.195-1.417.331-1.776.417-.313-.626-.926-1.859-1.524-3.063a1813.15 1813.15 0 0 0-2.493-5.01l.382-.033a944.77 944.77 0 0 1 1.959-.168c.785 1.325 3.483 5.874 4.514 7.608l-1.062.248Zm8.35 3.123c-1.134.375-1.749.58-2.081.691-.296-.485-.945-1.571-1.522-2.54l5.423-1.382c.235.32.683.925 1.569 2.106-.848.283-2.26.751-3.388 1.125Zm2.62-5.701L18.555 9.67l1.226-.216.562.698.56.694-1.234.302Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-laravel_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgLogoLinkedin = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.82 1.5H3.294c-.957 0-1.794.69-1.794 1.635v17.566c0 .951.837 1.799 1.794 1.799h17.521c.963 0 1.685-.854 1.685-1.8V3.136c.006-.946-.722-1.635-1.68-1.635ZM8.01 19.005H5V9.65H8.01v9.354ZM6.61 8.228h-.022c-.963 0-1.586-.716-1.586-1.613C5.002 5.7 5.642 5 6.626 5c.984 0 1.587.695 1.608 1.614 0 .897-.624 1.613-1.625 1.613Zm12.395 10.777h-3.009V13.89c0-1.225-.438-2.063-1.526-2.063-.832 0-1.324.563-1.543 1.111-.082.197-.104.465-.104.739v5.328H9.815V9.65h3.008v1.301c.438-.623 1.122-1.52 2.713-1.52 1.975 0 3.469 1.301 3.469 4.108v5.465Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoMarkdown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.266 3H1.734C.777 3 0 3.815 0 4.817v14.364C0 20.184.777 21 1.734 21h20.532C23.22 21 24 20.184 24 19.18V4.818C24 3.815 23.223 3 22.266 3ZM13.5 17.25h-3V12l-2.25 3L6 12v5.25H3V6.75h3l2.25 3.75 2.25-3.75h3v10.5Zm4.5 0L14.25 12h2.252L16.5 6.75h3V12h2.25L18 17.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoMastodon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.137c0-4.881-3.2-6.312-3.2-6.312-1.614-.74-4.385-1.052-7.263-1.075h-.07c-2.878.023-5.647.335-7.26 1.075 0 0-3.2 1.43-3.2 6.312 0 1.118-.022 2.454.013 3.871.116 4.773.876 9.478 5.292 10.646 2.036.539 3.784.651 5.192.574 2.553-.14 3.984-.91 3.984-.91l-.084-1.852s-1.825.575-3.874.505c-2.03-.07-4.171-.219-4.5-2.71a5.083 5.083 0 0 1-.046-.698c1.485.331 2.997.533 4.518.602 1.544.07 2.992-.09 4.463-.266 2.821-.336 5.277-2.074 5.586-3.66.488-2.5.449-6.102.449-6.102Zm-3.775 6.289H16.38V8.69c0-1.21-.51-1.823-1.527-1.823-1.125 0-1.69.728-1.69 2.167v3.14h-2.329v-3.14c0-1.44-.562-2.167-1.69-2.167-1.018 0-1.527.613-1.527 1.823v5.736H5.274v-5.91c0-1.208.309-2.167.926-2.878.638-.71 1.472-1.074 2.508-1.074 1.2 0 2.107.46 2.707 1.382l.585.977.584-.977c.6-.922 1.508-1.382 2.707-1.382 1.036 0 1.87.364 2.508 1.074.618.71.927 1.67.926 2.878v5.91Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoMedium = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M1.313 1.313v21.375h21.375V1.313H1.313ZM19.07 6.377l-1.146 1.1a.336.336 0 0 0-.128.32v8.076a.334.334 0 0 0 .128.322l1.119 1.1v.24h-5.63v-.24l1.159-1.127c.114-.114.114-.148.114-.321V9.319l-3.225 8.19h-.436l-3.754-8.19v5.49a.758.758 0 0 0 .208.63l1.508 1.829v.241H4.71v-.241l1.509-1.83a.732.732 0 0 0 .194-.63V8.461a.556.556 0 0 0-.18-.47L4.891 6.377v-.241h4.163l3.218 7.057 2.829-7.057h3.968v.242Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoNoSmoking = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.625 12h-.75v2.25h.75V12ZM5.25 14.25h6.075L9.075 12H5.25v2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.086 2.817a.407.407 0 0 1-.047-.028 10.258 10.258 0 0 0-1.612-.694l-.254-.084A10.462 10.462 0 0 0 12 1.5C6.202 1.5 1.5 6.202 1.5 12a10.486 10.486 0 0 0 5.41 9.178c.018.01.032.024.05.033.518.277 1.057.509 1.613.694l.254.084c1.025.333 2.095.505 3.173.511 5.798 0 10.5-4.702 10.5-10.5a10.489 10.489 0 0 0-5.414-9.183ZM12 19.987a7.59 7.59 0 0 1-1.275-.112 7.979 7.979 0 0 1-1.336-.342c-.089-.028-.178-.056-.262-.09a7.607 7.607 0 0 1-.891-.402 7.984 7.984 0 0 1-4.224-7.046c0-1.743.582-3.347 1.533-4.66l11.12 11.12c-1.318.951-2.921 1.533-4.665 1.533Zm6.46-3.328L7.34 5.541c1.313-.947 2.912-1.529 4.66-1.529.427.002.854.04 1.275.113.454.075.901.19 1.336.342.084.028.173.056.262.09.29.109.57.235.844.379a7.981 7.981 0 0 1 4.275 7.069c-.005 1.743-.586 3.342-1.533 4.654Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 12h-1.594l1.594 1.594V12ZM18.75 12H18v2.25h.75V12ZM16.88 9.97c-.413-.192-1.032-.267-2.138-.267h-.169c-.595.005-.745-.004-.937-.286-.131-.197-.047-.693.173-1.026a.375.375 0 0 0-.118-.529.387.387 0 0 0-.191-.057 2.516 2.516 0 0 1-.858-.183c-.497-.21-.731-.567-.731-1.083 0-1.21 1.022-1.298 1.069-1.298v-.75c-.563 0-1.82.515-1.82 2.048 0 .82.423 1.453 1.206 1.781.181.074.37.13.562.17-.155.459-.169.979.08 1.345.422.623.951.618 1.56.614h.165c1.232 0 1.622.107 1.823.201.267.122.319.352.31.736v.047h.75v-.047c0-.333.014-1.069-.736-1.415Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.438c0-1.205-.14-1.838-.427-2.325-.403-.675-1.05-1.05-1.823-1.05h-.816c.136-.39.254-.928.164-1.449-.15-.88-.895-1.406-2.02-1.406v.75c.985 0 1.224.427 1.285.783.117.68-.32 1.505-.324 1.514a.375.375 0 0 0 .142.504c.057.032.121.05.186.05H16.5c.51 0 .91.229 1.177.684.145.248.323.632.323 1.94h.75v.005Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoNodejs = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m20.145 6.096-7.286-4.37a1.735 1.735 0 0 0-1.718 0l-7.286 4.37A1.79 1.79 0 0 0 3 7.632v8.727a1.793 1.793 0 0 0 .855 1.537l1.91 1.141.011.006c.965.494 1.334.494 1.762.494 1.507 0 2.443-.975 2.443-2.545V8.53a.399.399 0 0 0-.395-.402H8.537a.399.399 0 0 0-.394.402v8.462a.703.703 0 0 1-.321.613c-.277.168-.679.133-1.132-.101l-1.831-1.102a.051.051 0 0 1-.022-.043V7.755a.062.062 0 0 1 .027-.05l7.118-4.359a.039.039 0 0 1 .034 0l7.122 4.36a.063.063 0 0 1 .025.051v8.602a.06.06 0 0 1-.021.047l-7.128 4.249a.057.057 0 0 1-.037 0l-1.82-1.081a.366.366 0 0 0-.367-.02l-.016.01c-.503.298-.638.375-1.104.545-.076.027-.254.093-.27.27-.015.177.155.302.306.39l2.432 1.494c.26.155.556.237.858.238h.027c.295-.005.583-.087.836-.238l7.286-4.366A1.798 1.798 0 0 0 21 16.36V7.632a1.793 1.793 0 0 0-.855-1.536Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.432 14.91c-1.748 0-2.12-.489-2.231-1.277a.396.396 0 0 0-.386-.344h-.928a.395.395 0 0 0-.387.403c0 .683.24 2.914 3.934 2.914 1.143 0 2.093-.267 2.748-.773.655-.506 1.006-1.242 1.006-2.119 0-1.76-1.149-2.242-3.41-2.557-2.3-.32-2.3-.482-2.3-.838 0-.257 0-.857 1.662-.857 1.183 0 1.816.15 2.019.937a.39.39 0 0 0 .378.313h.931a.387.387 0 0 0 .289-.134.417.417 0 0 0 .1-.302c-.121-1.667-1.34-2.512-3.715-2.512-2.16 0-3.448.973-3.448 2.602 0 1.786 1.336 2.29 3.342 2.5 2.344.242 2.344.595 2.344.908.001.486-.201 1.135-1.948 1.135Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoNpm = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 9.99h-1.331v2.676H12V9.989Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.313v8.034h6.666v1.34H12v-1.34h12V7.313H0Zm6.666 6.698H5.334V9.994H3.998v4.017H1.331V8.653h5.335v5.358Zm6.665 0h-2.667v1.34H7.997V8.654h5.334v5.358Zm9.338 0h-1.332V9.994h-1.33v4.017h-1.332V9.994h-1.331v4.017h-2.667V8.653h8.001v5.358h-.01Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoOctocat = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.103 13.6c-.457 0-.85.214-1.165.65-.317.437-.473.965-.473 1.594 0 .63.161 1.168.473 1.6.31.431.703.65 1.165.65.426 0 .797-.218 1.11-.65.313-.431.472-.964.472-1.599s-.16-1.163-.472-1.594c-.311-.43-.682-.65-1.11-.65ZM15.953 13.6c-.452 0-.85.214-1.166.65-.316.437-.472.965-.472 1.594 0 .63.16 1.168.472 1.6.311.431.708.65 1.165.65.428 0 .797-.218 1.116-.65.318-.431.472-.964.472-1.599s-.161-1.163-.472-1.594c-.312-.43-.683-.65-1.116-.65Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.532 7.734c-.005 0 .136-.726.015-1.99-.11-1.266-.375-2.428-.808-3.494 0 0-.221.04-.643.147-.422.107-1.112.322-2.054.752-.93.431-1.909 1.005-2.928 1.701-.693-.198-1.728-.3-3.114-.3-1.32 0-2.355.102-3.114.3-2.24-1.57-4.116-2.436-5.63-2.6-.432 1.067-.7 2.235-.803 3.504-.121 1.266.02 1.996.02 1.996C1.252 9.085.75 11.01.75 12.6c0 1.228.035 2.34.307 3.327.28.98.637 1.781 1.059 2.397.436.623.973 1.17 1.587 1.618.628.473 1.205.813 1.728 1.026.527.223 1.125.386 1.808.503.506.098 1.018.166 1.532.203 0 0 1.406.076 3.234.076s3.23-.076 3.23-.076a13.391 13.391 0 0 0 1.531-.205 8.388 8.388 0 0 0 1.803-.503c.523-.218 1.1-.553 1.734-1.026a6.797 6.797 0 0 0 1.582-1.62c.422-.614.779-1.416 1.06-2.397.281-.98.305-2.1.305-3.33 0-1.537-.502-3.488-1.718-4.859Zm-3.284 11.863c-1.402.665-3.46.934-6.193.934h-.105c-2.732 0-4.792-.264-6.167-.934-1.376-.67-2.075-2.037-2.075-4.098 0-1.234.432-2.234 1.28-3 .373-.328.824-.559 1.387-.696.563-.137 1.075-.14 1.557-.127.472.02 1.135.112 1.974.178.838.066 1.471.152 2.1.152.586 0 1.365-.102 2.616-.203 1.25-.101 2.185-.152 2.787-.051.618.102 1.155.315 1.612.747.89.802 1.334 1.802 1.336 3-.005 2.061-.713 3.433-2.109 4.098Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoPaypal = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.913 6.975c-.02.13-.044.262-.07.398-.898 4.594-3.973 6.178-7.9 6.178h-2a.97.97 0 0 0-.959.819L7.96 20.83l-.29 1.832a.509.509 0 0 0 .505.588h3.547a.852.852 0 0 0 .843-.715l.035-.18.668-4.219.042-.231a.85.85 0 0 1 .844-.717h.53c3.436 0 6.125-1.389 6.911-5.406.328-1.678.159-3.08-.71-4.065a3.388 3.388 0 0 0-.972-.742Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.071 2.395C17.055 1.243 15.221.75 12.873.75H6.06a.973.973 0 0 0-.963.82L2.258 19.475a.582.582 0 0 0 .577.673h4.208L8.1 13.48l-.033.21a.969.969 0 0 1 .96-.82h1.998c3.927 0 7.002-1.586 7.9-6.177.027-.136.05-.268.07-.398.268-1.697-.002-2.853-.924-3.9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoPinterest = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.002 1.5c-5.798 0-10.5 4.702-10.5 10.5 0 4.298 2.588 7.992 6.286 9.619-.028-.732-.004-1.613.183-2.41l1.35-5.723s-.337-.67-.337-1.66c0-1.556.9-2.718 2.024-2.718.957 0 1.416.717 1.416 1.575 0 .96-.614 2.395-.928 3.726-.263 1.116.558 2.02 1.66 2.02 1.987 0 3.327-2.554 3.327-5.582 0-2.302-1.551-4.022-4.368-4.022-3.183 0-5.17 2.377-5.17 5.03 0 .914.271 1.56.693 2.057.192.23.22.324.15.586-.051.193-.164.657-.215.844-.07.267-.286.361-.525.263-1.468-.6-2.152-2.203-2.152-4.013 0-2.981 2.517-6.558 7.505-6.558 4.008 0 6.647 2.902 6.647 6.014 0 4.12-2.293 7.196-5.668 7.196-1.134 0-2.198-.614-2.564-1.308 0 0-.609 2.419-.74 2.887-.22.811-.657 1.618-1.055 2.25.967.286 1.969.43 2.977.432 5.798 0 10.5-4.702 10.5-10.5C22.498 6.206 17.8 1.5 12.002 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoPlaystation = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.74 9.516c-.038-.802-.155-1.618-.507-2.349a3.863 3.863 0 0 0-.774-1.087 4.948 4.948 0 0 0-.998-.764c-.801-.478-1.758-.797-3.956-1.454C10.306 3.206 9 3 9 3v16.795L12.745 21s.005-9.319.005-14.04v-.177c0-.436.352-.788.755-.788h.023c.399 0 .727.352.727.788v6.248c.515.249 1.368.436 1.96.427.391.01.779-.081 1.124-.267.356-.197.654-.485.863-.835.232-.394.39-.828.464-1.28.087-.506.092-1.035.073-1.56ZM4.063 16.772c1.284-.46 4.186-1.383 4.186-1.383v-2.212s-3.586 1.162-5.218 1.739c-.403.145-.81.277-1.204.445-.46.192-.91.408-1.317.694-.183.117-.332.28-.432.474a.814.814 0 0 0-.023.637c.094.24.272.436.473.59.366.277.802.446 1.238.572 1.335.444 2.737.655 4.144.624.68-.01 1.687-.09 2.343-.206v-1.97s-.515.118-1.936.587c-.215.07-.43.155-.656.201-.333.07-.672.104-1.012.104-.305-.014-.62-.033-.905-.146-.103-.047-.216-.103-.258-.215-.037-.094.014-.188.08-.253.131-.136.319-.211.497-.282Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 16.214c-.005-.28-.173-.525-.37-.703-.333-.295-.746-.482-1.158-.632-.258-.09-.436-.155-.69-.235-1.18-.384-2.432-.525-3.67-.53-.374.014-1.082.024-1.453.066-1.026.117-3.154.722-3.154.722v2.287s3.164-1.012 4.523-1.49a4.426 4.426 0 0 1 1.42-.216c.305.01.62.033.91.146.103.042.21.103.258.21.042.122-.043.235-.136.305-.22.178-.502.249-.76.347-1.922.68-6.22 2.095-6.22 2.095v2.203s5.494-1.856 8.006-2.756c.417-.155.84-.286 1.238-.487.37-.188.74-.403 1.022-.718a.925.925 0 0 0 .234-.614Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoPwa = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m15.502 16.5 3.643-9H16.73l-2.492 5.816L12.466 7.5h-1.857l-1.902 5.816-1.342-2.65L6.15 14.39 7.383 16.5H9.76l1.72-5.216 1.64 5.216h2.382ZM2.287 13.41h1.484c.405.006.81-.044 1.2-.15l.384-1.18 1.072-3.3a2.613 2.613 0 0 0-.28-.367C5.596 7.804 4.791 7.5 3.73 7.5H0v9h2.287v-3.09Zm1.964-3.84c.215.217.323.506.323.869 0 .362-.094.652-.282.868-.207.238-.589.357-1.145.357h-.86V9.246h.863c.519 0 .886.108 1.101.324Zm13.414 5.318.693-1.746h2.001l-.95-2.649L20.598 7.5l3.403 9h-2.51l-.58-1.612h-3.245Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoPython = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.719 1.705c-.872-.143-2.147-.21-3.013-.205-.811 0-1.621.07-2.421.205C7.14 2.08 6.75 2.863 6.75 4.31v1.69H12v.75H5.045c-1.948 0-3.53 2.33-3.545 5.21v.04c0 .505.049 1.007.147 1.5.435 2.17 1.792 3.75 3.398 3.75H6v-2.53c0-1.468.977-2.81 2.578-3.099l.463-.057h5.678c.238 0 .476-.031.706-.094a2.46 2.46 0 0 0 1.825-2.39v-4.77c0-1.356-1.157-2.378-2.531-2.604Zm-5.582 3.24a.955.955 0 1 1-.006-1.91.955.955 0 0 1 .006 1.91Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.279 10.172c-.502-1.997-1.8-3.422-3.324-3.422h-.83v2.224c0 1.855-1.219 3.198-2.706 3.428-.15.024-.303.035-.455.035H9.285c-.24 0-.48.03-.714.092-1.046.274-1.821 1.144-1.821 2.273v4.77c0 1.36 1.366 2.156 2.706 2.546 1.604.466 3.35.55 5.27 0 1.274-.364 2.524-1.1 2.524-2.546V18H12v-.75h6.955c1.38 0 2.576-1.169 3.162-2.874A7.35 7.35 0 0 0 22.5 12a7.53 7.53 0 0 0-.221-1.828Zm-7.443 8.765a.955.955 0 1 1 .007 1.91.955.955 0 0 1-.007-1.91Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoReact = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.25 8.472c-.24-.082-.481-.158-.724-.229.04-.164.077-.329.111-.495.549-2.667.19-4.816-1.034-5.523-1.172-.679-3.094.029-5.033 1.72-.19.167-.377.339-.56.515a10.989 10.989 0 0 0-.375-.345c-2.032-1.808-4.068-2.57-5.29-1.86-1.173.68-1.521 2.7-1.027 5.228.049.25.104.499.166.747-.288.082-.567.17-.833.262C2.27 9.324.75 10.63.75 11.982c0 1.397 1.633 2.799 4.114 3.649.201.068.405.132.61.19a13.93 13.93 0 0 0-.177.805c-.469 2.485-.103 4.457 1.066 5.133 1.208.698 3.235-.02 5.21-1.75.156-.136.313-.28.469-.433.197.191.4.377.61.556 1.912 1.65 3.8 2.315 4.968 1.637 1.207-.7 1.6-2.818 1.09-5.396-.04-.197-.084-.398-.135-.603.142-.042.282-.086.418-.13 2.578-.857 4.258-2.242 4.258-3.657-.001-1.36-1.571-2.672-4.001-3.511Zm-6.047-3.8c1.66-1.45 3.213-2.021 3.92-1.613.754.436 1.047 2.192.574 4.495-.031.15-.065.3-.101.448a22.868 22.868 0 0 0-3.009-.476 22.556 22.556 0 0 0-1.902-2.379c.168-.163.34-.322.517-.476Zm-5.81 8.465a28.373 28.373 0 0 0 1.345 2.325 20.406 20.406 0 0 1-2.074-.334c.199-.643.444-1.31.73-1.99Zm0-2.265c-.28-.665-.519-1.32-.714-1.951a21.603 21.603 0 0 1 2.04-.351 27.817 27.817 0 0 0-1.327 2.302h.002Zm.512 1.133a27.347 27.347 0 0 1 2.048-3.558 27.22 27.22 0 0 1 4.101 0c.382.565.743 1.144 1.084 1.735.341.59.665 1.194.97 1.809-.301.62-.624 1.228-.967 1.825-.341.594-.7 1.176-1.079 1.746a31.343 31.343 0 0 1-4.1.008 27.27 27.27 0 0 1-2.059-3.565h.002Zm8.068 2.293c.226-.393.444-.792.652-1.195.286.648.538 1.31.756 1.984-.693.156-1.394.275-2.1.358.238-.378.469-.76.692-1.147Zm.643-3.425a31.397 31.397 0 0 0-.648-1.172c-.218-.381-.446-.757-.684-1.128.718.09 1.407.212 2.052.36a20.64 20.64 0 0 1-.72 1.94ZM12.01 5.836c.468.511.91 1.046 1.324 1.602a27.96 27.96 0 0 0-2.66 0c.438-.578.885-1.115 1.336-1.602ZM6.828 3.088c.753-.437 2.417.187 4.172 1.747.112.1.225.204.337.313-.69.749-1.33 1.543-1.915 2.377-1.01.09-2.013.247-3.003.468-.057-.23-.109-.461-.155-.694-.424-2.167-.143-3.8.564-4.211ZM5.73 14.893a11.199 11.199 0 0 1-.555-.174c-1.097-.374-2.003-.864-2.625-1.397-.557-.477-.84-.954-.84-1.34 0-.821 1.223-1.868 3.26-2.579.256-.089.514-.17.774-.244.303.973.669 1.924 1.097 2.848a23.548 23.548 0 0 0-1.11 2.886Zm5.21 4.391c-.874.765-1.748 1.308-2.52 1.58-.692.246-1.244.253-1.577.06-.71-.41-1.005-1.994-.603-4.118.048-.25.103-.5.165-.75 1 .215 2.012.362 3.032.44.59.838 1.236 1.637 1.931 2.39-.14.138-.283.27-.428.398Zm1.098-1.088a21.557 21.557 0 0 1-1.354-1.624 33.59 33.59 0 0 0 2.675-.005 20.6 20.6 0 0 1-1.322 1.629Zm5.836 1.34c-.134.724-.403 1.206-.736 1.4-.71.411-2.226-.124-3.861-1.534a15.464 15.464 0 0 1-.566-.516 22.714 22.714 0 0 0 1.886-2.4 22.375 22.375 0 0 0 3.047-.47c.046.185.086.367.122.545.225 1.139.257 2.17.108 2.975Zm.816-4.811c-.123.04-.25.08-.378.118a22.658 22.658 0 0 0-1.14-2.856c.428-.913.794-1.854 1.096-2.816.23.067.453.138.669.212 2.082.718 3.352 1.782 3.352 2.599 0 .871-1.372 2.003-3.599 2.743Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 13.994a2.016 2.016 0 1 0 .013-4.031A2.016 2.016 0 0 0 12 13.994Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoReddit = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.188 12a1.687 1.687 0 1 0 0 3.375 1.687 1.687 0 0 0 0-3.375ZM9.459 15.246a1.688 1.688 0 1 0-1.292-3.118 1.688 1.688 0 0 0 1.292 3.118Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 11.896c0-1.463-1.178-2.652-2.625-2.652-.61 0-1.2.213-1.67.603-1.64-1.114-3.786-1.796-6.077-1.934l1.032-3.704 3.113.62c.089 1.24 1.125 2.225 2.374 2.225 1.312 0 2.38-1.078 2.38-2.4 0-1.323-1.105-2.404-2.418-2.404-.915 0-1.702.525-2.102 1.349l-4.219-.839-1.458 5.134-.217.006c-2.373.103-4.61.793-6.317 1.947a2.596 2.596 0 0 0-1.671-.603c-1.448 0-2.625 1.19-2.625 2.652a2.645 2.645 0 0 0 1.318 2.3 4.623 4.623 0 0 0-.042.624c.005 1.863 1.054 3.61 2.953 4.922 1.882 1.294 4.373 2.008 7.02 2.008 2.649 0 5.146-.714 7.024-2.01 1.9-1.313 2.946-3.06 2.946-4.925 0-.209-.013-.417-.04-.624a2.64 2.64 0 0 0 1.32-2.296Zm-3.844-8.38a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm-17.404 8.38a1.387 1.387 0 0 1 1.38-1.393c.222 0 .442.056.638.16-.727.676-1.262 1.426-1.597 2.236a1.418 1.418 0 0 1-.42-1.003Zm16.318 6.807c-1.676 1.153-3.92 1.788-6.318 1.788-2.398 0-4.643-.634-6.317-1.788-1.546-1.068-2.401-2.45-2.401-3.89 0-.437.079-.87.232-1.28.266-.737.757-1.428 1.46-2.052.22-.194.45-.374.692-.54l.014-.01.01-.008c1.675-1.15 3.916-1.781 6.31-1.781 2.396 0 4.637.633 6.311 1.78l.01.009.017.012c.24.165.472.345.691.538.703.624 1.195 1.315 1.46 2.053a3.637 3.637 0 0 1 .23 1.28c0 1.44-.853 2.822-2.401 3.89Zm3.262-5.809c-.334-.81-.87-1.56-1.597-2.236.197-.104.417-.159.64-.158a1.387 1.387 0 0 1 1.378 1.393 1.408 1.408 0 0 1-.42 1.002Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.151 16.98c-.011.01-1.198 1.221-3.147 1.23-1.969-.009-3.107-1.182-3.155-1.23a.194.194 0 0 0-.274 0l-.642.63a.196.196 0 0 0 0 .277c.16.159 1.627 1.604 4.068 1.614 2.435-.01 3.908-1.455 4.068-1.614a.195.195 0 0 0 0-.277l-.643-.631a.193.193 0 0 0-.272 0h-.003Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoRss = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.089 16.069a2.828 2.828 0 1 0 2.839 2.833 2.842 2.842 0 0 0-2.84-2.834Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.75v4.057c2.438 0 4.778.722 6.5 2.443 1.722 1.721 2.438 4.057 2.438 6.5h4.062c0-7.104-5.89-13-13-13Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 2.25v4.058c8.684 0 15.432 6.753 15.432 15.442h4.068c0-10.75-8.734-19.5-19.5-19.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoSass = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-sass_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.99 15.377c-.07-.558-.352-1.043-.844-1.442a.17.17 0 0 0-.02-.02l-.025-.018-.008-.006-.261-.187-.009-.007-.033-.023a.162.162 0 0 0-.04-.017c-.825-.492-2.192-.836-4.285-.098-.499-.84-.555-1.513-.221-2.544.06-.18.004-.298-.174-.375-.358-.152-.849-.075-1.196.017-.163.042-.26.134-.291.273-.22 1.032-.86 1.974-1.48 2.883l-.036.054c-.382-.81-.303-1.436-.037-2.221.053-.157.011-.26-.135-.339-.41-.211-1.025-.066-1.27.006-.31.09-.643.93-1.014 1.933a9.279 9.279 0 0 1-.223.57c-.115.234-.224.502-.34.785-.263.642-.559 1.364-.982 1.818-.154-.34.088-.876.323-1.395.278-.615.54-1.196.238-1.566a.556.556 0 0 0-.39-.203.621.621 0 0 0-.288.047c.031-.265.032-.474-.045-.727-.11-.36-.398-.562-.793-.551-.901.026-1.664.697-2.145 1.256-.32.375-1.031.66-1.655.912-.247.104-.481.198-.677.292-.311-.264-.707-.53-1.125-.81-1.172-.787-2.5-1.679-2.545-2.888-.066-1.787 1.968-3.054 3.744-3.958 1.346-.684 2.516-1.138 3.577-1.386 1.49-.348 2.75-.278 3.742.208.542.266.796.844.635 1.438-.422 1.545-2.17 2.603-3.665 3.08-.9.286-1.666.406-2.343.367-.849-.05-1.542-.475-1.838-.656a.993.993 0 0 0-.15-.085l-.013-.003a.15.15 0 0 0-.15.047c-.06.072-.04.187-.017.245.288.754.883 1.23 1.769 1.415.29.058.585.086.88.084 2.072 0 4.717-1.195 5.688-2.18.662-.67 1.145-1.359 1.344-2.547.209-1.244-.635-2.11-1.495-2.508-2.089-.964-4.462-.583-6.084-.093C5.689 4.826 3.725 5.867 2.2 7.11.32 8.64-.36 10.063.179 11.34c.553 1.31 1.903 2.128 3.209 2.92.422.256.823.5 1.184.75l-.333.161c-1.096.531-2.339 1.129-3.028 2.117-.5.72-.595 1.435-.279 2.129.17.369.47.619.886.744.217.061.441.09.666.088.812 0 1.705-.328 2.19-.631.86-.54 1.416-1.263 1.655-2.151.213-.79.162-1.576-.148-2.277l1.053-.53c-.508 1.687-.119 2.695.309 3.251.157.205.441.328.759.334.317.005.609-.114.774-.318.312-.386.543-.839.755-1.29-.011.294.003.593.104.847.09.228.24.38.431.438.205.062.444.01.675-.148 1.04-.71 1.75-2.418 2.32-3.79.082-.195.16-.382.235-.557.141.505.338.994.586 1.456.055.1.05.144-.024.227-.113.124-.27.273-.438.431-.505.48-1.134 1.079-1.218 1.605-.033.211.112.403.337.447.679.135 1.496-.063 2.187-.528.628-.421.864-1.01.703-1.743-.156-.706.2-1.582 1.059-2.607.14.587.328 1.062.587 1.478l-.007.006c-.626.546-1.482 1.293-1.35 2.2a.627.627 0 0 0 .515.536c.09.016.183.014.272-.007.82-.172 1.436-.518 1.884-1.058.448-.54.284-1.137.133-1.602 1.172-.317 2.216-.31 3.192.024.549.187.942.495 1.169.92.285.535.131 1.029-.436 1.39-.173.111-.257.18-.262.265a.126.126 0 0 0 .046.105c.066.054.268.147.727-.14.421-.266.669-.626.732-1.08.013-.124.013-.25 0-.375ZM5.252 16.552l-.004.06c-.073.686-.422 1.285-1.039 1.781-.387.313-.807.504-1.183.54-.263.026-.454-.01-.567-.105-.085-.072-.13-.18-.14-.329-.077-1.194 1.796-2.38 2.85-2.771.075.268.103.547.083.824Zm4.798-3.368c-.173.988-.68 2.854-1.474 3.579-.038.034-.07.046-.085.043-.014-.003-.025-.02-.037-.047-.265-.615-.167-1.653.234-2.47.31-.629.75-1.045 1.243-1.171a.252.252 0 0 1 .063-.01.074.074 0 0 1 .047.013.077.077 0 0 1 .009.063Zm3.914 3.604c-.15.156-.355.134-.306.077l.76-.808c-.06.278-.242.508-.454.73Zm3.158-.7a.662.662 0 0 1-.232.066c-.021-.425.39-.904.797-1.223.11.443-.114.912-.565 1.158Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-sass_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgLogoSkype = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.898 14.23a9.638 9.638 0 0 0 .23-2.116c0-5.452-4.486-9.876-10.022-9.876a10.4 10.4 0 0 0-1.711.14A5.793 5.793 0 0 0 7.309 1.5C4.104 1.5 1.5 4.064 1.5 7.225a5.604 5.604 0 0 0 .797 2.9 9.9 9.9 0 0 0-.203 1.985c0 5.458 4.486 9.876 10.016 9.876.615.002 1.228-.053 1.833-.164a5.88 5.88 0 0 0 2.748.677c3.21 0 5.809-2.565 5.809-5.725a5.53 5.53 0 0 0-.602-2.543Zm-4.648 2.598c-.465.645-1.149 1.159-2.035 1.52-.886.36-1.932.542-3.136.542-1.438 0-2.642-.252-3.588-.744a4.734 4.734 0 0 1-1.652-1.444c-.427-.601-.64-1.202-.64-1.78 0-.362.14-.674.416-.936.273-.252.629-.383 1.044-.383.345 0 .64.098.881.301.23.191.427.476.585.848.154.355.348.693.578 1.005.198.256.477.47.837.64.367.169.853.256 1.453.256.826 0 1.505-.175 2.013-.52.504-.333.745-.737.745-1.23 0-.388-.127-.694-.389-.935-.273-.252-.629-.448-1.072-.58-.454-.14-1.072-.29-1.838-.448-1.04-.219-1.922-.481-2.625-.776-.716-.301-1.296-.722-1.723-1.242-.432-.53-.646-1.197-.646-1.98a3.18 3.18 0 0 1 .679-1.996c.448-.574 1.1-1.022 1.947-1.329.832-.306 1.822-.459 2.938-.459.897 0 1.68.104 2.335.301.657.197 1.215.476 1.658.815.443.339.766.7.973 1.078.208.378.313.76.313 1.125 0 .35-.137.672-.411.951a1.39 1.39 0 0 1-1.028.427c-.372 0-.662-.088-.864-.263-.188-.164-.383-.415-.597-.782-.251-.464-.552-.837-.897-1.1-.34-.25-.897-.382-1.674-.382-.716 0-1.301.141-1.734.422-.416.268-.618.58-.618.946a.856.856 0 0 0 .202.574c.165.19.368.343.596.449.257.13.527.232.804.306.282.077.744.192 1.384.334.815.17 1.56.366 2.216.568.667.214 1.242.47 1.712.771.467.295.855.699 1.132 1.177.268.468.405 1.06.405 1.739a3.52 3.52 0 0 1-.679 2.214Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoSlack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.912 14.77a2.206 2.206 0 1 1-2.206-2.207h2.206v2.207ZM7.024 14.771a2.206 2.206 0 0 1 4.412 0v5.524a2.206 2.206 0 0 1-4.412 0v-5.524ZM9.23 5.912a2.206 2.206 0 1 1 2.207-2.206v2.206H9.23ZM9.23 7.024a2.206 2.206 0 0 1 0 4.412H3.706a2.206 2.206 0 1 1 0-4.412H9.23ZM18.088 9.229a2.206 2.206 0 1 1 2.206 2.208h-2.206V9.229ZM16.976 9.23a2.206 2.206 0 1 1-4.412 0V3.706a2.206 2.206 0 0 1 4.412 0V9.23ZM14.77 18.087a2.207 2.207 0 1 1-2.207 2.206v-2.206h2.207ZM14.77 16.977a2.206 2.206 0 0 1 0-4.412h5.524a2.206 2.206 0 1 1 0 4.412H14.77Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoSnapchat = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 16.276a8.92 8.92 0 0 1-1.537-.25c-1.279-.31-2.57-1.137-3.193-2.457-.324-.686-.124-.872.556-1.125.665-.247 1.397-.362 1.728-1.078.276-.598.053-1.301-.488-1.664-.737-.493-1.423-.01-2.186.097.175-2.187.406-4.151-1.062-5.987C15.85 2.29 13.938 1.5 12.014 1.5c-1.925 0-3.838.79-5.054 2.312-1.47 1.84-1.237 3.806-1.063 5.997-.765-.106-1.444-.6-2.185-.103a1.34 1.34 0 0 0-.255 2.016c.541.62 1.483.445 2.036.966.304.285.164.59-.016.944-.679 1.331-1.84 2.144-3.274 2.417-.187.035-1.046.134-1.453.17 0 .436.024.787.076 1.02.138.611.578 1.105 1.11 1.41.525.3 1.664.302 1.955.727.14.21.082.576.25.815.17.242.429.406.72.457.872.17 1.75-.337 2.645-.099.696.186 1.243.744 1.84 1.125.727.462 1.516.77 2.383.82 1.786.104 2.809-.886 4.246-1.707.914-.522 1.788-.18 2.76-.125.942.053 1.102-.434 1.388-1.167.031-.073.055-.15.072-.227a.499.499 0 0 0 .107-.069c.094-.074.495-.11.598-.134.482-.114.954-.241 1.367-.525.53-.364.828-.867.918-1.53a4.39 4.39 0 0 0 .065-.735ZM9.75 6c.414 0 .75.503.75 1.125s-.336 1.125-.75 1.125S9 7.747 9 7.125 9.336 6 9.75 6Zm4.857 3.642c-.715.703-1.64 1.092-2.607 1.092A3.675 3.675 0 0 1 9.39 9.64a.375.375 0 1 1 .532-.53A2.928 2.928 0 0 0 12 9.984a2.96 2.96 0 0 0 2.08-.876.375.375 0 1 1 .527.534ZM14.25 8.25c-.414 0-.75-.504-.75-1.125S13.836 6 14.25 6s.75.504.75 1.125-.336 1.125-.75 1.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoSoundcloud = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-soundcloud_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.272 13.031a.1.1 0 0 0-.094.094L0 14.467l.175 1.32a.1.1 0 0 0 .096.094.1.1 0 0 0 .094-.094l.208-1.32-.206-1.342a.1.1 0 0 0-.094-.094H.272ZM1.259 12.297a.1.1 0 1 0-.2 0l-.234 2.171.234 2.123a.1.1 0 0 0 .17.071.1.1 0 0 0 .03-.07l.268-2.124-.268-2.172ZM4.977 10.293a.188.188 0 0 0-.182.182l-.187 3.995.187 2.581a.182.182 0 0 0 .364 0l.212-2.581-.212-3.995a.187.187 0 0 0-.182-.182ZM3.053 11.68a.145.145 0 0 0-.141.142L2.7 14.468l.211 2.56a.14.14 0 0 0 .282 0l.24-2.56-.24-2.648a.145.145 0 0 0-.14-.14ZM6.932 17.231a.226.226 0 0 0 .223-.222l.184-2.538-.184-5.319a.223.223 0 0 0-.446 0l-.163 5.318.163 2.54a.226.226 0 0 0 .223.221ZM10.935 17.242a.31.31 0 0 0 .305-.305l.128-2.466-.128-6.14a.305.305 0 0 0-.61 0l-.115 6.14.115 2.47a.309.309 0 0 0 .305.302ZM8.918 17.233a.266.266 0 0 0 .264-.264l.156-2.5-.156-5.357a.264.264 0 1 0-.527 0l-.141 5.357.14 2.5a.265.265 0 0 0 .264.262v.002ZM4.01 17.21a.165.165 0 0 0 .162-.16l.226-2.583-.226-2.456a.161.161 0 1 0-.323 0l-.2 2.456.2 2.581a.164.164 0 0 0 .162.162ZM2.102 17.07a.126.126 0 0 0 .12-.119l.255-2.484-.254-2.578a.12.12 0 1 0-.241 0l-.224 2.578.224 2.484a.123.123 0 0 0 .12.119ZM9.923 9.026a.286.286 0 0 0-.285.285l-.127 5.161.127 2.485a.285.285 0 0 0 .569 0l.14-2.485-.14-5.162a.286.286 0 0 0-.284-.284ZM5.953 17.236a.207.207 0 0 0 .202-.202l.198-2.564-.2-4.908a.203.203 0 0 0-.405 0l-.175 4.908.176 2.565a.205.205 0 0 0 .204.2ZM8.164 16.993l.17-2.521-.17-5.498a.243.243 0 1 0-.486 0l-.151 5.498.151 2.523a.243.243 0 0 0 .486 0v-.002ZM21.047 11.302c-.392-.001-.78.077-1.14.23-.235-2.681-2.467-4.782-5.188-4.782a5.246 5.246 0 0 0-1.888.355c-.223.087-.281.177-.284.35v9.439a.36.36 0 0 0 .319.351l8.182.005c1.63 0 2.954-1.331 2.954-2.974 0-1.642-1.322-2.974-2.954-2.974h-.001ZM11.943 7.448a.328.328 0 0 0-.325.328l-.134 6.697.134 2.432a.324.324 0 0 0 .454.31.326.326 0 0 0 .196-.313v.003l.145-2.432-.145-6.7a.328.328 0 0 0-.325-.325Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-soundcloud_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgLogoStackoverflow = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 20.625V15h1.875v7.5H3V15h1.875v5.625h13.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.99 14.474 9.307 1.915.394-1.843-9.308-1.915-.394 1.843Zm1.23-4.365 8.618 3.954.787-1.7-8.617-3.976-.788 1.722Zm2.389-4.172 7.312 5.99 1.207-1.431-7.313-5.99-1.206 1.43ZM15.375 1.5 13.81 2.616l5.663 7.517L21 9l-5.625-7.5ZM6.75 18.75h9.563v-1.875H6.75v1.875Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoSteam = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.444 9.76a1.688 1.688 0 1 1-3.376 0 1.688 1.688 0 0 1 3.376 0Zm-1.697-3.244a3.254 3.254 0 0 0-3.253 3.22l-2.025 2.906a2.404 2.404 0 0 0-1.49.328L4.8 9.281a2.428 2.428 0 1 0-2.372 2.949c.436 0 .864-.118 1.238-.343l9.178 3.685a2.426 2.426 0 0 0 4.786-.277l3.117-2.278a3.251 3.251 0 0 0 0-6.501Zm0 1.073a2.177 2.177 0 1 1-.005 4.355 2.177 2.177 0 0 1 .005-4.355Zm-18.319.422a1.79 1.79 0 0 1 1.58.947l-.886-.356v.004a1.416 1.416 0 0 0-1.06 2.625v.005l.755.3a1.783 1.783 0 1 1-.39-3.525Zm12.788 5.26a1.786 1.786 0 1 1-1.58 2.62c.295.117.586.234.881.356a1.418 1.418 0 1 0 1.055-2.634l-.745-.3c.128-.026.258-.04.389-.043Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoStencil = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.85 15.66h9.25l-5 5.34H3.9l4.95-5.34ZM24 9.328H4.997L0 14.672h19.003L24 9.328ZM10.884 3H20.1l-4.977 5.34H5.9L10.884 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoTableau = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-tableau_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.376 15.952h1.248V12.55h3.14v-1.21h-3.14V7.936h-1.248v3.403h-3.1v1.21h3.1v3.403ZM5.59 20.867h1.06v-3.025h2.798v-.946H6.649v-3.063H5.59v3.063H2.792v.946H5.59v3.025ZM17.35 9.938h1.06V6.915h2.835v-.908H18.41V2.944h-1.06v3.063h-2.798v.908h2.799v3.023ZM11.565 23.25h.908v-2.156H14.4V20.3h-1.928v-2.156h-.908v2.157h-1.89v.793h1.89v2.156ZM5.628 9.938h.985V6.877h2.836v-.87h-2.84V2.944h-.984v3.063H2.792v.87h2.836v3.061ZM20.424 14.477h.908v-2.118h1.918v-.832h-1.918V9.41h-.908v2.118h-1.89v.832h1.89v2.118Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.35 20.867h1.06v-3.025h2.835v-.946H18.41v-3.063h-1.06v3.063h-2.798v.946h2.799v3.025Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.39 3.473V2.83H12.5V.75h-.68v2.08H9.928v.643h1.89v2.08h.68v-2.08h1.892ZM2.63 14.325h.68v-2.08h1.893v-.642H3.311v-2.04h-.68v2.041H.75v.681l1.88-.004v2.044Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-tableau_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgLogoTiktok = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.321 5.562a5.124 5.124 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.971-1.165-1.956-1.282-2.645h.004c-.097-.573-.057-.943-.05-.943h-3.865v14.943c0 .2 0 .399-.008.595 0 .024-.003.046-.004.073 0 .01 0 .022-.003.033v.009a3.282 3.282 0 0 1-1.65 2.604 3.225 3.225 0 0 1-1.6.422c-1.8 0-3.26-1.468-3.26-3.281 0-1.814 1.46-3.282 3.26-3.282.341 0 .68.054 1.004.16l.005-3.936A7.179 7.179 0 0 0 4.76 10.71a7.583 7.583 0 0 0-1.655 2.04c-.163.281-.779 1.412-.853 3.246-.047 1.04.266 2.12.415 2.565v.01c.093.262.457 1.158 1.049 1.913a7.856 7.856 0 0 0 1.674 1.58v-.01l.009.01c1.87 1.27 3.945 1.187 3.945 1.187.36-.015 1.562 0 2.928-.647 1.515-.718 2.377-1.787 2.377-1.787a7.427 7.427 0 0 0 1.296-2.153c.35-.92.466-2.022.466-2.462V8.273c.047.028.672.441.672.441s.9.577 2.303.952c1.006.267 2.363.324 2.363.324V6.153c-.475.052-1.44-.098-2.429-.59Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoTumblr = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.281 1.5H5.625A4.09 4.09 0 0 0 1.5 5.625v12.656c0 2.306 1.82 4.219 4.125 4.219h12.656c2.306 0 4.219-1.913 4.219-4.219V5.625c0-2.306-1.913-4.125-4.219-4.125ZM15.75 18.563h-2.438c-1.992 0-3.374-1.11-3.374-3.563v-3.75H8.25V9c1.993-.516 2.716-2.265 2.813-3.75h2.062v3.375h2.438v2.625h-2.438l-.018 3.305c0 1.025.515 1.38 1.341 1.38l1.302.002v2.626Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoTux = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.797 18.987c-.069-.037-.134-.072-.188-.103-.303-.18-.61-.494-.555-.836.113-.747.135-1.1-.023-1.35a.731.731 0 0 0-.36-.29v-.003a1.3 1.3 0 0 0 .133-.475c.067-.515-.235-2.062-.642-3.314-.38-1.156-1.371-2.343-2.096-3.213l-.169-.204c-1.12-1.356-1.14-1.79-1.244-3.875a111.47 111.47 0 0 0-.055-1.031C15.463 1.942 14.25.75 12 .75c-1.181 0-2.092.335-2.706.997-.491.529-.763 1.253-.763 2.04 0 1.383.094 2.484.101 2.544.066 1.674.047 1.933-.39 2.698-.104.184-.392.51-.697.854-.398.448-.848.956-1.095 1.37-.177.295-.276.591-.38.905-.16.479-.341 1.021-.851 1.715-.59.8-.728 1.388-.516 2.224-.232.302-.226.673-.223.948.007.095.002.191-.014.286-.107.355-.582.44-1.031.477-.074.005-.145.01-.213.013-.34.019-.635.035-.803.296-.163.251-.053.647.1 1.194l.103.378c.085.328-.008.491-.126.695-.114.198-.244.422-.244.823 0 .688.937.844 2.018 1.029.345.058.703.118 1.06.198.546.125 1.08.292 1.598.501.456.175.816.313 1.239.313.758 0 1.324-.458 1.871-.9l.101-.082c.26-.21 1.008-.188 1.61-.171.162.005.315.01.452.01h.292c.631-.004 1.497-.01 1.98.117.175.046.29.174.435.337.275.307.617.691 1.565.691.909 0 1.385-.408 1.937-.881.335-.288.682-.585 1.175-.837.184-.094.357-.182.52-.263 1.06-.534 1.645-.828 1.645-1.304 0-.465-.574-.774-.953-.978ZM9.896 4.143a.652.652 0 0 1 .584.422c.092.26.085.488.01.606 0 0-.01-.047-.017-.067a.696.696 0 0 0-.302-.403.533.533 0 0 0-.419-.069c-.2.053-.394.235-.417.881-.242-.49-.109-.844.043-1.078a.669.669 0 0 1 .518-.292Zm-.82 17.578c-.076.743-.864.732-1.103.713-.46-.039-1.015-.22-1.553-.395-.212-.07-.43-.14-.644-.204-.618-.182-1.411-.316-2.049-.422l-.424-.072c-.13-.023-.216-.06-.244-.108-.047-.077.018-.246.09-.441.098-.26.231-.62.226-1.058 0-.183-.069-.389-.133-.588-.076-.235-.154-.477-.09-.592.057-.104.316-.117.543-.117h.106c.166 0 .31.003.41-.024.305-.085.697-.325.835-.651.042-.102.064-.325.094-.656.017-.194.035-.393.057-.496a.166.166 0 0 1 .099-.12c.077-.036.318-.09.873.191.524.265 1.073 1.212 1.603 2.127.167.288.325.56.483.814.658 1.056.883 1.481.82 2.1v-.001Zm6.039-1.48a3.216 3.216 0 0 1-.213.512.027.027 0 0 1-.05 0 .027.027 0 0 1-.001-.02c.08-.28.114-.573.099-.864-.012-.222-.019-.356-.125-.399-.106-.043-.2.039-.443.26l-.177.16c-.506.443-1.26.968-2.607 1.095-.79.074-1.293-.218-1.45-.382a.102.102 0 0 0-.143-.004.104.104 0 0 0-.024.108c.1.32.056.574-.023.758-.044.104-.087.097-.094-.015a1.861 1.861 0 0 0-.14-.666 14.556 14.556 0 0 0-.417-.838v-.002c.152-.07.415-.226.533-.51.118-.284.21-.844-.46-1.488-.295-.284-1.036-.804-1.69-1.266-.512-.358-1.04-.729-1.11-.82-.21-.276-.298-.436-.325-.921l.01-.323.012-.117c0-.007.004-.013.01-.017a.027.027 0 0 1 .035 0c.005.004.008.01.009.017.02.154.05.306.094.455.05.175.112.356.17.43.149.199.354.347.546.399a.258.258 0 0 0 .235-.034c.137-.11.124-.356.102-.766-.022-.422-.052-1 .087-1.62.264-1.171.512-1.523.826-1.968l.124-.178c.067-.097.14-.192.219-.292.35-.45.746-.96.652-1.92a9.379 9.379 0 0 1-.04-.533.047.047 0 0 1 .088-.028l.023.036.057.094c.228.375.64 1.058 1.176 1.058a.639.639 0 0 0 .11-.01c1.097-.184 2.434-1.418 2.446-1.43.147-.14.133-.288.077-.37a.243.243 0 0 0-.302-.082c-.154.066-.335.148-.526.235-.648.294-1.734.785-1.98.672a1.082 1.082 0 0 1-.31-.254.047.047 0 0 1 .066-.064c.263.108.448.068.666-.004l.047-.015c.44-.145.666-.224 1.442-.567.245-.115.5-.208.762-.278.188-.047.301-.076.362-.203a.312.312 0 0 0-.024-.334c-.072-.088-.19-.12-.328-.09-.15.036-.22.141-.3.211-.113.096-.235.195-.806.406-1.266.468-1.621.497-2.12.16-.46-.313-.71-.62-.71-.75 0-.1.256-.267.409-.367.062-.041.121-.08.17-.115.203-.151.609-.534.627-.55.253-.254.84-.103 1.171.12a.105.105 0 0 0 .081.02.1.1 0 0 0 .079-.121c-.197-.819-.006-1.282.187-1.526a1.059 1.059 0 0 1 .82-.397c.6 0 1.02.468 1.02 1.144 0 .516-.132.787-.257.952a.081.081 0 0 1-.145-.041.083.083 0 0 1 .013-.054c.104-.178.158-.38.157-.586a.778.778 0 0 0-.79-.782c-.184 0-.632.07-.786.724-.037.17-.043.347-.016.519l.004.033c.042.346.717.587 1.277.727.532.134.609.292.414.92-.195.63.146 1.23.267 1.387.148.181.279.377.39.584.127.247.231.506.31.773.102.318.19.593.498.994.52.675.828 2.28.703 3.656-.01.114-.024.202-.036.266-.02.119-.034.197.031.253.065.055.148.032.34-.03l.161-.051c.194-.055.391-.1.59-.131a.102.102 0 0 0 .075-.055c.16-.324.18-.713.187-1.053 0-.041 0-.085.003-.13.009-.365.02-.888-.139-1.5a.047.047 0 0 1 .03-.06.047.047 0 0 1 .061.03c.16.382.266.785.312 1.197.12 1.058-.089 1.504-.09 1.508a.075.075 0 0 0 .045.106c.124.044.236.12.325.218.068.078.043.113-.054.076a1.7 1.7 0 0 0-.598-.107c-.488 0-.849.232-1.009.43a.813.813 0 0 0-.18.529l-.002.002c-.35-.035-.607.057-.819.291l-.004.005c-.293.363-.187 1.154-.06 1.803.06.303.262 1.197.08 1.767v-.001Zm4.504.473c-.736.314-1.192.68-1.593 1.002-.265.213-.516.413-.81.57-.475.25-1.168.305-1.56-.362-.11-.187-.033-.462.074-.841.143-.504.34-1.193.174-2.093l-.117-.624c-.13-.694-.182-.955-.13-1.163.029-.115.16-.14.274-.14a.98.98 0 0 1 .124.008c.062.213.175.407.328.568.267.274.639.413 1.104.414.099.008 1.216.073 1.713-1.05.068.009.171.033.201.108.06.15-.012.418-.07.633-.043.155-.08.289-.077.392.014.75.515 1.068 1.21 1.508.085.053.172.108.26.166.09.058.135.112.135.159-.024.224-.937.617-1.24.745Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoTwitch = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m3.75 1.5-1.5 3.75V19.5h4.5v3h3l3-3h3.75l5.25-5.25V1.5h-18Zm15.75 12-3 3H12l-3 3v-3H5.25V3.75H19.5v9.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 6.703H15v6.047h2.25V6.703ZM12 6.703H9.75v6.047H12V6.703Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoTwitter = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 5.133a9.46 9.46 0 0 1-2.65.717 4.57 4.57 0 0 0 2.03-2.513c-.908.531-1.9.904-2.932 1.102a4.647 4.647 0 0 0-3.371-1.44c-2.55 0-4.615 2.035-4.615 4.543a4.37 4.37 0 0 0 .119 1.036A13.158 13.158 0 0 1 2.315 3.83a4.485 4.485 0 0 0-.627 2.282c0 1.575.821 2.968 2.062 3.783a4.57 4.57 0 0 1-2.1-.567v.056c0 2.203 1.595 4.036 3.704 4.453-.397.106-.805.16-1.216.16-.291 0-.582-.028-.868-.085.587 1.805 2.294 3.117 4.315 3.155a9.355 9.355 0 0 1-6.835 1.88A13.062 13.062 0 0 0 7.816 21c8.501 0 13.146-6.924 13.146-12.928 0-.197-.006-.394-.015-.586a9.304 9.304 0 0 0 2.303-2.353Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoUsd = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.25 22.5v-1.707c-3.725-.215-5.988-2.134-6-5.043h3.375c.083 1.235 1.118 2.177 2.625 2.344V13.5l-1.255-.328c-2.86-.665-4.39-2.315-4.39-4.785 0-2.912 2.086-4.82 5.645-5.106V1.5h1.5v1.781c3.628.296 5.578 2.238 5.625 4.969H15c-.036-1.128-.742-2.034-2.25-2.156v4.312l1.445.341c3.037.665 4.555 2.237 4.555 4.816 0 3.015-2.05 4.963-6 5.218V22.5h-1.5Zm0-12.375V6.094c-1.293.071-2.216.866-2.216 1.993 0 1.046.768 1.73 2.216 2.038Zm1.5 3.656v4.313c1.788-.072 2.643-.887 2.643-2.146 0-1.152-.855-1.928-2.643-2.167Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoVenmo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.82 1.5H3.294c-.957 0-1.794.69-1.794 1.635V20.7c0 .952.837 1.8 1.794 1.8h17.521c.963 0 1.685-.853 1.685-1.8V3.136c.006-.946-.722-1.635-1.68-1.635Zm-7.789 16.64h-4.86L6.223 6.49l4.254-.405 1.03 8.291c.963-1.568 2.151-4.031 2.151-5.713 0-.92-.157-1.546-.403-2.062l3.873-.784c.448.74.65 1.5.65 2.464 0 3.07-2.621 7.06-4.747 9.86Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoVercel = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m12 2.25 11.25 19.5H.75L12 2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoVimeo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.355 5.343c-.235-1.096-.821-1.817-1.904-2.168-1.083-.352-3.043-.211-4.412.787-1.256.914-2.168 2.55-2.531 3.669a.187.187 0 0 0 .24.234c.505-.178 1.019-.333 1.594-.302a1.195 1.195 0 0 1 1.168 1.185c.014.46-.01.877-.169 1.298-.503 1.344-1.294 2.647-2.229 3.785-.14.17-.298.325-.469.464-.478.388-.881.286-1.19-.244-.254-.435-.422-.885-.572-1.363-.582-1.86-.789-3.79-1.117-5.696-.154-.914-.328-1.865-.843-2.666-.544-.834-1.341-1.152-2.344-1.031-.69.084-1.73.82-2.241 1.237 0 0-2.625 2.197-3.836 3.345l.994 1.265s.84-.585 1.29-.857c.267-.16.581-.192.806.01.211.182.45.421.577.66.267.501.525 1.026.69 1.564a315.194 315.194 0 0 1 1.771 6.245c.296 1.068.652 2.07 1.313 2.979.905 1.246 1.857 1.532 3.324 1.007 1.191-.426 2.185-1.227 3.094-2.056 1.552-1.415 2.771-3.064 4.009-4.741a21.999 21.999 0 0 0 2.41-4.076c.652-1.452.91-2.975.577-4.534Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoVk = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.72 6.188c.167-.53 0-.914-.738-.914h-2.455c-.619 0-.905.337-1.072.697 0 0-1.263 3.075-3.026 5.069-.572.576-.834.768-1.144.768-.167 0-.381-.192-.381-.72V6.163c0-.625-.19-.913-.715-.913h-3.86c-.382 0-.62.288-.62.577 0 .6.881.744.976 2.426v3.653c0 .793-.14.938-.453.938-.833 0-2.859-3.1-4.074-6.63-.236-.7-.476-.964-1.096-.964H1.584c-.715 0-.834.336-.834.697 0 .648.834 3.915 3.884 8.239 2.026 2.953 4.909 4.54 7.506 4.54 1.573 0 1.764-.36 1.764-.96V15.53c0-.72.143-.84.643-.84.357 0 1.001.191 2.455 1.609 1.667 1.681 1.953 2.45 2.883 2.45h2.454c.715 0 1.049-.36.858-1.057-.214-.697-1.025-1.705-2.073-2.906-.572-.673-1.43-1.417-1.692-1.778-.357-.48-.262-.672 0-1.105-.024 0 2.979-4.276 3.288-5.718",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoVue = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 6.751 9.399 2.246H5.676L12 13.201l6.324-10.955h-3.723L12 6.751Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.19 2.246 12 14.701 4.81 2.246H.737L12 21.754 23.262 2.246h-4.071Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoWebComponent = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m23.25 12-5.625-9.75h-6.387L9.183 5.813h6.385L19.138 12l-3.57 6.188H9.183l2.055 3.562h6.387L23.25 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.433 18.188 4.863 12l3.57-6.188 2.055-3.562H6.375L.75 12l5.625 9.75h4.113l-2.055-3.563Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoWechat = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-wechat_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.156 13.993a.984.984 0 1 1 .98-.984.977.977 0 0 1-.98.984Zm-4.789 0a.984.984 0 1 1 .98-.984.978.978 0 0 1-.98.984Zm7.13 5.572C23.02 18.472 24 16.835 24 14.977c0-3.332-3.21-6.063-7.238-6.063-4.027 0-7.238 2.731-7.238 6.063s3.21 6.063 7.238 6.063c.816 0 1.633-.11 2.34-.328a.671.671 0 0 1 .218-.055.781.781 0 0 1 .38.11l1.581.928a.546.546 0 0 0 .163.055.235.235 0 0 0 .218-.219.673.673 0 0 0-.036-.18c-.019-.069-.234-.75-.345-1.185a.878.878 0 0 1-.015-.163.534.534 0 0 1 .234-.438"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.537 8.368a1.147 1.147 0 0 1 0-2.294c.599 0 1.143.546 1.143 1.147.055.6-.49 1.147-1.143 1.147Zm-5.768 0a1.147 1.147 0 1 1 1.143-1.15 1.152 1.152 0 0 1-1.143 1.148v.002ZM8.653 2.25C3.863 2.25 0 5.473 0 9.516c0 2.184 1.143 4.15 2.993 5.462.164.108.195.35.195.444a.533.533 0 0 1-.031.21c-.164.546-.373 1.43-.382 1.477-.008.047-.054.164-.054.219a.257.257 0 0 0 .272.273.336.336 0 0 0 .164-.055l1.905-1.093c.164-.11.273-.11.436-.11.093.002.186.02.272.055.87.274 1.85.383 2.83.383h.49a6.246 6.246 0 0 1-.272-1.803c0-3.66 3.537-6.609 7.891-6.609h.49c-.6-3.442-4.192-6.119-8.546-6.119Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-wechat_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgLogoWhatsapp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.44 4.552a10.413 10.413 0 0 0-7.396-3.051C6.281 1.5 1.59 6.169 1.588 11.907a10.341 10.341 0 0 0 1.396 5.203L1.5 22.5l5.543-1.446a10.483 10.483 0 0 0 4.997 1.266h.004c5.762 0 10.453-4.669 10.456-10.407a10.32 10.32 0 0 0-3.06-7.36Zm-7.396 16.011h-.004a8.708 8.708 0 0 1-4.423-1.205L7.3 19.17l-3.29.859.879-3.192-.207-.328a8.6 8.6 0 0 1-1.329-4.602c0-4.768 3.9-8.648 8.694-8.648a8.672 8.672 0 0 1 8.688 8.655c-.002 4.769-3.9 8.65-8.69 8.65Zm4.767-6.478c-.261-.13-1.547-.759-1.785-.846-.238-.086-.414-.13-.588.13-.174.261-.675.844-.827 1.02-.153.176-.305.195-.566.065-.261-.13-1.104-.405-2.102-1.29-.776-.69-1.3-1.541-1.453-1.801-.152-.26-.016-.402.115-.531.117-.117.26-.304.392-.456.13-.152.174-.26.26-.434.087-.173.044-.325-.02-.455-.066-.13-.589-1.41-.806-1.93-.213-.508-.428-.44-.588-.447-.152-.008-.328-.01-.501-.01a.962.962 0 0 0-.697.326c-.24.26-.914.89-.914 2.17 0 1.278.937 2.515 1.067 2.689.129.173 1.842 2.8 4.463 3.926.486.209.984.391 1.49.548.625.197 1.195.17 1.645.103.502-.075 1.546-.63 1.764-1.237.217-.607.217-1.127.152-1.236-.065-.108-.24-.174-.501-.304Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoWindows = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12.422H10.875v8.39L22.5 22.5V12.422ZM10.125 12.422H1.5v7.031l8.625 1.252v-8.283ZM22.5 1.5 10.875 3.16v8.512H22.5V1.5ZM10.125 3.268 1.5 4.5v7.172h8.625V3.268Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoWordpress = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m12.14 12.716-1.537 4.486h-.005l-1.19 3.427c.084.023.164.042.248.066h.014a9.025 9.025 0 0 0 2.32.304c.391.003.782-.025 1.168-.084a8.642 8.642 0 0 0 1.889-.455c-.131-.281-.413-.905-.427-.933l-2.48-6.81ZM3.788 8.46C3.317 9.52 3 10.824 3 12c0 .295.014.59.042.881.324 3.338 2.48 6.14 5.442 7.402.122.051.249.103.375.15L4.5 8.466c-.375-.014-.445.009-.712-.005Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.166 8.222a8.816 8.816 0 0 0-.708-1.247c-.075-.113-.16-.225-.24-.338A9.048 9.048 0 0 0 15.24 3.61 8.869 8.869 0 0 0 11.995 3a8.977 8.977 0 0 0-7.003 3.362 9.187 9.187 0 0 0-.82 1.2c.666.004 1.49.004 1.584.004.849 0 2.156-.103 2.156-.103.441-.028.488.614.052.666 0 0-.44.052-.928.075l2.948 8.766 1.772-5.311-1.256-3.45c-.44-.024-.848-.075-.848-.075-.441-.024-.385-.694.046-.666 0 0 1.336.103 2.133.103.849 0 2.157-.103 2.157-.103.435-.028.492.614.051.666 0 0-.436.051-.923.075l2.92 8.7.81-2.7c.409-1.05.615-1.918.615-2.611 0-.999-.361-1.692-.67-2.232-.408-.67-.793-1.232-.793-1.893 0-.746.563-1.44 1.36-1.44h.103C18.689 6 19.092 7.22 19.144 8.049v.028c.019.338.004.586.004.882 0 .815-.154 1.739-.614 2.896l-1.828 5.288-1.045 3.08a5.92 5.92 0 0 0 .248-.117c2.658-1.285 4.594-3.844 5.002-6.877.06-.403.09-.81.089-1.219a8.957 8.957 0 0 0-.834-3.787Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25a9.753 9.753 0 0 1 3.797 18.734A9.753 9.753 0 0 1 8.203 3.016 9.689 9.689 0 0 1 12 2.25Zm0-.75C6.201 1.5 1.5 6.201 1.5 12S6.201 22.5 12 22.5 22.5 17.799 22.5 12 17.799 1.5 12 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoXbox = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.944 11.638c1.86-2.747 3.651-4.35 3.651-4.35s-1.973-2.292-4.35-3.16l-.154-.037a10.506 10.506 0 0 0-1.472 14.236c0-.206.028-3.295 2.325-6.689ZM22.5 12a10.487 10.487 0 0 0-3.59-7.909l-.15.043c-2.377.867-4.355 3.159-4.355 3.159s1.79 1.603 3.651 4.35c2.297 3.394 2.325 6.483 2.32 6.69a10.444 10.444 0 0 0 2.124-6.334ZM9.431 3.792c1.374.614 2.56 1.622 2.56 1.622s1.195-1.003 2.568-1.622c1.725-.773 3.043-.53 3.39-.445a10.502 10.502 0 0 0-11.898 0c.338-.085 1.65-.333 3.38.445ZM16.814 13.73c-2.17-2.668-4.823-4.402-4.823-4.402s-2.64 1.735-4.814 4.402c-1.866 2.292-2.56 3.975-2.935 5.053l-.06.225a10.5 10.5 0 0 0 15.637 0l-.066-.225c-.375-1.078-1.073-2.761-2.939-5.053Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoXing = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M14.71 14.245 21.983 1.5H17.11L9.816 14.24a.064.064 0 0 0 0 .08l4.635 8.147c.02.033.038.033.075.033h4.833l-4.654-8.19a.082.082 0 0 1 .004-.065ZM10.402 10.135 7.64 5.298a.094.094 0 0 0-.094-.047h-4.5l2.76 4.894a.053.053 0 0 1 .005.037l-3.796 6.319h4.537a.073.073 0 0 0 .075-.042l3.774-6.268a.116.116 0 0 0 0-.056Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoYahoo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.234 1.74c-.636 0-1.266-.043-1.834-.24L12 10.25 6.6 1.5c-.568.197-1.164.24-1.8.24-.624 0-1.243-.049-1.8-.24l7.2 11.632V22.5c.563-.191 1.172-.24 1.8-.24.628 0 1.238.049 1.8.24v-9.352L21 1.5c-.557.188-1.142.24-1.766.24Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoYen = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 1.5h-3.75L12 11.866 6.75 1.5H3l5.267 9.75H6v2.25h3.448l.677 1.453v.797H6V18h4.125v4.5h3.75V18H18v-2.25h-4.125v-.797l.698-1.453H18v-2.25h-2.264L21 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgLogoYoutube = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#logo-youtube_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.843 6.975c0-2.11-1.552-3.807-3.47-3.807A170.472 170.472 0 0 0 12.423 3h-.844c-2.7 0-5.353.047-7.95.169-1.912 0-3.464 1.706-3.464 3.815A69.731 69.731 0 0 0 0 11.99a72.582 72.582 0 0 0 .16 5.011c0 2.11 1.551 3.82 3.463 3.82 2.729.127 5.527.183 8.372.178 2.85.01 5.64-.05 8.372-.178 1.917 0 3.469-1.71 3.469-3.82.112-1.673.164-3.342.16-5.016.01-1.668-.041-3.339-.153-5.01Zm-14.14 9.614V7.378L16.5 11.98l-6.797 4.608Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo-youtube_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgMagnet = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18.741a.75.75 0 0 1 .75.75v2.25a.75.75 0 0 1-1.5 0v-2.25a.75.75 0 0 1 .75-.75ZM6.348 17.642a.75.75 0 0 1 0 1.06l-1.591 1.591a.75.75 0 1 1-1.061-1.06l1.59-1.591a.75.75 0 0 1 1.062 0ZM1.499 14.991a.75.75 0 0 1 .75-.75H4.5a.75.75 0 1 1 0 1.5H2.25a.75.75 0 0 1-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.542 14.64 11.084 16.1a.75.75 0 0 0 0 1.06l2.121 2.122a.75.75 0 0 0 1.06 0l1.46-1.459a.186.186 0 0 0 .04-.204.186.186 0 0 0-.04-.061l-2.918-2.917a.189.189 0 0 0-.265 0ZM6.178 8.276 4.72 9.734a.75.75 0 0 0 0 1.06l2.12 2.122a.75.75 0 0 0 1.062 0l1.458-1.458a.187.187 0 0 0 0-.265L6.443 8.276a.187.187 0 0 0-.265 0ZM20.102 3.904a6.75 6.75 0 0 0-9.549-.002L7.503 6.95a.188.188 0 0 0 0 .265l2.918 2.917a.188.188 0 0 0 .265 0l3.047-3.05a2.25 2.25 0 0 1 3.209.028c.858.887.819 2.308-.053 3.18l-3.021 3.022a.186.186 0 0 0-.04.205c.009.022.023.043.04.06l2.917 2.918a.187.187 0 0 0 .265 0l3.004-3.004c2.642-2.641 2.689-6.944.048-9.588Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMailOpen = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m21.031 7.24-8.183-4.043a1.926 1.926 0 0 0-1.696 0L2.969 7.24A2.606 2.606 0 0 0 1.5 9.587v8.654c0 1.447 1.192 2.625 2.656 2.625h15.688c1.464 0 2.656-1.178 2.656-2.625V9.587a2.607 2.607 0 0 0-1.469-2.347Zm-9.2-2.702a.385.385 0 0 1 .339 0l7.94 3.922-8.063 3.984a.385.385 0 0 1-.34 0l-7.94-3.922 8.063-3.984Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMailUnread = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M23.25 6.003a3 3 0 0 0-4.986-2.253 3.023 3.023 0 0 0-.596.718v.002c-.026.043-.05.086-.073.129l-.011.023a2.48 2.48 0 0 0-.134.295 3.692 3.692 0 0 0-.036.1l-.017.049a3.406 3.406 0 0 0-.045.15c-.01.032-.017.064-.024.094l-.014.058-.018.094a3.515 3.515 0 0 0-.024.158l-.008.058-.009.11c0 .016-.003.033-.003.05a3.07 3.07 0 0 0-.002.299v.03l.01.132.003.023a2.36 2.36 0 0 0 .041.27c0 .01.005.02.007.03.008.04.017.08.028.12v.009c.01.042.022.082.035.123l.01.032a2.992 2.992 0 0 0 .15.382l.015.031.05.098a3.016 3.016 0 0 0 1.395 1.31l.019.01c.083.037.167.07.254.1l.045.015.07.022.064.019.09.023.08.019.055.01.085.016.044.007.128.017.036.003.104.007.04.003c.047 0 .091.003.137.003.054 0 .108 0 .161-.004l.05-.004.11-.009.058-.007.099-.014.06-.01.093-.02.057-.013a1.698 1.698 0 0 0 .149-.039l.096-.03.05-.016.099-.037.043-.017c.035-.014.07-.03.104-.045l.036-.016a2.47 2.47 0 0 0 .112-.056l.023-.01c.043-.024.086-.048.128-.074h.003c.27-.159.515-.359.724-.593.484-.548.75-1.253.75-1.984Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.408 9.494-4.948 3.848a.75.75 0 0 1-.92 0l-6.75-5.25a.75.75 0 1 1 .92-1.184L12 11.8l4.417-3.435a4.494 4.494 0 0 1-.067-4.615H4.126A2.628 2.628 0 0 0 1.5 6.375v11.25a2.628 2.628 0 0 0 2.625 2.625h15.75a2.627 2.627 0 0 0 2.625-2.625V9.9a4.492 4.492 0 0 1-5.092-.406Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMail = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.875 3.75H4.125A2.628 2.628 0 0 0 1.5 6.375v11.25a2.628 2.628 0 0 0 2.625 2.625h15.75a2.627 2.627 0 0 0 2.625-2.625V6.375a2.627 2.627 0 0 0-2.625-2.625Zm-.665 4.342-6.75 5.25a.75.75 0 0 1-.92 0l-6.75-5.25a.75.75 0 1 1 .92-1.184L12 11.8l6.29-4.892a.75.75 0 0 1 .92 1.184Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMaleFemale = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.969.75H16.5a1.031 1.031 0 0 0 0 2.063h.98L15.74 4.55a7.393 7.393 0 0 0-5.615-2.582c-4.084 0-7.406 3.322-7.406 7.406 0 3.734 2.778 6.83 6.375 7.334v1.76H7.78a1.031 1.031 0 1 0 0 2.062h1.313v1.688a1.031 1.031 0 0 0 2.062 0V20.53h1.313a1.031 1.031 0 1 0 0-2.062h-1.313v-1.76c3.597-.503 6.375-3.6 6.375-7.334 0-1.05-.223-2.087-.656-3.043l2.063-2.063v.981a1.032 1.032 0 0 0 2.062 0V1.781A1.032 1.032 0 0 0 19.969.75Zm-9.844 13.969a5.344 5.344 0 1 1 5.344-5.344 5.35 5.35 0 0 1-5.344 5.344Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMale = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.719 2.25H16.5a1.031 1.031 0 0 0 0 2.063h1.73l-2.832 2.83c-3.196-2.478-7.828-2.25-10.76.683-3.18 3.18-3.18 8.355.003 11.533a8.166 8.166 0 0 0 11.53 0c2.934-2.933 3.162-7.563.684-10.76l2.832-2.828V7.5a1.031 1.031 0 0 0 2.063 0V3.281a1.03 1.03 0 0 0-1.031-1.031Zm-6.004 15.652a6.1 6.1 0 0 1-8.617 0 6.1 6.1 0 0 1 0-8.617 6.1 6.1 0 0 1 8.617 0 6.1 6.1 0 0 1 0 8.617Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMan = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.25A2.625 2.625 0 1 0 12 0a2.625 2.625 0 0 0 0 5.25ZM14.25 6h-4.5a3.009 3.009 0 0 0-3 3v5.04c0 .509.395.941.903.96a.938.938 0 0 0 .972-.938V9.389A.383.383 0 0 1 8.975 9a.375.375 0 0 1 .4.375v13.546a1.078 1.078 0 0 0 2.156 0v-6.687a.48.48 0 0 1 .438-.485.469.469 0 0 1 .5.469v6.703a1.078 1.078 0 1 0 2.156 0V9.388a.383.383 0 0 1 .35-.387.375.375 0 0 1 .4.375v4.665c0 .508.395.941.903.96a.937.937 0 0 0 .972-.938V9a3.009 3.009 0 0 0-3-3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMap = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.258 5.313A1.5 1.5 0 0 0 1.5 6.62v13.911a1.5 1.5 0 0 0 2.262 1.295l3.944-2.58a.376.376 0 0 0 .17-.315V2.177a.375.375 0 0 0-.586-.31L2.258 5.312ZM9.954 1.843a.375.375 0 0 0-.579.313v16.76a.375.375 0 0 0 .17.316l4.5 2.926a.374.374 0 0 0 .58-.314V5.094a.375.375 0 0 0-.17-.316l-4.5-2.935ZM21.775 2.179a1.483 1.483 0 0 0-1.535-.007l-3.945 2.579a.375.375 0 0 0-.17.315v16.756a.375.375 0 0 0 .587.31l5.019-3.443a1.5 1.5 0 0 0 .769-1.313V3.501a1.536 1.536 0 0 0-.725-1.322Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMedal = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3ZM4.677 1.5a2.25 2.25 0 0 0-2.013 1.244L1.211 5.65a2.262 2.262 0 0 0-.073 1.85h13.04a.188.188 0 0 0 .16-.088l3.539-5.625a.188.188 0 0 0-.158-.287H4.677Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.79 5.652-1.454-2.907a2.235 2.235 0 0 0-1.537-1.193L16.055 7.5l-2.086 3.332a5.999 5.999 0 0 0-3.938 0L8.938 9.088A.187.187 0 0 0 8.78 9H2.397a.187.187 0 0 0-.157.29l3.876 6.033a6 6 0 1 0 11.766 0l4.788-7.448a2.261 2.261 0 0 0 .12-2.223ZM12.194 19.494a3 3 0 1 1-.392-5.987 3 3 0 0 1 .393 5.987Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMedical = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 21.75h-1.5a1.5 1.5 0 0 1-1.5-1.5l.002-4.023a.188.188 0 0 0-.28-.163l-3.486 2.019a1.476 1.476 0 0 1-2.015-.54l-.774-1.342-.002-.005a1.484 1.484 0 0 1 .541-2.007l3.498-2.027a.188.188 0 0 0 0-.324L3.74 9.812a1.472 1.472 0 0 1-.542-2.015l.77-1.339a1.476 1.476 0 0 1 2.02-.54L9.47 7.933a.188.188 0 0 0 .281-.163L9.75 3.75a1.5 1.5 0 0 1 1.5-1.5h1.5a1.5 1.5 0 0 1 1.5 1.5v4.018a.188.188 0 0 0 .187.188.188.188 0 0 0 .094-.025l3.485-2.019a1.477 1.477 0 0 1 2.016.54l.773 1.343.002.004a1.478 1.478 0 0 1-.545 2.01l-3.494 2.024a.188.188 0 0 0-.068.256c.016.028.04.052.068.069l3.494 2.024a1.47 1.47 0 0 1 .542 2.016l-.771 1.338a1.477 1.477 0 0 1-2.019.541l-3.483-2.015a.188.188 0 0 0-.282.162l.001 4.026a1.5 1.5 0 0 1-1.5 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMedkit = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.5H18v-.75a2.252 2.252 0 0 0-2.25-2.25h-7.5A2.252 2.252 0 0 0 6 3.75v.75H3.75a3.003 3.003 0 0 0-3 3v12a3 3 0 0 0 3 3h16.5a3 3 0 0 0 3-3v-12a3.003 3.003 0 0 0-3-3Zm-4.5 9.75h-3v3a.75.75 0 1 1-1.5 0v-3h-3a.75.75 0 1 1 0-1.5h3v-3a.75.75 0 1 1 1.5 0v3h3a.75.75 0 1 1 0 1.5Zm.75-9.75h-9v-.75A.75.75 0 0 1 8.25 3h7.5a.75.75 0 0 1 .75.75v.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMegaphone = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.25v.03a.815.815 0 0 1-.197.527v.003c-.253.299-.553.834-.553 1.69 0 .776.248 1.323.547 1.683a.89.89 0 0 1 .203.567 1.5 1.5 0 0 0 1.5 1.5h.375a.375.375 0 0 0 .375-.375v-6.75a.375.375 0 0 0-.375-.375H3.75a1.5 1.5 0 0 0-1.5 1.5ZM21.196 8.744l-.044-.008A.187.187 0 0 1 21 8.552V2.906c0-.593-.393-1.125-.98-1.328-.558-.193-1.14-.036-1.484.4A20.208 20.208 0 0 1 16.13 4.4c-1.108.937-2.168 1.605-3.141 1.983a.375.375 0 0 0-.241.35v7.281a.749.749 0 0 0 .454.689c.906.388 1.886 1.023 2.906 1.888a20.329 20.329 0 0 1 2.423 2.445 1.23 1.23 0 0 0 .989.462c.166 0 .331-.028.489-.081.601-.2.99-.713.99-1.306v-5.666a.188.188 0 0 1 .156-.185l.04-.006c.45-.123 1.304-.646 1.304-1.756 0-1.11-.853-1.633-1.304-1.755ZM11.25 15V7.125a.375.375 0 0 0-.375-.375h-4.5A.375.375 0 0 0 6 7.125v14.25A1.125 1.125 0 0 0 7.125 22.5h2.459a1.53 1.53 0 0 0 1.215-.584 1.484 1.484 0 0 0 .244-1.361 30.22 30.22 0 0 0-.27-.806c-.371-1.073-.86-1.738-.99-3.25A1.5 1.5 0 0 0 11.25 15Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMenu = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.125C3 6.504 3.504 6 4.125 6h15.75a1.125 1.125 0 0 1 0 2.25H4.125A1.125 1.125 0 0 1 3 7.125ZM3 12c0-.621.504-1.125 1.125-1.125h15.75a1.125 1.125 0 0 1 0 2.25H4.125A1.125 1.125 0 0 1 3 12ZM3 16.875c0-.621.504-1.125 1.125-1.125h15.75a1.125 1.125 0 0 1 0 2.25H4.125A1.125 1.125 0 0 1 3 16.875Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMicCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm-2.25 6A2.257 2.257 0 0 1 12 6a2.257 2.257 0 0 1 2.25 2.25v3A2.256 2.256 0 0 1 12 13.5a2.256 2.256 0 0 1-2.25-2.25v-3Zm6.75 3.385c0 1.095-.513 2.138-1.443 2.938a4.86 4.86 0 0 1-2.307 1.095v.832h.75a.75.75 0 1 1 0 1.5h-3a.75.75 0 1 1 0-1.5h.75v-.832a4.861 4.861 0 0 1-2.307-1.095c-.93-.8-1.443-1.843-1.443-2.938v-1.12a.75.75 0 0 1 1.5 0v1.12c0 1.203 1.313 2.6 3 2.6 1.387 0 3-1.135 3-2.6v-1.12a.75.75 0 1 1 1.5 0v1.12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMicOffCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25ZM12 6a2.257 2.257 0 0 1 2.25 2.25v3c0 .121-.01.242-.03.361a.094.094 0 0 1-.118.075.094.094 0 0 1-.044-.028l-3.957-4.353a.188.188 0 0 1-.022-.223A2.254 2.254 0 0 1 12 6Zm1.5 12h-2.979a.765.765 0 0 1-.77-.714.75.75 0 0 1 .749-.786h.75v-.832a4.861 4.861 0 0 1-2.307-1.095c-.93-.8-1.443-1.843-1.443-2.938V10.5a.746.746 0 0 1 1.29-.514.762.762 0 0 1 .21.533v1.116c0 1.203 1.313 2.6 3 2.6.078 0 .158-.003.237-.01a.185.185 0 0 1 .154.06l.988 1.087a.095.095 0 0 1 .021.088.094.094 0 0 1-.063.065c-.192.06-.388.108-.587.143v.832h.729c.404 0 .75.31.77.714A.752.752 0 0 1 13.5 18Zm-3.651-6.511 1.709 1.88a.047.047 0 0 1-.045.078 2.263 2.263 0 0 1-1.746-1.922.047.047 0 0 1 .057-.051c.01.002.018.007.025.015Zm7.155 5.613a.75.75 0 0 1-1.059-.05l-9-9.845A.75.75 0 0 1 8.055 6.2l9 9.844a.75.75 0 0 1-.05 1.059Zm-.504-5.467a3.615 3.615 0 0 1-.56 1.916.095.095 0 0 1-.07.045.093.093 0 0 1-.079-.03l-.9-.99a.188.188 0 0 1-.035-.195c.095-.237.143-.49.144-.746V10.52a.764.764 0 0 1 .64-.762c.462-.069.86.306.86.756v1.121Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMicOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.97 2.47a.75.75 0 0 1 1.06 0l15.75 15.75a.75.75 0 1 1-1.06 1.06L3.97 3.53a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 11.25V9.77c0-.403-.31-.75-.714-.77a.75.75 0 0 0-.786.75v1.5c0 .384-.042.767-.126 1.142a.094.094 0 0 0 .025.087l1.059 1.059a.094.094 0 0 0 .128.004.096.096 0 0 0 .026-.038 6.718 6.718 0 0 0 .388-2.255ZM12 16.5a5.267 5.267 0 0 1-5.25-5.25V9.77c0-.403-.31-.75-.714-.77a.75.75 0 0 0-.786.75v1.5c0 3.468 2.63 6.333 6 6.708v2.292H9.021c-.404 0-.75.31-.77.713A.75.75 0 0 0 9 21.75h5.979c.404 0 .75-.31.77-.714a.75.75 0 0 0-.749-.787h-2.25v-2.291a6.706 6.706 0 0 0 2.438-.76.187.187 0 0 0 .042-.298l-.862-.862a.14.14 0 0 0-.16-.027A5.202 5.202 0 0 1 12 16.5ZM12.053 2.25a3.734 3.734 0 0 0-3.209 1.714.188.188 0 0 0 .025.235l6.721 6.723a.093.093 0 0 0 .102.02.094.094 0 0 0 .058-.086V6.043c0-2.058-1.64-3.765-3.697-3.793Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.41 10.079a.094.094 0 0 0-.102-.02.094.094 0 0 0-.058.086v1.059c0 .999.396 1.957 1.1 2.667a3.682 3.682 0 0 0 3.646.993.095.095 0 0 0 .065-.067.093.093 0 0 0-.025-.09L8.41 10.078Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMic = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.25 21a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5H9a.75.75 0 0 1-.75-.75ZM6 9a.75.75 0 0 1 .75.75v1.5c0 2.886 2.364 5.25 5.25 5.25s5.25-2.364 5.25-5.25v-1.5a.75.75 0 0 1 1.5 0v1.5c0 3.714-3.036 6.75-6.75 6.75s-6.75-3.036-6.75-6.75v-1.5A.75.75 0 0 1 6 9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16.5a.75.75 0 0 1 .75.75V21a.75.75 0 0 1-1.5 0v-3.75a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 15a3.694 3.694 0 0 1-2.65-1.13 3.792 3.792 0 0 1-1.1-2.667V5.999A3.735 3.735 0 0 1 12 2.25 3.71 3.71 0 0 1 15.75 6v5.204c0 2.093-1.682 3.796-3.75 3.796Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMoon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 22.5A10.875 10.875 0 0 1 1.5 11.624c0-4.406 2.531-8.356 6.45-10.062a.75.75 0 0 1 .988.987c-.45 1.033-.688 2.356-.688 3.826 0 5.169 4.206 9.375 9.375 9.375 1.47 0 2.792-.238 3.826-.688a.75.75 0 0 1 .987.987c-1.706 3.92-5.657 6.45-10.063 6.45Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMove = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#move_svg__a)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.47.97a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1-1.06 1.06L12 2.56 8.78 5.78a.75.75 0 0 1-1.06-1.06L11.47.97Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.999.75a.75.75 0 0 1 .75.75l.001 21a.75.75 0 1 1-1.5 0v-21a.75.75 0 0 1 .749-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72 18.22a.75.75 0 0 1 1.06 0L12 21.44l3.22-3.22a.75.75 0 1 1 1.06 1.06l-3.75 3.75a.75.75 0 0 1-1.06 0l-3.75-3.75a.75.75 0 0 1 0-1.06ZM18.22 7.72a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1 0 1.06l-3.75 3.75a.75.75 0 1 1-1.06-1.06L21.44 12l-3.22-3.22a.75.75 0 0 1 0-1.06ZM5.78 7.72a.75.75 0 0 1 0 1.06L2.56 12l3.22 3.22a.75.75 0 1 1-1.06 1.06L.97 12.53a.75.75 0 0 1 0-1.06l3.75-3.75a.75.75 0 0 1 1.06 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.75 12a.75.75 0 0 1 .75-.75h21a.75.75 0 0 1 0 1.5h-21A.75.75 0 0 1 .75 12Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "move_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgMusicalNote = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M8.617 22.5a2.587 2.587 0 0 1-1.517-.494 2.655 2.655 0 0 1-1.1-2.15 2.356 2.356 0 0 1 1.6-2.238l2.384-.802a.761.761 0 0 0 .516-.726V4.313a1.504 1.504 0 0 1 1.13-1.46l5.08-1.32a1.031 1.031 0 0 1 1.29.999v2.707A1.504 1.504 0 0 1 16.866 6.7L12.57 7.785a.761.761 0 0 0-.57.742v11.348a2.26 2.26 0 0 1-1.537 2.148l-1.006.339c-.27.091-.554.138-.84.138Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgMusicalNotes = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.774 1.75a1.212 1.212 0 0 0-1.06-.208L9.371 4.053A1.514 1.514 0 0 0 8.25 5.53v10.594a.735.735 0 0 1-.52.695l-.006.003-2.438.843c-.932.312-1.536 1.178-1.536 2.205a2.603 2.603 0 0 0 1.089 2.139 2.569 2.569 0 0 0 2.337.353l.018-.006 1.024-.372A2.243 2.243 0 0 0 9.75 19.87V9.932c0-.341.224-.619.57-.706l.01-.003 8.186-2.186a.188.188 0 0 1 .234.18v6.654c0 .316-.2.58-.52.688l-.012.004-2.386.85a2.3 2.3 0 0 0-1.582 2.207 2.61 2.61 0 0 0 2.216 2.605c.407.06.822.021 1.211-.113l.017-.006 1.024-.372a2.242 2.242 0 0 0 1.532-2.114V2.718a1.208 1.208 0 0 0-.476-.967Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgNavigateCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.136 2.25c-5.484-.074-9.96 4.403-9.886 9.886.073 5.259 4.355 9.541 9.614 9.614 5.484.075 9.96-4.401 9.885-9.885-.072-5.26-4.354-9.542-9.613-9.615Zm4.317 5.965-3.855 8.743c-.224.49-.974.328-.974-.214v-4.181a.188.188 0 0 0-.187-.188h-4.18c-.54 0-.704-.744-.215-.969l8.744-3.859a.503.503 0 0 1 .667.668Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgNavigate = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.75 21.75a.75.75 0 0 1-.75-.77v-8.599a.375.375 0 0 0-.375-.375H3.019a.765.765 0 0 1-.726-.5.75.75 0 0 1 .394-.93l18-8.258a.75.75 0 0 1 .995.994l-8.25 18a.75.75 0 0 1-.682.438Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgNewspaper = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.62 5.25h-1.116l-.003.001-.001.003V19.5a1.5 1.5 0 1 0 3 0V7.13a1.88 1.88 0 0 0-1.88-1.88Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 19.5V3.375A1.875 1.875 0 0 0 16.125 1.5H3.375A1.875 1.875 0 0 0 1.5 3.375v16.5A2.625 2.625 0 0 0 4.125 22.5h16.071a.053.053 0 0 0 .038-.016.054.054 0 0 0 .005-.07.053.053 0 0 0-.029-.02A3.004 3.004 0 0 1 18 19.5ZM4.5 6a.75.75 0 0 1 .75-.75h3A.75.75 0 0 1 9 6v3a.75.75 0 0 1-.75.75h-3A.75.75 0 0 1 4.5 9V6Zm9.75 12.75H5.271a.765.765 0 0 1-.77-.714.75.75 0 0 1 .749-.786h8.979c.404 0 .75.31.77.714a.752.752 0 0 1-.749.786Zm0-3H5.271a.765.765 0 0 1-.77-.714.75.75 0 0 1 .749-.786h8.979c.404 0 .75.31.77.714a.752.752 0 0 1-.749.786Zm0-3H5.271a.765.765 0 0 1-.77-.714.75.75 0 0 1 .749-.786h8.979c.404 0 .75.31.77.714a.752.752 0 0 1-.749.786Zm0-3h-2.979a.765.765 0 0 1-.77-.714.752.752 0 0 1 .749-.786h2.979c.404 0 .75.31.77.714a.752.752 0 0 1-.749.786Zm0-3h-2.979a.765.765 0 0 1-.77-.714.752.752 0 0 1 .749-.786h2.979c.404 0 .75.31.77.714a.752.752 0 0 1-.749.786Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgNotificationsCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25ZM12 18c-.98 0-1.759-.415-1.863-1.293a.186.186 0 0 1 .11-.191.188.188 0 0 1 .077-.016h3.35a.187.187 0 0 1 .187.21C13.74 17.571 12.969 18 12 18Zm4.594-2.25H7.406c-.555 0-.843-.703-.524-1.078.765-.907 1.306-1.288 1.306-3.788 0-2.29 1.207-3.103 2.203-3.5a.532.532 0 0 0 .297-.313C10.861 6.497 11.35 6 12 6s1.138.497 1.313 1.072a.535.535 0 0 0 .297.313c.994.395 2.203 1.21 2.203 3.5 0 2.5.54 2.88 1.306 3.787.316.375.026 1.078-.525 1.078Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgNotificationsOffCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25ZM6.883 14.672c.765-.907 1.306-1.288 1.306-3.788 0-.117.003-.23.009-.34a.187.187 0 0 1 .328-.118l4.594 5.01a.187.187 0 0 1-.036.283.188.188 0 0 1-.102.03H7.406c-.554.001-.84-.702-.523-1.077Zm6.98 2.035C13.76 17.585 12.982 18 12 18c-.98 0-1.758-.415-1.863-1.293a.186.186 0 0 1 .11-.191.188.188 0 0 1 .077-.016h3.353a.187.187 0 0 1 .187.207Zm3.141.816a.75.75 0 0 1-1.059-.05l-9-9.938a.75.75 0 0 1 1.11-1.009l9 9.938a.75.75 0 0 1-.05 1.06Zm-.082-2.373-6.774-7.39a.187.187 0 0 1 .06-.299c.062-.027.123-.052.183-.076a.531.531 0 0 0 .296-.313C10.863 6.497 11.351 6 12 6c.65 0 1.139.497 1.313 1.072a.532.532 0 0 0 .297.313c.994.395 2.203 1.21 2.203 3.5 0 2.5.54 2.88 1.306 3.787.08.096.125.216.13.34a.188.188 0 0 1-.327.138Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgNotificationsOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 21.75a.746.746 0 0 1-.53-.22l-18-18a.75.75 0 0 1 1.06-1.06l18 18a.75.75 0 0 1-.53 1.28ZM20.629 15.999c-.078-.094-.154-.188-.23-.278-1.03-1.247-1.655-2-1.655-5.531 0-1.828-.437-3.328-1.299-4.453-.636-.832-1.495-1.462-2.627-1.928a.14.14 0 0 1-.039-.031C14.372 2.414 13.257 1.5 12 1.5s-2.371.914-2.779 2.276a.147.147 0 0 1-.038.03 7.4 7.4 0 0 0-1.025.516.375.375 0 0 0-.07.586l12.27 12.269a.375.375 0 0 0 .638-.31 1.66 1.66 0 0 0-.367-.868ZM5.257 10.188c0 3.532-.623 4.285-1.655 5.53l-.23.279a1.648 1.648 0 0 0-.218 1.763c.29.61.906.988 1.61.988h9.899a.375.375 0 0 0 .265-.64l-9-9a.375.375 0 0 0-.639.234c-.021.272-.032.553-.032.846ZM12 22.5a3.754 3.754 0 0 0 3.302-1.975.188.188 0 0 0-.166-.275H8.865a.187.187 0 0 0-.166.275A3.752 3.752 0 0 0 12 22.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgNotifications = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.629 15.999c-.078-.094-.154-.188-.23-.278-1.03-1.247-1.655-2-1.655-5.531 0-1.828-.437-3.328-1.299-4.453-.636-.832-1.495-1.462-2.627-1.928a.141.141 0 0 1-.039-.031C14.372 2.414 13.257 1.5 12 1.5s-2.371.914-2.779 2.276a.147.147 0 0 1-.038.03c-2.642 1.089-3.927 3.176-3.927 6.382 0 3.533-.623 4.286-1.655 5.531l-.23.279a1.648 1.648 0 0 0-.217 1.763c.29.61.905.988 1.61.988h14.478c.7 0 1.313-.378 1.603-.985A1.649 1.649 0 0 0 20.629 16ZM12 22.5a3.754 3.754 0 0 0 3.302-1.975.188.188 0 0 0-.166-.275H8.865a.187.187 0 0 0-.166.275A3.752 3.752 0 0 0 12 22.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgNuclear = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.136 2.25c-5.484-.074-9.96 4.403-9.886 9.886.073 5.259 4.355 9.541 9.614 9.614 5.484.075 9.96-4.401 9.885-9.885-.072-5.26-4.354-9.542-9.613-9.615Zm7.973 8.996-4.363-.004a.094.094 0 0 1-.091-.074 3.754 3.754 0 0 0-1.286-2.07.094.094 0 0 1-.026-.114l1.937-3.911a.093.093 0 0 1 .098-.052.093.093 0 0 1 .037.014 8.259 8.259 0 0 1 3.788 6.108.093.093 0 0 1-.094.103Zm-10.35.96a2.25 2.25 0 1 1 4.482-.411 2.25 2.25 0 0 1-4.482.41ZM7.718 5.073l1.938 3.91a.094.094 0 0 1-.025.115 3.754 3.754 0 0 0-1.287 2.07.094.094 0 0 1-.094.074l-4.363.004a.095.095 0 0 1-.07-.03.094.094 0 0 1-.024-.073 8.26 8.26 0 0 1 3.789-6.108.094.094 0 0 1 .136.038ZM7.7 18.917l2.64-3.473a.094.094 0 0 1 .113-.028 3.743 3.743 0 0 0 3.094 0 .094.094 0 0 1 .114.028l2.64 3.473a.094.094 0 0 1 .002.11.094.094 0 0 1-.028.027 8.234 8.234 0 0 1-8.548 0 .096.096 0 0 1-.044-.062.094.094 0 0 1 .017-.075Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgNutrition = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.578 7.795c-.875-1.526-2.225-2.381-4.011-2.542-.946-.084-1.828.158-2.683.393-.663.182-1.29.355-1.884.355-.594 0-1.219-.173-1.878-.355-.857-.235-1.743-.481-2.692-.392-1.706.16-3.07 1.036-3.952 2.535-.815 1.388-1.228 3.31-1.228 5.712 0 1.893.703 4.241 1.875 6.28.6 1.044 2.203 3.47 4.086 3.47 1.442 0 2.21-.443 2.77-.766.39-.224.624-.36 1.017-.36.393 0 .628.136 1.017.36.562.323 1.329.765 2.772.765 1.883 0 3.485-2.426 4.086-3.468 1.175-2.04 1.875-4.387 1.875-6.281.002-2.465-.381-4.33-1.17-5.706ZM10.125 16.5C9.504 16.5 9 15.493 9 14.25c0-1.242.504-2.25 1.125-2.25s1.125 1.008 1.125 2.25c0 1.243-.504 2.25-1.125 2.25Zm3.75 0c-.621 0-1.125-1.007-1.125-2.25 0-1.242.504-2.25 1.125-2.25S15 13.009 15 14.25c0 1.243-.504 2.25-1.125 2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.427 5.247c.617-.082 1.774-.367 2.757-1.35a4.593 4.593 0 0 0 1.313-2.728.375.375 0 0 0-.401-.419c-.596.045-1.723.275-2.753 1.306A4.575 4.575 0 0 0 12 4.838a.374.374 0 0 0 .427.409Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgOpen = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14.25a.75.75 0 0 1-.53-1.28l7.403-7.404a2.611 2.611 0 0 0-1.248-.316H4.875A2.628 2.628 0 0 0 2.25 7.875v11.25a2.628 2.628 0 0 0 2.625 2.625h11.25a2.627 2.627 0 0 0 2.625-2.625V7.875c0-.436-.108-.865-.316-1.248L11.03 14.03a.747.747 0 0 1-.53.22Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 2.25h-5.25a.75.75 0 1 0 0 1.5h3.44l-1.817 1.816c.449.244.817.612 1.06 1.06l1.817-1.815V8.25a.75.75 0 1 0 1.5 0V3a.75.75 0 0 0-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgOptions = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3 6.75h10.629a2.25 2.25 0 0 0 4.242 0H21a.75.75 0 1 0 0-1.5h-3.129a2.25 2.25 0 0 0-4.242 0H3a.75.75 0 0 0 0 1.5ZM21 17.25h-3.129a2.25 2.25 0 0 0-4.242 0H3a.75.75 0 1 0 0 1.5h10.629a2.25 2.25 0 0 0 4.242 0H21a.75.75 0 1 0 0-1.5ZM21 11.25H10.371a2.25 2.25 0 0 0-4.242 0H3a.75.75 0 1 0 0 1.5h3.129a2.25 2.25 0 0 0 4.242 0H21a.75.75 0 1 0 0-1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPaperPlane = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.172 1.83a1.125 1.125 0 0 0-1.195-.256L2.225 8.67h-.004a1.125 1.125 0 0 0 .047 2.117l.02.006 6.435 2.748a.75.75 0 0 0 .729-.168l10.33-9.625a.33.33 0 1 1 .468.469l-9.625 10.325a.75.75 0 0 0-.169.728l2.75 6.44.008.026c.15.435.53.741.99.762h.046a1.154 1.154 0 0 0 1.078-.725l7.096-18.746a1.124 1.124 0 0 0-.252-1.198Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPartlySunny = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.938 22.5H4.967c-1.382 0-2.574-.368-3.446-1.062C.526 20.645 0 19.468 0 18.037c0-1.25.472-2.334 1.366-3.136.714-.642 1.695-1.088 2.766-1.259.002 0 .003 0 .004-.002.302-1.828 1.117-3.38 2.358-4.485a6.574 6.574 0 0 1 4.381-1.656c1.417 0 2.741.44 3.83 1.274.851.66 1.53 1.515 1.978 2.494a.749.749 0 0 0 .524.422c1.22.263 2.27.81 3.055 1.594.972.972 1.488 2.265 1.488 3.741 0 1.54-.616 2.947-1.734 3.962-1.073.976-2.522 1.513-4.078 1.513ZM18.182 10.391c.568.168 1.114.4 1.63.69a.187.187 0 0 0 .272-.115c.114-.407.17-.828.166-1.25-.018-2.458-2.038-4.464-4.496-4.466a4.474 4.474 0 0 0-2.582.812h-.003a.158.158 0 0 0 .047.281 7.614 7.614 0 0 1 2.404 1.238 8.153 8.153 0 0 1 2.124 2.461.75.75 0 0 0 .438.349ZM23.25 10.5h-1.5a.75.75 0 1 1 0-1.5h1.5a.75.75 0 1 1 0 1.5ZM15.75 4.5a.75.75 0 0 1-.75-.75v-1.5a.75.75 0 1 1 1.5 0v1.5a.75.75 0 0 1-.75.75ZM11.507 6.257a.746.746 0 0 1-.53-.22l-1.06-1.06a.75.75 0 1 1 1.06-1.06l1.06 1.06a.75.75 0 0 1-.53 1.28ZM19.993 6.257a.75.75 0 0 1-.53-1.28l1.06-1.06a.75.75 0 1 1 1.06 1.06l-1.06 1.06a.746.746 0 0 1-.53.22Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPauseCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25ZM10.5 15A.75.75 0 1 1 9 15V9a.75.75 0 0 1 1.5 0v6Zm4.5 0a.75.75 0 1 1-1.5 0V9A.75.75 0 1 1 15 9v6Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPause = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.75 20.25H7.5a.75.75 0 0 1-.75-.75v-15a.75.75 0 0 1 .75-.75h2.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-.75.75ZM16.5 20.25h-2.25a.75.75 0 0 1-.75-.75v-15a.75.75 0 0 1 .75-.75h2.25a.75.75 0 0 1 .75.75v15a.75.75 0 0 1-.75.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPaw = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.987 8.566c-.26-.618-.692-1.064-1.25-1.288l-.008-.003c-.254-.1-.524-.15-.797-.15h-.03c-1.277.02-2.58 1.104-3.243 2.7-.486 1.168-.542 2.423-.149 3.359.26.618.693 1.064 1.253 1.289l.006.002c.254.1.524.15.797.15 1.29 0 2.606-1.085 3.281-2.702.48-1.166.533-2.42.14-3.357ZM17.885 15.45c-.736-.442-1.432-.86-1.887-1.612C14.743 11.756 13.986 10.5 12 10.5c-1.986 0-2.746 1.256-4.003 3.338-.455.752-1.153 1.171-1.892 1.616-.847.509-1.722 1.035-2.1 2.07-.146.373-.22.77-.218 1.172 0 1.685 1.313 3.056 2.925 3.056.832 0 1.718-.288 2.655-.594.9-.293 1.832-.596 2.638-.596.805 0 1.734.303 2.632.596.935.304 1.816.592 2.65.592 1.61 0 2.92-1.371 2.92-3.056a3.139 3.139 0 0 0-.222-1.172c-.378-1.036-1.253-1.562-2.1-2.071ZM7.031 8.852c.558.7 1.266 1.085 1.993 1.085.1 0 .199-.007.297-.022 1.517-.223 2.463-2.074 2.153-4.218-.13-.902-.477-1.741-.974-2.364-.557-.698-1.266-1.083-1.993-1.083-.099 0-.198.007-.296.022-1.518.223-2.463 2.075-2.153 4.219.13.9.476 1.738.973 2.361ZM14.68 9.915c.098.015.197.022.296.022.728 0 1.435-.385 1.993-1.085.497-.623.842-1.462.973-2.363.31-2.143-.635-3.994-2.153-4.218a2.01 2.01 0 0 0-.296-.022c-.727 0-1.436.385-1.993 1.084-.497.622-.844 1.462-.973 2.364-.31 2.143.635 3.995 2.152 4.218ZM5.23 14.475l.007-.002c.56-.225.992-.67 1.251-1.289.393-.937.338-2.19-.147-3.358-.672-1.615-1.989-2.701-3.276-2.701-.273 0-.543.05-.797.15l-.007.002c-.558.223-.99.67-1.25 1.288-.392.938-.337 2.192.148 3.359.672 1.615 1.989 2.7 3.276 2.7.272.001.542-.05.796-.15Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPencil = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.81 5.03c.274 0 .536.108.73.301l1.13 1.13a1.031 1.031 0 0 1-.002 1.46L5.881 20.676c-.096.095-.21.17-.335.223l-1.87.773a1.031 1.031 0 0 1-1.348-1.347l.773-1.872c.052-.125.128-.238.223-.334L16.08 5.332c.194-.193.456-.302.73-.303ZM19.219 2.387a1.806 1.806 0 0 1 1.967.392l.036.035a1.805 1.805 0 0 1 0 2.552l-.553.553a1.031 1.031 0 0 1-1.459 0l-1.13-1.13a1.031 1.031 0 0 1 .001-1.458l.552-.552c.168-.168.367-.301.586-.392Zm1.273 2.25.177-.176-.547-.547.37-.371-.37.37-.035-.035-.548-.547",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPeopleCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.136 2.25c-5.484-.074-9.96 4.403-9.886 9.886.073 5.259 4.355 9.541 9.614 9.614 5.484.075 9.96-4.401 9.885-9.885-.072-5.26-4.354-9.542-9.613-9.615Zm-.173 7.13a3.116 3.116 0 0 1 .797-1.631c.604-.644 1.46-.999 2.412-.999.4-.001.798.066 1.175.2.468.167.89.443 1.231.806.5.541.799 1.24.844 1.975.013.178.013.357 0 .535a4.04 4.04 0 0 1-.627 1.885c-.12.183-.255.356-.404.515-.615.656-1.403 1.019-2.218 1.019a2.795 2.795 0 0 1-1.185-.263 3.317 3.317 0 0 1-1.034-.756 3.926 3.926 0 0 1-.99-3.285Zm-7.018 1.141a2.807 2.807 0 0 1 .374-1.216A2.607 2.607 0 0 1 6.692 8.18a2.993 2.993 0 0 1 1.564-.112 2.672 2.672 0 0 1 1.442.797c.457.493.715 1.138.723 1.81a3.355 3.355 0 0 1-.557 1.905c-.199.3-.449.564-.739.777a2.539 2.539 0 0 1-.688.362c-.244.085-.5.13-.759.13-.044 0-.087 0-.13-.004a2.238 2.238 0 0 1-.508-.087 2.51 2.51 0 0 1-.478-.193c-.844-.445-1.48-1.367-1.605-2.443a3.09 3.09 0 0 1-.012-.6Zm2.527 8.372a8.309 8.309 0 0 1-2.903-3.312.187.187 0 0 1 .076-.246c.87-.49 1.983-.757 3.034-.757.797 0 1.44.094 2.001.276a.376.376 0 0 1 .122.645c-1.095.891-1.8 1.995-2.132 3.317a.13.13 0 0 1-.198.077ZM12 20.25a8.21 8.21 0 0 1-3.08-.596.187.187 0 0 1-.112-.21c.019-.095.04-.183.057-.256.334-1.333 1.161-2.438 2.391-3.196 1.092-.673 2.484-1.043 3.915-1.043 1.46 0 2.813.355 3.913 1.027a.128.128 0 0 1 .043.172A8.255 8.255 0 0 1 12 20.25ZM7.547 13.841ZM6.311 8.349Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.133 12.089c.158-.354.253-.732.281-1.118.007-.1.01-.2.007-.299a3.358 3.358 0 0 1-.288 1.417ZM6.311 8.35ZM7.041 13.755ZM4.958 11.119c.125 1.078.763 1.998 1.605 2.443-.844-.445-1.48-1.367-1.605-2.443ZM11.922 10.265a3.926 3.926 0 0 1 0 0 3.872 3.872 0 0 0 0 0ZM14.274 13.538ZM11.997 9.213ZM17.578 7.756ZM18.422 10.266ZM11.914 9.902ZM17.962 11.867ZM9.697 8.861ZM8.906 13.5ZM4.945 10.52ZM9.126 13.353ZM10.133 12.088ZM5.189 9.554ZM9.126 13.353Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPeople = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 12c-.964 0-1.896-.43-2.625-1.211a4.684 4.684 0 0 1-1.219-2.86c-.081-1.154.27-2.215.991-2.988.72-.774 1.728-1.191 2.853-1.191 1.117 0 2.127.425 2.845 1.196.726.78 1.078 1.839.997 2.983-.078 1.083-.511 2.098-1.219 2.86-.727.78-1.659 1.211-2.623 1.211ZM21.93 20.25H9.57a1.299 1.299 0 0 1-1.031-.5 1.416 1.416 0 0 1-.247-1.21c.395-1.584 1.373-2.898 2.828-3.8 1.291-.8 2.935-1.24 4.629-1.24 1.727 0 3.328.422 4.627 1.221 1.458.897 2.438 2.219 2.83 3.823a1.418 1.418 0 0 1-.249 1.208 1.297 1.297 0 0 1-1.028.498ZM6.89 12.188c-1.649 0-3.1-1.534-3.234-3.42-.066-.965.235-1.858.844-2.513.603-.648 1.453-1.005 2.39-1.005.938 0 1.782.36 2.388 1.011.614.66.914 1.551.844 2.509-.135 1.884-1.585 3.418-3.231 3.418ZM9.968 13.661c-.824-.403-1.894-.605-3.077-.605-1.38 0-2.722.36-3.777 1.014-1.195.742-2 1.822-2.325 3.127a1.284 1.284 0 0 0 .225 1.095 1.189 1.189 0 0 0 .942.457h5.203a.375.375 0 0 0 .369-.308c.005-.03.011-.059.019-.088.397-1.596 1.329-2.946 2.705-3.929a.376.376 0 0 0-.03-.628 3.769 3.769 0 0 0-.254-.135Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPersonAdd = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12c2.475 0 4.66-2.33 4.875-5.195.106-1.439-.345-2.78-1.271-3.778C16.187 2.042 14.906 1.5 13.5 1.5c-1.418 0-2.7.54-3.61 1.518-.92.99-1.368 2.334-1.265 3.786C8.835 9.67 11.021 12 13.5 12ZM23.22 20.614c-.395-2.195-1.63-4.038-3.57-5.332-1.724-1.15-3.908-1.782-6.15-1.782-2.242 0-4.426.633-6.15 1.781-1.94 1.294-3.175 3.138-3.57 5.332-.091.503.031 1 .336 1.365a1.45 1.45 0 0 0 1.134.522h16.5a1.451 1.451 0 0 0 1.135-.522 1.66 1.66 0 0 0 .336-1.364ZM4.875 13.5v-1.875H6.75a.75.75 0 1 0 0-1.5H4.875V8.25a.75.75 0 0 0-1.5 0v1.875H1.5a.75.75 0 1 0 0 1.5h1.875V13.5a.75.75 0 1 0 1.5 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPersonCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25ZM9.646 7.726c.594-.63 1.43-.976 2.354-.976.924 0 1.753.349 2.349.982.604.64.898 1.502.829 2.429C15.038 12 13.614 13.5 12 13.5c-1.614 0-3.042-1.5-3.178-3.34-.069-.934.225-1.798.824-2.434ZM12 20.25a8.227 8.227 0 0 1-5.906-2.495c.44-.626 1-1.16 1.647-1.567C8.936 15.422 10.448 15 12 15c1.552 0 3.064.422 4.258 1.188a5.76 5.76 0 0 1 1.648 1.567A8.223 8.223 0 0 1 12 20.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPersonRemove = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12c2.475 0 4.66-2.33 4.875-5.195.106-1.439-.345-2.78-1.271-3.778C16.187 2.042 14.906 1.5 13.5 1.5c-1.418 0-2.7.54-3.61 1.518-.92.99-1.368 2.334-1.265 3.786C8.835 9.67 11.021 12 13.5 12ZM23.22 20.614c-.395-2.195-1.63-4.038-3.57-5.332-1.724-1.15-3.908-1.782-6.15-1.782-2.242 0-4.426.633-6.15 1.781-1.94 1.294-3.175 3.138-3.57 5.332-.091.503.031 1 .336 1.365a1.45 1.45 0 0 0 1.134.522h16.5a1.451 1.451 0 0 0 1.135-.522 1.66 1.66 0 0 0 .336-1.364ZM6.75 10.125H1.5a.75.75 0 1 0 0 1.5h5.25a.75.75 0 1 0 0-1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPerson = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.592 3.027C14.68 2.042 13.406 1.5 12 1.5c-1.414 0-2.692.54-3.6 1.518-.918.99-1.365 2.334-1.26 3.786C7.348 9.67 9.528 12 12 12c2.472 0 4.648-2.33 4.86-5.195.106-1.439-.344-2.78-1.268-3.778ZM20.25 22.5H3.75a1.454 1.454 0 0 1-1.134-.522 1.655 1.655 0 0 1-.337-1.364c.396-2.195 1.63-4.038 3.571-5.333C7.574 14.132 9.758 13.5 12 13.5c2.242 0 4.426.633 6.15 1.781 1.94 1.294 3.175 3.138 3.571 5.332.09.503-.032 1-.337 1.365a1.454 1.454 0 0 1-1.134.522Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPhoneLandscape = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone-landscape_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 8.25v7.5a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-7.5a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3Zm21-1.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5v-.532a.372.372 0 0 1 .223-.342 1.5 1.5 0 0 0 .902-1.376v-3a1.5 1.5 0 0 0-.902-1.376.372.372 0 0 1-.223-.342V8.25A1.5 1.5 0 0 1 3 6.75h18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.25a.557.557 0 0 0 .22.447 2.25 2.25 0 0 1 .905 1.803v3a2.25 2.25 0 0 1-.905 1.803.557.557 0 0 0-.22.447.75.75 0 0 0 .75.75h18a.75.75 0 0 0 .75-.75v-7.5A.75.75 0 0 0 21 7.5H3a.75.75 0 0 0-.75.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 8.25v7.5a3 3 0 0 0 3 3h18a3 3 0 0 0 3-3v-7.5a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3Zm21-1.5a1.5 1.5 0 0 1 1.5 1.5v7.5a1.5 1.5 0 0 1-1.5 1.5H3a1.5 1.5 0 0 1-1.5-1.5v-.532a.372.372 0 0 1 .223-.342 1.5 1.5 0 0 0 .902-1.376v-3a1.5 1.5 0 0 0-.902-1.376.372.372 0 0 1-.223-.342V8.25A1.5 1.5 0 0 1 3 6.75h18Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone-landscape_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgPhonePortrait = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#phone-portrait_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0h-7.5a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3Zm1.5 21a1.5 1.5 0 0 1-1.5 1.5h-7.5a1.5 1.5 0 0 1-1.5-1.5V3a1.5 1.5 0 0 1 1.5-1.5h.532a.372.372 0 0 1 .342.223 1.5 1.5 0 0 0 1.376.902h3a1.5 1.5 0 0 0 1.376-.902.372.372 0 0 1 .342-.223h.532a1.5 1.5 0 0 1 1.5 1.5v18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 2.25a.557.557 0 0 0-.447.22 2.25 2.25 0 0 1-1.803.905h-3a2.25 2.25 0 0 1-1.803-.905.557.557 0 0 0-.447-.22.75.75 0 0 0-.75.75v18a.75.75 0 0 0 .75.75h7.5a.75.75 0 0 0 .75-.75V3a.75.75 0 0 0-.75-.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 0h-7.5a3 3 0 0 0-3 3v18a3 3 0 0 0 3 3h7.5a3 3 0 0 0 3-3V3a3 3 0 0 0-3-3Zm1.5 21a1.5 1.5 0 0 1-1.5 1.5h-7.5a1.5 1.5 0 0 1-1.5-1.5V3a1.5 1.5 0 0 1 1.5-1.5h.532a.372.372 0 0 1 .342.223 1.5 1.5 0 0 0 1.376.902h3a1.5 1.5 0 0 0 1.376-.902.372.372 0 0 1 .342-.223h.532a1.5 1.5 0 0 1 1.5 1.5v18Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "phone-portrait_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgPieChart = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M3.098 16.734a.75.75 0 0 1-.684-.443A10.5 10.5 0 0 1 12 1.5a.75.75 0 0 1 .75.75V12a.75.75 0 0 1-.444.685l-8.901 3.982a.747.747 0 0 1-.307.067Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7 3.197a.375.375 0 0 0-.45.366v8.438a2.253 2.253 0 0 1-1.331 2.054l-8.085 3.618a.376.376 0 0 0-.157.553A9.772 9.772 0 0 0 6.95 20.59a9.672 9.672 0 0 0 5.801 1.912c5.376 0 9.75-4.374 9.75-9.75 0-4.709-3.355-8.649-7.8-9.554Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPin = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4.5a3.75 3.75 0 1 0-4.5 3.675v13.273c0 .2.04.397.117.58l.472 1.126a.183.183 0 0 0 .255.07.184.184 0 0 0 .067-.07l.472-1.125c.077-.184.117-.381.117-.58V8.175a3.756 3.756 0 0 0 3-3.675Zm-2.625 0a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPint = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.703 4.654a27.03 27.03 0 0 1-.02-.313l-.135-2.185A1.5 1.5 0 0 0 17.052.75H6.947a1.5 1.5 0 0 0-1.495 1.406l-.137 2.186-.02.31c-.06.902-.104 1.554.175 3.078.078.427.245 1.062.456 1.867.591 2.25 1.58 6.017 1.58 9.17v3.358a1.125 1.125 0 0 0 1.125 1.125h6.738a1.125 1.125 0 0 0 1.125-1.125v-3.357c0-3.614.999-7.186 1.594-9.32.205-.732.367-1.312.44-1.716.282-1.524.238-2.176.175-3.078Zm-1.64-2.228.07 1.125a.188.188 0 0 1-.188.199h-9.89a.187.187 0 0 1-.188-.2l.07-1.124a.187.187 0 0 1 .188-.176h9.75a.188.188 0 0 1 .188.176Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPizza = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.71 3.18c-2.736-1.083-5.837-1.68-8.73-1.68-2.98 0-6.085.587-8.746 1.653-.951.386-1.115 1.066-.95 1.573l.19.477a.75.75 0 0 0 .999.407 95.707 95.707 0 0 1 1.266-.552C6.802 4.202 9.315 3.75 12 3.75c2.694 0 5.067.433 7.254 1.324.208.085.698.301 1.227.537a.75.75 0 0 0 1-.402l.175-.428.016-.042c.162-.479.007-1.174-.962-1.56Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.18 6.603c-2.133-.86-4.758-1.353-7.2-1.353-2.466.002-4.91.46-7.207 1.354a7.57 7.57 0 0 0-.201.088.75.75 0 0 0-.375.997l.726 1.589c1.543 3.378 4.415 9.66 5.73 12.378A1.487 1.487 0 0 0 12 22.5a1.488 1.488 0 0 0 1.348-.847l.003-.006L19.787 7.7a.75.75 0 0 0-.39-1.006 17.46 17.46 0 0 0-.21-.087l-.007-.003ZM9.097 10.497a1.5 1.5 0 1 1-.195-2.993 1.5 1.5 0 0 1 .195 2.993Zm3 6a1.5 1.5 0 1 1-.195-2.993 1.5 1.5 0 0 1 .196 2.993Zm3-5.25a1.5 1.5 0 1 1-.195-2.993 1.5 1.5 0 0 1 .196 2.993Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPlanet = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#planet_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.54 13.435a.375.375 0 0 0-.587.386C4.785 17.497 8.077 20.25 12 20.25c.833 0 1.662-.126 2.457-.375a.375.375 0 0 0 .037-.703 52.503 52.503 0 0 1-5.132-2.606c-1.663-.955-3.273-2-4.822-3.13ZM23.096 15.915a10.987 10.987 0 0 0-.689-.822.742.742 0 0 0-1.245.24c0 .008-.005.015-.008.022a.738.738 0 0 0 .148.753c1.066 1.172 1.238 1.805 1.194 1.939-.093.104-.799.323-2.726-.166a19.213 19.213 0 0 1-1.552-.466c.346-.396.652-.823.916-1.277l.025-.042a8.221 8.221 0 0 0 1.044-4.987C19.755 6.976 16.247 3.75 12 3.75a8.22 8.22 0 0 0-4.988 1.682 8.316 8.316 0 0 0-2.148 2.43c-.007.014-.016.028-.024.041a8.225 8.225 0 0 0-.648 1.43 23.636 23.636 0 0 1-.506-.453 18.41 18.41 0 0 1-.676-.656c-1.386-1.418-1.55-2.138-1.507-2.27.094-.105.728-.276 2.279.06a.742.742 0 0 0 .728-.248l.017-.021a.738.738 0 0 0-.406-1.192c-.368-.083-.74-.148-1.115-.194-1.44-.165-2.383.119-2.802.844-.152.262-.298.707-.128 1.34.252.941 1.15 2.082 2.42 3.277.404.381.846.768 1.317 1.155a38.608 38.608 0 0 0 2.614 1.963 52.91 52.91 0 0 0 5.026 3.079 49.08 49.08 0 0 0 4.323 2.073c.412.172.816.33 1.21.477.557.207 1.095.39 1.608.543l.052.015c1.206.36 2.223.548 3.022.563h.082c1.014 0 1.701-.3 2.043-.89.426-.733.191-1.703-.697-2.883Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "planet_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgPlayBackCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12c0 5.376 4.374 9.75 9.75 9.75s9.75-4.374 9.75-9.75S17.376 2.25 12 2.25 2.25 6.624 2.25 12Zm3.245-.436 5.365-3.24a.505.505 0 0 1 .765.436v2.499l4.86-2.936a.505.505 0 0 1 .765.437v6.48a.505.505 0 0 1-.765.437l-4.86-2.936v2.5a.505.505 0 0 1-.765.436l-5.365-3.241a.51.51 0 0 1 0-.872Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPlayBack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m1.44 10.756 8.853-5.297a1.431 1.431 0 0 1 1.457-.018 1.582 1.582 0 0 1 .786 1.381v3.706l8.471-5.07a1.432 1.432 0 0 1 1.457-.018 1.582 1.582 0 0 1 .786 1.381v10.36a1.582 1.582 0 0 1-.786 1.381 1.43 1.43 0 0 1-1.457-.018l-8.471-5.072v3.707a1.582 1.582 0 0 1-.786 1.383 1.43 1.43 0 0 1-1.457-.018L1.44 13.247a1.466 1.466 0 0 1 0-2.484v-.007Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPlayCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm3.505 10.186-5.365 3.24a.506.506 0 0 1-.765-.435V8.76a.505.505 0 0 1 .765-.437l5.365 3.241a.51.51 0 0 1 0 .872Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPlayForwardCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm6.505 10.186-5.365 3.24a.507.507 0 0 1-.765-.435v-2.5l-4.86 2.936a.506.506 0 0 1-.765-.436V8.76a.505.505 0 0 1 .765-.437l4.86 2.936v-2.5a.505.505 0 0 1 .765-.436l5.365 3.241a.51.51 0 0 1 0 .872Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPlayForward = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.56 10.756 13.707 5.46a1.431 1.431 0 0 0-1.457-.018 1.582 1.582 0 0 0-.786 1.381v3.706l-8.471-5.07a1.432 1.432 0 0 0-1.457-.018A1.582 1.582 0 0 0 .75 6.82v10.36a1.582 1.582 0 0 0 .786 1.381 1.43 1.43 0 0 0 1.457-.018l8.471-5.072v3.707a1.582 1.582 0 0 0 .786 1.383 1.43 1.43 0 0 0 1.457-.018l8.853-5.297a1.466 1.466 0 0 0 0-2.484v-.007Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPlaySkipBackCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 12c0 5.376 4.374 9.75 9.75 9.75s9.75-4.374 9.75-9.75S17.376 2.25 12 2.25 2.25 6.624 2.25 12Zm6-3a.75.75 0 0 1 1.5 0v2.484l5.235-3.162a.505.505 0 0 1 .765.438v6.48a.505.505 0 0 1-.765.437L9.75 12.516V15a.75.75 0 1 1-1.5 0V9Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPlaySkipBack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M5.25 3a.75.75 0 0 1 .75.75v6.395l10.911-6.53a1.647 1.647 0 0 1 1.677-.021c.562.319.912.937.912 1.61v13.593c0 .674-.35 1.29-.912 1.61a1.648 1.648 0 0 1-1.677-.022L6 13.855v6.395a.75.75 0 1 1-1.5 0V3.75A.75.75 0 0 1 5.25 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPlaySkipForwardCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25ZM15.75 15a.75.75 0 1 1-1.5 0v-2.484l-5.235 3.16a.506.506 0 0 1-.765-.435V8.76a.505.505 0 0 1 .765-.437l5.235 3.161V9a.75.75 0 1 1 1.5 0v6Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPlaySkipForward = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.75 3a.75.75 0 0 0-.75.75v6.395L7.089 3.615a1.647 1.647 0 0 0-1.677-.021 1.841 1.841 0 0 0-.912 1.61v13.593c0 .674.35 1.29.912 1.61a1.648 1.648 0 0 0 1.677-.022L18 13.855v6.395a.75.75 0 1 0 1.5 0V3.75a.75.75 0 0 0-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPlay = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M6.234 20.625c-.287 0-.57-.076-.82-.219a1.843 1.843 0 0 1-.912-1.609V5.203c0-.673.35-1.29.912-1.609a1.647 1.647 0 0 1 1.677.021l11.618 6.955a1.686 1.686 0 0 1 0 2.859l-11.62 6.956a1.663 1.663 0 0 1-.855.24Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPodium = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 1.5H9A1.5 1.5 0 0 0 7.5 3v19.313a.188.188 0 0 0 .188.187h8.625a.188.188 0 0 0 .187-.188V3A1.5 1.5 0 0 0 15 1.5ZM21.75 9h-3.375a.375.375 0 0 0-.375.375v12.75a.375.375 0 0 0 .375.375h3.75a1.125 1.125 0 0 0 1.125-1.125V10.5a1.5 1.5 0 0 0-1.5-1.5ZM2.25 6a1.5 1.5 0 0 0-1.5 1.5v13.875A1.125 1.125 0 0 0 1.875 22.5h3.75A.375.375 0 0 0 6 22.125V6.375A.375.375 0 0 0 5.625 6H2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPower = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 21.75c-5.376 0-9.75-4.38-9.75-9.766 0-2.927 1.277-5.672 3.504-7.526a1.031 1.031 0 1 1 1.32 1.585 7.702 7.702 0 0 0-2.761 5.941c0 4.248 3.448 7.704 7.687 7.704 4.239 0 7.688-3.456 7.688-7.704a7.687 7.687 0 0 0-2.805-5.936 1.03 1.03 0 1 1 1.313-1.59 9.745 9.745 0 0 1 3.554 7.526c0 5.385-4.374 9.767-9.75 9.767Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 12.75a1.032 1.032 0 0 1-1.031-1.031V3.28a1.031 1.031 0 1 1 2.062 0v8.438A1.031 1.031 0 0 1 12 12.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPricetag = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.89 2.119a2.083 2.083 0 0 0-1.486-.62h-5.762c-.378.002-.74.151-1.009.418L2.113 13.434a2.101 2.101 0 0 0 0 2.968l5.485 5.484a2.102 2.102 0 0 0 2.97 0l11.514-11.512c.267-.268.417-.63.418-1.008V3.6a2.074 2.074 0 0 0-.61-1.481ZM18 7.499a1.5 1.5 0 1 1 0-2.998A1.5 1.5 0 0 1 18 7.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPricetags = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pricetags_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 8.616V2.85a2.096 2.096 0 0 0-2.096-2.1h-5.762c-.378 0-.74.15-1.008.417L.614 12.683a2.103 2.103 0 0 0 0 2.97l5.484 5.484a2.102 2.102 0 0 0 2.969 0L20.583 9.624c.267-.268.416-.63.417-1.008ZM16.5 6.75a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.25 3a.75.75 0 0 0-.75.75v5.97L10.251 21.97a.751.751 0 1 0 1.06 1.06L23.593 10.75A1.398 1.398 0 0 0 24 9.75v-6a.75.75 0 0 0-.75-.75Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pricetags_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgPrint = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 5.25H4.969A2.719 2.719 0 0 0 2.25 7.969v7.406A2.625 2.625 0 0 0 4.875 18h.375v1.86a1.89 1.89 0 0 0 1.89 1.89h9.72a1.89 1.89 0 0 0 1.89-1.89V18h.375a2.625 2.625 0 0 0 2.625-2.625v-7.5a2.625 2.625 0 0 0-2.625-2.625ZM17.25 19.86a.392.392 0 0 1-.39.39H7.14a.392.392 0 0 1-.39-.39v-7.47a.392.392 0 0 1 .39-.39h9.72a.392.392 0 0 1 .39.39v7.47Zm1.219-10.114a1.125 1.125 0 1 1-.18-2.242 1.125 1.125 0 0 1 .18 2.242ZM16.125 2.25h-8.25A2.63 2.63 0 0 0 5.277 4.5h13.446a2.629 2.629 0 0 0-2.598-2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPulse = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 12.75a2.254 2.254 0 0 0-2.121 1.5H16.29l-1.33-3.988a.75.75 0 0 0-1.432.031l-2.086 7.302L8.99 2.875a.75.75 0 0 0-1.468-.058L4.665 14.25H2.25a.75.75 0 1 0 0 1.5h3a.75.75 0 0 0 .728-.569L8.102 6.68l2.407 14.443a.751.751 0 0 0 .698.627h.043a.75.75 0 0 0 .72-.544l2.334-8.17.733 2.2a.75.75 0 0 0 .712.514h2.379a2.25 2.25 0 1 0 2.121-3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgPush = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.625 16.5H12.75V9.31l2.47 2.47a.75.75 0 0 0 1.06-1.06l-3.75-3.75a.75.75 0 0 0-1.06 0l-3.75 3.75a.75.75 0 0 0 1.06 1.06l2.47-2.47v7.19H6.375a2.627 2.627 0 0 1-2.625-2.625v-9.75A2.628 2.628 0 0 1 6.375 1.5h11.25a2.628 2.628 0 0 1 2.625 2.625v9.75a2.627 2.627 0 0 1-2.625 2.625ZM12.75 21.75a.75.75 0 1 1-1.5 0V16.5h1.5v5.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgQrCode = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.125 15.75h-3a.375.375 0 0 0-.375.375v3c0 .207.168.375.375.375h3a.375.375 0 0 0 .375-.375v-3a.375.375 0 0 0-.375-.375ZM15.375 12.75h-2.25a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375ZM22.125 19.5h-2.25a.375.375 0 0 0-.375.375v2.25c0 .207.168.375.375.375h2.25a.375.375 0 0 0 .375-.375v-2.25a.375.375 0 0 0-.375-.375ZM22.125 12.75h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375ZM14.625 20.25h-1.5a.375.375 0 0 0-.375.375v1.5c0 .207.168.375.375.375h1.5a.375.375 0 0 0 .375-.375v-1.5a.375.375 0 0 0-.375-.375ZM21 1.5h-6.75a1.5 1.5 0 0 0-1.5 1.5v6.75a1.5 1.5 0 0 0 1.5 1.5H21a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 21 1.5Zm-1.5 6.375a.375.375 0 0 1-.375.375h-3a.375.375 0 0 1-.375-.375v-3a.375.375 0 0 1 .375-.375h3a.375.375 0 0 1 .375.375v3ZM9.75 1.5H3A1.5 1.5 0 0 0 1.5 3v6.75a1.5 1.5 0 0 0 1.5 1.5h6.75a1.5 1.5 0 0 0 1.5-1.5V3a1.5 1.5 0 0 0-1.5-1.5Zm-1.5 6.375a.375.375 0 0 1-.375.375h-3a.375.375 0 0 1-.375-.375v-3a.375.375 0 0 1 .375-.375h3a.375.375 0 0 1 .375.375v3ZM9.75 12.75H3a1.5 1.5 0 0 0-1.5 1.5V21A1.5 1.5 0 0 0 3 22.5h6.75a1.5 1.5 0 0 0 1.5-1.5v-6.75a1.5 1.5 0 0 0-1.5-1.5Zm-1.5 6.375a.375.375 0 0 1-.375.375h-3a.375.375 0 0 1-.375-.375v-3a.375.375 0 0 1 .375-.375h3a.375.375 0 0 1 .375.375v3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRadioButtonOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12c0-5.383 4.367-9.75 9.75-9.75s9.75 4.367 9.75 9.75-4.367 9.75-9.75 9.75S2.25 17.383 2.25 12ZM12 3.75A8.252 8.252 0 0 0 3.75 12 8.252 8.252 0 0 0 12 20.25 8.252 8.252 0 0 0 20.25 12 8.252 8.252 0 0 0 12 3.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRadioButtonOn = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 12c0-5.383 4.367-9.75 9.75-9.75s9.75 4.367 9.75 9.75-4.367 9.75-9.75 9.75S2.25 17.383 2.25 12ZM12 3.75A8.252 8.252 0 0 0 3.75 12 8.252 8.252 0 0 0 12 20.25 8.252 8.252 0 0 0 20.25 12 8.252 8.252 0 0 0 12 3.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.75a6.75 6.75 0 1 0 0-13.5 6.75 6.75 0 0 0 0 13.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRadio = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#radio_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.688a1.687 1.687 0 1 0 0-3.375 1.687 1.687 0 0 0 0 3.374ZM8.918 16.02a1.03 1.03 0 0 1-.772-.346 5.531 5.531 0 0 1 0-7.348 1.031 1.031 0 1 1 1.54 1.37 3.469 3.469 0 0 0 0 4.608 1.032 1.032 0 0 1-.77 1.716h.002ZM15.082 16.02a1.031 1.031 0 0 1-.77-1.716 3.468 3.468 0 0 0 0-4.608 1.03 1.03 0 1 1 1.541-1.37 5.531 5.531 0 0 1 0 7.348 1.03 1.03 0 0 1-.77.346Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.53 18.408a1.03 1.03 0 0 1-.755-.328 8.906 8.906 0 0 1 0-12.164 1.031 1.031 0 1 1 1.507 1.41 6.844 6.844 0 0 0 0 9.345 1.03 1.03 0 0 1-.753 1.735v.002ZM17.47 18.409a1.031 1.031 0 0 1-.752-1.734 6.843 6.843 0 0 0 0-9.346 1.03 1.03 0 1 1 1.506-1.41 8.906 8.906 0 0 1 0 12.164 1.027 1.027 0 0 1-.753.326Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.11 20.532a1.032 1.032 0 0 1-.769-1.72 10.235 10.235 0 0 0 0-13.624 1.031 1.031 0 0 1 1.537-1.375 12.297 12.297 0 0 1 0 16.375 1.03 1.03 0 0 1-.769.344ZM3.89 20.532a1.028 1.028 0 0 1-.769-.344 12.297 12.297 0 0 1 0-16.375 1.031 1.031 0 0 1 1.537 1.375 10.235 10.235 0 0 0 0 13.625 1.031 1.031 0 0 1-.767 1.719Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "radio_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgRainy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.387 6.532c-.786-.784-1.836-1.331-3.055-1.593a.75.75 0 0 1-.524-.422 6.668 6.668 0 0 0-1.978-2.495C14.741 1.19 13.417.75 12 .75a6.574 6.574 0 0 0-4.383 1.656C6.483 3.415 5.7 4.81 5.347 6.428a.752.752 0 0 1-.55.571c-1.171.295-1.673.588-2.306 1.151-.897.8-1.366 1.887-1.366 3.137 0 1.432.526 2.608 1.522 3.401.872.694 2.064 1.061 3.447 1.061h10.968c1.557 0 3.006-.537 4.079-1.513 1.117-1.015 1.734-2.422 1.734-3.962 0-1.476-.516-2.77-1.488-3.742ZM5.25 21a.748.748 0 0 1-.623-1.167l1.5-2.25a.75.75 0 0 1 1.247.833l-1.5 2.25A.75.75 0 0 1 5.25 21ZM7.5 23.25a.749.749 0 0 1-.623-1.167l3-4.5a.752.752 0 0 1 1.36.27.749.749 0 0 1-.112.563l-3 4.5a.75.75 0 0 1-.625.334ZM12.75 21a.75.75 0 0 1-.623-1.167l1.5-2.25a.75.75 0 1 1 1.247.833l-1.5 2.25a.75.75 0 0 1-.624.334ZM15 23.25a.75.75 0 0 1-.623-1.167l3-4.5a.75.75 0 1 1 1.247.833l-3 4.5a.751.751 0 0 1-.624.334Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgReader = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 1.5H6.75a3.003 3.003 0 0 0-3 3v15a3.003 3.003 0 0 0 3 3h10.5a3.004 3.004 0 0 0 3-3v-15a3.003 3.003 0 0 0-3-3ZM12 14.25H8.25a.75.75 0 1 1 0-1.5H12a.75.75 0 1 1 0 1.5Zm3.75-3.75h-7.5a.75.75 0 1 1 0-1.5h7.5a.75.75 0 1 1 0 1.5Zm0-3.75h-7.5a.75.75 0 0 1 0-1.5h7.5a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgReceipt = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.68 1.52a.763.763 0 0 0-.527.065L21 2.16l-1.163-.58a.75.75 0 0 0-.67 0l-1.177.58-1.162-.58a.75.75 0 0 0-.673 0L15 2.158l-1.146-.578a.75.75 0 0 0-.673-.003L12 2.16l-1.162-.582a.752.752 0 0 0-.672 0L9 2.16 7.836 1.58a.75.75 0 0 0-1.086.684v11.236l.002.003h8.998a1.5 1.5 0 0 1 1.5 1.5v4.872c0 1.45 1.55 2.625 3 2.625h.563a2.438 2.438 0 0 0 2.437-2.437V2.249a.75.75 0 0 0-.57-.728Zm-3.18 9.73h-5.976c-.405 0-.755-.312-.773-.717a.75.75 0 0 1 .749-.784h5.977c.405 0 .754.312.772.717a.75.75 0 0 1-.749.783Zm0-3.75h-8.976c-.405 0-.755-.312-.773-.717A.75.75 0 0 1 10.5 6h8.977c.405 0 .754.312.772.717a.749.749 0 0 1-.749.783Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 19.875V15.75A.75.75 0 0 0 15 15H2.25a1.505 1.505 0 0 0-1.5 1.502c0 2.37.27 3.355.678 4.105.69 1.274 1.94 1.893 3.822 1.893h11.516a.188.188 0 0 0 .134-.32c-.444-.444-1.15-1.04-1.15-2.305Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRecording = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.85 6.753c-2.77.077-5.022 2.33-5.1 5.1a5.233 5.233 0 0 0 1.423 3.74.094.094 0 0 1-.064.157H9.891a.093.093 0 0 1-.092-.11.094.094 0 0 1 .024-.048 5.233 5.233 0 0 0 1.427-3.739c-.076-2.77-2.327-5.023-5.098-5.1A5.256 5.256 0 0 0 .75 11.978c-.012 2.918 2.39 5.272 5.308 5.272h11.884c2.917 0 5.32-2.354 5.308-5.272a5.257 5.257 0 0 0-5.4-5.225Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRefreshCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75 0 5.384 4.366 9.75 9.75 9.75 5.376 0 9.75-4.374 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75Zm0 14.672a4.406 4.406 0 0 1 0-8.813h.197l-.661-.66a.657.657 0 0 1 .928-.929l1.875 1.875a.655.655 0 0 1 0 .928l-1.875 1.875a.656.656 0 1 1-.928-.928l.844-.843c-.112-.005-.24-.005-.38-.005a3.094 3.094 0 1 0 3.094 3.094.656.656 0 1 1 1.312 0A4.411 4.411 0 0 1 12 16.922Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRefresh = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.416 6.922A8.25 8.25 0 0 1 12 5.532c1.048 0 1.784.035 2.299.092.475.052.871.133 1.143.297.146.088.38.277.44.613a.86.86 0 0 1-.184.691 1.076 1.076 0 0 1-.347.282l-.007.003-.004.002-.005.003h-.002v.001c-.001 0-.002 0-.333-.672l.331.673a.75.75 0 0 1-1.021-.38 5.924 5.924 0 0 0-.177-.022c-.436-.049-1.11-.084-2.133-.084a6.75 6.75 0 1 0 6.75 6.75.75.75 0 0 1 1.5 0 8.25 8.25 0 1 1-12.834-6.86Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.47 2.188a.75.75 0 0 1 1.06 0l3.75 3.75a.75.75 0 0 1 0 1.061l-3.75 3.75a.75.75 0 1 1-1.06-1.06l3.22-3.22-3.22-3.22a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgReloadCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm5.625 8.538a.404.404 0 0 1-.404.404H14.43a.403.403 0 0 1-.285-.69l1.039-1.038-.263-.306a4.096 4.096 0 1 0 .913 4.208.748.748 0 0 1 .958-.458.752.752 0 0 1 .458.958A5.596 5.596 0 1 1 7.002 9.43a5.597 5.597 0 0 1 4.969-3.026 5.547 5.547 0 0 1 4.048 1.732l.026.03.202.234.689-.689a.396.396 0 0 1 .436-.089.404.404 0 0 1 .252.375l.001 2.791Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgReload = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 2.25a9.724 9.724 0 0 1 7.053 3.019l.013.013 1.003 1.166a.75.75 0 0 1-1.138.978l-.977-1.137a8.221 8.221 0 0 0-5.953-2.54h-.001A8.252 8.252 0 0 0 3 12a8.252 8.252 0 0 0 8.25 8.25m0-18C5.866 2.25 1.5 6.618 1.5 12c0 5.384 4.367 9.75 9.75 9.75a9.754 9.754 0 0 0 9.195-6.499.75.75 0 1 0-1.414-.5 8.254 8.254 0 0 1-7.781 5.5",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.75 4.566V9.75a.75.75 0 0 1-.75.75h-5.183a.75.75 0 0 1-.531-1.28l5.184-5.184a.75.75 0 0 1 1.28.53Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRemoveCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm3.75 10.5h-7.5a.75.75 0 1 1 0-1.5h7.5a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRemove = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 12a.75.75 0 0 1 .75-.75h13.5a.75.75 0 0 1 0 1.5H5.25A.75.75 0 0 1 4.5 12Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgReorderFour = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 14.25c0-.57.462-1.031 1.031-1.031H19.22a1.031 1.031 0 0 1 0 2.062H4.78c-.57 0-1.031-.462-1.031-1.031ZM3.75 9.75c0-.57.462-1.031 1.031-1.031H19.22a1.031 1.031 0 0 1 0 2.062H4.78c-.57 0-1.031-.462-1.031-1.031ZM3.75 5.25c0-.57.462-1.031 1.031-1.031H19.22a1.031 1.031 0 0 1 0 2.062H4.78c-.57 0-1.031-.461-1.031-1.031ZM3.75 18.75c0-.57.462-1.031 1.031-1.031H19.22a1.031 1.031 0 0 1 0 2.062H4.78c-.57 0-1.031-.461-1.031-1.031Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgReorderThree = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 12c0-.57.462-1.031 1.031-1.031H19.22a1.031 1.031 0 0 1 0 2.062H4.78c-.57 0-1.031-.462-1.031-1.031ZM3.75 8.25c0-.57.462-1.031 1.031-1.031H19.22a1.031 1.031 0 0 1 0 2.062H4.78c-.57 0-1.031-.461-1.031-1.031ZM3.75 15.75c0-.57.462-1.031 1.031-1.031H19.22a1.031 1.031 0 0 1 0 2.062H4.78c-.57 0-1.031-.461-1.031-1.031Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgReorderTwo = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 14.25c0-.57.462-1.031 1.031-1.031H18.47a1.031 1.031 0 0 1 0 2.062H5.53c-.57 0-1.031-.462-1.031-1.031ZM4.5 9.75c0-.57.462-1.031 1.031-1.031H18.47a1.031 1.031 0 0 1 0 2.062H5.53c-.57 0-1.031-.462-1.031-1.031Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRepeat = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.47 5.095a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.748 7.125H16.5a.75.75 0 0 1 0 1.5H6.751a3.011 3.011 0 0 0-3.001 3.001v.749a.75.75 0 0 1-1.5 0v-.752a4.511 4.511 0 0 1 4.498-4.498ZM9.53 13.345a.75.75 0 0 1 0 1.06l-1.72 1.72 1.72 1.72a.75.75 0 1 1-1.06 1.06l-2.25-2.25a.75.75 0 0 1 0-1.06l2.25-2.25a.75.75 0 0 1 1.06 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 10.875a.75.75 0 0 1 .75.75v.752a4.512 4.512 0 0 1-4.498 4.498H7.5a.75.75 0 0 1 0-1.5h9.749a3.01 3.01 0 0 0 3.001-3.001v-.749a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgResize = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5 4.5a.75.75 0 0 1 .75-.75h5.25a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-1.5 0v-4.5h-4.5a.75.75 0 0 1-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.55 4.449a.75.75 0 0 1 0 1.06L5.78 19.282a.75.75 0 0 1-1.061-1.06L18.49 4.448a.75.75 0 0 1 1.06 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.5 13.5a.75.75 0 0 1 .75.75v4.5h4.5a.75.75 0 0 1 0 1.5H4.5a.75.75 0 0 1-.75-.75v-5.25a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRestaurant = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#restaurant_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.761 10.497a3.727 3.727 0 0 0 2.652-1.099l3.61-3.607a.764.764 0 0 0 .04-1.05.75.75 0 0 0-1.087-.026L18.76 7.93a.576.576 0 0 1-.814 0 .592.592 0 0 1 .012-.827L21.16 3.9a.75.75 0 0 0-.026-1.085.732.732 0 0 0-.497-.19.783.783 0 0 0-.553.23l-3.2 3.2a.576.576 0 0 1-.814 0 .593.593 0 0 1 .011-.828l3.203-3.202A.75.75 0 0 0 19.258.94a.732.732 0 0 0-.496-.19.784.784 0 0 0-.553.23l-3.607 3.606a3.726 3.726 0 0 0-1.1 2.653v.386a.75.75 0 0 1-.22.531l-1.668 1.67a.187.187 0 0 1-.266 0L3.226 1.703A.75.75 0 0 0 2.167 1.7c-.71.704-1.089 1.697-1.089 2.872-.005 1.94 1.015 4.172 2.662 5.816l4.006 4.006a3.037 3.037 0 0 0 2.904.79.747.747 0 0 1 .698.174l.535.493c.137.14.215.33.215.526v.26c-.001.59.231 1.157.646 1.578l4.22 4.292.005.005a2.498 2.498 0 1 0 3.533-3.534l-6.328-6.327a.19.19 0 0 1-.04-.204.189.189 0 0 1 .04-.061l1.67-1.67a.75.75 0 0 1 .53-.219h.387Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89 16.78a4.562 4.562 0 0 1-3.204-1.324l-.65-.65a.375.375 0 0 0-.53 0L1.523 18.77c-.71.71-.963 1.756-.612 2.78.02.057.043.113.07.168.473.969 1.39 1.531 2.395 1.531a2.61 2.61 0 0 0 1.858-.77l5.314-5.34a.22.22 0 0 0 .062-.174v-.012a.216.216 0 0 0-.242-.2 4.573 4.573 0 0 1-.476.027Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "restaurant_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgReturnDownBack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78 9.97a.75.75 0 0 1 0 1.06L3.31 13.5l2.47 2.47a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 6.75a.75.75 0 0 1 .75.75v.938c0 3.145-2.532 5.812-5.719 5.812H3a.75.75 0 0 1 0-1.5h13.781c2.322 0 4.219-1.958 4.219-4.313V7.5a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgReturnDownForward = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.22 9.97a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l2.47-2.47-2.47-2.47a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 6.75A.75.75 0 0 1 3 7.5v.938c0 2.354 1.897 4.312 4.219 4.312H21a.75.75 0 0 1 0 1.5H7.219c-3.187 0-5.719-2.667-5.719-5.813V7.5a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgReturnUpBack = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78 6.97a.75.75 0 0 1 0 1.06L3.31 10.5l2.47 2.47a.75.75 0 1 1-1.06 1.06l-3-3a.75.75 0 0 1 0-1.06l3-3a.75.75 0 0 1 1.06 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 10.5A.75.75 0 0 1 3 9.75h13.781c3.187 0 5.719 2.667 5.719 5.813v.937a.75.75 0 0 1-1.5 0v-.938c0-2.354-1.897-4.312-4.219-4.312H3a.75.75 0 0 1-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgReturnUpForward = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.22 6.97a.75.75 0 0 1 1.06 0l3 3a.75.75 0 0 1 0 1.06l-3 3a.75.75 0 1 1-1.06-1.06l2.47-2.47-2.47-2.47a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 15.563c0-3.146 2.532-5.813 5.719-5.813H21a.75.75 0 0 1 0 1.5H7.219C4.897 11.25 3 13.208 3 15.563v.937a.75.75 0 0 1-1.5 0v-.938Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRibbon = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.61 15.732a8.081 8.081 0 0 1-1.327-.01 8.253 8.253 0 0 1-5.984-3.42.187.187 0 0 0-.318.017l-3.375 6.065c-.128.235-.148.516-.013.745a.786.786 0 0 0 .667.371h3.657a.717.717 0 0 1 .638.344l1.812 3.031a.762.762 0 0 0 .645.375.827.827 0 0 0 .682-.45l3.1-6.804a.187.187 0 0 0-.185-.264ZM22.39 18.37l-3.354-6.055a.187.187 0 0 0-.316-.017 8.273 8.273 0 0 1-3.67 2.88.754.754 0 0 0-.41.386l-1.727 3.801a.372.372 0 0 0 0 .31l1.419 3.121a.828.828 0 0 0 .68.454.765.765 0 0 0 .643-.38l1.806-3.027a.727.727 0 0 1 .646-.343h3.692c.313 0 .55-.163.656-.468a.793.793 0 0 0-.066-.662ZM12.012 9.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.012.75a6.757 6.757 0 0 0-6.75 6.75 6.758 6.758 0 0 0 6.75 6.75 6.758 6.758 0 0 0 6.75-6.75 6.757 6.757 0 0 0-6.75-6.75Zm0 10.5a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRocket = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.415 7.35a1.251 1.251 0 1 0 .001 2.503 1.251 1.251 0 0 0-.001-2.503Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.38 2.347v-.004a.955.955 0 0 0-.71-.718c-1.396-.34-3.594.023-6.029.998-2.454.984-4.754 2.437-6.308 3.995a15.033 15.033 0 0 0-1.385 1.585c-1.047-.046-1.97.103-2.746.442-2.706 1.19-3.48 4.239-3.685 5.49a1.172 1.172 0 0 0 1.274 1.36h.007l3.015-.33.01.107c.04.367.203.71.465.971l1.471 1.472c.26.262.604.426.971.465l.1.01-.327 3.012v.006a1.172 1.172 0 0 0 1.348 1.276c1.258-.202 4.305-.966 5.493-3.687.336-.771.485-1.69.443-2.735a14.74 14.74 0 0 0 1.591-1.385c1.567-1.559 3.025-3.84 4-6.258.97-2.408 1.334-4.622 1.002-6.072Zm-5.018 8.197a2.755 2.755 0 1 1 0-3.894 2.735 2.735 0 0 1 0 3.894Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.59 18.114a.75.75 0 0 0-.515.126c-.3.204-.6.407-.904.604-.615.4-1.35-.302-.985-.937l.57-.985a.75.75 0 0 0-.71-1.167c-.633.08-1.22.368-1.671.818-.172.172-.693.694-.974 2.684-.08.572-.13 1.147-.151 1.724a.75.75 0 0 0 .75.77h.019c.577-.021 1.153-.071 1.725-.15 1.99-.282 2.513-.804 2.684-.976.453-.45.74-1.04.815-1.675a.75.75 0 0 0-.653-.836Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgRose = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.135 5.601a.75.75 0 0 0-.8-.333c-.873.197-1.737.422-2.565.667-1.643.487-3.25 1.121-5.056 1.996-.872.425-1.218.626-2.25 1.225l-.21.125c-1.545.89-2.676 1.875-3.46 3.014C4.936 13.542 4.5 15 4.5 16.624c0 1.91.736 3.614 2.074 4.798C7.922 22.618 9.8 23.25 12 23.25c2.192 0 4.073-.672 5.438-1.942 1.328-1.235 2.062-2.971 2.062-4.889 0-1.171-.29-2.203-.57-3.197-.59-2.095-1.1-3.905 1.158-6.756a.75.75 0 0 0 .047-.865ZM10.266 5.603c-2.37-1.288-5.51-1.821-5.643-1.843a.75.75 0 0 0-.826.484.772.772 0 0 0 .178.79c1.492 1.583 1.54 3.224 1.343 4.904a.209.209 0 0 0 .355.17c.768-.774 1.705-1.477 2.831-2.127l.21-.122c1.036-.604 1.422-.829 2.349-1.278l.126-.061a.188.188 0 0 0 .03-.32 8.376 8.376 0 0 0-.953-.597ZM10.98 4.287c.162.087.333.187.512.295.495.303.96.655 1.386 1.05a.187.187 0 0 0 .2.035 31.504 31.504 0 0 1 3.925-1.36.187.187 0 0 0 .119-.263 51.978 51.978 0 0 0-.71-1.396.75.75 0 0 0-.662-.398c-.09 0-1.56.017-3.603.998-.425.205-.838.432-1.237.68a.188.188 0 0 0-.061.26.188.188 0 0 0 .071.066l.06.033ZM9.812 2.85c.343-.224.691-.432 1.043-.624a.094.094 0 0 0 .011-.157C9.649 1.15 8.537.803 8.47.783a.75.75 0 0 0-.823.273c-.345.479-.647.987-.904 1.518a.094.094 0 0 0 .06.132 23.11 23.11 0 0 1 2.138.67.094.094 0 0 0 .084-.01l.788-.516Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSad = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.425 4.575a10.501 10.501 0 1 0-14.85 14.85 10.5 10.5 0 1 0 14.85-14.85ZM8.625 9.75a1.125 1.125 0 1 1 0 2.25 1.125 1.125 0 0 1 0-2.25Zm-1.11 7.023c.563-1.89 2.354-3.273 4.483-3.273 2.129 0 3.92 1.384 4.486 3.273a.374.374 0 0 1-.367.477H7.883a.375.375 0 0 1-.366-.477ZM15.376 12a1.125 1.125 0 1 1 0-2.25 1.125 1.125 0 0 1 0 2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSave = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m21.84 5.614-3.454-3.455a2.234 2.234 0 0 0-1.59-.66H4.5a3 3 0 0 0-3 3v15a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V7.206a2.234 2.234 0 0 0-.66-1.591ZM5.626 5.25h8.25a.375.375 0 0 1 .375.375v2.25a.375.375 0 0 1-.375.375h-8.25a.375.375 0 0 1-.375-.375v-2.25a.375.375 0 0 1 .375-.375Zm6.55 14.996a3.75 3.75 0 1 1-.351-7.492 3.75 3.75 0 0 1 .352 7.492Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 18.75a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgScanCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm-1.875 15H8.812a2.065 2.065 0 0 1-2.062-2.063v-1.312a.75.75 0 1 1 1.5 0v1.313a.562.562 0 0 0 .563.562h1.312a.75.75 0 1 1 0 1.5Zm0-9H8.812a.563.563 0 0 0-.562.563v1.312a.75.75 0 1 1-1.5 0V8.812A2.065 2.065 0 0 1 8.813 6.75h1.312a.75.75 0 1 1 0 1.5Zm7.125 6.938a2.064 2.064 0 0 1-2.063 2.062h-1.312a.75.75 0 1 1 0-1.5h1.313a.562.562 0 0 0 .562-.563v-1.312a.75.75 0 1 1 1.5 0v1.313Zm0-5.063a.75.75 0 1 1-1.5 0V8.812a.563.563 0 0 0-.563-.562h-1.312a.75.75 0 1 1 0-1.5h1.313a2.065 2.065 0 0 1 2.062 2.063v1.312Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgScan = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.813 15c.569 0 1.03.462 1.03 1.031v2.157a3.657 3.657 0 0 1-3.655 3.656H16.03a1.031 1.031 0 0 1 0-2.063h2.157a1.594 1.594 0 0 0 1.593-1.593V16.03c0-.57.462-1.031 1.032-1.031ZM15 3.188c0-.57.462-1.032 1.031-1.032h2.157a3.656 3.656 0 0 1 3.656 3.656V7.97a1.031 1.031 0 0 1-2.063 0V5.812a1.594 1.594 0 0 0-1.593-1.593H16.03c-.57 0-1.031-.462-1.031-1.032ZM3.188 15c.569 0 1.03.462 1.03 1.031v2.157a1.594 1.594 0 0 0 1.595 1.593h2.156a1.031 1.031 0 0 1 0 2.063H5.812a3.657 3.657 0 0 1-3.656-3.657v-2.156c0-.57.462-1.031 1.031-1.031ZM5.813 4.219a1.594 1.594 0 0 0-1.594 1.593V7.97a1.031 1.031 0 0 1-2.063 0V5.812a3.656 3.656 0 0 1 3.656-3.656H7.97a1.031 1.031 0 0 1 0 2.063H5.812Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSchool = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 17.25a.75.75 0 0 1-.372-.098l-6.566-3.753a.375.375 0 0 0-.562.326v3.526a.75.75 0 0 0 .386.656l6.75 3.75a.75.75 0 0 0 .728 0l6.75-3.75a.75.75 0 0 0 .386-.656v-3.526a.376.376 0 0 0-.563-.326l-6.565 3.753a.75.75 0 0 1-.372.099Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.246 8.93v-.005a.75.75 0 0 0-.375-.575l-10.5-6a.75.75 0 0 0-.744 0l-10.5 6a.75.75 0 0 0 0 1.302l10.5 6a.75.75 0 0 0 .744 0l9.238-5.279a.093.093 0 0 1 .129.035c.008.014.012.03.012.047v6.775c0 .403.31.75.714.77a.75.75 0 0 0 .786-.75V9a.688.688 0 0 0-.004-.07Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSearchCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 3c-4.963 0-9 4.037-9 9s4.037 9 9 9 9-4.037 9-9-4.037-9-9-9Zm4.28 13.28a.75.75 0 0 1-1.06 0l-2.008-2.008a4.129 4.129 0 1 1 1.06-1.06l2.008 2.008a.75.75 0 0 1 0 1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.875 13.5a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSearch = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m21.407 19.753-4.41-4.41a8.148 8.148 0 0 0 1.633-4.903c0-4.516-3.674-8.19-8.19-8.19s-8.19 3.674-8.19 8.19 3.674 8.19 8.19 8.19a8.148 8.148 0 0 0 4.902-1.633l4.41 4.41a1.171 1.171 0 0 0 1.655-1.654ZM4.59 10.44a5.85 5.85 0 1 1 5.85 5.85 5.857 5.857 0 0 1-5.85-5.85Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSend = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m22.34 10.643-.007-.004-20.02-8.303a1.104 1.104 0 0 0-1.04.101 1.155 1.155 0 0 0-.523.965v5.31a1.125 1.125 0 0 0 .915 1.105l10.919 2.02a.188.188 0 0 1 0 .368L1.665 14.224a1.125 1.125 0 0 0-.915 1.104v5.311a1.105 1.105 0 0 0 .496.923 1.123 1.123 0 0 0 1.066.097l20.02-8.256.008-.004a1.5 1.5 0 0 0 0-2.756Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgServer = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 20.062c-2.454 0-5.221-.544-7.403-1.453-.8-.337-1.485-.882-2.046-1.313a.187.187 0 0 0-.301.15v.59c0 1.315 1.101 2.494 3.1 3.319C7.14 22.093 9.5 22.5 12 22.5s4.86-.407 6.65-1.145c1.999-.824 3.1-2.004 3.1-3.32v-.59a.187.187 0 0 0-.301-.149c-.56.43-1.246.976-2.047 1.313-2.181.909-4.948 1.453-7.402 1.453ZM21.75 5.93c-.038-1.296-1.133-2.456-3.094-3.274C16.863 1.91 14.5 1.5 12 1.5s-4.863.41-6.652 1.156C3.39 3.472 2.294 4.63 2.254 5.923l-.004.827c0 .3.244.772.686 1.16.522.455 1.296.905 2.24 1.3 2.007.838 4.559 1.337 6.824 1.337 2.265 0 4.817-.5 6.825-1.34.943-.394 1.718-.844 2.24-1.3.441-.384.685-.856.685-1.157v-.82Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.402 10.593c-2.18.91-4.948 1.453-7.402 1.453-2.454 0-5.221-.542-7.403-1.453-.8-.335-1.485-.88-2.046-1.312a.188.188 0 0 0-.301.15v1.443c0 .3.244.68.686 1.066.522.456 1.296.906 2.24 1.3 2.007.838 4.559 1.338 6.824 1.338 2.265 0 4.817-.501 6.825-1.34.943-.394 1.718-.843 2.24-1.3.441-.385.685-.763.685-1.064V9.432a.187.187 0 0 0-.301-.15c-.56.43-1.246.976-2.047 1.311Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.403 14.624c-2.182.91-4.949 1.454-7.403 1.454-2.454 0-5.221-.544-7.403-1.454-.8-.336-1.485-.881-2.046-1.312a.187.187 0 0 0-.3.15v1.397c0 .3.243.678.684 1.064.522.457 1.297.906 2.24 1.3 2.008.838 4.56 1.339 6.825 1.339 2.266 0 4.817-.5 6.825-1.34.943-.393 1.718-.843 2.24-1.3.441-.386.685-.764.685-1.063v-1.397a.188.188 0 0 0-.301-.15c-.56.43-1.246.976-2.046 1.313Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSettings = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 14.25a2.25 2.25 0 1 0 0-4.5 2.25 2.25 0 0 0 0 4.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.05 14.063-.023-.018-1.479-1.16a.756.756 0 0 1-.286-.625v-.542a.75.75 0 0 1 .287-.62l1.479-1.16.022-.018a1.251 1.251 0 0 0 .276-1.597L20.324 4.86a1.259 1.259 0 0 0-1.527-.54l-.017.006-1.739.7a.747.747 0 0 1-.678-.06 8.417 8.417 0 0 0-.469-.275.747.747 0 0 1-.383-.554l-.262-1.856-.006-.034a1.276 1.276 0 0 0-1.239-1.027H9.996a1.262 1.262 0 0 0-1.24 1.05l-.004.026-.262 1.86a.75.75 0 0 1-.38.553 8.21 8.21 0 0 0-.47.273.746.746 0 0 1-.676.06l-1.74-.704-.017-.006a1.26 1.26 0 0 0-1.522.531l-.006.01L1.674 8.34a1.252 1.252 0 0 0 .276 1.598l.023.018 1.479 1.16a.755.755 0 0 1 .286.625v.542a.75.75 0 0 1-.287.62l-1.478 1.16-.023.018a1.25 1.25 0 0 0-.276 1.597l2.002 3.464a1.258 1.258 0 0 0 1.527.54l.017-.006 1.737-.7a.747.747 0 0 1 .678.06c.154.098.31.19.47.275a.747.747 0 0 1 .383.554l.26 1.856.006.034a1.275 1.275 0 0 0 1.242 1.027h4.008a1.262 1.262 0 0 0 1.24-1.05l.005-.026.26-1.86a.75.75 0 0 1 .384-.553c.16-.086.317-.178.469-.273a.747.747 0 0 1 .676-.06l1.74.701.017.007a1.26 1.26 0 0 0 1.529-.542l2.002-3.464a1.251 1.251 0 0 0-.276-1.598Zm-6.304-1.887a3.75 3.75 0 1 1-3.922-3.922 3.76 3.76 0 0 1 3.922 3.922Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgShapes = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75H1.5a.75.75 0 0 1-.656-1.116l7.125-12.75a.75.75 0 0 1 1.31 0l7.124 12.75a.75.75 0 0 1-.653 1.116Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 7.5a7.55 7.55 0 0 0-1.527.156l3.491 6.247a2.25 2.25 0 0 1-1.964 3.347H8.594A7.5 7.5 0 1 0 15.75 7.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgShareSocial = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18 15.75a2.989 2.989 0 0 0-2.162.923l-6.937-3.904a2.993 2.993 0 0 0 0-1.54l6.937-3.903a2.99 2.99 0 1 0-.737-1.307L8.163 9.923a3 3 0 1 0 0 4.153l6.938 3.903a3 3 0 1 0 2.9-2.23Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgShare = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.625 8.25H12.75v6.797a.75.75 0 1 1-1.5 0V8.25H6.375a2.628 2.628 0 0 0-2.625 2.625v9A2.628 2.628 0 0 0 6.375 22.5h11.25a2.627 2.627 0 0 0 2.625-2.625v-9a2.627 2.627 0 0 0-2.625-2.625ZM12.75 4.06l2.47 2.47a.75.75 0 0 0 1.06-1.06l-3.75-3.75a.75.75 0 0 0-1.06 0L7.72 5.47a.75.75 0 0 0 1.06 1.06l2.47-2.47v4.19h1.5V4.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgShieldCheckmark = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.456 5.22a.75.75 0 0 0-.616-.691c-4.055-.728-5.747-1.254-9.531-2.963a.75.75 0 0 0-.618 0C7.907 3.276 6.215 3.801 2.16 4.53a.75.75 0 0 0-.616.69c-.18 2.865.204 5.534 1.145 7.934a16.382 16.382 0 0 0 3.358 5.274c2.506 2.66 5.167 3.814 5.675 4.018a.75.75 0 0 0 .563 0c.507-.204 3.168-1.359 5.675-4.018a16.384 16.384 0 0 0 3.351-5.274c.941-2.4 1.326-5.069 1.145-7.933Zm-6.14 3.52-5.194 6a.75.75 0 0 1-.535.26h-.03a.75.75 0 0 1-.526-.214l-2.306-2.26a.749.749 0 0 1 .517-1.286.75.75 0 0 1 .533.215l1.734 1.7 4.674-5.396a.75.75 0 0 1 1.134.982h-.001Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgShield = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.456 5.22a.75.75 0 0 0-.616-.692c-4.033-.723-5.73-1.288-9.371-2.927-.364-.136-.59-.133-.938 0C7.89 3.24 6.193 3.804 2.16 4.528a.75.75 0 0 0-.616.691c-.18 2.864.203 5.531 1.142 7.929a16.353 16.353 0 0 0 3.348 5.27c2.094 2.223 4.415 3.52 5.613 4.012a.938.938 0 0 0 .708 0c1.265-.512 3.501-1.773 5.611-4.014a16.355 16.355 0 0 0 3.349-5.268c.938-2.397 1.322-5.065 1.141-7.929Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgShirt = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 4.5c1.55 0 2.846-1.208 3-2.719.014-.14-.14-.281-.281-.281a.609.609 0 0 0-.222.042c-.01.004-.99.38-2.497.38-1.508 0-2.49-.375-2.497-.38a.76.76 0 0 0-.248-.042h-.003A.267.267 0 0 0 9 1.781C9.157 3.29 10.453 4.5 12 4.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m22.748 4.215-6.06-2.122a.188.188 0 0 0-.247.148 4.5 4.5 0 0 1-8.878 0 .188.188 0 0 0-.25-.148L1.251 4.215a.75.75 0 0 0-.489.848l.78 4.125a.75.75 0 0 0 .652.605l2.291.259a.375.375 0 0 1 .333.383l-.343 11.293a.75.75 0 0 0 .774.773h13.5a.75.75 0 0 0 .774-.773l-.343-11.293a.374.374 0 0 1 .333-.383l2.29-.26a.75.75 0 0 0 .653-.604l.78-4.125a.75.75 0 0 0-.489-.848Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgShuffle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.22 13.72a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 0 1 0-1.06ZM18.22 4.72a.75.75 0 0 1 1.06 0l2.25 2.25a.75.75 0 0 1 0 1.06l-2.25 2.25a.75.75 0 1 1-1.06-1.06l1.72-1.72-1.72-1.72a.75.75 0 0 1 0-1.06ZM12.416 11.376a.75.75 0 0 1 .208 1.04l-1.887 2.83a4.499 4.499 0 0 1-3.744 2.004H3a.75.75 0 1 1 0-1.5h3.993a3.001 3.001 0 0 0 2.496-1.335l1.887-2.83a.75.75 0 0 1 1.04-.209Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 7.5A.75.75 0 0 1 3 6.75h3.993a4.5 4.5 0 0 1 3.744 2.004l3.774 5.66a3 3 0 0 0 2.496 1.336H19.5a.75.75 0 0 1 0 1.5h-2.493a4.5 4.5 0 0 1-3.744-2.004l-3.774-5.66A3 3 0 0 0 6.993 8.25H3a.75.75 0 0 1-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.883 7.282a4.5 4.5 0 0 1 2.124-.532H19.5a.75.75 0 0 1 0 1.5h-2.493a3 3 0 0 0-2.496 1.336l-.387.58a.75.75 0 1 1-1.248-.832l.387-.58a4.5 4.5 0 0 1 1.62-1.472Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSkull = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.844 3.607C16.997 1.764 14.568.75 12 .75h-.017A9.75 9.75 0 0 0 2.25 10.5v4.719a3.732 3.732 0 0 0 2.357 3.484l1.112.442a.746.746 0 0 1 .457.55l.469 2.349a1.504 1.504 0 0 0 1.47 1.206h.51A.375.375 0 0 0 9 22.875v-1.854c0-.404.31-.75.714-.77A.752.752 0 0 1 10.5 21v1.875a.375.375 0 1 0 .75 0v-1.854c0-.404.31-.75.714-.77a.752.752 0 0 1 .786.749v1.875a.375.375 0 1 0 .75 0v-1.854c0-.404.31-.75.714-.77A.752.752 0 0 1 15 21v1.875a.375.375 0 0 0 .375.375h.51a1.505 1.505 0 0 0 1.471-1.206l.469-2.35a.75.75 0 0 1 .456-.55l1.112-.44a3.732 3.732 0 0 0 2.357-3.485v-4.64a9.79 9.79 0 0 0-2.906-6.972ZM8.047 15.744a2.625 2.625 0 1 1-.343-5.239 2.625 2.625 0 0 1 .343 5.24Zm5.125 2.877a.768.768 0 0 1-.436.129h-1.472a.75.75 0 0 1-.744-.921l.745-2.231c.126-.317.325-.551.641-.592.387-.047.656.135.826.573l.75 2.25a.75.75 0 0 1-.31.792Zm3.125-2.877a2.625 2.625 0 1 1-.34-5.239 2.625 2.625 0 0 1 .34 5.24Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSnow = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m21.61 16.36-1.594-.921a4.2 4.2 0 0 1 .981-.75A1.031 1.031 0 0 0 20 12.884a6.263 6.263 0 0 0-1.807 1.504L14.063 12l4.129-2.384a6.256 6.256 0 0 0 1.807 1.505 1.03 1.03 0 1 0 .997-1.806 4.207 4.207 0 0 1-.981-.75l1.593-.92a1.031 1.031 0 1 0-1.03-1.786l-1.594.92a4.204 4.204 0 0 1-.16-1.225A1.03 1.03 0 0 0 17.812 4.5h-.019a1.031 1.031 0 0 0-1.031 1.012c-.015.79.12 1.576.398 2.316l-4.129 2.386V5.446a6.257 6.257 0 0 0 2.207-.812 1.032 1.032 0 0 0-1.065-1.767c-.355.213-.74.373-1.142.474V1.78a1.031 1.031 0 1 0-2.062 0v1.56c-.402-.101-.787-.26-1.142-.474a1.031 1.031 0 0 0-1.065 1.767 6.258 6.258 0 0 0 2.207.812v4.768l-4.13-2.386c.279-.74.414-1.526.4-2.317A1.031 1.031 0 0 0 6.208 4.5h-.02a1.031 1.031 0 0 0-1.013 1.05c.008.415-.046.83-.16 1.228L3.423 5.86A1.031 1.031 0 1 0 2.39 7.645l1.593.92c-.288.298-.619.55-.981.75A1.031 1.031 0 1 0 4 11.122a6.263 6.263 0 0 0 1.807-1.505L9.937 12l-4.129 2.384a6.263 6.263 0 0 0-1.807-1.505 1.03 1.03 0 1 0-.997 1.806c.362.2.693.453.981.75l-1.594.924a1.03 1.03 0 0 0-.122 1.721 1.033 1.033 0 0 0 1.153.065l1.594-.92c.113.399.167.812.16 1.226A1.031 1.031 0 0 0 6.187 19.5h.02a1.032 1.032 0 0 0 1.03-1.012 6.263 6.263 0 0 0-.397-2.316l4.129-2.386v4.768a6.258 6.258 0 0 0-2.207.812 1.031 1.031 0 0 0 1.065 1.767c.355-.213.74-.373 1.142-.474v1.56a1.031 1.031 0 0 0 2.062 0v-1.56c.402.101.787.26 1.142.474a1.031 1.031 0 1 0 1.065-1.767 6.258 6.258 0 0 0-2.207-.812v-4.768l4.13 2.386a6.262 6.262 0 0 0-.4 2.317 1.031 1.031 0 0 0 1.031 1.012h.02a1.03 1.03 0 0 0 1.012-1.05 4.207 4.207 0 0 1 .16-1.228l1.594.92a1.032 1.032 0 1 0 1.031-1.784Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSpeedometer = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.955 5.543a11.25 11.25 0 0 0-16.378 15.41l.009.01c.015.016.03.033.047.049.034.04.074.084.12.13a1.93 1.93 0 0 0 2.83-.02 7.366 7.366 0 0 1 10.84 0 1.93 1.93 0 0 0 2.843.003l.15-.164.009-.009a11.247 11.247 0 0 0-.469-15.41l-.001.001ZM11.25 6a.75.75 0 1 1 1.5 0v1.5a.75.75 0 1 1-1.5 0V6ZM6 14.25H4.5a.75.75 0 0 1 0-1.5H6a.75.75 0 1 1 0 1.5Zm2.287-4.462a.75.75 0 0 1-1.06 0l-1.06-1.06a.75.75 0 1 1 1.06-1.061l1.06 1.06a.75.75 0 0 1 0 1.06Zm6.999 1.083-2.227 3.539a1.45 1.45 0 0 1-.328.328 1.412 1.412 0 0 1-1.64-2.297l3.539-2.227a.48.48 0 0 1 .548 0 .472.472 0 0 1 .108.657Zm1.487-1.083a.75.75 0 0 1-1.06-1.06l1.06-1.061a.75.75 0 1 1 1.06 1.06l-1.06 1.06ZM19.5 14.25H18a.75.75 0 0 1 0-1.5h1.5a.75.75 0 0 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSquare = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 21.75h-15a2.252 2.252 0 0 1-2.25-2.25v-15A2.252 2.252 0 0 1 4.5 2.25h15a2.252 2.252 0 0 1 2.25 2.25v15a2.252 2.252 0 0 1-2.25 2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgStarHalf = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1.5a.75.75 0 0 1 .713.518L14.983 9H22.5a.75.75 0 0 1 .424 1.368l-6.094 4.18 2.35 6.962a.75.75 0 0 1-1.151.847L12 17.99l-6.029 4.368a.75.75 0 0 1-1.15-.847l2.35-6.962-6.095-4.18A.75.75 0 0 1 1.5 9h7.518l2.269-6.982A.75.75 0 0 1 12 1.5Zm0 3.177-1.724 5.305a.75.75 0 0 1-.713.518H3.92l4.567 3.132a.75.75 0 0 1 .286.858l-1.78 5.275 4.567-3.31a.75.75 0 0 1 .88 0l4.567 3.31-1.78-5.275a.75.75 0 0 1 .286-.858L20.08 10.5h-5.642a.75.75 0 0 1-.714-.518L12 4.677Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25v14.813L5.531 21.75l2.532-7.5L1.5 9.75h8.063L12 2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgStar = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.469 22.5a.749.749 0 0 1-.44-.14L12 17.99l-6.028 4.37a.75.75 0 0 1-1.151-.848l2.351-6.964-6.094-4.179A.75.75 0 0 1 1.5 9h7.518l2.269-6.982a.75.75 0 0 1 1.426 0l2.27 6.985H22.5a.75.75 0 0 1 .424 1.368l-6.096 4.177 2.35 6.962a.75.75 0 0 1-.71.99Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgStatsChart = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.875 23.25h-1.5a1.125 1.125 0 0 1-1.125-1.125v-6.75a1.125 1.125 0 0 1 1.125-1.125h1.5A1.125 1.125 0 0 1 6 15.375v6.75a1.125 1.125 0 0 1-1.125 1.125ZM15.375 23.25h-1.5a1.125 1.125 0 0 1-1.125-1.125v-11.25a1.125 1.125 0 0 1 1.125-1.125h1.5a1.125 1.125 0 0 1 1.125 1.125v11.25a1.125 1.125 0 0 1-1.125 1.125ZM20.625 23.25h-1.5A1.125 1.125 0 0 1 18 22.125v-16.5A1.125 1.125 0 0 1 19.125 4.5h1.5a1.125 1.125 0 0 1 1.125 1.125v16.5a1.125 1.125 0 0 1-1.125 1.125ZM10.125 23.25h-1.5A1.125 1.125 0 0 1 7.5 22.125V1.875A1.125 1.125 0 0 1 8.625.75h1.5a1.125 1.125 0 0 1 1.125 1.125v20.25a1.125 1.125 0 0 1-1.125 1.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgStopCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.376 0-9.75 4.374-9.75 9.75s4.374 9.75 9.75 9.75 9.75-4.374 9.75-9.75S17.376 2.25 12 2.25Zm3.75 12.3a1.201 1.201 0 0 1-1.2 1.2h-5.1a1.201 1.201 0 0 1-1.2-1.2v-5.1a1.2 1.2 0 0 1 1.2-1.2h5.1a1.201 1.201 0 0 1 1.2 1.2v5.1Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgStop = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.375 20.25H5.625a1.875 1.875 0 0 1-1.875-1.875V5.625A1.875 1.875 0 0 1 5.625 3.75h12.75a1.875 1.875 0 0 1 1.875 1.875v12.75a1.875 1.875 0 0 1-1.875 1.875Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgStopwatch = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 13.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 3.82v-.445a1.125 1.125 0 1 0-2.25 0v.445a8.953 8.953 0 0 0-3.958 1.506l-.495-.498a1.127 1.127 0 0 0-1.594 1.594l.403.403A8.961 8.961 0 0 0 3 12.75c0 4.963 4.037 9 9 9s9-4.037 9-9c0-4.582-3.442-8.375-7.875-8.93ZM12 15a2.25 2.25 0 0 1-.75-4.371V7.125a.75.75 0 1 1 1.5 0v3.504A2.25 2.25 0 0 1 12 15Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgStorefront = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M22.5 21h-.563a.188.188 0 0 1-.187-.187V12.82a.189.189 0 0 0-.158-.188.187.187 0 0 0-.088.007c-.43.135-.876.21-1.327.224l-.16.002a5.072 5.072 0 0 1-2.477-.639.386.386 0 0 0-.375 0 5.07 5.07 0 0 1-2.477.64 4.973 4.973 0 0 1-2.459-.647.385.385 0 0 0-.379 0c-.761.427-1.62.65-2.492.647-.867 0-1.72-.226-2.473-.656a.386.386 0 0 0-.383 0 4.977 4.977 0 0 1-2.474.656c-.05 0-.102 0-.158-.002h-.002a4.92 4.92 0 0 1-1.373-.239.188.188 0 0 0-.245.178v8.009a.188.188 0 0 1-.187.187h-.54c-.405 0-.754.311-.772.716a.75.75 0 0 0 .749.784h20.977c.405 0 .754-.311.772-.716A.75.75 0 0 0 22.5 21Zm-12-3.187a.187.187 0 0 1-.188.187H6.189A.188.188 0 0 1 6 17.813v-3a.563.563 0 0 1 .563-.563h3.375a.563.563 0 0 1 .562.563v3ZM17.813 21h-3.375a.188.188 0 0 1-.188-.187v-6a.563.563 0 0 1 .563-.563h2.624a.563.563 0 0 1 .563.563v6a.187.187 0 0 1-.188.187ZM23.09 7.982l-2.013-4.617C20.55 2.232 19.347 1.5 18.012 1.5H5.986c-1.336 0-2.539.732-3.066 1.865L.908 7.982c-.421.91.136 1.844.136 1.844l.014.021c.022.037.063.094.088.13l.007.01.234.284.028.03.235.227.02.016c.137.118.284.225.44.318v.003c.51.309 1.09.481 1.687.5h.116a3.566 3.566 0 0 0 2.432-.952l.015-.015a.372.372 0 0 1 .51 0l.016.015a3.623 3.623 0 0 0 4.897 0 .375.375 0 0 1 .51 0 3.624 3.624 0 0 0 4.884.01.37.37 0 0 1 .502 0 3.6 3.6 0 0 0 2.452.942h.117a3.345 3.345 0 0 0 1.64-.502c.045-.026.088-.055.131-.083.333-.224.623-.507.856-.835l.082-.123a.413.413 0 0 0 .022-.04c.078-.158.495-.972.11-1.8Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSubway = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.5.75h-9a3.003 3.003 0 0 0-3 3v12a3.003 3.003 0 0 0 3 3h9a3.004 3.004 0 0 0 3-3v-12a3.003 3.003 0 0 0-3-3ZM9.75 3h4.5a.75.75 0 1 1 0 1.5h-4.5a.75.75 0 0 1 0-1.5Zm-1.5 13.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Zm7.5 0a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3ZM18 9a.75.75 0 0 1-.75.75H6.75A.75.75 0 0 1 6 9V7.5a.75.75 0 0 1 .75-.75h10.5a.75.75 0 0 1 .75.75V9ZM16.28 19.72a.75.75 0 0 0-1.06 1.06l.22.22H8.56l.22-.22a.75.75 0 0 0-1.06-1.06l-2.25 2.25a.751.751 0 1 0 1.06 1.06l.53-.53h9.88l.53.53a.75.75 0 0 0 1.06-1.06l-2.25-2.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSunny = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 5.531A1.031 1.031 0 0 1 10.969 4.5V2.25a1.031 1.031 0 1 1 2.062 0V4.5A1.031 1.031 0 0 1 12 5.531ZM12 22.781a1.031 1.031 0 0 1-1.031-1.031V19.5a1.031 1.031 0 1 1 2.062 0v2.25A1.031 1.031 0 0 1 12 22.781ZM17.304 7.729a1.031 1.031 0 0 1-.73-1.76l1.591-1.591a1.031 1.031 0 0 1 1.458 1.458l-1.59 1.59a1.028 1.028 0 0 1-.73.303ZM5.106 19.926a1.03 1.03 0 0 1-.73-1.76l1.592-1.591a1.03 1.03 0 1 1 1.458 1.458l-1.591 1.59a1.028 1.028 0 0 1-.73.303ZM21.75 13.031H19.5a1.031 1.031 0 1 1 0-2.062h2.25a1.031 1.031 0 1 1 0 2.062ZM4.5 13.031H2.25a1.031 1.031 0 1 1 0-2.062H4.5a1.031 1.031 0 1 1 0 2.062ZM18.894 19.926a1.028 1.028 0 0 1-.729-.303l-1.59-1.59a1.032 1.032 0 0 1 1.457-1.459l1.591 1.591a1.03 1.03 0 0 1-.729 1.76ZM6.697 7.729a1.026 1.026 0 0 1-.73-.302l-1.59-1.591a1.031 1.031 0 0 1 1.458-1.458l1.591 1.59a1.031 1.031 0 0 1-.73 1.76ZM12 16.781a4.781 4.781 0 1 1 0-9.562 4.781 4.781 0 0 1 0 9.562Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSwapHorizontal = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.72 1.72a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 0 1 0 1.06l-5.25 5.25a.75.75 0 1 1-1.06-1.06l4.72-4.72-4.72-4.72a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.75 7.5a.75.75 0 0 1 .75-.75h14.197a.75.75 0 0 1 0 1.5H4.5a.75.75 0 0 1-.75-.75ZM10.28 10.72a.75.75 0 0 1 0 1.06L5.56 16.5l4.72 4.72a.75.75 0 1 1-1.06 1.06l-5.25-5.25a.75.75 0 0 1 0-1.06l5.25-5.25a.75.75 0 0 1 1.06 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.594 16.5a.75.75 0 0 1 .75-.75H19.5a.75.75 0 0 1 0 1.5H5.344a.75.75 0 0 1-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSwapVertical = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.97 3.97a.75.75 0 0 1 1.06 0l5.25 5.25a.75.75 0 1 1-1.06 1.06L16.5 5.56l-4.72 4.72a.75.75 0 1 1-1.06-1.06l5.25-5.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 4.552a.75.75 0 0 1 .75.75V19.5a.75.75 0 0 1-1.5 0V5.302a.75.75 0 0 1 .75-.75ZM1.72 13.72a.75.75 0 0 1 1.06 0l4.72 4.72 4.72-4.72a.75.75 0 1 1 1.06 1.06l-5.25 5.25a.75.75 0 0 1-1.06 0l-5.25-5.25a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.75a.75.75 0 0 1 .75.75v14.156a.75.75 0 1 1-1.5 0V4.5a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSyncCircle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75Zm3.923 13.25a5.262 5.262 0 0 1-9.14-2.874.75.75 0 0 1-.944-1.156l1.106-1.106a.75.75 0 0 1 1.049-.012l1.156 1.106a.75.75 0 0 1-.844 1.219 3.762 3.762 0 0 0 6.503 1.82.75.75 0 0 1 1.114 1.004v-.002Zm2.239-2.97-1.107 1.106a.75.75 0 0 1-1.048.012l-1.157-1.106a.75.75 0 0 1 .83-1.224 3.758 3.758 0 0 0-6.492-1.82.75.75 0 1 1-1.117-1.001 5.258 5.258 0 0 1 9.135 2.886.75.75 0 0 1 .956 1.147Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgSync = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.005 3.762a9.14 9.14 0 0 1 3.97-.903c5.052 0 9.15 4.087 9.15 9.131v1.397a.75.75 0 0 1-1.053.686l-14.97-6.62a.75.75 0 0 1-.282-1.154 9.14 9.14 0 0 1 3.185-2.537Zm3.97.597A7.64 7.64 0 0 0 6.66 6.501l12.965 5.734v-.245c0-4.212-3.424-7.63-7.65-7.63ZM3.6 9.861a.75.75 0 0 1 .75.75v1.396c0 4.218 3.422 7.633 7.65 7.633a7.709 7.709 0 0 0 5.98-2.858.75.75 0 1 1 1.165.944 9.208 9.208 0 0 1-7.144 3.415H12c-5.053 0-9.15-4.085-9.15-9.134v-1.396a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.032 9.407a.75.75 0 0 1 1.049-.011l2.156 2.062A.75.75 0 0 1 5.2 12.542l-1.626-1.556L2.03 12.53a.75.75 0 0 1-1.06-1.06l2.062-2.063ZM17.74 11.482a.75.75 0 0 1 1.06-.024l1.626 1.556 1.544-1.544a.75.75 0 1 1 1.06 1.06l-2.062 2.063a.75.75 0 0 1-1.049.011l-2.156-2.062a.75.75 0 0 1-.024-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTabletLandscape = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tablet-landscape_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 6v12a3.004 3.004 0 0 1-3 3H3a3.003 3.003 0 0 1-3-3V6a3.003 3.003 0 0 1 3-3h18a3.003 3.003 0 0 1 3 3ZM1.5 18A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 21 4.5H3A1.5 1.5 0 0 0 1.5 6v12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 6a3.003 3.003 0 0 1 3-3h18a3.003 3.003 0 0 1 3 3v12a3.004 3.004 0 0 1-3 3H3a3.003 3.003 0 0 1-3-3V6Zm22.5 12V6A1.5 1.5 0 0 0 21 4.5H3A1.5 1.5 0 0 0 1.5 6v12A1.5 1.5 0 0 0 3 19.5h18a1.5 1.5 0 0 0 1.5-1.5Zm-.75 0a.75.75 0 0 1-.75.75H3a.75.75 0 0 1-.75-.75V6A.75.75 0 0 1 3 5.25h18a.75.75 0 0 1 .75.75v12Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tablet-landscape_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgTabletPortrait = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tablet-portrait_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 24H6a3.003 3.003 0 0 1-3-3V3a3.003 3.003 0 0 1 3-3h12a3.003 3.003 0 0 1 3 3v18a3.004 3.004 0 0 1-3 3ZM6 1.5A1.5 1.5 0 0 0 4.5 3v18A1.5 1.5 0 0 0 6 22.5h12a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 18 1.5H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 0a3.003 3.003 0 0 1 3 3v18a3.004 3.004 0 0 1-3 3H6a3.003 3.003 0 0 1-3-3V3a3.003 3.003 0 0 1 3-3h12ZM6 22.5h12a1.5 1.5 0 0 0 1.5-1.5V3A1.5 1.5 0 0 0 18 1.5H6A1.5 1.5 0 0 0 4.5 3v18A1.5 1.5 0 0 0 6 22.5Zm0-.75a.75.75 0 0 1-.75-.75V3A.75.75 0 0 1 6 2.25h12a.75.75 0 0 1 .75.75v18a.75.75 0 0 1-.75.75H6Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tablet-portrait_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgTelescope = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#telescope_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.042 11.719a.75.75 0 0 0-1.024-.275l-2.33 1.344a1.86 1.86 0 0 0-.882 1.168c-.116.484-.04.994.214 1.422l.204.354a1.875 1.875 0 0 0 2.56.685l2.329-1.342a.75.75 0 0 0 .275-1.025L5.042 11.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m17.946 20.662-4.412-8.756a.093.093 0 0 1 .037-.124l.389-.224a.75.75 0 0 0 .275-1.025l-2.228-3.86a.75.75 0 0 0-1.025-.274l-4.05 2.334a1.862 1.862 0 0 0-.873 1.138 1.632 1.632 0 0 0-.065.458c.003.356.432 1.064.85 1.794.45.785.902 1.588 1.234 1.788.212.128.586.23.9.23h.04L5.3 22.185a.75.75 0 1 0 1.362.629l4.391-9.5a.373.373 0 0 1 .153-.167l.9-.519a.092.092 0 0 1 .074-.008.093.093 0 0 1 .057.047l4.369 8.672a.75.75 0 1 0 1.34-.675v-.002ZM22.979 5.426l-2.162-3.738a1.879 1.879 0 0 0-2.561-.685l-4.375 2.52a1.861 1.861 0 0 0-.874 1.139c-.063.2-.083.412-.06.621.082.592.61 1.425 1.238 2.526.636 1.113 1.355 2.366 1.731 2.638a1.883 1.883 0 0 0 2.02.095l4.377-2.522a1.861 1.861 0 0 0 .88-1.165c.117-.486.04-.999-.214-1.429Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "telescope_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgTennisball = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 12a9.03 9.03 0 0 0 1.5-.126A10.5 10.5 0 0 0 12.126 1.5 9.03 9.03 0 0 0 12 3c0 4.963 4.037 9 9 9ZM11.876 22.5A9.243 9.243 0 0 0 12 21.003c0-4.963-4.037-9-9-9-.503 0-1.004.042-1.5.126A10.5 10.5 0 0 0 11.876 22.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.575 10.425A10.43 10.43 0 0 1 10.5 3c0-.47.031-.94.094-1.406a10.505 10.505 0 0 0-9 9C2.06 10.53 2.53 10.5 3 10.5a10.43 10.43 0 0 1 7.425 3.075A10.43 10.43 0 0 1 13.5 21a10.73 10.73 0 0 1-.094 1.407 10.506 10.506 0 0 0 9-9c-.466.062-.936.093-1.406.093a10.43 10.43 0 0 1-7.425-3.075Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTerminal = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 1.5H3.75a3.003 3.003 0 0 0-3 3v15a3.003 3.003 0 0 0 3 3h16.5a3.004 3.004 0 0 0 3-3v-15a3.003 3.003 0 0 0-3-3ZM4.5 12a.75.75 0 0 1-.469-1.335L7.05 8.25 4.03 5.835a.75.75 0 0 1 .938-1.171l3.75 3a.75.75 0 0 1 0 1.171l-3.75 3A.75.75 0 0 1 4.5 12Zm7.5 0H9a.75.75 0 1 1 0-1.5h3a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgText = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m13.716 19.115-5.625-15a1.031 1.031 0 0 0-1.932 0l-5.625 15a1.031 1.031 0 0 0 1.932.724l1.695-4.52a.094.094 0 0 1 .087-.06h5.754a.093.093 0 0 1 .087.06l1.695 4.52a1.032 1.032 0 0 0 1.932-.724ZM5.004 13.07l2.033-5.422a.094.094 0 0 1 .176 0l2.033 5.422a.094.094 0 0 1-.045.116.094.094 0 0 1-.043.011H5.092a.094.094 0 0 1-.088-.127ZM18.786 7.945c-1.956-.015-3.707 1.118-4.453 2.878a1.031 1.031 0 1 0 1.898.806c.417-.98 1.396-1.614 2.5-1.622 1.515-.01 2.738 1.242 2.738 2.759a.07.07 0 0 1-.068.07 39.17 39.17 0 0 0-3.334.225c-2.566.302-4.098 1.701-4.098 3.743 0 1.087.41 2.062 1.156 2.75.7.645 1.656 1 2.688 1 1.453 0 2.704-.375 3.653-1.088h.003a1.032 1.032 0 1 0 2.062.008v-6.703c0-2.633-2.11-4.807-4.745-4.826Zm-.974 10.546c-.821 0-1.78-.442-1.78-1.687 0-.5.179-.85.582-1.136.392-.278.994-.476 1.694-.559.99-.116 2.1-.18 3.053-.21a.094.094 0 0 1 .094.1c-.127 2.349-1.324 3.492-3.642 3.492Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgThermometer = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 13.462V3.797c0-1.646-1.307-3.02-2.953-3.044a3.004 3.004 0 0 0-3.047 3v9.709a.375.375 0 0 1-.15.299A5.319 5.319 0 0 0 6.75 18a5.25 5.25 0 1 0 10.5 0 5.32 5.32 0 0 0-2.1-4.24.375.375 0 0 1-.15-.299Zm-3.09 6.788a2.25 2.25 0 0 1-1.032-4.197.75.75 0 0 0 .375-.649V5.272c0-.403.31-.75.714-.77a.75.75 0 0 1 .783.75v10.152a.758.758 0 0 0 .382.653 2.25 2.25 0 0 1-1.223 4.194Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgThumbsDown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m1.872 8.344 6.758.287c.216.017 1.12.057 1.12 1.213 0 1.115-.898 1.187-1.132 1.213l-6.746.287c-.594-.006-1.122-.677-1.122-1.5s.528-1.494 1.122-1.5Zm6.63 6.171-5.003.391c-.593 0-1.249-.782-1.249-1.588v-.015c0-.766.522-1.39 1.166-1.397l5.084.08c1.25.155 1.25.912 1.25 1.238 0 1.073-1.022 1.273-1.247 1.291ZM4.227 1.5l4.189.419c1.148.043 1.335.808 1.335 1.287 0 .862-.629 1.153-1.25 1.153L4.234 4.5C3.552 4.49 3 3.82 3 3s.547-1.484 1.226-1.5Zm-1.61 3.352 5.924.291c.44.03 1.21.14 1.21 1.236 0 .562-.204 1.2-1.172 1.29l-5.963.183C2 7.845 1.5 7.219 1.5 6.379c0-.84.5-1.52 1.115-1.527ZM17.468 13.085l-.046.094a.763.763 0 0 1 .317-.34.773.773 0 0 0-.27.246Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.185 21.533c.442.623 1.174.967 2.065.967a.75.75 0 0 0 .67-.415c.141-.284.716-1.125 1.322-2.01.844-1.235 1.892-2.77 2.59-3.976l.005-.01c.96-1.664 1.423-2.576 1.585-2.907l.047-.094a.772.772 0 0 1 .625-.338h1.187a3.97 3.97 0 0 0 3.969-3.97V6.97A3.97 3.97 0 0 0 19.28 3h-2.287a.819.819 0 0 1-.449-.135C15.47 2.162 13.437 1.5 11.25 1.5c-.35 0-.665.007-.95.018a.375.375 0 0 0-.29.594l.004.007c.402.58.486 1.21.486 1.631 0 .4-.082.795-.243 1.161a.813.813 0 0 0 0 .66 2.992 2.992 0 0 1 0 2.361.811.811 0 0 0 0 .656 2.913 2.913 0 0 1 0 2.325.85.85 0 0 0 0 .688c.167.376.25.784.243 1.196 0 .384-.094.998-.375 1.461a.735.735 0 0 0-.053.64l.053.149c.056.175.07.36.04.542-.14.907-.453 1.702-.785 2.539-.144.365-.294.741-.432 1.138-.288.823-.202 1.65.237 2.267Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgThumbsUp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m22.128 15.656-6.758-.287c-.216-.017-1.12-.057-1.12-1.213 0-1.116.898-1.187 1.132-1.213l6.746-.287c.594.006 1.122.677 1.122 1.5 0 .824-.528 1.494-1.122 1.5Zm-6.63-6.172 5.003-.39c.593 0 1.249.782 1.249 1.588v.015c0 .765-.522 1.389-1.166 1.397l-5.084-.081c-1.25-.154-1.25-.912-1.25-1.237 0-1.073 1.022-1.273 1.247-1.292ZM19.773 22.5l-4.189-.419c-1.148-.043-1.335-.808-1.335-1.288 0-.861.629-1.153 1.25-1.153l4.266-.14c.681.01 1.234.68 1.234 1.5s-.547 1.484-1.226 1.5Zm1.61-3.352-5.924-.29c-.44-.03-1.21-.141-1.21-1.237 0-.562.204-1.2 1.172-1.29l5.962-.182c.617.006 1.116.632 1.116 1.472s-.5 1.52-1.115 1.527ZM6.531 10.915l.047-.094a.763.763 0 0 1-.317.34.766.766 0 0 0 .27-.246Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.815 2.467c-.442-.624-1.174-.967-2.065-.967a.75.75 0 0 0-.67.414c-.141.285-.716 1.125-1.322 2.012C9.914 5.16 8.866 6.695 8.168 7.9l-.005.01c-.96 1.664-1.423 2.575-1.586 2.907l-.046.094a.766.766 0 0 1-.272.244.741.741 0 0 1-.353.094H4.72a3.97 3.97 0 0 0-3.97 3.97v1.81A3.97 3.97 0 0 0 4.72 21h2.287c.16 0 .316.048.449.136 1.075.702 3.107 1.364 5.294 1.364.35 0 .665-.007.95-.018a.375.375 0 0 0 .29-.594l-.004-.007c-.402-.58-.486-1.21-.486-1.631 0-.4.082-.795.243-1.161a.814.814 0 0 0 0-.659 2.99 2.99 0 0 1 0-2.362.811.811 0 0 0 0-.656 2.912 2.912 0 0 1 0-2.325.85.85 0 0 0 0-.688 2.828 2.828 0 0 1-.243-1.196c0-.384.094-.998.375-1.462a.732.732 0 0 0 .053-.64 4.056 4.056 0 0 1-.053-.148 1.163 1.163 0 0 1-.04-.543c.14-.906.453-1.7.785-2.538.144-.365.294-.742.432-1.138.288-.823.202-1.65-.237-2.267Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgThunderstorm = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#thunderstorm_svg__a)",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.5 19.5a.75.75 0 0 1-.67-1.085l1.125-2.25a.75.75 0 1 1 1.341.671l-1.125 2.25a.75.75 0 0 1-.671.415ZM5.625 22.5a.75.75 0 0 1-.67-1.085l.75-1.5a.75.75 0 1 1 1.341.671l-.75 1.5a.75.75 0 0 1-.671.415ZM17.625 19.5a.75.75 0 0 1-.67-1.085l1.124-2.25a.75.75 0 0 1 1.342.671l-1.125 2.25a.75.75 0 0 1-.671.415ZM18.75 22.5a.75.75 0 0 1-.67-1.085l.75-1.5a.75.75 0 0 1 1.341.671l-.75 1.5a.75.75 0 0 1-.671.415Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.024 6.418a7.09 7.09 0 0 0-2.232-3.84A7.172 7.172 0 0 0 5.459 5.01 5.009 5.009 0 0 0 .75 10c0 2.758 2.246 5 5.006 5h3.109l-.605 3.627a.75.75 0 0 0 .74.874h1.5v3a.75.75 0 0 0 1.36.436l3.75-5.25A.75.75 0 0 0 15 16.5h-1.29l.375-1.5h4.868a4.292 4.292 0 0 0 .07-8.583Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "thunderstorm_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgTicket = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ticket_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.977 8.503 20.91 6.435a.938.938 0 0 0-1.266-.047 1.444 1.444 0 0 1-1.954-.075 1.444 1.444 0 0 1-.075-1.954.937.937 0 0 0-.047-1.265l-2.07-2.071a.933.933 0 0 0-1.319 0L10.881 4.32a1.868 1.868 0 0 0-.449.727.361.361 0 0 1-.226.226 1.864 1.864 0 0 0-.727.45l-8.456 8.455a.933.933 0 0 0 0 1.319l2.07 2.069a.938.938 0 0 0 1.266.046 1.438 1.438 0 0 1 2.03 2.03.938.938 0 0 0 .046 1.265l2.069 2.068a.933.933 0 0 0 1.318 0l8.457-8.456c.203-.204.357-.453.448-.726a.362.362 0 0 1 .227-.227c.274-.091.522-.245.726-.449l3.298-3.297a.933.933 0 0 0 0-1.317Zm-10.705-1.39a.75.75 0 0 1-1.06 0l-.54-.54a.75.75 0 0 1 1.06-1.06l.54.54a.75.75 0 0 1 0 1.06Zm2.063 2.063a.75.75 0 0 1-1.06 0l-.516-.516a.751.751 0 0 1 1.06-1.06l.516.515a.75.75 0 0 1 0 1.062v-.001Zm2.062 2.062a.75.75 0 0 1-1.06 0l-.516-.515a.75.75 0 0 1 1.06-1.06l.516.515a.748.748 0 0 1 .003 1.063l-.003-.003Zm2.083 2.088a.749.749 0 0 1-1.06 0l-.537-.539a.751.751 0 1 1 1.063-1.058l.537.539a.75.75 0 0 1 0 1.06l-.003-.002Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ticket_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
};

const SvgTime = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25c-5.385 0-9.75 4.365-9.75 9.75 0 5.384 4.365 9.75 9.75 9.75 5.384 0 9.75-4.366 9.75-9.75 0-5.385-4.366-9.75-9.75-9.75Zm4.5 11.25H12a.75.75 0 0 1-.75-.75V6a.75.75 0 1 1 1.5 0v6h3.75a.75.75 0 1 1 0 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTimer = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12 2.25A9.75 9.75 0 0 0 2.25 12 9.75 9.75 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25ZM8.14 7.61l4.923 3.328a1.523 1.523 0 0 1-1.746 2.496 1.557 1.557 0 0 1-.375-.375L7.613 8.138a.381.381 0 0 1 .531-.531l-.003.003ZM12 20.25c-4.547 0-8.25-3.7-8.25-8.25a8.182 8.182 0 0 1 2.525-5.94.663.663 0 1 1 .92.955A6.869 6.869 0 0 0 5.078 12 6.931 6.931 0 0 0 12 18.923 6.931 6.931 0 0 0 18.923 12c0-3.594-2.752-6.557-6.26-6.89v2.577a.663.663 0 0 1-1.326 0V4.413A.663.663 0 0 1 12 3.75c4.55 0 8.25 3.703 8.25 8.25 0 4.547-3.7 8.25-8.25 8.25Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgToday = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 3h-.75v-.73c0-.403-.31-.75-.714-.77a.75.75 0 0 0-.786.75V3H6.75v-.73c0-.403-.31-.75-.714-.77a.75.75 0 0 0-.786.75V3H4.5a3 3 0 0 0-3 3v.562a.187.187 0 0 0 .188.188h20.625a.188.188 0 0 0 .187-.188V6a3 3 0 0 0-3-3ZM22.36 8.25H1.64a.14.14 0 0 0-.14.14V19.5a3 3 0 0 0 3 3h15a3 3 0 0 0 3-3V8.39a.14.14 0 0 0-.14-.14ZM10.5 14.41a1.34 1.34 0 0 1-1.34 1.34H5.84a1.34 1.34 0 0 1-1.34-1.34v-3.32a1.34 1.34 0 0 1 1.34-1.34h3.32a1.34 1.34 0 0 1 1.34 1.34v3.32Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgToggle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.25 5.25H6.75A6.758 6.758 0 0 0 0 12a6.758 6.758 0 0 0 6.75 6.75h10.5A6.758 6.758 0 0 0 24 12a6.758 6.758 0 0 0-6.75-6.75Zm0 12a5.25 5.25 0 1 1 0-10.499 5.25 5.25 0 0 1 0 10.499Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTrailSign = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m23.03 15.22-2.78-2.78a1.49 1.49 0 0 0-1.06-.44h-6.44v-1.5h6.75A1.5 1.5 0 0 0 21 9V4.5A1.5 1.5 0 0 0 19.5 3h-6.75v-.75a.75.75 0 1 0-1.5 0V3H4.81a1.49 1.49 0 0 0-1.06.44L.97 6.22a.75.75 0 0 0 0 1.06l2.78 2.78a1.49 1.49 0 0 0 1.06.44h6.44V12H4.5A1.5 1.5 0 0 0 3 13.5V18a1.5 1.5 0 0 0 1.5 1.5h6.75v2.25a.75.75 0 1 0 1.5 0V19.5h6.44a1.491 1.491 0 0 0 1.06-.44l2.78-2.78a.75.75 0 0 0 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTrain = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.059 15.31a1.5 1.5 0 0 0 .003-2.122 1.5 1.5 0 0 0-2.12.004 1.5 1.5 0 0 0-.004 2.121 1.5 1.5 0 0 0 2.12-.004Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.5 1.5h-.703a.469.469 0 0 1-.369-.177A1.497 1.497 0 0 0 14.25.75h-4.5a1.5 1.5 0 0 0-1.224.634.281.281 0 0 1-.23.116H7.5c-1.725 0-3 1.352-3 3v11.953c0 1.09 1.2 1.972 3.89 2.857 1.137.366 2.291.675 3.459.925.1.02.203.02.302 0a35.287 35.287 0 0 0 3.458-.925c2.691-.885 3.891-1.766 3.891-2.857V4.5a3 3 0 0 0-3-3ZM8.625 6h6.75a.375.375 0 0 1 .375.375v2.25a.375.375 0 0 1-.375.375h-6.75a.375.375 0 0 1-.375-.375v-2.25A.375.375 0 0 1 8.625 6Zm3.57 11.244a3 3 0 1 1-.39-5.987 3 3 0 0 1 .39 5.987Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.53 21.97-2.235-2.235a.763.763 0 0 0-1.049-.04.75.75 0 0 0-.026 1.085l.22.22H8.56l.205-.205a.763.763 0 0 0 .04-1.05.75.75 0 0 0-1.085-.026l-2.25 2.25a.75.75 0 1 0 1.06 1.06l.53-.529h9.88l.53.53a.75.75 0 0 0 1.06-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTransgender = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.469 1.5H18.28a1.031 1.031 0 1 0 0 2.063h.698l-2.792 2.792a7.017 7.017 0 0 0-8.374 0L7.458 6l1.24-1.24A1.032 1.032 0 0 0 7.24 3.303L6 4.542l-.98-.98h.699a1.031 1.031 0 1 0 0-2.062H2.53A1.031 1.031 0 0 0 1.5 2.531V5.72a1.031 1.031 0 1 0 2.063 0V5.02L4.542 6 3.303 7.238a1.031 1.031 0 1 0 1.459 1.459L6 7.458l.355.355A6.993 6.993 0 0 0 4.969 12 7.04 7.04 0 0 0 12 19.031a6.994 6.994 0 0 0 4.193-1.39l1.104 1.104-1.244 1.244a1.032 1.032 0 0 0 1.459 1.46l1.241-1.243 1.986 1.991A1.031 1.031 0 1 0 22.2 20.74l-1.989-1.99 1.237-1.237a1.031 1.031 0 1 0-1.459-1.459l-1.235 1.235-1.104-1.107a7.017 7.017 0 0 0-.005-8.367l2.793-2.794v.698a1.032 1.032 0 0 0 2.062 0V2.53A1.031 1.031 0 0 0 21.469 1.5ZM7.03 12a4.969 4.969 0 1 1 9.938 0 4.969 4.969 0 0 1-9.938 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTrashBin = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21 2.25H3a1.5 1.5 0 0 0-1.5 1.5v.75A1.5 1.5 0 0 0 3 6h18a1.5 1.5 0 0 0 1.5-1.5v-.75a1.5 1.5 0 0 0-1.5-1.5ZM3.49 7.5a.375.375 0 0 0-.375.414l1.233 11.839v.01a2.25 2.25 0 0 0 2.236 1.987h10.832a2.25 2.25 0 0 0 2.235-1.987v-.01l1.231-11.84a.376.376 0 0 0-.375-.413H3.49Zm11.665 8.47a.75.75 0 1 1-1.06 1.06L12 14.936 9.905 17.03a.75.75 0 0 1-1.06-1.06l2.094-2.095-2.095-2.095a.75.75 0 0 1 1.061-1.06L12 12.814l2.095-2.094a.75.75 0 0 1 1.06 1.06l-2.095 2.095 2.095 2.095Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTrash = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.25 4.5h-4.5V3.375A1.875 1.875 0 0 0 13.875 1.5h-3.75A1.875 1.875 0 0 0 8.25 3.375V4.5h-4.5a.75.75 0 0 0 0 1.5h.797l.89 14.293c.067 1.259 1.032 2.207 2.25 2.207h8.625c1.225 0 2.17-.927 2.25-2.203L19.453 6h.797a.75.75 0 1 0 0-1.5Zm-11.223 15H9a.75.75 0 0 1-.75-.723l-.375-10.5a.75.75 0 0 1 1.5-.054l.375 10.5a.75.75 0 0 1-.723.777Zm3.723-.75a.75.75 0 1 1-1.5 0V8.25a.75.75 0 1 1 1.5 0v10.5Zm1.5-14.25h-4.5V3.375A.37.37 0 0 1 10.125 3h3.75a.371.371 0 0 1 .375.375V4.5Zm1.5 14.277a.75.75 0 0 1-.75.723h-.027a.75.75 0 0 1-.723-.777l.375-10.5a.75.75 0 0 1 1.5.054l-.375 10.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTrendingDown = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.75 11.25a.75.75 0 0 1 .75.75v5.25a.75.75 0 0 1-.75.75H16.5a.75.75 0 0 1 0-1.5H21V12a.75.75 0 0 1 .75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.72 6.22a.75.75 0 0 1 1.06 0l5.69 5.689a.75.75 0 0 0 1.06 0L11.91 9.53a2.25 2.25 0 0 1 3.182 0l6.44 6.439a.75.75 0 1 1-1.061 1.06l-6.44-6.439a.75.75 0 0 0-1.06 0L10.59 12.97a2.25 2.25 0 0 1-3.182 0l-5.69-5.69a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTrendingUp = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.75 6.75A.75.75 0 0 1 16.5 6h5.25a.75.75 0 0 1 .75.75V12a.75.75 0 0 1-1.5 0V7.5h-4.5a.75.75 0 0 1-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.53 6.97a.75.75 0 0 1 0 1.06l-6.439 6.44a2.25 2.25 0 0 1-3.182 0L9.53 12.09a.75.75 0 0 0-1.06 0l-5.69 5.69a.75.75 0 0 1-1.06-1.061l5.689-5.69a2.25 2.25 0 0 1 3.182 0l2.379 2.379a.75.75 0 0 0 1.06 0l6.44-6.44a.75.75 0 0 1 1.06 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTriangle = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 21.75H2.25a.75.75 0 0 1-.66-1.107l9.75-18a.75.75 0 0 1 1.32 0l9.75 18a.75.75 0 0 1-.66 1.107Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTrophy = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 3.75h-2.817a.188.188 0 0 1-.188-.188v-.566a1.5 1.5 0 0 0-1.5-1.496l-10.49.012A1.5 1.5 0 0 0 5.258 3.01v.554a.188.188 0 0 1-.188.187H2.25a.75.75 0 0 0-.75.75v.75c0 2.556 1.406 5.271 3.587 5.876a.366.366 0 0 1 .26.276c.27 1.26 1.103 2.461 2.41 3.45.98.743 2.15 1.29 3.2 1.523a.375.375 0 0 1 .293.366v4.072a.188.188 0 0 1-.188.187h-2.79c-.405 0-.75.31-.771.714a.75.75 0 0 0 .749.786h7.479c.404 0 .75-.31.77-.714A.752.752 0 0 0 15.75 21h-2.813a.188.188 0 0 1-.187-.188v-4.071a.375.375 0 0 1 .293-.366c1.05-.234 2.22-.78 3.2-1.522 1.308-.99 2.14-2.19 2.41-3.45a.367.367 0 0 1 .26-.277c2.18-.605 3.587-3.32 3.587-5.876V4.5a.75.75 0 0 0-.75-.75ZM5.25 9.292a.187.187 0 0 1-.281.161c-.481-.286-.832-.72-1.038-1.026-.558-.829-.89-1.906-.928-2.982a.188.188 0 0 1 .188-.195h1.875a.187.187 0 0 1 .187.188c0 1.286-.003 2.759-.003 3.854Zm14.819-.865c-.206.306-.557.74-1.038 1.026a.187.187 0 0 1-.281-.162c0-1.243 0-2.654-.002-3.854a.187.187 0 0 1 .187-.187h1.875a.187.187 0 0 1 .188.195c-.037 1.076-.37 2.153-.929 2.982Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgTv = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20.993 18H3.007A2.259 2.259 0 0 1 .75 15.743V6.007A2.26 2.26 0 0 1 3.007 3.75h17.986a2.26 2.26 0 0 1 2.257 2.257v9.736A2.259 2.259 0 0 1 20.993 18Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 19.5a.75.75 0 0 1 .75-.75h12a.75.75 0 0 1 0 1.5H6a.75.75 0 0 1-.75-.75Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgUmbrella = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.424 5.326a10.419 10.419 0 0 0-6.39-3.025.379.379 0 0 1-.323-.264.74.74 0 0 0-1.423 0 .38.38 0 0 1-.322.264A10.5 10.5 0 0 0 1.5 12.728a.77.77 0 0 0 .34.65.75.75 0 0 0 .94-.097 2.433 2.433 0 0 1 3.437-.003.746.746 0 0 0 1.059.007 2.934 2.934 0 0 1 3.82-.275.387.387 0 0 1 .154.309v6.91c0 .403-.31.75-.712.77a.75.75 0 0 1-.788-.748.75.75 0 0 0-.764-.75c-.421.007-.745.38-.736.801a2.253 2.253 0 0 0 2.22 2.199c1.26.015 2.28-1.028 2.28-2.288v-6.894a.387.387 0 0 1 .154-.31 2.934 2.934 0 0 1 3.816.272.75.75 0 0 0 1.06 0 2.434 2.434 0 0 1 3.44 0 .75.75 0 0 0 .916.113.769.769 0 0 0 .364-.666 10.432 10.432 0 0 0-3.076-7.402Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgUnlink = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75 8.625a3.375 3.375 0 0 0 0 6.75h2.656a1.125 1.125 0 1 1 0 2.25H6.75a5.625 5.625 0 1 1 0-11.25h2.597a1.125 1.125 0 0 1 0 2.25H6.75ZM13.528 7.5c0-.621.503-1.125 1.125-1.125h2.597a5.625 5.625 0 1 1 0 11.25h-2.656a1.125 1.125 0 0 1 0-2.25h2.656a3.375 3.375 0 0 0 0-6.75h-2.597A1.125 1.125 0 0 1 13.528 7.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgVideocamOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15.75 8.415a3.165 3.165 0 0 0-3.165-3.165H8.872a.187.187 0 0 0-.132.32l6.69 6.69a.188.188 0 0 0 .32-.133V8.415ZM.75 8.438v7.125a3.188 3.188 0 0 0 3.188 3.188h8.624c.732 0 1.442-.252 2.009-.715a.187.187 0 0 0 .015-.281L2.55 5.719a.187.187 0 0 0-.228-.029A3.187 3.187 0 0 0 .75 8.438ZM21.75 18.018a1.5 1.5 0 0 1-.61-.13.747.747 0 0 1-.126-.072l-3.877-2.73a1.5 1.5 0 0 1-.637-1.226v-3.722a1.5 1.5 0 0 1 .637-1.226l3.877-2.729a.742.742 0 0 1 .127-.072 1.5 1.5 0 0 1 2.109 1.37v9.036a1.5 1.5 0 0 1-1.5 1.5Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.22 3.22a.75.75 0 0 1 1.06 0l15.75 15.75a.75.75 0 1 1-1.06 1.06L3.22 4.28a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgVideocam = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.75 18.018a1.5 1.5 0 0 1-.61-.13.747.747 0 0 1-.126-.072l-3.877-2.73a1.5 1.5 0 0 1-.637-1.226v-3.722a1.5 1.5 0 0 1 .637-1.226l3.877-2.729a.742.742 0 0 1 .127-.072 1.5 1.5 0 0 1 2.109 1.37v9.036a1.5 1.5 0 0 1-1.5 1.5ZM12.563 18.75H3.937A3.19 3.19 0 0 1 .75 15.562V8.439A3.19 3.19 0 0 1 3.938 5.25h8.647a3.169 3.169 0 0 1 3.165 3.165v7.148a3.19 3.19 0 0 1-3.188 3.187Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgVolumeHigh = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.875 19.5a1.12 1.12 0 0 1-.697-.243L5.895 15.75h-3.27A1.125 1.125 0 0 1 1.5 14.625v-5.25A1.125 1.125 0 0 1 2.625 8.25h3.27l4.283-3.507A1.125 1.125 0 0 1 12 5.625v12.75a1.125 1.125 0 0 1-1.125 1.125ZM15 15.75a.75.75 0 0 1-.67-1.088c.445-.884.67-1.781.67-2.663 0-.908-.218-1.778-.667-2.659a.75.75 0 0 1 1.335-.681c.56 1.096.832 2.19.832 3.34 0 1.119-.281 2.241-.83 3.337a.75.75 0 0 1-.67.413Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 18a.75.75 0 0 1-.65-1.125c.886-1.543 1.4-2.836 1.4-4.876 0-2.07-.512-3.354-1.398-4.872a.75.75 0 0 1 1.296-.755C18.887 8.067 19.5 9.6 19.5 11.999c0 2.364-.612 3.905-1.6 5.626a.75.75 0 0 1-.65.375Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5 20.25a.75.75 0 0 1-.628-1.16C20.15 17.131 21 15.176 21 12c0-3.117-.852-5.092-2.132-7.097a.75.75 0 0 1 .795-1.136.75.75 0 0 1 .47.33C21.553 6.322 22.5 8.518 22.5 12c0 3.035-.687 5.326-2.372 7.91a.749.749 0 0 1-.628.34Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgVolumeLow = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M13.875 19.509c-.24 0-.473-.077-.666-.22l-.031-.024-4.287-3.516H5.625A1.125 1.125 0 0 1 4.5 14.624v-5.25A1.125 1.125 0 0 1 5.625 8.25H8.89l4.287-3.516.031-.024A1.125 1.125 0 0 1 15 5.617v12.766a1.125 1.125 0 0 1-1.125 1.125ZM18 15.75a.749.749 0 0 1-.67-1.087c.445-.886.67-1.781.67-2.664 0-.907-.218-1.777-.668-2.659a.75.75 0 0 1 1.337-.681c.56 1.098.831 2.19.831 3.34 0 1.117-.281 2.24-.83 3.337a.75.75 0 0 1-.67.413Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgVolumeMedium = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.375 19.509c-.24 0-.473-.077-.666-.22l-.031-.024-4.287-3.516H4.125A1.125 1.125 0 0 1 3 14.624v-5.25A1.125 1.125 0 0 1 4.125 8.25H7.39l4.287-3.516.031-.024a1.125 1.125 0 0 1 1.792.907v12.766a1.125 1.125 0 0 1-1.125 1.125ZM16.5 15.75a.749.749 0 0 1-.67-1.087c.445-.886.67-1.781.67-2.664 0-.907-.218-1.777-.668-2.659a.75.75 0 0 1 1.337-.681c.56 1.098.831 2.19.831 3.34 0 1.117-.281 2.24-.83 3.337a.75.75 0 0 1-.67.413Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.75 18a.75.75 0 0 1-.65-1.124c.884-1.545 1.4-2.839 1.4-4.875 0-2.068-.513-3.353-1.398-4.873a.75.75 0 0 1 1.296-.752C20.387 8.07 21 9.604 21 12c0 2.36-.612 3.902-1.6 5.625a.752.752 0 0 1-.65.375Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgVolumeMute = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.47 3.22a.75.75 0 0 1 1.06 0l16.5 16.5a.75.75 0 1 1-1.06 1.06L2.47 4.28a.75.75 0 0 1 0-1.06Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.406 4.634a1.12 1.12 0 0 0-1.198.085l-.03.024L8.84 5.838a.375.375 0 0 0-.028.555L11.36 8.94a.375.375 0 0 0 .64-.265V5.652a1.149 1.149 0 0 0-.594-1.018ZM11.781 15.717 4.532 8.47a.75.75 0 0 0-.53-.22H2.625A1.125 1.125 0 0 0 1.5 9.375v5.25a1.125 1.125 0 0 0 1.125 1.125h3.27l4.313 3.53a1.121 1.121 0 0 0 1.212.08 1.15 1.15 0 0 0 .58-1.01v-2.104a.75.75 0 0 0-.219-.53ZM16.5 12c0-1.152-.272-2.244-.832-3.341a.75.75 0 1 0-1.336.682c.45.88.668 1.75.668 2.659 0 .125-.005.252-.014.38a.375.375 0 0 0 .108.294l.673.673a.375.375 0 0 0 .636-.202c.064-.378.097-.761.097-1.145ZM19.5 12c0-2.4-.613-3.933-1.602-5.628a.75.75 0 0 0-1.296.755C17.488 8.645 18 9.93 18 12c0 1.118-.154 2.01-.44 2.843a.375.375 0 0 0 .09.388l.584.585a.376.376 0 0 0 .616-.13c.416-1.072.65-2.22.65-3.686Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 12c0-3.48-.946-5.677-2.368-7.904a.75.75 0 1 0-1.265.807C20.147 6.908 21 8.883 21 12c0 2.165-.395 3.762-1.051 5.18a.375.375 0 0 0 .074.423l.559.558a.375.375 0 0 0 .605-.1c.92-1.894 1.313-3.764 1.313-6.061Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgVolumeOff = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.125 19.5a1.122 1.122 0 0 1-.697-.244l-4.287-3.51H7.875A1.125 1.125 0 0 1 6.75 14.62V9.378a1.125 1.125 0 0 1 1.125-1.125h3.265l4.287-3.51a1.125 1.125 0 0 1 1.823.883v12.749a1.125 1.125 0 0 1-1.125 1.125Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgWalk = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m14.65 22.495-2.644-5.344-2.091-2.672a3.393 3.393 0 0 1-.472-1.73V6.733h.729a1.875 1.875 0 0 1 1.875 1.875v8.54",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.693 6.733a.75.75 0 0 1 .75-.75h.729a2.625 2.625 0 0 1 2.625 2.625v8.45l2.526 5.104a.75.75 0 0 1-1.344.665l-2.61-5.274-2.045-2.612a.75.75 0 0 1-.055-.08 4.143 4.143 0 0 1-.576-2.112V6.733Zm2.604 8.295v-6.42a1.125 1.125 0 0 0-1.104-1.125v5.267c0 .459.118.91.344 1.308l.76.97Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.721 10.39a11.864 11.864 0 0 1 .934-1.47c.307-.41.643-.789.98-1.06.35-.278.62-.377.808-.377a.75.75 0 1 0 0-1.5c-.68 0-1.279.334-1.744.706-.476.381-.899.87-1.244 1.33a13.366 13.366 0 0 0-1.148 1.836l-.005.01-.001.003v.001l.67.336-.671-.336a.75.75 0 0 0-.079.336v3.472a.75.75 0 0 0 1.5 0v-3.288Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.254 13.678a.866.866 0 0 1-.48-.146l-2.82-1.812a.992.992 0 0 1-.454-.834V9.775a.265.265 0 0 1 .407-.224l3.828 2.537a.868.868 0 0 1-.483 1.59h.002ZM8.058 23.13a.867.867 0 0 1-.695-.347c-.288-.383-.187-.805.174-1.215l2.81-3.5a.347.347 0 0 1 .504.097c.073.12.158.265.243.426.246.467.282.755-.078 1.205-.375.469-2.438 3.161-2.438 3.161-.123.14-.339.174-.52.174ZM12.047 4.997a1.736 1.736 0 1 0 0-3.472 1.736 1.736 0 0 0 0 3.472Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.047 1.9a1.361 1.361 0 1 0 0 2.722 1.361 1.361 0 0 0 0-2.722ZM9.936 3.26a2.111 2.111 0 1 1 4.222 0 2.111 2.111 0 0 1-4.222 0Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgWallet = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M4.477 4.876h15c.175 0 .35.01.524.033a3.094 3.094 0 0 0-3.634-2.604L4.031 4.41h-.014a3.094 3.094 0 0 0-1.925 1.225 4.105 4.105 0 0 1 2.385-.76ZM19.477 6h-15a3.003 3.003 0 0 0-3 3v9a3.003 3.003 0 0 0 3 3h15a3.003 3.003 0 0 0 3-3V9a3.004 3.004 0 0 0-3-3Zm-2.227 9a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.5 12.164V7.5c0-1.016.563-2.719 2.515-3.088 1.657-.31 3.298-.31 3.298-.31s1.078.75.187.75C6.61 4.852 6.633 6 7.5 6s0 1.102 0 1.102l-3.492 3.96L1.5 12.165Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgWarning = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M21.05 18.707 13.061 3.87c-.566-1.052-2.074-1.052-2.641 0L2.43 18.707a1.5 1.5 0 0 0 1.32 2.211h15.978a1.5 1.5 0 0 0 1.321-2.211Zm-9.31-.086a.938.938 0 1 1 .001-1.875.938.938 0 0 1 0 1.875Zm1.019-9.429-.27 5.719a.75.75 0 1 1-1.5 0l-.268-5.716a1.02 1.02 0 0 1 1.008-1.064h.01a1.019 1.019 0 0 1 1.018 1.064l.002-.003Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgWatch = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M15 6.375H9A2.625 2.625 0 0 0 6.375 9v6A2.625 2.625 0 0 0 9 17.625h6A2.625 2.625 0 0 0 17.625 15V9A2.625 2.625 0 0 0 15 6.375Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 4.5v-3A.75.75 0 0 0 15 .75H9a.75.75 0 0 0-.75.75v3A3.754 3.754 0 0 0 4.5 8.25v7.5a3.754 3.754 0 0 0 3.75 3.75v3a.75.75 0 0 0 .75.75h6a.75.75 0 0 0 .75-.75v-3a3.754 3.754 0 0 0 3.75-3.75v-7.5a3.754 3.754 0 0 0-3.75-3.75ZM18.375 15A3.379 3.379 0 0 1 15 18.375H9A3.379 3.379 0 0 1 5.625 15V9A3.379 3.379 0 0 1 9 5.625h6A3.379 3.379 0 0 1 18.375 9v6Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgWater = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M12.428 2.817a.562.562 0 0 0-.855 0C10.089 4.553 5.25 10.554 5.25 15c0 4.143 2.608 6.75 6.75 6.75 4.142 0 6.75-2.607 6.75-6.75 0-4.445-4.839-10.446-6.322-12.182Zm.322 16.495a.564.564 0 1 1 .003-1.125 2.815 2.815 0 0 0 2.81-2.81.557.557 0 0 1 .64-.561.564.564 0 0 1 .485.558 3.942 3.942 0 0 1-3.938 3.938Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgWifi = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 14.263a6.375 6.375 0 0 0-8.472 0 .985.985 0 1 0 1.309 1.471 4.406 4.406 0 0 1 5.854 0 .985.985 0 0 0 1.308-1.472v.001Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.013 8.611c-2.643-.003-5.188 1.001-7.116 2.81a.985.985 0 1 0 1.345 1.437 8.45 8.45 0 0 1 11.542 0 .985.985 0 1 0 1.345-1.438 10.382 10.382 0 0 0-7.116-2.809Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.656 8.243a14.484 14.484 0 0 0-19.286 0A.984.984 0 1 0 3.683 9.71a12.516 12.516 0 0 1 16.66 0 .984.984 0 1 0 1.313-1.468ZM12.013 19.94a1.5 1.5 0 1 0 0-2.999 1.5 1.5 0 0 0 0 3Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgWine = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M19.433 4.45v-.7a.75.75 0 0 0-.75-.75H5.318a.75.75 0 0 0-.75.75v.7c-.069.532-.453 4.253 1.73 6.782 1.166 1.35 2.83 2.102 4.952 2.243V19.5H7.5a.75.75 0 1 0 0 1.5h9a.75.75 0 1 0 0-1.5h-3.75v-6.025c2.122-.14 3.786-.893 4.951-2.243 2.184-2.53 1.799-6.25 1.732-6.783Zm-13.374.16a.71.71 0 0 0 .009-.11h11.865c0 .037.002.073.008.11.08.71.08 1.429 0 2.14H6.061a9.576 9.576 0 0 1-.002-2.14Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

const SvgWoman = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 19,
    height: props.size || 19,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M11.988 5.25a2.625 2.625 0 1 0 0-5.25 2.625 2.625 0 0 0 0 5.25ZM18.498 13.026l-.484-1.613v-.005L16.961 7.9h-.002l-.118-.396A2.103 2.103 0 0 0 14.826 6H9.2a2.102 2.102 0 0 0-2.016 1.504l-.118.396h-.003l-1.052 3.51v.004l-.486 1.613c-.147.487.107 1.016.589 1.179a.937.937 0 0 0 1.2-.618l1.199-3.996.102-.339a.375.375 0 0 1 .72.198l-2.05 6.834a.75.75 0 0 0 .718.966h1.36v5.376c0 .771.493 1.374 1.124 1.374.632 0 1.125-.603 1.125-1.374V17.25h.75v5.376c0 .771.494 1.374 1.125 1.374.632 0 1.125-.603 1.125-1.374V17.25h1.407a.75.75 0 0 0 .718-.966l-2.05-6.835a.374.374 0 0 1 .72-.198l.102.34 1.199 3.995a.939.939 0 0 0 1.2.617c.48-.161.735-.69.59-1.177Z",
    fill: !props.color ? '#242424' : props.color === 'inherit' ? 'currentColor' : props.color
  }));
};

export { SvgAccessibility as Accessibility, SvgAdd as Add, SvgAddCircle as AddCircle, SvgAirplane as Airplane, SvgAlarm as Alarm, SvgAlbums as Albums, SvgAlert as Alert, SvgAlertCircle as AlertCircle, SvgAmericanFootball as AmericanFootball, SvgAnalytics as Analytics, SvgAperture as Aperture, SvgApps as Apps, SvgArchive as Archive, SvgArrowBack as ArrowBack, SvgArrowBackCircle as ArrowBackCircle, SvgArrowDown as ArrowDown, SvgArrowDownCircle as ArrowDownCircle, SvgArrowForward as ArrowForward, SvgArrowForwardCircle as ArrowForwardCircle, SvgArrowRedo as ArrowRedo, SvgArrowRedoCircle as ArrowRedoCircle, SvgArrowUndo as ArrowUndo, SvgArrowUndoCircle as ArrowUndoCircle, SvgArrowUp as ArrowUp, SvgArrowUpCircle as ArrowUpCircle, SvgAtCircle as AtCircle, SvgAttach as Attach, SvgBackspace as Backspace, SvgBag as Bag, SvgBagAdd as BagAdd, SvgBagCheck as BagCheck, SvgBagHandle as BagHandle, SvgBagRemove as BagRemove, SvgBan as Ban, SvgBandage as Bandage, SvgBarChart as BarChart, SvgBarbell as Barbell, SvgBarcode as Barcode, SvgBaseball as Baseball, SvgBasket as Basket, SvgBasketball as Basketball, SvgBatteryCharging as BatteryCharging, SvgBatteryDead as BatteryDead, SvgBatteryFull as BatteryFull, SvgBatteryHalf as BatteryHalf, SvgBeaker as Beaker, SvgBed as Bed, SvgBeer as Beer, SvgBicycle as Bicycle, SvgBluetooth as Bluetooth, SvgBoat as Boat, SvgBody as Body, SvgBonfire as Bonfire, SvgBook as Book, SvgBookmark as Bookmark, SvgBookmarks as Bookmarks, SvgBriefcase as Briefcase, SvgBrowsers as Browsers, SvgBrush as Brush, SvgBug as Bug, SvgBuild as Build, SvgBulb as Bulb, SvgBus as Bus, SvgBusiness as Business, SvgCafe as Cafe, SvgCalculator as Calculator, SvgCalendar as Calendar, SvgCalendarClear as CalendarClear, SvgCall as Call, SvgCamera as Camera, SvgCameraReverse as CameraReverse, SvgCar as Car, SvgCarSport as CarSport, SvgCard as Card, SvgCaretBack as CaretBack, SvgCaretBackCircle as CaretBackCircle, SvgCaretDown as CaretDown, SvgCaretDownCircle as CaretDownCircle, SvgCaretForward as CaretForward, SvgCaretForwardCircle as CaretForwardCircle, SvgCaretUp as CaretUp, SvgCaretUpCircle as CaretUpCircle, SvgCart as Cart, SvgCash as Cash, SvgCellular as Cellular, SvgChatbox as Chatbox, SvgChatboxEllipses as ChatboxEllipses, SvgChatbubble as Chatbubble, SvgChatbubbleEllipses as ChatbubbleEllipses, SvgChatbubbles as Chatbubbles, SvgCheckbox as Checkbox, SvgCheckmark as Checkmark, SvgCheckmarkCircle as CheckmarkCircle, SvgCheckmarkDone as CheckmarkDone, SvgCheckmarkDoneCircle as CheckmarkDoneCircle, SvgChevronBack as ChevronBack, SvgChevronBackCircle as ChevronBackCircle, SvgChevronDown as ChevronDown, SvgChevronDownCircle as ChevronDownCircle, SvgChevronForward as ChevronForward, SvgChevronForwardCircle as ChevronForwardCircle, SvgChevronUp as ChevronUp, SvgChevronUpCircle as ChevronUpCircle, SvgClipboard as Clipboard, SvgClose as Close, SvgCloseCircle as CloseCircle, SvgCloud as Cloud, SvgCloudCircle as CloudCircle, SvgCloudDone as CloudDone, SvgCloudDownload as CloudDownload, SvgCloudOffline as CloudOffline, SvgCloudUpload as CloudUpload, SvgCloudy as Cloudy, SvgCloudyNight as CloudyNight, SvgCode as Code, SvgCodeDownload as CodeDownload, SvgCodeSlash as CodeSlash, SvgCodeWorking as CodeWorking, SvgCog as Cog, SvgColorFill as ColorFill, SvgColorFilter as ColorFilter, SvgColorPalette as ColorPalette, SvgColorWand as ColorWand, SvgCompass as Compass, SvgConstruct as Construct, SvgContract as Contract, SvgContrast as Contrast, SvgCopy as Copy, SvgCreate as Create, SvgCrop as Crop, SvgCube as Cube, SvgCut as Cut, SvgDesktop as Desktop, SvgDice as Dice, SvgDisc as Disc, SvgDocument as Document, SvgDocumentAttach as DocumentAttach, SvgDocumentLock as DocumentLock, SvgDocumentText as DocumentText, SvgDocuments as Documents, SvgDownload as Download, SvgDuplicate as Duplicate, SvgEar as Ear, SvgEarth as Earth, SvgEasel as Easel, SvgEgg as Egg, SvgEllipse as Ellipse, SvgEllipsisHorizontal as EllipsisHorizontal, SvgEllipsisHorizontalCircle as EllipsisHorizontalCircle, SvgEllipsisVertical as EllipsisVertical, SvgEllipsisVerticalCircle as EllipsisVerticalCircle, SvgEnter as Enter, SvgExit as Exit, SvgExpand as Expand, SvgExtensionPuzzle as ExtensionPuzzle, SvgEye as Eye, SvgEyeOff as EyeOff, SvgEyedrop as Eyedrop, SvgFastFood as FastFood, SvgFemale as Female, SvgFileTray as FileTray, SvgFileTrayFull as FileTrayFull, SvgFileTrayStacked as FileTrayStacked, SvgFilm as Film, SvgFilter as Filter, SvgFilterCircle as FilterCircle, SvgFingerPrint as FingerPrint, SvgFish as Fish, SvgFitness as Fitness, SvgFlag as Flag, SvgFlame as Flame, SvgFlash as Flash, SvgFlashOff as FlashOff, SvgFlashlight as Flashlight, SvgFlask as Flask, SvgFlower as Flower, SvgFolder as Folder, SvgFolderOpen as FolderOpen, SvgFootball as Football, SvgFunnel as Funnel, SvgGameController as GameController, SvgGift as Gift, SvgGitBranch as GitBranch, SvgGitCommit as GitCommit, SvgGitCompare as GitCompare, SvgGitMerge as GitMerge, SvgGitNetwork as GitNetwork, SvgGitPullRequest as GitPullRequest, SvgGlasses as Glasses, SvgGlobe as Globe, SvgGolf as Golf, SvgGrid as Grid, SvgHammer as Hammer, SvgHandLeft as HandLeft, SvgHandRight as HandRight, SvgHappy as Happy, SvgHardwareChip as HardwareChip, SvgHeadset as Headset, SvgHeart as Heart, SvgHeartCircle as HeartCircle, SvgHeartDislike as HeartDislike, SvgHeartDislikeCircle as HeartDislikeCircle, SvgHeartHalf as HeartHalf, SvgHelp as Help, SvgHelpBuoy as HelpBuoy, SvgHelpCircle as HelpCircle, SvgHome as Home, SvgHourglass as Hourglass, SvgIceCream as IceCream, SvgIconFacebook as IconFacebook, SvgIconGoogle as IconGoogle, SvgIconMicrosoft as IconMicrosoft, SvgImage as Image, SvgImages as Images, SvgInfinite as Infinite, SvgInformation as Information, SvgInformationCircle as InformationCircle, SvgInvertMode as InvertMode, SvgJournal as Journal, SvgKey as Key, SvgKeypad as Keypad, SvgLanguage as Language, SvgLaptop as Laptop, SvgLayers as Layers, SvgLeaf as Leaf, SvgLibrary as Library, SvgLink as Link, SvgList as List, SvgListCircle as ListCircle, SvgLocate as Locate, SvgLocation as Location, SvgLockClosed as LockClosed, SvgLockOpen as LockOpen, SvgLogIn as LogIn, SvgLogOut as LogOut, SvgLogoAlipay as LogoAlipay, SvgLogoAmazon as LogoAmazon, SvgLogoAmplify as LogoAmplify, SvgLogoAndroid as LogoAndroid, SvgLogoAngular as LogoAngular, SvgLogoApple as LogoApple, SvgLogoAppleAppstore as LogoAppleAppstore, SvgLogoBehance as LogoBehance, SvgLogoBitbucket as LogoBitbucket, SvgLogoBitcoin as LogoBitcoin, SvgLogoBuffer as LogoBuffer, SvgLogoCapacitor as LogoCapacitor, SvgLogoChrome as LogoChrome, SvgLogoClosedCaptioning as LogoClosedCaptioning, SvgLogoCodepen as LogoCodepen, SvgLogoCss3 as LogoCss3, SvgLogoDesignernews as LogoDesignernews, SvgLogoDeviantart as LogoDeviantart, SvgLogoDiscord as LogoDiscord, SvgLogoDocker as LogoDocker, SvgLogoDribbble as LogoDribbble, SvgLogoDropbox as LogoDropbox, SvgLogoEdge as LogoEdge, SvgLogoElectron as LogoElectron, SvgLogoEuro as LogoEuro, SvgLogoFacebook as LogoFacebook, SvgLogoFigma as LogoFigma, SvgLogoFirebase as LogoFirebase, SvgLogoFirefox as LogoFirefox, SvgLogoFlickr as LogoFlickr, SvgLogoFoursquare as LogoFoursquare, SvgLogoGithub as LogoGithub, SvgLogoGitlab as LogoGitlab, SvgLogoGoogle as LogoGoogle, SvgLogoGooglePlaystore as LogoGooglePlaystore, SvgLogoHackernews as LogoHackernews, SvgLogoHtml5 as LogoHtml5, SvgLogoInstagram as LogoInstagram, SvgLogoIonic as LogoIonic, SvgLogoIonitron as LogoIonitron, SvgLogoJavascript as LogoJavascript, SvgLogoLaravel as LogoLaravel, SvgLogoLinkedin as LogoLinkedin, SvgLogoMarkdown as LogoMarkdown, SvgLogoMastodon as LogoMastodon, SvgLogoMedium as LogoMedium, SvgLogoNoSmoking as LogoNoSmoking, SvgLogoNodejs as LogoNodejs, SvgLogoNpm as LogoNpm, SvgLogoOctocat as LogoOctocat, SvgLogoPaypal as LogoPaypal, SvgLogoPinterest as LogoPinterest, SvgLogoPlaystation as LogoPlaystation, SvgLogoPwa as LogoPwa, SvgLogoPython as LogoPython, SvgLogoReact as LogoReact, SvgLogoReddit as LogoReddit, SvgLogoRss as LogoRss, SvgLogoSass as LogoSass, SvgLogoSkype as LogoSkype, SvgLogoSlack as LogoSlack, SvgLogoSnapchat as LogoSnapchat, SvgLogoSoundcloud as LogoSoundcloud, SvgLogoStackoverflow as LogoStackoverflow, SvgLogoSteam as LogoSteam, SvgLogoStencil as LogoStencil, SvgLogoTableau as LogoTableau, SvgLogoTiktok as LogoTiktok, SvgLogoTumblr as LogoTumblr, SvgLogoTux as LogoTux, SvgLogoTwitch as LogoTwitch, SvgLogoTwitter as LogoTwitter, SvgLogoUsd as LogoUsd, SvgLogoVenmo as LogoVenmo, SvgLogoVercel as LogoVercel, SvgLogoVimeo as LogoVimeo, SvgLogoVk as LogoVk, SvgLogoVue as LogoVue, SvgLogoWebComponent as LogoWebComponent, SvgLogoWechat as LogoWechat, SvgLogoWhatsapp as LogoWhatsapp, SvgLogoWindows as LogoWindows, SvgLogoWordpress as LogoWordpress, SvgLogoXbox as LogoXbox, SvgLogoXing as LogoXing, SvgLogoYahoo as LogoYahoo, SvgLogoYen as LogoYen, SvgLogoYoutube as LogoYoutube, SvgMagnet as Magnet, SvgMail as Mail, SvgMailOpen as MailOpen, SvgMailUnread as MailUnread, SvgMale as Male, SvgMaleFemale as MaleFemale, SvgMan as Man, SvgMap as Map, SvgMedal as Medal, SvgMedical as Medical, SvgMedkit as Medkit, SvgMegaphone as Megaphone, SvgMenu as Menu, SvgMic as Mic, SvgMicCircle as MicCircle, SvgMicOff as MicOff, SvgMicOffCircle as MicOffCircle, SvgMoon as Moon, SvgMove as Move, SvgMusicalNote as MusicalNote, SvgMusicalNotes as MusicalNotes, SvgNavigate as Navigate, SvgNavigateCircle as NavigateCircle, SvgNewspaper as Newspaper, SvgNotifications as Notifications, SvgNotificationsCircle as NotificationsCircle, SvgNotificationsOff as NotificationsOff, SvgNotificationsOffCircle as NotificationsOffCircle, SvgNuclear as Nuclear, SvgNutrition as Nutrition, SvgOpen as Open, SvgOptions as Options, SvgPaperPlane as PaperPlane, SvgPartlySunny as PartlySunny, SvgPause as Pause, SvgPauseCircle as PauseCircle, SvgPaw as Paw, SvgPencil as Pencil, SvgPeople as People, SvgPeopleCircle as PeopleCircle, SvgPerson as Person, SvgPersonAdd as PersonAdd, SvgPersonCircle as PersonCircle, SvgPersonRemove as PersonRemove, SvgPhoneLandscape as PhoneLandscape, SvgPhonePortrait as PhonePortrait, SvgPieChart as PieChart, SvgPin as Pin, SvgPint as Pint, SvgPizza as Pizza, SvgPlanet as Planet, SvgPlay as Play, SvgPlayBack as PlayBack, SvgPlayBackCircle as PlayBackCircle, SvgPlayCircle as PlayCircle, SvgPlayForward as PlayForward, SvgPlayForwardCircle as PlayForwardCircle, SvgPlaySkipBack as PlaySkipBack, SvgPlaySkipBackCircle as PlaySkipBackCircle, SvgPlaySkipForward as PlaySkipForward, SvgPlaySkipForwardCircle as PlaySkipForwardCircle, SvgPodium as Podium, SvgPower as Power, SvgPricetag as Pricetag, SvgPricetags as Pricetags, SvgPrint as Print, SvgPulse as Pulse, SvgPush as Push, SvgQrCode as QrCode, SvgRadio as Radio, SvgRadioButtonOff as RadioButtonOff, SvgRadioButtonOn as RadioButtonOn, SvgRainy as Rainy, SvgReader as Reader, SvgReceipt as Receipt, SvgRecording as Recording, SvgRefresh as Refresh, SvgRefreshCircle as RefreshCircle, SvgReload as Reload, SvgReloadCircle as ReloadCircle, SvgRemove as Remove, SvgRemoveCircle as RemoveCircle, SvgReorderFour as ReorderFour, SvgReorderThree as ReorderThree, SvgReorderTwo as ReorderTwo, SvgRepeat as Repeat, SvgResize as Resize, SvgRestaurant as Restaurant, SvgReturnDownBack as ReturnDownBack, SvgReturnDownForward as ReturnDownForward, SvgReturnUpBack as ReturnUpBack, SvgReturnUpForward as ReturnUpForward, SvgRibbon as Ribbon, SvgRocket as Rocket, SvgRose as Rose, SvgSad as Sad, SvgSave as Save, SvgScan as Scan, SvgScanCircle as ScanCircle, SvgSchool as School, SvgSearch as Search, SvgSearchCircle as SearchCircle, SvgSend as Send, SvgServer as Server, SvgSettings as Settings, SvgShapes as Shapes, SvgShare as Share, SvgShareSocial as ShareSocial, SvgShield as Shield, SvgShieldCheckmark as ShieldCheckmark, SvgShirt as Shirt, SvgShuffle as Shuffle, SvgSkull as Skull, SvgSnow as Snow, SvgSpeedometer as Speedometer, SvgSquare as Square, SvgStar as Star, SvgStarHalf as StarHalf, SvgStatsChart as StatsChart, SvgStop as Stop, SvgStopCircle as StopCircle, SvgStopwatch as Stopwatch, SvgStorefront as Storefront, SvgSubway as Subway, SvgSunny as Sunny, SvgSwapHorizontal as SwapHorizontal, SvgSwapVertical as SwapVertical, SvgSync as Sync, SvgSyncCircle as SyncCircle, SvgTabletLandscape as TabletLandscape, SvgTabletPortrait as TabletPortrait, SvgTelescope as Telescope, SvgTennisball as Tennisball, SvgTerminal as Terminal, SvgText as Text, SvgThermometer as Thermometer, SvgThumbsDown as ThumbsDown, SvgThumbsUp as ThumbsUp, SvgThunderstorm as Thunderstorm, SvgTicket as Ticket, SvgTime as Time, SvgTimer as Timer, SvgToday as Today, SvgToggle as Toggle, SvgTrailSign as TrailSign, SvgTrain as Train, SvgTransgender as Transgender, SvgTrash as Trash, SvgTrashBin as TrashBin, SvgTrendingDown as TrendingDown, SvgTrendingUp as TrendingUp, SvgTriangle as Triangle, SvgTrophy as Trophy, SvgTv as Tv, SvgUmbrella as Umbrella, SvgUnlink as Unlink, SvgVideocam as Videocam, SvgVideocamOff as VideocamOff, SvgVolumeHigh as VolumeHigh, SvgVolumeLow as VolumeLow, SvgVolumeMedium as VolumeMedium, SvgVolumeMute as VolumeMute, SvgVolumeOff as VolumeOff, SvgWalk as Walk, SvgWallet as Wallet, SvgWarning as Warning, SvgWatch as Watch, SvgWater as Water, SvgWifi as Wifi, SvgWine as Wine, SvgWoman as Woman };
